import { createColorParam, type ColorPalette } from '@paint-ai/shared';

export interface BuiltInExcelShade {
  name: string;
  code: string;
  hex: string;
  rgb?: string;
}

// Full Asian Paints / Nippon Paint Colour Creation Palette Database (2468 Total Shades)
export const BUILTIN_EXCEL_SHADES: BuiltInExcelShade[] = [
  {
    "name": "Abacadabra",
    "code": "NP N 2034 P",
    "hex": "#CEC9C3",
    "rgb": "206, 201, 195"
  },
  {
    "name": "Air Cushion",
    "code": "NP OW 1081 P",
    "hex": "#EAE6DF",
    "rgb": "234, 230, 223"
  },
  {
    "name": "Alabaster",
    "code": "NP OW 1018 P",
    "hex": "#F4F0E8",
    "rgb": "244, 240, 232"
  },
  {
    "name": "Antique White",
    "code": "NP OW 1002 P",
    "hex": "#FAF5EA",
    "rgb": "250, 245, 234"
  },
  {
    "name": "White Lace",
    "code": "NP OW 1004 P",
    "hex": "#FAF7F0",
    "rgb": "250, 247, 240"
  },
  {
    "name": "Morning Mist",
    "code": "NP OW 1082 P",
    "hex": "#EFECE6",
    "rgb": "239, 236, 230"
  },
  {
    "name": "Lily White",
    "code": "NP OW 1010 P",
    "hex": "#F7F5EE",
    "rgb": "247, 245, 238"
  },
  {
    "name": "Cotton Wool",
    "code": "NP OW 1084 P",
    "hex": "#E5E1D8",
    "rgb": "229, 225, 216"
  },
  {
    "name": "Pure Vanilla",
    "code": "NP OW 1008 P",
    "hex": "#FBF8F1",
    "rgb": "251, 248, 241"
  },
  {
    "name": "Soft Silk",
    "code": "NP OW 1020 P",
    "hex": "#F2EDE2",
    "rgb": "242, 237, 226"
  },
  {
    "name": "Pearl White",
    "code": "NP OW 1012 P",
    "hex": "#F6F3EC",
    "rgb": "246, 243, 236"
  },
  {
    "name": "Ivory Illusion",
    "code": "NP OW 1028 P",
    "hex": "#EFE8D8",
    "rgb": "239, 232, 216"
  },
  {
    "name": "Creamy Crust",
    "code": "NP OW 1030 P",
    "hex": "#FAF2E2",
    "rgb": "250, 242, 226"
  },
  {
    "name": "Shell White",
    "code": "NP OW 1006 P",
    "hex": "#F8F4EC",
    "rgb": "248, 244, 236"
  },
  {
    "name": "Crystal Clear",
    "code": "NP OW 1086 P",
    "hex": "#ECE9E2",
    "rgb": "236, 233, 226"
  },
  {
    "name": "Absolute Yellow",
    "code": "NP YO 1113 A",
    "hex": "#FACF19",
    "rgb": "250, 207, 25"
  },
  {
    "name": "Amber Wave",
    "code": "NP YO 1184 T",
    "hex": "#E2B887",
    "rgb": "226, 184, 135"
  },
  {
    "name": "Warm Sand",
    "code": "NP YO 1201 T",
    "hex": "#E8C59C",
    "rgb": "232, 197, 156"
  },
  {
    "name": "Golden Touch",
    "code": "NP YO 1115 A",
    "hex": "#F5BA13",
    "rgb": "245, 186, 19"
  },
  {
    "name": "Sunshine Yellow",
    "code": "NP YO 1114 T",
    "hex": "#F8DB52",
    "rgb": "248, 219, 82"
  },
  {
    "name": "Buttercup",
    "code": "NP YO 1110 P",
    "hex": "#FAF09E",
    "rgb": "250, 240, 158"
  },
  {
    "name": "Saffron Flame",
    "code": "NP YO 1130 A",
    "hex": "#EB881E",
    "rgb": "235, 136, 30"
  },
  {
    "name": "Mango Smoothie",
    "code": "NP YO 1138 T",
    "hex": "#F3B058",
    "rgb": "243, 176, 88"
  },
  {
    "name": "Apricot Nectar",
    "code": "NP YO 1146 T",
    "hex": "#F7C08A",
    "rgb": "247, 192, 138"
  },
  {
    "name": "Desert Sand",
    "code": "NP YO 1202 P",
    "hex": "#EFE1CD",
    "rgb": "239, 225, 205"
  },
  {
    "name": "Tuscan Sun",
    "code": "NP YO 1120 A",
    "hex": "#F2A900",
    "rgb": "242, 169, 0"
  },
  {
    "name": "Creamy Custard",
    "code": "NP YO 1188 P",
    "hex": "#F5E5C9",
    "rgb": "245, 229, 201"
  },
  {
    "name": "Accented Brown",
    "code": "NP N 3386 A",
    "hex": "#554841",
    "rgb": "85, 72, 65"
  },
  {
    "name": "Urban Ash Gray",
    "code": "NP N 2001 P",
    "hex": "#D3D6D6",
    "rgb": "211, 214, 214"
  },
  {
    "name": "Slate Graphite",
    "code": "NP N 2040 T",
    "hex": "#3A404A",
    "rgb": "58, 64, 74"
  },
  {
    "name": "African Safari",
    "code": "NP N 1867 A",
    "hex": "#A88C68",
    "rgb": "168, 140, 104"
  },
  {
    "name": "Charcoal Smoke",
    "code": "NP N 2042 A",
    "hex": "#282D35",
    "rgb": "40, 45, 53"
  },
  {
    "name": "Mist Gray",
    "code": "NP N 2002 P",
    "hex": "#E1E3E3",
    "rgb": "225, 227, 227"
  },
  {
    "name": "Cool Pewter",
    "code": "NP N 2004 T",
    "hex": "#B0B5B7",
    "rgb": "176, 181, 183"
  },
  {
    "name": "Industrial Steel",
    "code": "NP N 2006 D",
    "hex": "#7B8286",
    "rgb": "123, 130, 134"
  },
  {
    "name": "Mocha Fudge",
    "code": "NP N 1870 A",
    "hex": "#5C4A38",
    "rgb": "92, 74, 56"
  },
  {
    "name": "Walnut Shell",
    "code": "NP N 1868 D",
    "hex": "#7D6348",
    "rgb": "125, 99, 72"
  },
  {
    "name": "Toasted Sesame",
    "code": "NP N 1866 T",
    "hex": "#C2AB8E",
    "rgb": "194, 171, 142"
  },
  {
    "name": "Hazelnut Cream",
    "code": "NP N 1864 P",
    "hex": "#E3D5C3",
    "rgb": "227, 213, 195"
  },
  {
    "name": "Silver Birch",
    "code": "NP N 1998 P",
    "hex": "#E7E8E6",
    "rgb": "231, 232, 230"
  },
  {
    "name": "Stone Mason",
    "code": "NP N 2038 T",
    "hex": "#6D7278",
    "rgb": "109, 114, 120"
  },
  {
    "name": "Dark Ebony",
    "code": "NP N 2048 A",
    "hex": "#1E2024",
    "rgb": "30, 32, 36"
  },
  {
    "name": "Aegean Sea",
    "code": "NP BGG 1597 D",
    "hex": "#00A0A0",
    "rgb": "0, 160, 160"
  },
  {
    "name": "Alps Blue",
    "code": "NP BGG 1572 P",
    "hex": "#B8D5E5",
    "rgb": "184, 213, 229"
  },
  {
    "name": "Peacock Blue",
    "code": "NP BGG 1580 D",
    "hex": "#1A6B7C",
    "rgb": "26, 107, 124"
  },
  {
    "name": "Blue Horizon",
    "code": "NP PB 1520 T",
    "hex": "#6B9AC4",
    "rgb": "107, 154, 196"
  },
  {
    "name": "Royal Indigo",
    "code": "NP PB 1528 A",
    "hex": "#1E3A75",
    "rgb": "30, 58, 117"
  },
  {
    "name": "Sky Breeze",
    "code": "NP PB 1514 P",
    "hex": "#C4DCF0",
    "rgb": "196, 220, 240"
  },
  {
    "name": "Ocean Calm",
    "code": "NP BGG 1582 D",
    "hex": "#0E5265",
    "rgb": "14, 82, 101"
  },
  {
    "name": "Aquamarine Mist",
    "code": "NP BGG 1594 P",
    "hex": "#B5E2E2",
    "rgb": "181, 226, 226"
  },
  {
    "name": "Deep Navy",
    "code": "NP PB 1530 A",
    "hex": "#122143",
    "rgb": "18, 33, 67"
  },
  {
    "name": "Powder Blue",
    "code": "NP PB 1512 P",
    "hex": "#D6E6F5",
    "rgb": "214, 230, 245"
  },
  {
    "name": "Teal Cascade",
    "code": "NP BGG 1590 D",
    "hex": "#008080",
    "rgb": "0, 128, 128"
  },
  {
    "name": "Glacier Ice",
    "code": "NP BGG 1570 P",
    "hex": "#D1E5F0",
    "rgb": "209, 229, 240"
  },
  {
    "name": "Acid Lime",
    "code": "NP BGG 1687 A",
    "hex": "#CBCF2F",
    "rgb": "203, 207, 47"
  },
  {
    "name": "Olive Grove",
    "code": "NP BGG 1675 A",
    "hex": "#6B7D3B",
    "rgb": "107, 125, 59"
  },
  {
    "name": "Sage Leaf",
    "code": "NP BGG 1668 T",
    "hex": "#9AB08A",
    "rgb": "154, 176, 138"
  },
  {
    "name": "Minty Breeze",
    "code": "NP BGG 1666 P",
    "hex": "#C2DEC1",
    "rgb": "194, 222, 193"
  },
  {
    "name": "Forest Emerald",
    "code": "NP BGG 1680 A",
    "hex": "#1B4D3E",
    "rgb": "27, 77, 62"
  },
  {
    "name": "Meadow Green",
    "code": "NP BGG 1672 T",
    "hex": "#78AB5B",
    "rgb": "120, 171, 91"
  },
  {
    "name": "Pistachio Cream",
    "code": "NP BGG 1670 P",
    "hex": "#D1E5C4",
    "rgb": "209, 229, 196"
  },
  {
    "name": "Spring Bamboo",
    "code": "NP BGG 1684 T",
    "hex": "#B5C942",
    "rgb": "181, 201, 66"
  },
  {
    "name": "Absolutely Pink",
    "code": "NP AC 2077 A",
    "hex": "#BF486C",
    "rgb": "191, 72, 108"
  },
  {
    "name": "Affectionate Hug",
    "code": "NP R 2364 P",
    "hex": "#F5D4CB",
    "rgb": "245, 212, 203"
  },
  {
    "name": "Terracotta Red",
    "code": "NP R 1282 A",
    "hex": "#A84E32",
    "rgb": "168, 78, 50"
  },
  {
    "name": "Adolescence",
    "code": "NP PB 1392 T",
    "hex": "#BC8DBA",
    "rgb": "188, 141, 186"
  },
  {
    "name": "Crimson Passion",
    "code": "NP R 1275 A",
    "hex": "#A61C2B",
    "rgb": "166, 28, 43"
  },
  {
    "name": "Rose Blush",
    "code": "NP R 1260 P",
    "hex": "#F2C1C8",
    "rgb": "242, 193, 200"
  },
  {
    "name": "Plum Wine",
    "code": "NP PB 1400 A",
    "hex": "#5C2A53",
    "rgb": "92, 42, 83"
  },
  {
    "name": "Lavender Fields",
    "code": "NP PB 1390 P",
    "hex": "#D6B2D5",
    "rgb": "214, 178, 213"
  },
  {
    "name": "Ruby Slipper",
    "code": "NP R 1272 A",
    "hex": "#B82838",
    "rgb": "184, 40, 56"
  },
  {
    "name": "Coral Reef",
    "code": "NP R 1266 T",
    "hex": "#E87A6E",
    "rgb": "232, 122, 110"
  },
  {
    "name": "Peach Blossom",
    "code": "NP R 1258 P",
    "hex": "#FAD0C4",
    "rgb": "250, 208, 196"
  },
  {
    "name": "Dusty Rose",
    "code": "NP R 1262 T",
    "hex": "#D4969E",
    "rgb": "212, 150, 158"
  },
  {
    "name": "Cool Harmony 1",
    "code": "NP OW 1001 P",
    "hex": "#ECD9C9",
    "rgb": "236, 217, 201"
  },
  {
    "name": "Muted Sand 2",
    "code": "NP OW 1002 T",
    "hex": "#E1D3C6",
    "rgb": "225, 211, 198"
  },
  {
    "name": "Classic Dusk 3",
    "code": "NP OW 1003 D",
    "hex": "#F2EDE8",
    "rgb": "242, 237, 232"
  },
  {
    "name": "Mystic Echo 4",
    "code": "NP OW 1004 A",
    "hex": "#F8F5F1",
    "rgb": "248, 245, 241"
  },
  {
    "name": "Silver Reflection 5",
    "code": "NP OW 1005 N",
    "hex": "#E5DACF",
    "rgb": "229, 218, 207"
  },
  {
    "name": "Pacific Blossom 7",
    "code": "NP OW 1007 T",
    "hex": "#F7EADD",
    "rgb": "247, 234, 221"
  },
  {
    "name": "Saharan Sanctuary 8",
    "code": "NP OW 1008 D",
    "hex": "#F4F0EC",
    "rgb": "244, 240, 236"
  },
  {
    "name": "Coastal Glow 9",
    "code": "NP OW 1009 A",
    "hex": "#E1DDD9",
    "rgb": "225, 221, 217"
  },
  {
    "name": "Soft Symphony 10",
    "code": "NP OW 1010 N",
    "hex": "#EADCCF",
    "rgb": "234, 220, 207"
  },
  {
    "name": "Cool Horizon 11",
    "code": "NP OW 1011 P",
    "hex": "#FAE7D5",
    "rgb": "250, 231, 213"
  },
  {
    "name": "Muted Tranquility 12",
    "code": "NP OW 1012 T",
    "hex": "#EDE2D8",
    "rgb": "237, 226, 216"
  },
  {
    "name": "Classic Breeze 13",
    "code": "NP OW 1013 D",
    "hex": "#E0DEDB",
    "rgb": "224, 222, 219"
  },
  {
    "name": "Mystic Aura 14",
    "code": "NP OW 1014 A",
    "hex": "#F0EBE5",
    "rgb": "240, 235, 229"
  },
  {
    "name": "Silver Feather 15",
    "code": "NP OW 1015 N",
    "hex": "#F9EADA",
    "rgb": "249, 234, 218"
  },
  {
    "name": "Satin Twilight 16",
    "code": "NP OW 1016 P",
    "hex": "#E7D6C5",
    "rgb": "231, 214, 197"
  },
  {
    "name": "Pacific Tide 17",
    "code": "NP OW 1017 T",
    "hex": "#E3DAD1",
    "rgb": "227, 218, 209"
  },
  {
    "name": "Saharan Dream 18",
    "code": "NP OW 1018 D",
    "hex": "#F6F3F1",
    "rgb": "246, 243, 241"
  },
  {
    "name": "Coastal Stone 19",
    "code": "NP OW 1019 A",
    "hex": "#F5EEE7",
    "rgb": "245, 238, 231"
  },
  {
    "name": "Soft Dawn 20",
    "code": "NP OW 1020 N",
    "hex": "#E2D3C4",
    "rgb": "226, 211, 196"
  },
  {
    "name": "Cool Canvas 21",
    "code": "NP OW 1021 P",
    "hex": "#E8D8C8",
    "rgb": "232, 216, 200"
  },
  {
    "name": "Muted Shadow 22",
    "code": "NP OW 1022 T",
    "hex": "#F9F2E9",
    "rgb": "249, 242, 233"
  },
  {
    "name": "Classic Velvet 23",
    "code": "NP OW 1023 D",
    "hex": "#EFEDEA",
    "rgb": "239, 237, 234"
  },
  {
    "name": "Mystic Petal 24",
    "code": "NP OW 1024 A",
    "hex": "#E0D9D0",
    "rgb": "224, 217, 208"
  },
  {
    "name": "Silver Haven 25",
    "code": "NP OW 1025 N",
    "hex": "#EEDECC",
    "rgb": "238, 222, 204"
  },
  {
    "name": "Satin Mist 26",
    "code": "NP OW 1026 P",
    "hex": "#FAEAD9",
    "rgb": "250, 234, 217"
  },
  {
    "name": "Pacific Elegance 27",
    "code": "NP OW 1027 T",
    "hex": "#E9E3DD",
    "rgb": "233, 227, 221"
  },
  {
    "name": "Saharan Cloud 28",
    "code": "NP OW 1028 D",
    "hex": "#E2DFDD",
    "rgb": "226, 223, 221"
  },
  {
    "name": "Coastal Serenity 29",
    "code": "NP OW 1029 A",
    "hex": "#F4EBE0",
    "rgb": "244, 235, 224"
  },
  {
    "name": "Soft Whisper 30",
    "code": "NP OW 1030 N",
    "hex": "#F7E5D2",
    "rgb": "247, 229, 210"
  },
  {
    "name": "Cool Harmony 31",
    "code": "NP OW 1031 P",
    "hex": "#E3D7C9",
    "rgb": "227, 215, 201"
  },
  {
    "name": "Muted Sand 32",
    "code": "NP OW 1032 T",
    "hex": "#E6E2DD",
    "rgb": "230, 226, 221"
  },
  {
    "name": "Classic Dusk 33",
    "code": "NP OW 1033 D",
    "hex": "#F9F5F2",
    "rgb": "249, 245, 242"
  },
  {
    "name": "Mystic Echo 34",
    "code": "NP OW 1034 A",
    "hex": "#F1E6D9",
    "rgb": "241, 230, 217"
  },
  {
    "name": "Silver Reflection 35",
    "code": "NP OW 1035 N",
    "hex": "#E1D1BF",
    "rgb": "225, 209, 191"
  },
  {
    "name": "Satin Silk 36",
    "code": "NP OW 1036 P",
    "hex": "#ECE1D3",
    "rgb": "236, 225, 211"
  },
  {
    "name": "Pacific Blossom 37",
    "code": "NP OW 1037 T",
    "hex": "#FAF6F2",
    "rgb": "250, 246, 242"
  },
  {
    "name": "Saharan Sanctuary 38",
    "code": "NP OW 1038 D",
    "hex": "#EBE7E2",
    "rgb": "235, 231, 226"
  },
  {
    "name": "Coastal Glow 39",
    "code": "NP OW 1039 A",
    "hex": "#E1D6C8",
    "rgb": "225, 214, 200"
  },
  {
    "name": "Soft Symphony 40",
    "code": "NP OW 1040 N",
    "hex": "#F3E2CF",
    "rgb": "243, 226, 207"
  },
  {
    "name": "Cool Horizon 41",
    "code": "NP OW 1041 P",
    "hex": "#F8EDE1",
    "rgb": "248, 237, 225"
  },
  {
    "name": "Muted Tranquility 42",
    "code": "NP OW 1042 T",
    "hex": "#E5E2DF",
    "rgb": "229, 226, 223"
  },
  {
    "name": "Classic Breeze 43",
    "code": "NP OW 1043 D",
    "hex": "#E5E0DA",
    "rgb": "229, 224, 218"
  },
  {
    "name": "Mystic Aura 44",
    "code": "NP OW 1044 A",
    "hex": "#F8EAD9",
    "rgb": "248, 234, 217"
  },
  {
    "name": "Silver Feather 45",
    "code": "NP OW 1045 N",
    "hex": "#F3E3D0",
    "rgb": "243, 227, 208"
  },
  {
    "name": "Satin Twilight 46",
    "code": "NP OW 1046 P",
    "hex": "#E1D9D0",
    "rgb": "225, 217, 208"
  },
  {
    "name": "Pacific Tide 47",
    "code": "NP OW 1047 T",
    "hex": "#EAE8E6",
    "rgb": "234, 232, 230"
  },
  {
    "name": "Saharan Dream 48",
    "code": "NP OW 1048 D",
    "hex": "#FAF3EB",
    "rgb": "250, 243, 235"
  },
  {
    "name": "Coastal Stone 49",
    "code": "NP OW 1049 A",
    "hex": "#EDDFCD",
    "rgb": "237, 223, 205"
  },
  {
    "name": "Soft Dawn 50",
    "code": "NP OW 1050 N",
    "hex": "#E1D3C1",
    "rgb": "225, 211, 193"
  },
  {
    "name": "Cool Canvas 51",
    "code": "NP OW 1051 P",
    "hex": "#F1EAE2",
    "rgb": "241, 234, 226"
  },
  {
    "name": "Muted Shadow 52",
    "code": "NP OW 1052 T",
    "hex": "#F9F7F4",
    "rgb": "249, 247, 244"
  },
  {
    "name": "Classic Velvet 53",
    "code": "NP OW 1053 D",
    "hex": "#E6DFD6",
    "rgb": "230, 223, 214"
  },
  {
    "name": "Mystic Petal 54",
    "code": "NP OW 1054 A",
    "hex": "#E3D5C3",
    "rgb": "227, 213, 195"
  },
  {
    "name": "Silver Haven 55",
    "code": "NP OW 1055 N",
    "hex": "#F6E9D7",
    "rgb": "246, 233, 215"
  },
  {
    "name": "Satin Mist 56",
    "code": "NP OW 1056 P",
    "hex": "#F5EFE8",
    "rgb": "245, 239, 232"
  },
  {
    "name": "Pacific Elegance 57",
    "code": "NP OW 1057 T",
    "hex": "#E2E0DD",
    "rgb": "226, 224, 221"
  },
  {
    "name": "Saharan Cloud 58",
    "code": "NP OW 1058 D",
    "hex": "#E9E0D5",
    "rgb": "233, 224, 213"
  },
  {
    "name": "Coastal Serenity 59",
    "code": "NP OW 1059 A",
    "hex": "#FAEAD5",
    "rgb": "250, 234, 213"
  },
  {
    "name": "Soft Whisper 60",
    "code": "NP OW 1060 N",
    "hex": "#EEE3D2",
    "rgb": "238, 227, 210"
  },
  {
    "name": "Cool Harmony 61",
    "code": "NP OW 1061 P",
    "hex": "#E0DDD7",
    "rgb": "224, 221, 215"
  },
  {
    "name": "Muted Sand 62",
    "code": "NP OW 1062 T",
    "hex": "#EFECE9",
    "rgb": "239, 236, 233"
  },
  {
    "name": "Classic Dusk 63",
    "code": "NP OW 1063 D",
    "hex": "#F9EFE1",
    "rgb": "249, 239, 225"
  },
  {
    "name": "Mystic Echo 64",
    "code": "NP OW 1064 A",
    "hex": "#E8DAC5",
    "rgb": "232, 218, 197"
  },
  {
    "name": "Silver Reflection 65",
    "code": "NP OW 1065 N",
    "hex": "#E2D8CA",
    "rgb": "226, 216, 202"
  },
  {
    "name": "Satin Silk 66",
    "code": "NP OW 1066 P",
    "hex": "#F5F2ED",
    "rgb": "245, 242, 237"
  },
  {
    "name": "Pacific Blossom 67",
    "code": "NP OW 1067 T",
    "hex": "#F6F2ED",
    "rgb": "246, 242, 237"
  },
  {
    "name": "Saharan Sanctuary 68",
    "code": "NP OW 1068 D",
    "hex": "#E3D9C9",
    "rgb": "227, 217, 201"
  },
  {
    "name": "Coastal Glow 69",
    "code": "NP OW 1069 A",
    "hex": "#E7D9C4",
    "rgb": "231, 217, 196"
  },
  {
    "name": "Soft Symphony 70",
    "code": "NP OW 1070 N",
    "hex": "#F9F0E2",
    "rgb": "249, 240, 226"
  },
  {
    "name": "Cool Horizon 71",
    "code": "NP OW 1071 P",
    "hex": "#F0EEEA",
    "rgb": "240, 238, 234"
  },
  {
    "name": "Muted Tranquility 72",
    "code": "NP OW 1072 T",
    "hex": "#E0DCD6",
    "rgb": "224, 220, 214"
  },
  {
    "name": "Classic Breeze 73",
    "code": "NP OW 1073 D",
    "hex": "#EDE1D0",
    "rgb": "237, 225, 208"
  },
  {
    "name": "Mystic Aura 74",
    "code": "NP OW 1074 A",
    "hex": "#FAEBD5",
    "rgb": "250, 235, 213"
  },
  {
    "name": "Silver Feather 75",
    "code": "NP OW 1075 N",
    "hex": "#EAE3D8",
    "rgb": "234, 227, 216"
  },
  {
    "name": "Satin Twilight 76",
    "code": "NP OW 1076 P",
    "hex": "#E1E0DD",
    "rgb": "225, 224, 221"
  },
  {
    "name": "Pacific Tide 77",
    "code": "NP OW 1077 T",
    "hex": "#F4EEE5",
    "rgb": "244, 238, 229"
  },
  {
    "name": "Saharan Dream 78",
    "code": "NP OW 1078 D",
    "hex": "#F7EAD6",
    "rgb": "247, 234, 214"
  },
  {
    "name": "Coastal Stone 79",
    "code": "NP OW 1079 A",
    "hex": "#E4D8C5",
    "rgb": "228, 216, 197"
  },
  {
    "name": "Soft Dawn 80",
    "code": "NP OW 1080 N",
    "hex": "#E5E0D7",
    "rgb": "229, 224, 215"
  },
  {
    "name": "Muted Shadow 82",
    "code": "NP OW 1082 T",
    "hex": "#F2ECE1",
    "rgb": "242, 236, 225"
  },
  {
    "name": "Classic Velvet 83",
    "code": "NP OW 1083 D",
    "hex": "#E1D5C1",
    "rgb": "225, 213, 193"
  },
  {
    "name": "Mystic Petal 84",
    "code": "NP OW 1084 A",
    "hex": "#EBE0CD",
    "rgb": "235, 224, 205"
  },
  {
    "name": "Silver Haven 85",
    "code": "NP OW 1085 N",
    "hex": "#FAF5ED",
    "rgb": "250, 245, 237"
  },
  {
    "name": "Pacific Elegance 87",
    "code": "NP OW 1087 T",
    "hex": "#E1DACE",
    "rgb": "225, 218, 206"
  },
  {
    "name": "Saharan Cloud 88",
    "code": "NP OW 1088 D",
    "hex": "#F2E4CE",
    "rgb": "242, 228, 206"
  },
  {
    "name": "Coastal Serenity 89",
    "code": "NP OW 1089 A",
    "hex": "#F8EDDB",
    "rgb": "248, 237, 219"
  },
  {
    "name": "Soft Whisper 90",
    "code": "NP OW 1090 N",
    "hex": "#E6E2DC",
    "rgb": "230, 226, 220"
  },
  {
    "name": "Cool Harmony 91",
    "code": "NP OW 1091 P",
    "hex": "#E4E2DE",
    "rgb": "228, 226, 222"
  },
  {
    "name": "Muted Sand 92",
    "code": "NP OW 1092 T",
    "hex": "#F7EEDF",
    "rgb": "247, 238, 223"
  },
  {
    "name": "Classic Dusk 93",
    "code": "NP OW 1093 D",
    "hex": "#F4E6CF",
    "rgb": "244, 230, 207"
  },
  {
    "name": "Mystic Echo 94",
    "code": "NP OW 1094 A",
    "hex": "#E2D9CA",
    "rgb": "226, 217, 202"
  },
  {
    "name": "Silver Reflection 95",
    "code": "NP OW 1095 N",
    "hex": "#E9E7E2",
    "rgb": "233, 231, 226"
  },
  {
    "name": "Satin Silk 96",
    "code": "NP OW 1096 P",
    "hex": "#FAF7F1",
    "rgb": "250, 247, 241"
  },
  {
    "name": "Pacific Blossom 97",
    "code": "NP OW 1097 T",
    "hex": "#EEE4D3",
    "rgb": "238, 228, 211"
  },
  {
    "name": "Saharan Sanctuary 98",
    "code": "NP OW 1098 D",
    "hex": "#E0D5BF",
    "rgb": "224, 213, 191"
  },
  {
    "name": "Coastal Glow 99",
    "code": "NP OW 1099 A",
    "hex": "#F0E8DA",
    "rgb": "240, 232, 218"
  },
  {
    "name": "Soft Symphony 100",
    "code": "NP OW 1100 N",
    "hex": "#F9F7F3",
    "rgb": "249, 247, 243"
  },
  {
    "name": "Cool Horizon 101",
    "code": "NP OW 1101 P",
    "hex": "#E7E4DD",
    "rgb": "231, 228, 221"
  },
  {
    "name": "Muted Tranquility 102",
    "code": "NP OW 1102 T",
    "hex": "#E3D9C6",
    "rgb": "227, 217, 198"
  },
  {
    "name": "Classic Breeze 103",
    "code": "NP OW 1103 D",
    "hex": "#F6E9D2",
    "rgb": "246, 233, 210"
  },
  {
    "name": "Mystic Aura 104",
    "code": "NP OW 1104 A",
    "hex": "#F5EFE2",
    "rgb": "245, 239, 226"
  },
  {
    "name": "Silver Feather 105",
    "code": "NP OW 1105 N",
    "hex": "#E2E1DE",
    "rgb": "226, 225, 222"
  },
  {
    "name": "Satin Twilight 106",
    "code": "NP OW 1106 P",
    "hex": "#E8E3DA",
    "rgb": "232, 227, 218"
  },
  {
    "name": "Pacific Tide 107",
    "code": "NP OW 1107 T",
    "hex": "#F9EED8",
    "rgb": "249, 238, 216"
  },
  {
    "name": "Saharan Dream 108",
    "code": "NP OW 1108 D",
    "hex": "#EFE4CE",
    "rgb": "239, 228, 206"
  },
  {
    "name": "Coastal Stone 109",
    "code": "NP OW 1109 A",
    "hex": "#E0DCD2",
    "rgb": "224, 220, 210"
  },
  {
    "name": "Soft Dawn 110",
    "code": "NP OW 1110 N",
    "hex": "#EEECE9",
    "rgb": "238, 236, 233"
  },
  {
    "name": "Cool Canvas 111",
    "code": "NP OW 1111 P",
    "hex": "#FAF4E8",
    "rgb": "250, 244, 232"
  },
  {
    "name": "Muted Shadow 112",
    "code": "NP OW 1112 T",
    "hex": "#E9DEC8",
    "rgb": "233, 222, 200"
  },
  {
    "name": "Classic Velvet 113",
    "code": "NP OW 1113 D",
    "hex": "#E2D8C4",
    "rgb": "226, 216, 196"
  },
  {
    "name": "Mystic Petal 114",
    "code": "NP OW 1114 A",
    "hex": "#F4F0E8",
    "rgb": "244, 240, 232"
  },
  {
    "name": "Silver Haven 115",
    "code": "NP OW 1115 N",
    "hex": "#F7F5F1",
    "rgb": "247, 245, 241"
  },
  {
    "name": "Satin Mist 116",
    "code": "NP OW 1116 P",
    "hex": "#E4DDD0",
    "rgb": "228, 221, 208"
  },
  {
    "name": "Pacific Elegance 117",
    "code": "NP OW 1117 T",
    "hex": "#E6DBC4",
    "rgb": "230, 219, 196"
  },
  {
    "name": "Saharan Cloud 118",
    "code": "NP OW 1118 D",
    "hex": "#F9EFDB",
    "rgb": "249, 239, 219"
  },
  {
    "name": "Coastal Serenity 119",
    "code": "NP OW 1119 A",
    "hex": "#F1EEE8",
    "rgb": "241, 238, 232"
  },
  {
    "name": "Soft Whisper 120",
    "code": "NP OW 1120 N",
    "hex": "#E1DFDA",
    "rgb": "225, 223, 218"
  },
  {
    "name": "Cool Harmony 121",
    "code": "NP OW 1121 P",
    "hex": "#ECE5D5",
    "rgb": "236, 229, 213"
  },
  {
    "name": "Muted Sand 122",
    "code": "NP OW 1122 T",
    "hex": "#FAEED4",
    "rgb": "250, 238, 212"
  },
  {
    "name": "Classic Dusk 123",
    "code": "NP OW 1123 D",
    "hex": "#EBE3D2",
    "rgb": "235, 227, 210"
  },
  {
    "name": "Mystic Echo 124",
    "code": "NP OW 1124 A",
    "hex": "#E1DFDA",
    "rgb": "225, 223, 218"
  },
  {
    "name": "Silver Reflection 125",
    "code": "NP OW 1125 N",
    "hex": "#F3F0EA",
    "rgb": "243, 240, 234"
  },
  {
    "name": "Satin Silk 126",
    "code": "NP OW 1126 P",
    "hex": "#F8EFDC",
    "rgb": "248, 239, 220"
  },
  {
    "name": "Pacific Blossom 127",
    "code": "NP OW 1127 T",
    "hex": "#E5DAC3",
    "rgb": "229, 218, 195"
  },
  {
    "name": "Saharan Sanctuary 128",
    "code": "NP OW 1128 D",
    "hex": "#E5DED0",
    "rgb": "229, 222, 208"
  },
  {
    "name": "Coastal Glow 129",
    "code": "NP OW 1129 A",
    "hex": "#F8F6F2",
    "rgb": "248, 246, 242"
  },
  {
    "name": "Soft Symphony 130",
    "code": "NP OW 1130 N",
    "hex": "#F3F0E8",
    "rgb": "243, 240, 232"
  },
  {
    "name": "Cool Horizon 131",
    "code": "NP OW 1131 P",
    "hex": "#E1D9C5",
    "rgb": "225, 217, 197"
  },
  {
    "name": "Muted Tranquility 132",
    "code": "NP OW 1132 T",
    "hex": "#EAE0C8",
    "rgb": "234, 224, 200"
  },
  {
    "name": "Classic Breeze 133",
    "code": "NP OW 1133 D",
    "hex": "#FAF4E6",
    "rgb": "250, 244, 230"
  },
  {
    "name": "Mystic Aura 134",
    "code": "NP OW 1134 A",
    "hex": "#EDEBE8",
    "rgb": "237, 235, 232"
  },
  {
    "name": "Silver Feather 135",
    "code": "NP OW 1135 N",
    "hex": "#E1DDD4",
    "rgb": "225, 221, 212"
  },
  {
    "name": "Satin Twilight 136",
    "code": "NP OW 1136 P",
    "hex": "#F1E7D0",
    "rgb": "241, 231, 208"
  },
  {
    "name": "Pacific Tide 137",
    "code": "NP OW 1137 T",
    "hex": "#F9EFD6",
    "rgb": "249, 239, 214"
  },
  {
    "name": "Saharan Dream 138",
    "code": "NP OW 1138 D",
    "hex": "#E6E2D8",
    "rgb": "230, 226, 216"
  },
  {
    "name": "Coastal Stone 139",
    "code": "NP OW 1139 A",
    "hex": "#E3E2DF",
    "rgb": "227, 226, 223"
  },
  {
    "name": "Soft Dawn 140",
    "code": "NP OW 1140 N",
    "hex": "#F6F1E5",
    "rgb": "246, 241, 229"
  },
  {
    "name": "Cool Canvas 141",
    "code": "NP OW 1141 P",
    "hex": "#F5EBD2",
    "rgb": "245, 235, 210"
  },
  {
    "name": "Muted Shadow 142",
    "code": "NP OW 1142 T",
    "hex": "#E2DAC5",
    "rgb": "226, 218, 197"
  },
  {
    "name": "Classic Velvet 143",
    "code": "NP OW 1143 D",
    "hex": "#E8E5DD",
    "rgb": "232, 229, 221"
  },
  {
    "name": "Mystic Petal 144",
    "code": "NP OW 1144 A",
    "hex": "#FAF8F4",
    "rgb": "250, 248, 244"
  },
  {
    "name": "Silver Haven 145",
    "code": "NP OW 1145 N",
    "hex": "#EFE9DA",
    "rgb": "239, 233, 218"
  },
  {
    "name": "Satin Mist 146",
    "code": "NP OW 1146 P",
    "hex": "#E0D7BF",
    "rgb": "224, 215, 191"
  },
  {
    "name": "Pacific Elegance 147",
    "code": "NP OW 1147 T",
    "hex": "#EFE7D3",
    "rgb": "239, 231, 211"
  },
  {
    "name": "Saharan Cloud 148",
    "code": "NP OW 1148 D",
    "hex": "#F9F7EF",
    "rgb": "249, 247, 239"
  },
  {
    "name": "Coastal Serenity 149",
    "code": "NP OW 1149 A",
    "hex": "#E8E6E2",
    "rgb": "232, 230, 226"
  },
  {
    "name": "Soft Whisper 150",
    "code": "NP OW 1150 N",
    "hex": "#E2DCCC",
    "rgb": "226, 220, 204"
  },
  {
    "name": "Cool Harmony 151",
    "code": "NP OW 1151 P",
    "hex": "#F5EBD0",
    "rgb": "245, 235, 208"
  },
  {
    "name": "Muted Sand 152",
    "code": "NP OW 1152 T",
    "hex": "#F6EFDC",
    "rgb": "246, 239, 220"
  },
  {
    "name": "Classic Dusk 153",
    "code": "NP OW 1153 D",
    "hex": "#E3E1DC",
    "rgb": "227, 225, 220"
  },
  {
    "name": "Mystic Echo 154",
    "code": "NP OW 1154 A",
    "hex": "#E7E5DF",
    "rgb": "231, 229, 223"
  },
  {
    "name": "Silver Reflection 155",
    "code": "NP OW 1155 N",
    "hex": "#F9F2DD",
    "rgb": "249, 242, 221"
  },
  {
    "name": "Satin Silk 156",
    "code": "NP OW 1156 P",
    "hex": "#F0E7CD",
    "rgb": "240, 231, 205"
  },
  {
    "name": "Pacific Blossom 157",
    "code": "NP OW 1157 T",
    "hex": "#E1DBCC",
    "rgb": "225, 219, 204"
  },
  {
    "name": "Saharan Sanctuary 158",
    "code": "NP OW 1158 D",
    "hex": "#EDECE7",
    "rgb": "237, 236, 231"
  },
  {
    "name": "Coastal Glow 159",
    "code": "NP OW 1159 A",
    "hex": "#FAF7EE",
    "rgb": "250, 247, 238"
  },
  {
    "name": "Soft Symphony 160",
    "code": "NP OW 1160 N",
    "hex": "#EAE3CD",
    "rgb": "234, 227, 205"
  },
  {
    "name": "Cool Horizon 161",
    "code": "NP OW 1161 P",
    "hex": "#E1D9C1",
    "rgb": "225, 217, 193"
  },
  {
    "name": "Muted Tranquility 162",
    "code": "NP OW 1162 T",
    "hex": "#F3EFE0",
    "rgb": "243, 239, 224"
  },
  {
    "name": "Classic Breeze 163",
    "code": "NP OW 1163 D",
    "hex": "#F7F6F2",
    "rgb": "247, 246, 242"
  },
  {
    "name": "Mystic Aura 164",
    "code": "NP OW 1164 A",
    "hex": "#E4E1D7",
    "rgb": "228, 225, 215"
  },
  {
    "name": "Silver Feather 165",
    "code": "NP OW 1165 N",
    "hex": "#E5DEC6",
    "rgb": "229, 222, 198"
  },
  {
    "name": "Satin Twilight 166",
    "code": "NP OW 1166 P",
    "hex": "#F8F0D6",
    "rgb": "248, 240, 214"
  },
  {
    "name": "Pacific Tide 167",
    "code": "NP OW 1167 T",
    "hex": "#F2EFE3",
    "rgb": "242, 239, 227"
  },
  {
    "name": "Saharan Dream 168",
    "code": "NP OW 1168 D",
    "hex": "#E1E0DC",
    "rgb": "225, 224, 220"
  },
  {
    "name": "Coastal Stone 169",
    "code": "NP OW 1169 A",
    "hex": "#EBE7DA",
    "rgb": "235, 231, 218"
  },
  {
    "name": "Soft Dawn 170",
    "code": "NP OW 1170 N",
    "hex": "#FAF2D6",
    "rgb": "250, 242, 214"
  },
  {
    "name": "Cool Canvas 171",
    "code": "NP OW 1171 P",
    "hex": "#ECE5CD",
    "rgb": "236, 229, 205"
  },
  {
    "name": "Muted Shadow 172",
    "code": "NP OW 1172 T",
    "hex": "#E1DED5",
    "rgb": "225, 222, 213"
  },
  {
    "name": "Classic Velvet 173",
    "code": "NP OW 1173 D",
    "hex": "#F2F0EC",
    "rgb": "242, 240, 236"
  },
  {
    "name": "Mystic Petal 174",
    "code": "NP OW 1174 A",
    "hex": "#F8F4E3",
    "rgb": "248, 244, 227"
  },
  {
    "name": "Silver Haven 175",
    "code": "NP OW 1175 N",
    "hex": "#E6DEC4",
    "rgb": "230, 222, 196"
  },
  {
    "name": "Satin Mist 176",
    "code": "NP OW 1176 P",
    "hex": "#E4DEC9",
    "rgb": "228, 222, 201"
  },
  {
    "name": "Pacific Elegance 177",
    "code": "NP OW 1177 T",
    "hex": "#F7F5ED",
    "rgb": "247, 245, 237"
  },
  {
    "name": "Saharan Cloud 178",
    "code": "NP OW 1178 D",
    "hex": "#F4F2ED",
    "rgb": "244, 242, 237"
  },
  {
    "name": "Coastal Serenity 179",
    "code": "NP OW 1179 A",
    "hex": "#E2DDCB",
    "rgb": "226, 221, 203"
  },
  {
    "name": "Soft Whisper 180",
    "code": "NP OW 1180 N",
    "hex": "#E9E2C6",
    "rgb": "233, 226, 198"
  },
  {
    "name": "Cool Harmony 181",
    "code": "NP OW 1181 P",
    "hex": "#FAF4DF",
    "rgb": "250, 244, 223"
  },
  {
    "name": "Muted Sand 182",
    "code": "NP OW 1182 T",
    "hex": "#EEECE6",
    "rgb": "238, 236, 230"
  },
  {
    "name": "Classic Dusk 183",
    "code": "NP OW 1183 D",
    "hex": "#E0DFD8",
    "rgb": "224, 223, 216"
  },
  {
    "name": "Mystic Echo 184",
    "code": "NP OW 1184 A",
    "hex": "#F0EAD5",
    "rgb": "240, 234, 213"
  },
  {
    "name": "Silver Reflection 185",
    "code": "NP OW 1185 N",
    "hex": "#F9F1D4",
    "rgb": "249, 241, 212"
  },
  {
    "name": "Satin Silk 186",
    "code": "NP OW 1186 P",
    "hex": "#E7E3D2",
    "rgb": "231, 227, 210"
  },
  {
    "name": "Pacific Blossom 187",
    "code": "NP OW 1187 T",
    "hex": "#E3E1DD",
    "rgb": "227, 225, 221"
  },
  {
    "name": "Saharan Sanctuary 188",
    "code": "NP OW 1188 D",
    "hex": "#F6F3EA",
    "rgb": "246, 243, 234"
  },
  {
    "name": "Coastal Glow 189",
    "code": "NP OW 1189 A",
    "hex": "#F5EFD7",
    "rgb": "245, 239, 215"
  },
  {
    "name": "Soft Symphony 190",
    "code": "NP OW 1190 N",
    "hex": "#E3DCC2",
    "rgb": "227, 220, 194"
  },
  {
    "name": "Cool Horizon 191",
    "code": "NP OW 1191 P",
    "hex": "#E8E4D6",
    "rgb": "232, 228, 214"
  },
  {
    "name": "Muted Tranquility 192",
    "code": "NP OW 1192 T",
    "hex": "#F9F8F4",
    "rgb": "249, 248, 244"
  },
  {
    "name": "Classic Breeze 193",
    "code": "NP OW 1193 D",
    "hex": "#F0EDE2",
    "rgb": "240, 237, 226"
  },
  {
    "name": "Mystic Aura 194",
    "code": "NP OW 1194 A",
    "hex": "#E0DBC2",
    "rgb": "224, 219, 194"
  },
  {
    "name": "Silver Feather 195",
    "code": "NP OW 1195 N",
    "hex": "#EEE8CD",
    "rgb": "238, 232, 205"
  },
  {
    "name": "Satin Twilight 196",
    "code": "NP OW 1196 P",
    "hex": "#FAF7EA",
    "rgb": "250, 247, 234"
  },
  {
    "name": "Pacific Tide 197",
    "code": "NP OW 1197 T",
    "hex": "#E9E8E4",
    "rgb": "233, 232, 228"
  },
  {
    "name": "Saharan Dream 198",
    "code": "NP OW 1198 D",
    "hex": "#E2DFD2",
    "rgb": "226, 223, 210"
  },
  {
    "name": "Coastal Stone 199",
    "code": "NP OW 1199 A",
    "hex": "#F4EED1",
    "rgb": "244, 238, 209"
  },
  {
    "name": "Soft Dawn 200",
    "code": "NP OW 1200 N",
    "hex": "#F7F1D7",
    "rgb": "247, 241, 215"
  },
  {
    "name": "Cool Canvas 201",
    "code": "NP OW 1201 P",
    "hex": "#E4E2D8",
    "rgb": "228, 226, 216"
  },
  {
    "name": "Muted Shadow 202",
    "code": "NP OW 1202 T",
    "hex": "#E6E5E1",
    "rgb": "230, 229, 225"
  },
  {
    "name": "Classic Velvet 203",
    "code": "NP OW 1203 D",
    "hex": "#F8F5E3",
    "rgb": "248, 245, 227"
  },
  {
    "name": "Mystic Petal 204",
    "code": "NP OW 1204 A",
    "hex": "#F1EBCE",
    "rgb": "241, 235, 206"
  },
  {
    "name": "Silver Haven 205",
    "code": "NP OW 1205 N",
    "hex": "#E1DCC6",
    "rgb": "225, 220, 198"
  },
  {
    "name": "Satin Mist 206",
    "code": "NP OW 1206 P",
    "hex": "#ECEAE3",
    "rgb": "236, 234, 227"
  },
  {
    "name": "Pacific Elegance 207",
    "code": "NP OW 1207 T",
    "hex": "#FAF9F3",
    "rgb": "250, 249, 243"
  },
  {
    "name": "Saharan Cloud 208",
    "code": "NP OW 1208 D",
    "hex": "#EBE7D4",
    "rgb": "235, 231, 212"
  },
  {
    "name": "Coastal Serenity 209",
    "code": "NP OW 1209 A",
    "hex": "#E1DBBF",
    "rgb": "225, 219, 191"
  },
  {
    "name": "Soft Whisper 210",
    "code": "NP OW 1210 N",
    "hex": "#F2EED9",
    "rgb": "242, 238, 217"
  },
  {
    "name": "Cool Harmony 211",
    "code": "NP OW 1211 P",
    "hex": "#F8F7F0",
    "rgb": "248, 247, 240"
  },
  {
    "name": "Muted Sand 212",
    "code": "NP OW 1212 T",
    "hex": "#E5E4DD",
    "rgb": "229, 228, 221"
  },
  {
    "name": "Classic Dusk 213",
    "code": "NP OW 1213 D",
    "hex": "#E4E0CB",
    "rgb": "228, 224, 203"
  },
  {
    "name": "Mystic Echo 214",
    "code": "NP OW 1214 A",
    "hex": "#F7F2D3",
    "rgb": "247, 242, 211"
  },
  {
    "name": "Silver Reflection 215",
    "code": "NP OW 1215 N",
    "hex": "#F3F0DD",
    "rgb": "243, 240, 221"
  },
  {
    "name": "Satin Silk 216",
    "code": "NP OW 1216 P",
    "hex": "#E1E0DC",
    "rgb": "225, 224, 220"
  },
  {
    "name": "Pacific Blossom 217",
    "code": "NP OW 1217 T",
    "hex": "#EAE8DF",
    "rgb": "234, 232, 223"
  },
  {
    "name": "Saharan Sanctuary 218",
    "code": "NP OW 1218 D",
    "hex": "#FAF5DB",
    "rgb": "250, 245, 219"
  },
  {
    "name": "Coastal Glow 219",
    "code": "NP OW 1219 A",
    "hex": "#EDE8CA",
    "rgb": "237, 232, 202"
  },
  {
    "name": "Soft Symphony 220",
    "code": "NP OW 1220 N",
    "hex": "#E1DECF",
    "rgb": "225, 222, 207"
  },
  {
    "name": "Cool Horizon 221",
    "code": "NP OW 1221 P",
    "hex": "#F1F0EC",
    "rgb": "241, 240, 236"
  },
  {
    "name": "Muted Tranquility 222",
    "code": "NP OW 1222 T",
    "hex": "#F9F7EA",
    "rgb": "249, 247, 234"
  },
  {
    "name": "Classic Breeze 223",
    "code": "NP OW 1223 D",
    "hex": "#E7E2C8",
    "rgb": "231, 226, 200"
  },
  {
    "name": "Mystic Aura 224",
    "code": "NP OW 1224 A",
    "hex": "#E3DFC4",
    "rgb": "227, 223, 196"
  },
  {
    "name": "Silver Feather 225",
    "code": "NP OW 1225 N",
    "hex": "#F6F4E7",
    "rgb": "246, 244, 231"
  },
  {
    "name": "Satin Twilight 226",
    "code": "NP OW 1226 P",
    "hex": "#F5F4F0",
    "rgb": "245, 244, 240"
  },
  {
    "name": "Pacific Tide 227",
    "code": "NP OW 1227 T",
    "hex": "#E2E0D2",
    "rgb": "226, 224, 210"
  },
  {
    "name": "Saharan Dream 228",
    "code": "NP OW 1228 D",
    "hex": "#E8E4C7",
    "rgb": "232, 228, 199"
  },
  {
    "name": "Coastal Stone 229",
    "code": "NP OW 1229 A",
    "hex": "#F9F5D9",
    "rgb": "249, 245, 217"
  },
  {
    "name": "Soft Dawn 230",
    "code": "NP OW 1230 N",
    "hex": "#EFEDE3",
    "rgb": "239, 237, 227"
  },
  {
    "name": "Cool Canvas 231",
    "code": "NP OW 1231 P",
    "hex": "#E0E0DB",
    "rgb": "224, 224, 219"
  },
  {
    "name": "Muted Shadow 232",
    "code": "NP OW 1232 T",
    "hex": "#EFECDA",
    "rgb": "239, 236, 218"
  },
  {
    "name": "Classic Velvet 233",
    "code": "NP OW 1233 D",
    "hex": "#F9F5D5",
    "rgb": "249, 245, 213"
  },
  {
    "name": "Mystic Petal 234",
    "code": "NP OW 1234 A",
    "hex": "#E8E5CD",
    "rgb": "232, 229, 205"
  },
  {
    "name": "Silver Haven 235",
    "code": "NP OW 1235 N",
    "hex": "#E2E1D9",
    "rgb": "226, 225, 217"
  },
  {
    "name": "Satin Mist 236",
    "code": "NP OW 1236 P",
    "hex": "#F5F4EE",
    "rgb": "245, 244, 238"
  },
  {
    "name": "Pacific Elegance 237",
    "code": "NP OW 1237 T",
    "hex": "#F6F3DE",
    "rgb": "246, 243, 222"
  },
  {
    "name": "Saharan Cloud 238",
    "code": "NP OW 1238 D",
    "hex": "#E3DFC1",
    "rgb": "227, 223, 193"
  },
  {
    "name": "Coastal Serenity 239",
    "code": "NP OW 1239 A",
    "hex": "#E7E4CE",
    "rgb": "231, 228, 206"
  },
  {
    "name": "Soft Whisper 240",
    "code": "NP OW 1240 N",
    "hex": "#F9F8F1",
    "rgb": "249, 248, 241"
  },
  {
    "name": "Cool Harmony 241",
    "code": "NP OW 1241 P",
    "hex": "#F1F0E8",
    "rgb": "241, 240, 232"
  },
  {
    "name": "Muted Sand 242",
    "code": "NP OW 1242 T",
    "hex": "#E1DEC7",
    "rgb": "225, 222, 199"
  },
  {
    "name": "Classic Dusk 243",
    "code": "NP OW 1243 D",
    "hex": "#EDE9CA",
    "rgb": "237, 233, 202"
  },
  {
    "name": "Mystic Echo 244",
    "code": "NP OW 1244 A",
    "hex": "#FAF7E3",
    "rgb": "250, 247, 227"
  },
  {
    "name": "Silver Reflection 245",
    "code": "NP OW 1245 N",
    "hex": "#EAEAE4",
    "rgb": "234, 234, 228"
  },
  {
    "name": "Satin Silk 246",
    "code": "NP OW 1246 P",
    "hex": "#E1E0D7",
    "rgb": "225, 224, 215"
  },
  {
    "name": "Pacific Blossom 247",
    "code": "NP OW 1247 T",
    "hex": "#F3F0D5",
    "rgb": "243, 240, 213"
  },
  {
    "name": "Saharan Sanctuary 248",
    "code": "NP OW 1248 D",
    "hex": "#F7F4D4",
    "rgb": "247, 244, 212"
  },
  {
    "name": "Coastal Glow 249",
    "code": "NP OW 1249 A",
    "hex": "#E4E3D3",
    "rgb": "228, 227, 211"
  },
  {
    "name": "Soft Symphony 250",
    "code": "NP OW 1250 N",
    "hex": "#E5E5E0",
    "rgb": "229, 229, 224"
  },
  {
    "name": "Cool Harmony 1-1",
    "code": "NP YO 1001 P",
    "hex": "#D28B22",
    "rgb": "210, 139, 34"
  },
  {
    "name": "Muted Sand 2-1",
    "code": "NP YO 1002 T",
    "hex": "#B48237",
    "rgb": "180, 130, 55"
  },
  {
    "name": "Classic Dusk 3-1",
    "code": "NP YO 1003 D",
    "hex": "#E4C89F",
    "rgb": "228, 200, 159"
  },
  {
    "name": "Mystic Echo 4-1",
    "code": "NP YO 1004 A",
    "hex": "#F5DEBB",
    "rgb": "245, 222, 187"
  },
  {
    "name": "Silver Reflection 5-1",
    "code": "NP YO 1005 N",
    "hex": "#C1934E",
    "rgb": "193, 147, 78"
  },
  {
    "name": "Satin Silk 6",
    "code": "NP YO 1006 P",
    "hex": "#BD7D1C",
    "rgb": "189, 125, 28"
  },
  {
    "name": "Pacific Blossom 7-1",
    "code": "NP YO 1007 T",
    "hex": "#F2B65A",
    "rgb": "242, 182, 90"
  },
  {
    "name": "Saharan Sanctuary 8-1",
    "code": "NP YO 1008 D",
    "hex": "#E8D1AD",
    "rgb": "232, 209, 173"
  },
  {
    "name": "Coastal Glow 9-1",
    "code": "NP YO 1009 A",
    "hex": "#B5A283",
    "rgb": "181, 162, 131"
  },
  {
    "name": "Soft Symphony 10-1",
    "code": "NP YO 1010 N",
    "hex": "#CC9745",
    "rgb": "204, 151, 69"
  },
  {
    "name": "Cool Horizon 11-1",
    "code": "NP YO 1011 P",
    "hex": "#FAA726",
    "rgb": "250, 167, 38"
  },
  {
    "name": "Muted Tranquility 12-1",
    "code": "NP YO 1012 T",
    "hex": "#D7A85F",
    "rgb": "215, 168, 95"
  },
  {
    "name": "Classic Breeze 13-1",
    "code": "NP YO 1013 D",
    "hex": "#B3A38B",
    "rgb": "179, 163, 139"
  },
  {
    "name": "Mystic Aura 14-1",
    "code": "NP YO 1014 A",
    "hex": "#DFC296",
    "rgb": "223, 194, 150"
  },
  {
    "name": "Silver Feather 15-1",
    "code": "NP YO 1015 N",
    "hex": "#F8B245",
    "rgb": "248, 178, 69"
  },
  {
    "name": "Satin Twilight 16-1",
    "code": "NP YO 1016 P",
    "hex": "#C58622",
    "rgb": "197, 134, 34"
  },
  {
    "name": "Pacific Tide 17-1",
    "code": "NP YO 1017 T",
    "hex": "#B9965F",
    "rgb": "185, 150, 95"
  },
  {
    "name": "Saharan Dream 18-1",
    "code": "NP YO 1018 D",
    "hex": "#EFDCBE",
    "rgb": "239, 220, 190"
  },
  {
    "name": "Coastal Stone 19-1",
    "code": "NP YO 1019 A",
    "hex": "#EDCA91",
    "rgb": "237, 202, 145"
  },
  {
    "name": "Soft Dawn 20-1",
    "code": "NP YO 1020 N",
    "hex": "#B8812A",
    "rgb": "184, 129, 42"
  },
  {
    "name": "Cool Canvas 21-1",
    "code": "NP YO 1021 P",
    "hex": "#C78B29",
    "rgb": "199, 139, 41"
  },
  {
    "name": "Muted Shadow 22-1",
    "code": "NP YO 1022 T",
    "hex": "#F8D090",
    "rgb": "248, 208, 144"
  },
  {
    "name": "Classic Velvet 23-1",
    "code": "NP YO 1023 D",
    "hex": "#DCCBB0",
    "rgb": "220, 203, 176"
  },
  {
    "name": "Mystic Petal 24-1",
    "code": "NP YO 1024 A",
    "hex": "#B39461",
    "rgb": "179, 148, 97"
  },
  {
    "name": "Silver Haven 25-1",
    "code": "NP YO 1025 N",
    "hex": "#D99729",
    "rgb": "217, 151, 41"
  },
  {
    "name": "Satin Mist 26-1",
    "code": "NP YO 1026 P",
    "hex": "#F9B33F",
    "rgb": "249, 179, 63"
  },
  {
    "name": "Pacific Elegance 27-1",
    "code": "NP YO 1027 T",
    "hex": "#CAAF82",
    "rgb": "202, 175, 130"
  },
  {
    "name": "Saharan Cloud 28-1",
    "code": "NP YO 1028 D",
    "hex": "#B6A890",
    "rgb": "182, 168, 144"
  },
  {
    "name": "Coastal Serenity 29-1",
    "code": "NP YO 1029 A",
    "hex": "#EBBC6F",
    "rgb": "235, 188, 111"
  },
  {
    "name": "Soft Whisper 30-1",
    "code": "NP YO 1030 N",
    "hex": "#F1A527",
    "rgb": "241, 165, 39"
  },
  {
    "name": "Cool Harmony 31-1",
    "code": "NP YO 1031 P",
    "hex": "#BB8B3A",
    "rgb": "187, 139, 58"
  },
  {
    "name": "Muted Sand 32-1",
    "code": "NP YO 1032 T",
    "hex": "#C3AD88",
    "rgb": "195, 173, 136"
  },
  {
    "name": "Classic Dusk 33-1",
    "code": "NP YO 1033 D",
    "hex": "#F6E1BC",
    "rgb": "246, 225, 188"
  },
  {
    "name": "Mystic Echo 34-1",
    "code": "NP YO 1034 A",
    "hex": "#E1B05B",
    "rgb": "225, 176, 91"
  },
  {
    "name": "Silver Reflection 35-1",
    "code": "NP YO 1035 N",
    "hex": "#B37B1B",
    "rgb": "179, 123, 27"
  },
  {
    "name": "Satin Silk 36-1",
    "code": "NP YO 1036 P",
    "hex": "#D4A34F",
    "rgb": "212, 163, 79"
  },
  {
    "name": "Pacific Blossom 37-1",
    "code": "NP YO 1037 T",
    "hex": "#FAE2BA",
    "rgb": "250, 226, 186"
  },
  {
    "name": "Saharan Sanctuary 38-1",
    "code": "NP YO 1038 D",
    "hex": "#CFBA96",
    "rgb": "207, 186, 150"
  },
  {
    "name": "Coastal Glow 39-1",
    "code": "NP YO 1039 A",
    "hex": "#B4893D",
    "rgb": "180, 137, 61"
  },
  {
    "name": "Soft Symphony 40-1",
    "code": "NP YO 1040 N",
    "hex": "#E69F23",
    "rgb": "230, 159, 35"
  },
  {
    "name": "Cool Horizon 41-1",
    "code": "NP YO 1041 P",
    "hex": "#F4C26B",
    "rgb": "244, 194, 107"
  },
  {
    "name": "Muted Tranquility 42-1",
    "code": "NP YO 1042 T",
    "hex": "#BFAF94",
    "rgb": "191, 175, 148"
  },
  {
    "name": "Classic Breeze 43-1",
    "code": "NP YO 1043 D",
    "hex": "#BEA880",
    "rgb": "190, 168, 128"
  },
  {
    "name": "Mystic Aura 44-1",
    "code": "NP YO 1044 A",
    "hex": "#F4B444",
    "rgb": "244, 180, 68"
  },
  {
    "name": "Silver Feather 45-1",
    "code": "NP YO 1045 N",
    "hex": "#E6A228",
    "rgb": "230, 162, 40"
  },
  {
    "name": "Satin Twilight 46-1",
    "code": "NP YO 1046 P",
    "hex": "#B5955C",
    "rgb": "181, 149, 92"
  },
  {
    "name": "Pacific Tide 47-1",
    "code": "NP YO 1047 T",
    "hex": "#CFC0A5",
    "rgb": "207, 192, 165"
  },
  {
    "name": "Saharan Dream 48-1",
    "code": "NP YO 1048 D",
    "hex": "#FAD799",
    "rgb": "250, 215, 153"
  },
  {
    "name": "Coastal Stone 49-1",
    "code": "NP YO 1049 A",
    "hex": "#D49A30",
    "rgb": "212, 154, 48"
  },
  {
    "name": "Soft Dawn 50-1",
    "code": "NP YO 1050 N",
    "hex": "#B38025",
    "rgb": "179, 128, 37"
  },
  {
    "name": "Cool Canvas 51-1",
    "code": "NP YO 1051 P",
    "hex": "#E1BF82",
    "rgb": "225, 191, 130"
  },
  {
    "name": "Muted Shadow 52-1",
    "code": "NP YO 1052 T",
    "hex": "#F7E5C5",
    "rgb": "247, 229, 197"
  },
  {
    "name": "Classic Velvet 53-1",
    "code": "NP YO 1053 D",
    "hex": "#C3A46A",
    "rgb": "195, 164, 106"
  },
  {
    "name": "Mystic Petal 54-1",
    "code": "NP YO 1054 A",
    "hex": "#BB8523",
    "rgb": "187, 133, 35"
  },
  {
    "name": "Silver Haven 55-1",
    "code": "NP YO 1055 N",
    "hex": "#F0B13D",
    "rgb": "240, 177, 61"
  },
  {
    "name": "Satin Mist 56-1",
    "code": "NP YO 1056 P",
    "hex": "#EBCE97",
    "rgb": "235, 206, 151"
  },
  {
    "name": "Pacific Elegance 57-1",
    "code": "NP YO 1057 T",
    "hex": "#B7A990",
    "rgb": "183, 169, 144"
  },
  {
    "name": "Saharan Cloud 58-1",
    "code": "NP YO 1058 D",
    "hex": "#CAA560",
    "rgb": "202, 165, 96"
  },
  {
    "name": "Coastal Serenity 59-1",
    "code": "NP YO 1059 A",
    "hex": "#F9B028",
    "rgb": "249, 176, 40"
  },
  {
    "name": "Soft Whisper 60-1",
    "code": "NP YO 1060 N",
    "hex": "#DAA643",
    "rgb": "218, 166, 67"
  },
  {
    "name": "Cool Harmony 61-1",
    "code": "NP YO 1061 P",
    "hex": "#B3A07D",
    "rgb": "179, 160, 125"
  },
  {
    "name": "Muted Sand 62-1",
    "code": "NP YO 1062 T",
    "hex": "#DCCAA7",
    "rgb": "220, 202, 167"
  },
  {
    "name": "Classic Dusk 63-1",
    "code": "NP YO 1063 D",
    "hex": "#F8C665",
    "rgb": "248, 198, 101"
  },
  {
    "name": "Mystic Echo 64-1",
    "code": "NP YO 1064 A",
    "hex": "#C88E1E",
    "rgb": "200, 142, 30"
  },
  {
    "name": "Silver Reflection 65-1",
    "code": "NP YO 1065 N",
    "hex": "#B89044",
    "rgb": "184, 144, 68"
  },
  {
    "name": "Satin Silk 66-1",
    "code": "NP YO 1066 P",
    "hex": "#ECD8B0",
    "rgb": "236, 216, 176"
  },
  {
    "name": "Pacific Blossom 67-1",
    "code": "NP YO 1067 T",
    "hex": "#EFD8AD",
    "rgb": "239, 216, 173"
  },
  {
    "name": "Saharan Sanctuary 68-1",
    "code": "NP YO 1068 D",
    "hex": "#BA903F",
    "rgb": "186, 144, 63"
  },
  {
    "name": "Coastal Glow 69-1",
    "code": "NP YO 1069 A",
    "hex": "#C58C1E",
    "rgb": "197, 140, 30"
  },
  {
    "name": "Soft Symphony 70-1",
    "code": "NP YO 1070 N",
    "hex": "#F7C96D",
    "rgb": "247, 201, 109"
  },
  {
    "name": "Cool Horizon 71-1",
    "code": "NP YO 1071 P",
    "hex": "#DFCEAD",
    "rgb": "223, 206, 173"
  },
  {
    "name": "Muted Tranquility 72-1",
    "code": "NP YO 1072 T",
    "hex": "#B39F78",
    "rgb": "179, 159, 120"
  },
  {
    "name": "Classic Breeze 73-1",
    "code": "NP YO 1073 D",
    "hex": "#D6A33C",
    "rgb": "214, 163, 60"
  },
  {
    "name": "Mystic Aura 74-1",
    "code": "NP YO 1074 A",
    "hex": "#FAB52B",
    "rgb": "250, 181, 43"
  },
  {
    "name": "Silver Feather 75-1",
    "code": "NP YO 1075 N",
    "hex": "#CDAB69",
    "rgb": "205, 171, 105"
  },
  {
    "name": "Satin Twilight 76-1",
    "code": "NP YO 1076 P",
    "hex": "#B5A990",
    "rgb": "181, 169, 144"
  },
  {
    "name": "Pacific Tide 77-1",
    "code": "NP YO 1077 T",
    "hex": "#E8CA8E",
    "rgb": "232, 202, 142"
  },
  {
    "name": "Saharan Dream 78-1",
    "code": "NP YO 1078 D",
    "hex": "#F3B537",
    "rgb": "243, 181, 55"
  },
  {
    "name": "Coastal Stone 79-1",
    "code": "NP YO 1079 A",
    "hex": "#BD8C27",
    "rgb": "189, 140, 39"
  },
  {
    "name": "Soft Dawn 80-1",
    "code": "NP YO 1080 N",
    "hex": "#C0A66F",
    "rgb": "192, 166, 111"
  },
  {
    "name": "Cool Canvas 81",
    "code": "NP YO 1081 P",
    "hex": "#F5E5C4",
    "rgb": "245, 229, 196"
  },
  {
    "name": "Muted Shadow 82-1",
    "code": "NP YO 1082 T",
    "hex": "#E4C27C",
    "rgb": "228, 194, 124"
  },
  {
    "name": "Classic Velvet 83-1",
    "code": "NP YO 1083 D",
    "hex": "#B48422",
    "rgb": "180, 132, 34"
  },
  {
    "name": "Mystic Petal 84-1",
    "code": "NP YO 1084 A",
    "hex": "#D19E35",
    "rgb": "209, 158, 53"
  },
  {
    "name": "Silver Haven 85-1",
    "code": "NP YO 1085 N",
    "hex": "#FADDA1",
    "rgb": "250, 221, 161"
  },
  {
    "name": "Satin Mist 86",
    "code": "NP YO 1086 P",
    "hex": "#D2C4A6",
    "rgb": "210, 196, 166"
  },
  {
    "name": "Pacific Elegance 87-1",
    "code": "NP YO 1087 T",
    "hex": "#B49555",
    "rgb": "180, 149, 85"
  },
  {
    "name": "Saharan Cloud 88-1",
    "code": "NP YO 1088 D",
    "hex": "#E3A625",
    "rgb": "227, 166, 37"
  },
  {
    "name": "Coastal Serenity 89-1",
    "code": "NP YO 1089 A",
    "hex": "#F5BF4C",
    "rgb": "245, 191, 76"
  },
  {
    "name": "Soft Whisper 90-1",
    "code": "NP YO 1090 N",
    "hex": "#C1AF87",
    "rgb": "193, 175, 135"
  },
  {
    "name": "Cool Harmony 91-1",
    "code": "NP YO 1091 P",
    "hex": "#BCAE8F",
    "rgb": "188, 174, 143"
  },
  {
    "name": "Muted Sand 92-1",
    "code": "NP YO 1092 T",
    "hex": "#F2C462",
    "rgb": "242, 196, 98"
  },
  {
    "name": "Classic Dusk 93-1",
    "code": "NP YO 1093 D",
    "hex": "#E9AA23",
    "rgb": "233, 170, 35"
  },
  {
    "name": "Mystic Echo 94-1",
    "code": "NP YO 1094 A",
    "hex": "#B69244",
    "rgb": "182, 146, 68"
  },
  {
    "name": "Silver Reflection 95-1",
    "code": "NP YO 1095 N",
    "hex": "#CCBC98",
    "rgb": "204, 188, 152"
  },
  {
    "name": "Satin Silk 96-1",
    "code": "NP YO 1096 P",
    "hex": "#F9E4B4",
    "rgb": "249, 228, 180"
  },
  {
    "name": "Pacific Blossom 97-1",
    "code": "NP YO 1097 T",
    "hex": "#D7AB49",
    "rgb": "215, 171, 73"
  },
  {
    "name": "Saharan Sanctuary 98-1",
    "code": "NP YO 1098 D",
    "hex": "#B3831C",
    "rgb": "179, 131, 28"
  },
  {
    "name": "Coastal Glow 99-1",
    "code": "NP YO 1099 A",
    "hex": "#DEB762",
    "rgb": "222, 183, 98"
  },
  {
    "name": "Soft Symphony 100-1",
    "code": "NP YO 1100 N",
    "hex": "#F8E7C1",
    "rgb": "248, 231, 193"
  },
  {
    "name": "Cool Horizon 101-1",
    "code": "NP YO 1101 P",
    "hex": "#C6B185",
    "rgb": "198, 177, 133"
  },
  {
    "name": "Muted Tranquility 102-1",
    "code": "NP YO 1102 T",
    "hex": "#B99033",
    "rgb": "185, 144, 51"
  },
  {
    "name": "Classic Breeze 103-1",
    "code": "NP YO 1103 D",
    "hex": "#EEB229",
    "rgb": "238, 178, 41"
  },
  {
    "name": "Mystic Aura 104-1",
    "code": "NP YO 1104 A",
    "hex": "#EDCA79",
    "rgb": "237, 202, 121"
  },
  {
    "name": "Silver Feather 105-1",
    "code": "NP YO 1105 N",
    "hex": "#B8AD93",
    "rgb": "184, 173, 147"
  },
  {
    "name": "Satin Twilight 106-1",
    "code": "NP YO 1106 P",
    "hex": "#C7AF79",
    "rgb": "199, 175, 121"
  },
  {
    "name": "Pacific Tide 107-1",
    "code": "NP YO 1107 T",
    "hex": "#F8BE38",
    "rgb": "248, 190, 56"
  },
  {
    "name": "Saharan Dream 108-1",
    "code": "NP YO 1108 D",
    "hex": "#DDA82E",
    "rgb": "221, 168, 46"
  },
  {
    "name": "Coastal Stone 109-1",
    "code": "NP YO 1109 A",
    "hex": "#B39C68",
    "rgb": "179, 156, 104"
  },
  {
    "name": "Soft Dawn 110-1",
    "code": "NP YO 1110 N",
    "hex": "#D9CCAD",
    "rgb": "217, 204, 173"
  },
  {
    "name": "Cool Canvas 111-1",
    "code": "NP YO 1111 P",
    "hex": "#F9D787",
    "rgb": "249, 215, 135"
  },
  {
    "name": "Muted Shadow 112-1",
    "code": "NP YO 1112 T",
    "hex": "#CB9926",
    "rgb": "203, 153, 38"
  },
  {
    "name": "Classic Velvet 113-1",
    "code": "NP YO 1113 D",
    "hex": "#B68E2E",
    "rgb": "182, 142, 46"
  },
  {
    "name": "Mystic Petal 114-1",
    "code": "NP YO 1114 A",
    "hex": "#EAD197",
    "rgb": "234, 209, 151"
  },
  {
    "name": "Silver Haven 115-1",
    "code": "NP YO 1115 N",
    "hex": "#F1E2BE",
    "rgb": "241, 226, 190"
  },
  {
    "name": "Satin Mist 116-1",
    "code": "NP YO 1116 P",
    "hex": "#BB9E59",
    "rgb": "187, 158, 89"
  },
  {
    "name": "Pacific Elegance 117-1",
    "code": "NP YO 1117 T",
    "hex": "#C2921F",
    "rgb": "194, 146, 31"
  },
  {
    "name": "Saharan Cloud 118-1",
    "code": "NP YO 1118 D",
    "hex": "#F6C44C",
    "rgb": "246, 196, 76"
  },
  {
    "name": "Coastal Serenity 119-1",
    "code": "NP YO 1119 A",
    "hex": "#E2CE9E",
    "rgb": "226, 206, 158"
  },
  {
    "name": "Soft Whisper 120-1",
    "code": "NP YO 1120 N",
    "hex": "#B3A789",
    "rgb": "179, 167, 137"
  },
  {
    "name": "Cool Harmony 121-1",
    "code": "NP YO 1121 P",
    "hex": "#D4AF55",
    "rgb": "212, 175, 85"
  },
  {
    "name": "Muted Sand 122-1",
    "code": "NP YO 1122 T",
    "hex": "#FABC26",
    "rgb": "250, 188, 38"
  },
  {
    "name": "Classic Dusk 123-1",
    "code": "NP YO 1123 D",
    "hex": "#D0AA4D",
    "rgb": "208, 170, 77"
  },
  {
    "name": "Mystic Echo 124-1",
    "code": "NP YO 1124 A",
    "hex": "#B4A786",
    "rgb": "180, 167, 134"
  },
  {
    "name": "Silver Reflection 125-1",
    "code": "NP YO 1125 N",
    "hex": "#E5D3A6",
    "rgb": "229, 211, 166"
  },
  {
    "name": "Satin Silk 126-1",
    "code": "NP YO 1126 P",
    "hex": "#F4C652",
    "rgb": "244, 198, 82"
  },
  {
    "name": "Pacific Blossom 127-1",
    "code": "NP YO 1127 T",
    "hex": "#BF911E",
    "rgb": "191, 145, 30"
  },
  {
    "name": "Saharan Sanctuary 128-1",
    "code": "NP YO 1128 D",
    "hex": "#BEA054",
    "rgb": "190, 160, 84"
  },
  {
    "name": "Coastal Glow 129-1",
    "code": "NP YO 1129 A",
    "hex": "#F3E4BD",
    "rgb": "243, 228, 189"
  },
  {
    "name": "Soft Symphony 130-1",
    "code": "NP YO 1130 N",
    "hex": "#E7D19B",
    "rgb": "231, 209, 155"
  },
  {
    "name": "Cool Horizon 131-1",
    "code": "NP YO 1131 P",
    "hex": "#B59032",
    "rgb": "181, 144, 50"
  },
  {
    "name": "Muted Tranquility 132-1",
    "code": "NP YO 1132 T",
    "hex": "#CE9E24",
    "rgb": "206, 158, 36"
  },
  {
    "name": "Classic Breeze 133-1",
    "code": "NP YO 1133 D",
    "hex": "#FAD780",
    "rgb": "250, 215, 128"
  },
  {
    "name": "Mystic Aura 134-1",
    "code": "NP YO 1134 A",
    "hex": "#D5C9AA",
    "rgb": "213, 201, 170"
  },
  {
    "name": "Silver Feather 135-1",
    "code": "NP YO 1135 N",
    "hex": "#B3A06D",
    "rgb": "179, 160, 109"
  },
  {
    "name": "Satin Twilight 136-1",
    "code": "NP YO 1136 P",
    "hex": "#E1B033",
    "rgb": "225, 176, 51"
  },
  {
    "name": "Pacific Tide 137-1",
    "code": "NP YO 1137 T",
    "hex": "#F7C033",
    "rgb": "247, 192, 51"
  },
  {
    "name": "Saharan Dream 138-1",
    "code": "NP YO 1138 D",
    "hex": "#C3AD71",
    "rgb": "195, 173, 113"
  },
  {
    "name": "Coastal Stone 139-1",
    "code": "NP YO 1139 A",
    "hex": "#BAB095",
    "rgb": "186, 176, 149"
  },
  {
    "name": "Soft Dawn 140-1",
    "code": "NP YO 1140 N",
    "hex": "#F0D282",
    "rgb": "240, 210, 130"
  },
  {
    "name": "Cool Canvas 141-1",
    "code": "NP YO 1141 P",
    "hex": "#EBB72C",
    "rgb": "235, 183, 44"
  },
  {
    "name": "Muted Shadow 142-1",
    "code": "NP YO 1142 T",
    "hex": "#B7922E",
    "rgb": "183, 146, 46"
  },
  {
    "name": "Classic Velvet 143-1",
    "code": "NP YO 1143 D",
    "hex": "#C9B682",
    "rgb": "201, 182, 130"
  },
  {
    "name": "Mystic Petal 144-1",
    "code": "NP YO 1144 A",
    "hex": "#F9EBC4",
    "rgb": "249, 235, 196"
  },
  {
    "name": "Silver Haven 145-1",
    "code": "NP YO 1145 N",
    "hex": "#DABB67",
    "rgb": "218, 187, 103"
  },
  {
    "name": "Satin Mist 146-1",
    "code": "NP YO 1146 P",
    "hex": "#B38A1D",
    "rgb": "179, 138, 29"
  },
  {
    "name": "Pacific Elegance 147-1",
    "code": "NP YO 1147 T",
    "hex": "#DBB344",
    "rgb": "219, 179, 68"
  },
  {
    "name": "Saharan Cloud 148-1",
    "code": "NP YO 1148 D",
    "hex": "#F9E5AE",
    "rgb": "249, 229, 174"
  },
  {
    "name": "Coastal Serenity 149-1",
    "code": "NP YO 1149 A",
    "hex": "#C8BC98",
    "rgb": "200, 188, 152"
  },
  {
    "name": "Soft Whisper 150-1",
    "code": "NP YO 1150 N",
    "hex": "#B79A4A",
    "rgb": "183, 154, 74"
  },
  {
    "name": "Cool Harmony 151-1",
    "code": "NP YO 1151 P",
    "hex": "#ECB724",
    "rgb": "236, 183, 36"
  },
  {
    "name": "Muted Sand 152-1",
    "code": "NP YO 1152 T",
    "hex": "#EFC859",
    "rgb": "239, 200, 89"
  },
  {
    "name": "Classic Dusk 153-1",
    "code": "NP YO 1153 D",
    "hex": "#BAAD8A",
    "rgb": "186, 173, 138"
  },
  {
    "name": "Mystic Echo 154-1",
    "code": "NP YO 1154 A",
    "hex": "#C4B68E",
    "rgb": "196, 182, 142"
  },
  {
    "name": "Silver Reflection 155-1",
    "code": "NP YO 1155 N",
    "hex": "#F7CC53",
    "rgb": "247, 204, 83"
  },
  {
    "name": "Satin Silk 156-1",
    "code": "NP YO 1156 P",
    "hex": "#E0AE23",
    "rgb": "224, 174, 35"
  },
  {
    "name": "Pacific Blossom 157-1",
    "code": "NP YO 1157 T",
    "hex": "#B3994F",
    "rgb": "179, 153, 79"
  },
  {
    "name": "Saharan Sanctuary 158-1",
    "code": "NP YO 1158 D",
    "hex": "#D6CAA6",
    "rgb": "214, 202, 166"
  },
  {
    "name": "Coastal Glow 159-1",
    "code": "NP YO 1159 A",
    "hex": "#FAE4A7",
    "rgb": "250, 228, 167"
  },
  {
    "name": "Soft Symphony 160-1",
    "code": "NP YO 1160 N",
    "hex": "#CDA739",
    "rgb": "205, 167, 57"
  },
  {
    "name": "Cool Horizon 161-1",
    "code": "NP YO 1161 P",
    "hex": "#B58F1F",
    "rgb": "181, 143, 31"
  },
  {
    "name": "Muted Tranquility 162-1",
    "code": "NP YO 1162 T",
    "hex": "#E8CB77",
    "rgb": "232, 203, 119"
  },
  {
    "name": "Classic Breeze 163-1",
    "code": "NP YO 1163 D",
    "hex": "#F3E6C1",
    "rgb": "243, 230, 193"
  },
  {
    "name": "Mystic Aura 164-1",
    "code": "NP YO 1164 A",
    "hex": "#BDAB74",
    "rgb": "189, 171, 116"
  },
  {
    "name": "Silver Feather 165-1",
    "code": "NP YO 1165 N",
    "hex": "#C09B2B",
    "rgb": "192, 155, 43"
  },
  {
    "name": "Satin Twilight 166-1",
    "code": "NP YO 1166 P",
    "hex": "#F5C433",
    "rgb": "245, 196, 51"
  },
  {
    "name": "Pacific Tide 167-1",
    "code": "NP YO 1167 T",
    "hex": "#E5CD85",
    "rgb": "229, 205, 133"
  },
  {
    "name": "Saharan Dream 168-1",
    "code": "NP YO 1168 D",
    "hex": "#B4AB90",
    "rgb": "180, 171, 144"
  },
  {
    "name": "Coastal Stone 169-1",
    "code": "NP YO 1169 A",
    "hex": "#D1B971",
    "rgb": "209, 185, 113"
  },
  {
    "name": "Soft Dawn 170-1",
    "code": "NP YO 1170 N",
    "hex": "#FAC82F",
    "rgb": "250, 200, 47"
  },
  {
    "name": "Cool Canvas 171-1",
    "code": "NP YO 1171 P",
    "hex": "#D3AC35",
    "rgb": "211, 172, 53"
  },
  {
    "name": "Muted Shadow 172-1",
    "code": "NP YO 1172 T",
    "hex": "#B3A474",
    "rgb": "179, 164, 116"
  },
  {
    "name": "Classic Velvet 173-1",
    "code": "NP YO 1173 D",
    "hex": "#E3D7B3",
    "rgb": "227, 215, 179"
  },
  {
    "name": "Mystic Petal 174-1",
    "code": "NP YO 1174 A",
    "hex": "#F6D674",
    "rgb": "246, 214, 116"
  },
  {
    "name": "Silver Haven 175-1",
    "code": "NP YO 1175 N",
    "hex": "#C19A1F",
    "rgb": "193, 154, 31"
  },
  {
    "name": "Satin Mist 176-1",
    "code": "NP YO 1176 P",
    "hex": "#BC9D3A",
    "rgb": "188, 157, 58"
  },
  {
    "name": "Pacific Elegance 177-1",
    "code": "NP YO 1177 T",
    "hex": "#F2E0A9",
    "rgb": "242, 224, 169"
  },
  {
    "name": "Saharan Cloud 178-1",
    "code": "NP YO 1178 D",
    "hex": "#E9DCB2",
    "rgb": "233, 220, 178"
  },
  {
    "name": "Coastal Serenity 179-1",
    "code": "NP YO 1179 A",
    "hex": "#B69C49",
    "rgb": "182, 156, 73"
  },
  {
    "name": "Soft Whisper 180-1",
    "code": "NP YO 1180 N",
    "hex": "#CBA21F",
    "rgb": "203, 162, 31"
  },
  {
    "name": "Cool Harmony 181-1",
    "code": "NP YO 1181 P",
    "hex": "#F9D45D",
    "rgb": "249, 212, 93"
  },
  {
    "name": "Muted Sand 182-1",
    "code": "NP YO 1182 T",
    "hex": "#D8CBA1",
    "rgb": "216, 203, 161"
  },
  {
    "name": "Classic Dusk 183-1",
    "code": "NP YO 1183 D",
    "hex": "#B3A781",
    "rgb": "179, 167, 129"
  },
  {
    "name": "Mystic Echo 184-1",
    "code": "NP YO 1184 A",
    "hex": "#DEBB4B",
    "rgb": "222, 187, 75"
  },
  {
    "name": "Silver Reflection 185-1",
    "code": "NP YO 1185 N",
    "hex": "#F8C726",
    "rgb": "248, 199, 38"
  },
  {
    "name": "Satin Silk 186-1",
    "code": "NP YO 1186 P",
    "hex": "#C6AC57",
    "rgb": "198, 172, 87"
  },
  {
    "name": "Pacific Blossom 187-1",
    "code": "NP YO 1187 T",
    "hex": "#B9AF90",
    "rgb": "185, 175, 144"
  },
  {
    "name": "Saharan Sanctuary 188-1",
    "code": "NP YO 1188 D",
    "hex": "#EEDC9F",
    "rgb": "238, 220, 159"
  },
  {
    "name": "Coastal Glow 189-1",
    "code": "NP YO 1189 A",
    "hex": "#EEC642",
    "rgb": "238, 198, 66"
  },
  {
    "name": "Soft Symphony 190-1",
    "code": "NP YO 1190 N",
    "hex": "#B89520",
    "rgb": "184, 149, 32"
  },
  {
    "name": "Cool Horizon 191-1",
    "code": "NP YO 1191 P",
    "hex": "#C7B066",
    "rgb": "199, 176, 102"
  },
  {
    "name": "Muted Tranquility 192-1",
    "code": "NP YO 1192 T",
    "hex": "#F8EDC5",
    "rgb": "248, 237, 197"
  },
  {
    "name": "Classic Breeze 193-1",
    "code": "NP YO 1193 D",
    "hex": "#DDCA87",
    "rgb": "221, 202, 135"
  },
  {
    "name": "Mystic Aura 194-1",
    "code": "NP YO 1194 A",
    "hex": "#B39328",
    "rgb": "179, 147, 40"
  },
  {
    "name": "Silver Feather 195-1",
    "code": "NP YO 1195 N",
    "hex": "#D8B22D",
    "rgb": "216, 178, 45"
  },
  {
    "name": "Satin Twilight 196-1",
    "code": "NP YO 1196 P",
    "hex": "#F9E291",
    "rgb": "249, 226, 145"
  },
  {
    "name": "Pacific Tide 197-1",
    "code": "NP YO 1197 T",
    "hex": "#CBC2A2",
    "rgb": "203, 194, 162"
  },
  {
    "name": "Saharan Dream 198-1",
    "code": "NP YO 1198 D",
    "hex": "#B6A463",
    "rgb": "182, 164, 99"
  },
  {
    "name": "Coastal Stone 199-1",
    "code": "NP YO 1199 A",
    "hex": "#EAC02C",
    "rgb": "234, 192, 44"
  },
  {
    "name": "Soft Dawn 200-1",
    "code": "NP YO 1200 N",
    "hex": "#F1CA3D",
    "rgb": "241, 202, 61"
  },
  {
    "name": "Cool Canvas 201-1",
    "code": "NP YO 1201 P",
    "hex": "#BCAD79",
    "rgb": "188, 173, 121"
  },
  {
    "name": "Muted Shadow 202-1",
    "code": "NP YO 1202 T",
    "hex": "#C2B999",
    "rgb": "194, 185, 153"
  },
  {
    "name": "Classic Velvet 203-1",
    "code": "NP YO 1203 D",
    "hex": "#F6DA74",
    "rgb": "246, 218, 116"
  },
  {
    "name": "Mystic Petal 204-1",
    "code": "NP YO 1204 A",
    "hex": "#E2B925",
    "rgb": "226, 185, 37"
  },
  {
    "name": "Silver Haven 205-1",
    "code": "NP YO 1205 N",
    "hex": "#B39937",
    "rgb": "179, 153, 55"
  },
  {
    "name": "Satin Mist 206-1",
    "code": "NP YO 1206 P",
    "hex": "#D3C594",
    "rgb": "211, 197, 148"
  },
  {
    "name": "Pacific Elegance 207-1",
    "code": "NP YO 1207 T",
    "hex": "#FAEDBE",
    "rgb": "250, 237, 190"
  },
  {
    "name": "Saharan Cloud 208-1",
    "code": "NP YO 1208 D",
    "hex": "#D0B654",
    "rgb": "208, 182, 84"
  },
  {
    "name": "Coastal Serenity 209-1",
    "code": "NP YO 1209 A",
    "hex": "#B4941B",
    "rgb": "180, 148, 27"
  },
  {
    "name": "Soft Whisper 210-1",
    "code": "NP YO 1210 N",
    "hex": "#E5C755",
    "rgb": "229, 199, 85"
  },
  {
    "name": "Cool Harmony 211-1",
    "code": "NP YO 1211 P",
    "hex": "#F4E7B6",
    "rgb": "244, 231, 182"
  },
  {
    "name": "Muted Sand 212-1",
    "code": "NP YO 1212 T",
    "hex": "#C0B48A",
    "rgb": "192, 180, 138"
  },
  {
    "name": "Classic Dusk 213-1",
    "code": "NP YO 1213 D",
    "hex": "#BEA340",
    "rgb": "190, 163, 64"
  },
  {
    "name": "Mystic Echo 214-1",
    "code": "NP YO 1214 A",
    "hex": "#F3C826",
    "rgb": "243, 200, 38"
  },
  {
    "name": "Silver Reflection 215-1",
    "code": "NP YO 1215 N",
    "hex": "#E7CC66",
    "rgb": "231, 204, 102"
  },
  {
    "name": "Satin Silk 216-1",
    "code": "NP YO 1216 P",
    "hex": "#B5AD8D",
    "rgb": "181, 173, 141"
  },
  {
    "name": "Pacific Blossom 217-1",
    "code": "NP YO 1217 T",
    "hex": "#CEC08A",
    "rgb": "206, 192, 138"
  },
  {
    "name": "Saharan Sanctuary 218-1",
    "code": "NP YO 1218 D",
    "hex": "#FAD545",
    "rgb": "250, 213, 69"
  },
  {
    "name": "Coastal Glow 219-1",
    "code": "NP YO 1219 A",
    "hex": "#D5B225",
    "rgb": "213, 178, 37"
  },
  {
    "name": "Soft Symphony 220-1",
    "code": "NP YO 1220 N",
    "hex": "#B3A15C",
    "rgb": "179, 161, 92"
  },
  {
    "name": "Cool Horizon 221-1",
    "code": "NP YO 1221 P",
    "hex": "#E0D7B2",
    "rgb": "224, 215, 178"
  },
  {
    "name": "Muted Tranquility 222-1",
    "code": "NP YO 1222 T",
    "hex": "#F7E497",
    "rgb": "247, 228, 151"
  },
  {
    "name": "Classic Breeze 223-1",
    "code": "NP YO 1223 D",
    "hex": "#C4A62C",
    "rgb": "196, 166, 44"
  },
  {
    "name": "Mystic Aura 224-1",
    "code": "NP YO 1224 A",
    "hex": "#BA9D27",
    "rgb": "186, 157, 39"
  },
  {
    "name": "Silver Feather 225-1",
    "code": "NP YO 1225 N",
    "hex": "#F0DC8B",
    "rgb": "240, 220, 139"
  },
  {
    "name": "Satin Twilight 226-1",
    "code": "NP YO 1226 P",
    "hex": "#ECE2BC",
    "rgb": "236, 226, 188"
  },
  {
    "name": "Pacific Tide 227-1",
    "code": "NP YO 1227 T",
    "hex": "#B7A763",
    "rgb": "183, 167, 99"
  },
  {
    "name": "Saharan Dream 228-1",
    "code": "NP YO 1228 D",
    "hex": "#C9A925",
    "rgb": "201, 169, 37"
  },
  {
    "name": "Coastal Stone 229-1",
    "code": "NP YO 1229 A",
    "hex": "#F9D53F",
    "rgb": "249, 213, 63"
  },
  {
    "name": "Soft Dawn 230-1",
    "code": "NP YO 1230 N",
    "hex": "#DBCC8D",
    "rgb": "219, 204, 141"
  },
  {
    "name": "Cool Canvas 231-1",
    "code": "NP YO 1231 P",
    "hex": "#B3AB8D",
    "rgb": "179, 171, 141"
  },
  {
    "name": "Muted Shadow 232-1",
    "code": "NP YO 1232 T",
    "hex": "#DBC567",
    "rgb": "219, 197, 103"
  },
  {
    "name": "Classic Velvet 233-1",
    "code": "NP YO 1233 D",
    "hex": "#F9D128",
    "rgb": "249, 209, 40"
  },
  {
    "name": "Mystic Petal 234-1",
    "code": "NP YO 1234 A",
    "hex": "#C9AE3E",
    "rgb": "201, 174, 62"
  },
  {
    "name": "Silver Haven 235-1",
    "code": "NP YO 1235 N",
    "hex": "#B7AD80",
    "rgb": "183, 173, 128"
  },
  {
    "name": "Satin Mist 236-1",
    "code": "NP YO 1236 P",
    "hex": "#ECE1B3",
    "rgb": "236, 225, 179"
  },
  {
    "name": "Pacific Elegance 237-1",
    "code": "NP YO 1237 T",
    "hex": "#F0D561",
    "rgb": "240, 213, 97"
  },
  {
    "name": "Saharan Cloud 238-1",
    "code": "NP YO 1238 D",
    "hex": "#BA9D1C",
    "rgb": "186, 157, 28"
  },
  {
    "name": "Coastal Serenity 239-1",
    "code": "NP YO 1239 A",
    "hex": "#C4AD49",
    "rgb": "196, 173, 73"
  },
  {
    "name": "Soft Whisper 240-1",
    "code": "NP YO 1240 N",
    "hex": "#F7EBB8",
    "rgb": "247, 235, 184"
  },
  {
    "name": "Cool Harmony 241-1",
    "code": "NP YO 1241 P",
    "hex": "#E0D5A2",
    "rgb": "224, 213, 162"
  },
  {
    "name": "Muted Sand 242-1",
    "code": "NP YO 1242 T",
    "hex": "#B39D3C",
    "rgb": "179, 157, 60"
  },
  {
    "name": "Classic Dusk 243-1",
    "code": "NP YO 1243 D",
    "hex": "#D6B521",
    "rgb": "214, 181, 33"
  },
  {
    "name": "Mystic Echo 244-1",
    "code": "NP YO 1244 A",
    "hex": "#FAE16E",
    "rgb": "250, 225, 110"
  },
  {
    "name": "Silver Reflection 245-1",
    "code": "NP YO 1245 N",
    "hex": "#CEC6A0",
    "rgb": "206, 198, 160"
  },
  {
    "name": "Satin Silk 246-1",
    "code": "NP YO 1246 P",
    "hex": "#B5AA79",
    "rgb": "181, 170, 121"
  },
  {
    "name": "Pacific Blossom 247-1",
    "code": "NP YO 1247 T",
    "hex": "#E7C940",
    "rgb": "231, 201, 64"
  },
  {
    "name": "Saharan Sanctuary 248-1",
    "code": "NP YO 1248 D",
    "hex": "#F3D02A",
    "rgb": "243, 208, 42"
  },
  {
    "name": "Coastal Glow 249-1",
    "code": "NP YO 1249 A",
    "hex": "#BEAD61",
    "rgb": "190, 173, 97"
  },
  {
    "name": "Soft Symphony 250-1",
    "code": "NP YO 1250 N",
    "hex": "#C0B999",
    "rgb": "192, 185, 153"
  },
  {
    "name": "Cool Horizon 251",
    "code": "NP YO 1251 P",
    "hex": "#F5E495",
    "rgb": "245, 228, 149"
  },
  {
    "name": "Muted Tranquility 252",
    "code": "NP YO 1252 T",
    "hex": "#E5C634",
    "rgb": "229, 198, 52"
  },
  {
    "name": "Classic Breeze 253",
    "code": "NP YO 1253 D",
    "hex": "#B49B25",
    "rgb": "180, 155, 37"
  },
  {
    "name": "Mystic Aura 254",
    "code": "NP YO 1254 A",
    "hex": "#D0C179",
    "rgb": "208, 193, 121"
  },
  {
    "name": "Silver Feather 255",
    "code": "NP YO 1255 N",
    "hex": "#FAF1C8",
    "rgb": "250, 241, 200"
  },
  {
    "name": "Satin Twilight 256",
    "code": "NP YO 1256 P",
    "hex": "#D3C372",
    "rgb": "211, 195, 114"
  },
  {
    "name": "Pacific Tide 257",
    "code": "NP YO 1257 T",
    "hex": "#B39B21",
    "rgb": "179, 155, 33"
  },
  {
    "name": "Saharan Dream 258",
    "code": "NP YO 1258 D",
    "hex": "#E2C639",
    "rgb": "226, 198, 57"
  },
  {
    "name": "Coastal Stone 259",
    "code": "NP YO 1259 A",
    "hex": "#F6E79F",
    "rgb": "246, 231, 159"
  },
  {
    "name": "Soft Dawn 260",
    "code": "NP YO 1260 N",
    "hex": "#C2BB99",
    "rgb": "194, 187, 153"
  },
  {
    "name": "Cool Canvas 261",
    "code": "NP YO 1261 P",
    "hex": "#BCAB59",
    "rgb": "188, 171, 89"
  },
  {
    "name": "Muted Shadow 262",
    "code": "NP YO 1262 T",
    "hex": "#F1D027",
    "rgb": "241, 208, 39"
  },
  {
    "name": "Classic Velvet 263",
    "code": "NP YO 1263 D",
    "hex": "#EACF48",
    "rgb": "234, 207, 72"
  },
  {
    "name": "Mystic Petal 264",
    "code": "NP YO 1264 A",
    "hex": "#B6AD7F",
    "rgb": "182, 173, 127"
  },
  {
    "name": "Silver Haven 265",
    "code": "NP YO 1265 N",
    "hex": "#CBC39A",
    "rgb": "203, 195, 154"
  },
  {
    "name": "Satin Mist 266",
    "code": "NP YO 1266 P",
    "hex": "#F9E164",
    "rgb": "249, 225, 100"
  },
  {
    "name": "Pacific Elegance 267",
    "code": "NP YO 1267 T",
    "hex": "#D8BB21",
    "rgb": "216, 187, 33"
  },
  {
    "name": "Saharan Cloud 268",
    "code": "NP YO 1268 D",
    "hex": "#B3A143",
    "rgb": "179, 161, 67"
  },
  {
    "name": "Coastal Serenity 269",
    "code": "NP YO 1269 A",
    "hex": "#DDD4A5",
    "rgb": "221, 212, 165"
  },
  {
    "name": "Soft Whisper 270",
    "code": "NP YO 1270 N",
    "hex": "#F8EDB3",
    "rgb": "248, 237, 179"
  },
  {
    "name": "Cool Harmony 271",
    "code": "NP YO 1271 P",
    "hex": "#C6B243",
    "rgb": "198, 178, 67"
  },
  {
    "name": "Muted Sand 272",
    "code": "NP YO 1272 T",
    "hex": "#B8A01D",
    "rgb": "184, 160, 29"
  },
  {
    "name": "Classic Dusk 273",
    "code": "NP YO 1273 D",
    "hex": "#EED969",
    "rgb": "238, 217, 105"
  },
  {
    "name": "Mystic Echo 274",
    "code": "NP YO 1274 A",
    "hex": "#EEE6B9",
    "rgb": "238, 230, 185"
  },
  {
    "name": "Silver Reflection 275",
    "code": "NP YO 1275 N",
    "hex": "#B9AF7C",
    "rgb": "185, 175, 124"
  },
  {
    "name": "Satin Silk 276",
    "code": "NP YO 1276 P",
    "hex": "#C6B037",
    "rgb": "198, 176, 55"
  },
  {
    "name": "Pacific Blossom 277",
    "code": "NP YO 1277 T",
    "hex": "#F8D92B",
    "rgb": "248, 217, 43"
  },
  {
    "name": "Saharan Sanctuary 278",
    "code": "NP YO 1278 D",
    "hex": "#DECD72",
    "rgb": "222, 205, 114"
  },
  {
    "name": "Coastal Glow 279",
    "code": "NP YO 1279 A",
    "hex": "#B3AD8E",
    "rgb": "179, 173, 142"
  },
  {
    "name": "Soft Symphony 280",
    "code": "NP YO 1280 N",
    "hex": "#D8CB83",
    "rgb": "216, 203, 131"
  },
  {
    "name": "Cool Horizon 281",
    "code": "NP YO 1281 P",
    "hex": "#F9DD38",
    "rgb": "249, 221, 56"
  },
  {
    "name": "Muted Tranquility 282",
    "code": "NP YO 1282 T",
    "hex": "#CBB42A",
    "rgb": "203, 180, 42"
  },
  {
    "name": "Classic Breeze 283",
    "code": "NP YO 1283 D",
    "hex": "#B6AB6A",
    "rgb": "182, 171, 106"
  },
  {
    "name": "Mystic Aura 284",
    "code": "NP YO 1284 A",
    "hex": "#E9E3BB",
    "rgb": "233, 227, 187"
  },
  {
    "name": "Silver Feather 285",
    "code": "NP YO 1285 N",
    "hex": "#F2E283",
    "rgb": "242, 226, 131"
  },
  {
    "name": "Satin Twilight 286",
    "code": "NP YO 1286 P",
    "hex": "#BCA623",
    "rgb": "188, 166, 35"
  },
  {
    "name": "Pacific Tide 287",
    "code": "NP YO 1287 T",
    "hex": "#C2AD31",
    "rgb": "194, 173, 49"
  },
  {
    "name": "Saharan Dream 288",
    "code": "NP YO 1288 D",
    "hex": "#F6E99E",
    "rgb": "246, 233, 158"
  },
  {
    "name": "Coastal Stone 289",
    "code": "NP YO 1289 A",
    "hex": "#E3DCB3",
    "rgb": "227, 220, 179"
  },
  {
    "name": "Soft Dawn 290",
    "code": "NP YO 1290 N",
    "hex": "#B3A655",
    "rgb": "179, 166, 85"
  },
  {
    "name": "Cool Canvas 291",
    "code": "NP YO 1291 P",
    "hex": "#D3BA22",
    "rgb": "211, 186, 34"
  },
  {
    "name": "Muted Shadow 292",
    "code": "NP YO 1292 T",
    "hex": "#FAE24D",
    "rgb": "250, 226, 77"
  },
  {
    "name": "Classic Velvet 293",
    "code": "NP YO 1293 D",
    "hex": "#D1C892",
    "rgb": "209, 200, 146"
  },
  {
    "name": "Mystic Petal 294",
    "code": "NP YO 1294 A",
    "hex": "#B4AE89",
    "rgb": "180, 174, 137"
  },
  {
    "name": "Silver Haven 295",
    "code": "NP YO 1295 N",
    "hex": "#E5D25C",
    "rgb": "229, 210, 92"
  },
  {
    "name": "Satin Mist 296",
    "code": "NP YO 1296 P",
    "hex": "#F5D925",
    "rgb": "245, 217, 37"
  },
  {
    "name": "Pacific Elegance 297",
    "code": "NP YO 1297 T",
    "hex": "#C0B048",
    "rgb": "192, 176, 72"
  },
  {
    "name": "Saharan Cloud 298",
    "code": "NP YO 1298 D",
    "hex": "#BDB78D",
    "rgb": "189, 183, 141"
  },
  {
    "name": "Coastal Serenity 299",
    "code": "NP YO 1299 A",
    "hex": "#F3EAAF",
    "rgb": "243, 234, 175"
  },
  {
    "name": "Soft Whisper 300",
    "code": "NP YO 1300 N",
    "hex": "#E8D44E",
    "rgb": "232, 212, 78"
  },
  {
    "name": "Cool Harmony 301",
    "code": "NP YO 1301 P",
    "hex": "#B5A11C",
    "rgb": "181, 161, 28"
  },
  {
    "name": "Muted Sand 302",
    "code": "NP YO 1302 T",
    "hex": "#CDBF5B",
    "rgb": "205, 191, 91"
  },
  {
    "name": "Classic Dusk 303",
    "code": "NP YO 1303 D",
    "hex": "#FAF3C2",
    "rgb": "250, 243, 194"
  },
  {
    "name": "Mystic Echo 304",
    "code": "NP YO 1304 A",
    "hex": "#D6CD8F",
    "rgb": "214, 205, 143"
  },
  {
    "name": "Silver Reflection 305",
    "code": "NP YO 1305 N",
    "hex": "#B3A331",
    "rgb": "179, 163, 49"
  },
  {
    "name": "Satin Silk 306",
    "code": "NP YO 1306 P",
    "hex": "#E0C927",
    "rgb": "224, 201, 39"
  },
  {
    "name": "Pacific Blossom 307",
    "code": "NP YO 1307 T",
    "hex": "#F7E87F",
    "rgb": "247, 232, 127"
  },
  {
    "name": "Saharan Sanctuary 308",
    "code": "NP YO 1308 D",
    "hex": "#C4BF9C",
    "rgb": "196, 191, 156"
  },
  {
    "name": "Coastal Glow 309",
    "code": "NP YO 1309 A",
    "hex": "#BAB171",
    "rgb": "186, 177, 113"
  },
  {
    "name": "Soft Symphony 310",
    "code": "NP YO 1310 N",
    "hex": "#EFD936",
    "rgb": "239, 217, 54"
  },
  {
    "name": "Cool Horizon 311",
    "code": "NP YO 1311 P",
    "hex": "#ECD631",
    "rgb": "236, 214, 49"
  },
  {
    "name": "Muted Tranquility 312",
    "code": "NP YO 1312 T",
    "hex": "#B7AE6B",
    "rgb": "183, 174, 107"
  },
  {
    "name": "Classic Breeze 313",
    "code": "NP YO 1313 D",
    "hex": "#C8C4A0",
    "rgb": "200, 196, 160"
  },
  {
    "name": "Mystic Aura 314",
    "code": "NP YO 1314 A",
    "hex": "#F9EB87",
    "rgb": "249, 235, 135"
  },
  {
    "name": "Silver Feather 315",
    "code": "NP YO 1315 N",
    "hex": "#DBC629",
    "rgb": "219, 198, 41"
  },
  {
    "name": "Satin Twilight 316",
    "code": "NP YO 1316 P",
    "hex": "#B3A32D",
    "rgb": "179, 163, 45"
  },
  {
    "name": "Pacific Tide 317",
    "code": "NP YO 1317 T",
    "hex": "#DAD18D",
    "rgb": "218, 209, 141"
  },
  {
    "name": "Saharan Dream 318",
    "code": "NP YO 1318 D",
    "hex": "#F9F3C4",
    "rgb": "249, 243, 196"
  },
  {
    "name": "Coastal Stone 319",
    "code": "NP YO 1319 A",
    "hex": "#C9BD5F",
    "rgb": "201, 189, 95"
  },
  {
    "name": "Soft Dawn 320",
    "code": "NP YO 1320 N",
    "hex": "#B7A61D",
    "rgb": "183, 166, 29"
  },
  {
    "name": "Cool Canvas 321",
    "code": "NP YO 1321 P",
    "hex": "#EBD949",
    "rgb": "235, 217, 73"
  },
  {
    "name": "Muted Shadow 322",
    "code": "NP YO 1322 T",
    "hex": "#F0E8A8",
    "rgb": "240, 232, 168"
  },
  {
    "name": "Classic Velvet 323",
    "code": "NP YO 1323 D",
    "hex": "#BAB68E",
    "rgb": "186, 182, 142"
  },
  {
    "name": "Mystic Petal 324",
    "code": "NP YO 1324 A",
    "hex": "#C4B74F",
    "rgb": "196, 183, 79"
  },
  {
    "name": "Silver Haven 325",
    "code": "NP YO 1325 N",
    "hex": "#F7E025",
    "rgb": "247, 224, 37"
  },
  {
    "name": "Satin Mist 326",
    "code": "NP YO 1326 P",
    "hex": "#E0D154",
    "rgb": "224, 209, 84"
  },
  {
    "name": "Pacific Elegance 327",
    "code": "NP YO 1327 T",
    "hex": "#B3AE85",
    "rgb": "179, 174, 133"
  },
  {
    "name": "Saharan Cloud 328",
    "code": "NP YO 1328 D",
    "hex": "#D5CF9A",
    "rgb": "213, 207, 154"
  },
  {
    "name": "Coastal Serenity 329",
    "code": "NP YO 1329 A",
    "hex": "#FAE854",
    "rgb": "250, 232, 84"
  },
  {
    "name": "Soft Whisper 330",
    "code": "NP YO 1330 N",
    "hex": "#CEBC20",
    "rgb": "206, 188, 32"
  },
  {
    "name": "Cool Harmony 331",
    "code": "NP YO 1331 P",
    "hex": "#B5AA50",
    "rgb": "181, 170, 80"
  },
  {
    "name": "Muted Sand 332",
    "code": "NP YO 1332 T",
    "hex": "#E7E2B4",
    "rgb": "231, 226, 180"
  },
  {
    "name": "Classic Dusk 333",
    "code": "NP YO 1333 D",
    "hex": "#F3EBA3",
    "rgb": "243, 235, 163"
  },
  {
    "name": "Mystic Echo 334",
    "code": "NP YO 1334 A",
    "hex": "#BEB034",
    "rgb": "190, 176, 52"
  },
  {
    "name": "Silver Reflection 335",
    "code": "NP YO 1335 N",
    "hex": "#BFB021",
    "rgb": "191, 176, 33"
  },
  {
    "name": "Satin Silk 336",
    "code": "NP YO 1336 P",
    "hex": "#F4E97D",
    "rgb": "244, 233, 125"
  },
  {
    "name": "Pacific Blossom 337",
    "code": "NP YO 1337 T",
    "hex": "#E5E1B7",
    "rgb": "229, 225, 183"
  },
  {
    "name": "Saharan Sanctuary 338",
    "code": "NP YO 1338 D",
    "hex": "#B4AD6E",
    "rgb": "180, 173, 110"
  },
  {
    "name": "Coastal Glow 339",
    "code": "NP YO 1339 A",
    "hex": "#D0C02F",
    "rgb": "208, 192, 47"
  },
  {
    "name": "Soft Symphony 340",
    "code": "NP YO 1340 N",
    "hex": "#FAE734",
    "rgb": "250, 231, 52"
  },
  {
    "name": "Cool Horizon 341",
    "code": "NP YO 1341 P",
    "hex": "#D3CB7B",
    "rgb": "211, 203, 123"
  },
  {
    "name": "Muted Tranquility 342",
    "code": "NP YO 1342 T",
    "hex": "#B3B08F",
    "rgb": "179, 176, 143"
  },
  {
    "name": "Classic Breeze 343",
    "code": "NP YO 1343 D",
    "hex": "#E2D87A",
    "rgb": "226, 216, 122"
  },
  {
    "name": "Mystic Aura 344",
    "code": "NP YO 1344 A",
    "hex": "#F6E42E",
    "rgb": "246, 228, 46"
  },
  {
    "name": "Silver Feather 345",
    "code": "NP YO 1345 N",
    "hex": "#C2B531",
    "rgb": "194, 181, 49"
  },
  {
    "name": "Satin Twilight 346",
    "code": "NP YO 1346 P",
    "hex": "#BBB679",
    "rgb": "187, 182, 121"
  },
  {
    "name": "Pacific Tide 347",
    "code": "NP YO 1347 T",
    "hex": "#F1EDBE",
    "rgb": "241, 237, 190"
  },
  {
    "name": "Saharan Dream 348",
    "code": "NP YO 1348 D",
    "hex": "#EADF6E",
    "rgb": "234, 223, 110"
  },
  {
    "name": "Coastal Stone 349",
    "code": "NP YO 1349 A",
    "hex": "#B6A91D",
    "rgb": "182, 169, 29"
  },
  {
    "name": "Soft Dawn 350",
    "code": "NP YO 1350 N",
    "hex": "#CBBF3F",
    "rgb": "203, 191, 63"
  },
  {
    "name": "Cool Canvas 351",
    "code": "NP YO 1351 P",
    "hex": "#F9F3AF",
    "rgb": "249, 243, 175"
  },
  {
    "name": "Muted Shadow 352",
    "code": "NP YO 1352 T",
    "hex": "#D9D4A5",
    "rgb": "217, 212, 165"
  },
  {
    "name": "Classic Velvet 353",
    "code": "NP YO 1353 D",
    "hex": "#B3AA48",
    "rgb": "179, 170, 72"
  },
  {
    "name": "Mystic Petal 354",
    "code": "NP YO 1354 A",
    "hex": "#DDCD21",
    "rgb": "221, 205, 33"
  },
  {
    "name": "Silver Haven 355",
    "code": "NP YO 1355 N",
    "hex": "#F8EC5D",
    "rgb": "248, 236, 93"
  },
  {
    "name": "Satin Mist 356",
    "code": "NP YO 1356 P",
    "hex": "#C7C394",
    "rgb": "199, 195, 148"
  },
  {
    "name": "Pacific Elegance 357",
    "code": "NP YO 1357 T",
    "hex": "#B8B485",
    "rgb": "184, 180, 133"
  },
  {
    "name": "Saharan Cloud 358",
    "code": "NP YO 1358 D",
    "hex": "#EDE150",
    "rgb": "237, 225, 80"
  },
  {
    "name": "Coastal Serenity 359",
    "code": "NP YO 1359 A",
    "hex": "#EEDF25",
    "rgb": "238, 223, 37"
  },
  {
    "name": "Soft Whisper 360",
    "code": "NP YO 1360 N",
    "hex": "#B9B152",
    "rgb": "185, 177, 82"
  },
  {
    "name": "Cool Harmony 361",
    "code": "NP YO 1361 P",
    "hex": "#C6C29A",
    "rgb": "198, 194, 154"
  },
  {
    "name": "Muted Sand 362",
    "code": "NP YO 1362 T",
    "hex": "#F8F2A6",
    "rgb": "248, 242, 166"
  },
  {
    "name": "Classic Dusk 363",
    "code": "NP YO 1363 D",
    "hex": "#DED23D",
    "rgb": "222, 210, 61"
  },
  {
    "name": "Mystic Echo 364",
    "code": "NP YO 1364 A",
    "hex": "#B3A81F",
    "rgb": "179, 168, 31"
  },
  {
    "name": "Silver Reflection 365",
    "code": "NP YO 1365 N",
    "hex": "#D7D06F",
    "rgb": "215, 208, 111"
  },
  {
    "name": "Satin Silk 366",
    "code": "NP YO 1366 P",
    "hex": "#F9F6C7",
    "rgb": "249, 246, 199"
  },
  {
    "name": "Pacific Blossom 367",
    "code": "NP YO 1367 T",
    "hex": "#CCC67C",
    "rgb": "204, 198, 124"
  },
  {
    "name": "Saharan Sanctuary 368",
    "code": "NP YO 1368 D",
    "hex": "#B6AC29",
    "rgb": "182, 172, 41"
  },
  {
    "name": "Coastal Glow 369",
    "code": "NP YO 1369 A",
    "hex": "#E9DC30",
    "rgb": "233, 220, 48"
  },
  {
    "name": "Soft Symphony 370",
    "code": "NP YO 1370 N",
    "hex": "#F2EB8D",
    "rgb": "242, 235, 141"
  },
  {
    "name": "Cool Horizon 371",
    "code": "NP YO 1371 P",
    "hex": "#BCBA97",
    "rgb": "188, 186, 151"
  },
  {
    "name": "Muted Tranquility 372",
    "code": "NP YO 1372 T",
    "hex": "#C1BB69",
    "rgb": "193, 187, 105"
  },
  {
    "name": "Classic Breeze 373",
    "code": "NP YO 1373 D",
    "hex": "#F6E92E",
    "rgb": "246, 233, 46"
  },
  {
    "name": "Mystic Aura 374",
    "code": "NP YO 1374 A",
    "hex": "#E3D83A",
    "rgb": "227, 216, 58"
  },
  {
    "name": "Silver Feather 375",
    "code": "NP YO 1375 N",
    "hex": "#B4B074",
    "rgb": "180, 176, 116"
  },
  {
    "name": "Satin Twilight 376",
    "code": "NP YO 1376 P",
    "hex": "#D2CFA5",
    "rgb": "210, 207, 165"
  },
  {
    "name": "Pacific Tide 377",
    "code": "NP YO 1377 T",
    "hex": "#FAF276",
    "rgb": "250, 242, 118"
  },
  {
    "name": "Saharan Dream 378",
    "code": "NP YO 1378 D",
    "hex": "#D1C722",
    "rgb": "209, 199, 34"
  },
  {
    "name": "Coastal Stone 379",
    "code": "NP YO 1379 A",
    "hex": "#B4AD38",
    "rgb": "180, 173, 56"
  },
  {
    "name": "Soft Dawn 380",
    "code": "NP YO 1380 N",
    "hex": "#E4E0A0",
    "rgb": "228, 224, 160"
  },
  {
    "name": "Cool Canvas 381",
    "code": "NP YO 1381 P",
    "hex": "#F5F2BA",
    "rgb": "245, 242, 186"
  },
  {
    "name": "Muted Shadow 382",
    "code": "NP YO 1382 T",
    "hex": "#C0BA4D",
    "rgb": "192, 186, 77"
  },
  {
    "name": "Classic Velvet 383",
    "code": "NP YO 1383 D",
    "hex": "#BDB41C",
    "rgb": "189, 180, 28"
  },
  {
    "name": "Mystic Petal 384",
    "code": "NP YO 1384 A",
    "hex": "#F3EA5B",
    "rgb": "243, 234, 91"
  },
  {
    "name": "Silver Haven 385",
    "code": "NP YO 1385 N",
    "hex": "#E8E5AD",
    "rgb": "232, 229, 173"
  },
  {
    "name": "Satin Mist 386",
    "code": "NP YO 1386 P",
    "hex": "#B5B383",
    "rgb": "181, 179, 131"
  },
  {
    "name": "Pacific Elegance 387",
    "code": "NP YO 1387 T",
    "hex": "#CDC645",
    "rgb": "205, 198, 69"
  },
  {
    "name": "Saharan Cloud 388",
    "code": "NP YO 1388 D",
    "hex": "#FAEF27",
    "rgb": "250, 239, 39"
  },
  {
    "name": "Coastal Serenity 389",
    "code": "NP YO 1389 A",
    "hex": "#D6D05F",
    "rgb": "214, 208, 95"
  },
  {
    "name": "Soft Whisper 390",
    "code": "NP YO 1390 N",
    "hex": "#B3B18B",
    "rgb": "179, 177, 139"
  },
  {
    "name": "Cool Harmony 391",
    "code": "NP YO 1391 P",
    "hex": "#DFDC95",
    "rgb": "223, 220, 149"
  },
  {
    "name": "Muted Sand 392",
    "code": "NP YO 1392 T",
    "hex": "#F7EF44",
    "rgb": "247, 239, 68"
  },
  {
    "name": "Classic Dusk 393",
    "code": "NP YO 1393 D",
    "hex": "#C5BD22",
    "rgb": "197, 189, 34"
  },
  {
    "name": "Mystic Echo 394",
    "code": "NP YO 1394 A",
    "hex": "#BAB55F",
    "rgb": "186, 181, 95"
  },
  {
    "name": "Silver Reflection 395",
    "code": "NP YO 1395 N",
    "hex": "#EFEDBE",
    "rgb": "239, 237, 190"
  },
  {
    "name": "Satin Silk 396",
    "code": "NP YO 1396 P",
    "hex": "#ECE890",
    "rgb": "236, 232, 144"
  },
  {
    "name": "Pacific Blossom 397",
    "code": "NP YO 1397 T",
    "hex": "#B8B229",
    "rgb": "184, 178, 41"
  },
  {
    "name": "Saharan Sanctuary 398",
    "code": "NP YO 1398 D",
    "hex": "#C8C12A",
    "rgb": "200, 193, 42"
  },
  {
    "name": "Coastal Glow 399",
    "code": "NP YO 1399 A",
    "hex": "#F8F491",
    "rgb": "248, 244, 145"
  },
  {
    "name": "Soft Symphony 400",
    "code": "NP YO 1400 N",
    "hex": "#DCDAB0",
    "rgb": "220, 218, 176"
  },
  {
    "name": "Cool Harmony 1-2",
    "code": "NP N 1001 P",
    "hex": "#7B5651",
    "rgb": "123, 86, 81"
  },
  {
    "name": "Muted Sand 2-2",
    "code": "NP N 1002 T",
    "hex": "#362927",
    "rgb": "54, 41, 39"
  },
  {
    "name": "Classic Dusk 3-2",
    "code": "NP N 1003 D",
    "hex": "#A59A98",
    "rgb": "165, 154, 152"
  },
  {
    "name": "Mystic Echo 4-2",
    "code": "NP N 1004 A",
    "hex": "#CEC5C4",
    "rgb": "206, 197, 196"
  },
  {
    "name": "Silver Reflection 5-2",
    "code": "NP N 1005 N",
    "hex": "#544341",
    "rgb": "84, 67, 65"
  },
  {
    "name": "Satin Silk 6-1",
    "code": "NP N 1006 P",
    "hex": "#4B3431",
    "rgb": "75, 52, 49"
  },
  {
    "name": "Pacific Blossom 7-2",
    "code": "NP N 1007 T",
    "hex": "#C79D97",
    "rgb": "199, 157, 151"
  },
  {
    "name": "Saharan Sanctuary 8-2",
    "code": "NP N 1008 D",
    "hex": "#B0A7A6",
    "rgb": "176, 167, 166"
  },
  {
    "name": "Coastal Glow 9-2",
    "code": "NP N 1009 A",
    "hex": "#3A3636",
    "rgb": "58, 54, 54"
  },
  {
    "name": "Soft Symphony 10-2",
    "code": "NP N 1010 N",
    "hex": "#6F5653",
    "rgb": "111, 86, 83"
  },
  {
    "name": "Cool Horizon 11-2",
    "code": "NP N 1011 P",
    "hex": "#D8978D",
    "rgb": "216, 151, 141"
  },
  {
    "name": "Muted Tranquility 12-2",
    "code": "NP N 1012 T",
    "hex": "#886F6B",
    "rgb": "136, 111, 107"
  },
  {
    "name": "Classic Breeze 13-2",
    "code": "NP N 1013 D",
    "hex": "#333231",
    "rgb": "51, 50, 49"
  },
  {
    "name": "Mystic Aura 14-2",
    "code": "NP N 1014 A",
    "hex": "#998D8B",
    "rgb": "153, 141, 139"
  },
  {
    "name": "Silver Feather 15-2",
    "code": "NP N 1015 N",
    "hex": "#D39F97",
    "rgb": "211, 159, 151"
  },
  {
    "name": "Satin Twilight 16-2",
    "code": "NP N 1016 P",
    "hex": "#5E433E",
    "rgb": "94, 67, 62"
  },
  {
    "name": "Pacific Tide 17-2",
    "code": "NP N 1017 T",
    "hex": "#433937",
    "rgb": "67, 57, 55"
  },
  {
    "name": "Saharan Dream 18-2",
    "code": "NP N 1018 D",
    "hex": "#BFB9B9",
    "rgb": "191, 185, 185"
  },
  {
    "name": "Coastal Stone 19-2",
    "code": "NP N 1019 A",
    "hex": "#BAA7A4",
    "rgb": "186, 167, 164"
  },
  {
    "name": "Soft Dawn 20-2",
    "code": "NP N 1020 N",
    "hex": "#402F2C",
    "rgb": "64, 47, 44"
  },
  {
    "name": "Cool Canvas 21-2",
    "code": "NP N 1021 P",
    "hex": "#634843",
    "rgb": "99, 72, 67"
  },
  {
    "name": "Muted Shadow 22-2",
    "code": "NP N 1022 T",
    "hex": "#D5BCB7",
    "rgb": "213, 188, 183"
  },
  {
    "name": "Classic Velvet 23-2",
    "code": "NP N 1023 D",
    "hex": "#94908F",
    "rgb": "148, 144, 143"
  },
  {
    "name": "Mystic Petal 24-2",
    "code": "NP N 1024 A",
    "hex": "#332C2B",
    "rgb": "51, 44, 43"
  },
  {
    "name": "Silver Haven 25-2",
    "code": "NP N 1025 N",
    "hex": "#8D655E",
    "rgb": "141, 101, 94"
  },
  {
    "name": "Satin Mist 26-2",
    "code": "NP N 1026 P",
    "hex": "#D7A096",
    "rgb": "215, 160, 150"
  },
  {
    "name": "Pacific Elegance 27-2",
    "code": "NP N 1027 T",
    "hex": "#6A605E",
    "rgb": "106, 96, 94"
  },
  {
    "name": "Saharan Cloud 28-2",
    "code": "NP N 1028 D",
    "hex": "#3C3A3A",
    "rgb": "60, 58, 58"
  },
  {
    "name": "Coastal Serenity 29-2",
    "code": "NP N 1029 A",
    "hex": "#B59893",
    "rgb": "181, 152, 147"
  },
  {
    "name": "Soft Whisper 30-2",
    "code": "NP N 1030 N",
    "hex": "#C38A80",
    "rgb": "195, 138, 128"
  },
  {
    "name": "Cool Harmony 31-2",
    "code": "NP N 1031 P",
    "hex": "#473734",
    "rgb": "71, 55, 52"
  },
  {
    "name": "Muted Sand 32-2",
    "code": "NP N 1032 T",
    "hex": "#595352",
    "rgb": "89, 83, 82"
  },
  {
    "name": "Classic Dusk 33-2",
    "code": "NP N 1033 D",
    "hex": "#D1C8C6",
    "rgb": "209, 200, 198"
  },
  {
    "name": "Mystic Echo 34-2",
    "code": "NP N 1034 A",
    "hex": "#A0827C",
    "rgb": "160, 130, 124"
  },
  {
    "name": "Silver Reflection 35-2",
    "code": "NP N 1035 N",
    "hex": "#342522",
    "rgb": "52, 37, 34"
  },
  {
    "name": "Satin Silk 36-2",
    "code": "NP N 1036 P",
    "hex": "#816762",
    "rgb": "129, 103, 98"
  },
  {
    "name": "Pacific Blossom 37-2",
    "code": "NP N 1037 T",
    "hex": "#D9CECC",
    "rgb": "217, 206, 204"
  },
  {
    "name": "Saharan Sanctuary 38-2",
    "code": "NP N 1038 D",
    "hex": "#766F6E",
    "rgb": "118, 111, 110"
  },
  {
    "name": "Coastal Glow 39-2",
    "code": "NP N 1039 A",
    "hex": "#372B29",
    "rgb": "55, 43, 41"
  },
  {
    "name": "Soft Symphony 40-2",
    "code": "NP N 1040 N",
    "hex": "#AA796F",
    "rgb": "170, 121, 111"
  },
  {
    "name": "Cool Horizon 41-2",
    "code": "NP N 1041 P",
    "hex": "#CBA8A1",
    "rgb": "203, 168, 161"
  },
  {
    "name": "Muted Tranquility 42-2",
    "code": "NP N 1042 T",
    "hex": "#504D4C",
    "rgb": "80, 77, 76"
  },
  {
    "name": "Classic Breeze 43-2",
    "code": "NP N 1043 D",
    "hex": "#4F4947",
    "rgb": "79, 73, 71"
  },
  {
    "name": "Mystic Aura 44-2",
    "code": "NP N 1044 A",
    "hex": "#CA9A90",
    "rgb": "202, 154, 144"
  },
  {
    "name": "Silver Feather 45-2",
    "code": "NP N 1045 N",
    "hex": "#AB7B71",
    "rgb": "171, 123, 113"
  },
  {
    "name": "Satin Twilight 46-2",
    "code": "NP N 1046 P",
    "hex": "#38302E",
    "rgb": "56, 48, 46"
  },
  {
    "name": "Pacific Tide 47-2",
    "code": "NP N 1047 T",
    "hex": "#757171",
    "rgb": "117, 113, 113"
  },
  {
    "name": "Saharan Dream 48-2",
    "code": "NP N 1048 D",
    "hex": "#D8C2BE",
    "rgb": "216, 194, 190"
  },
  {
    "name": "Coastal Stone 49-2",
    "code": "NP N 1049 A",
    "hex": "#826059",
    "rgb": "130, 96, 89"
  },
  {
    "name": "Soft Dawn 50-2",
    "code": "NP N 1050 N",
    "hex": "#342623",
    "rgb": "52, 38, 35"
  },
  {
    "name": "Cool Canvas 51-2",
    "code": "NP N 1051 P",
    "hex": "#9F8D89",
    "rgb": "159, 141, 137"
  },
  {
    "name": "Muted Shadow 52-2",
    "code": "NP N 1052 T",
    "hex": "#D1CCCB",
    "rgb": "209, 204, 203"
  },
  {
    "name": "Classic Velvet 53-2",
    "code": "NP N 1053 D",
    "hex": "#5A4E4C",
    "rgb": "90, 78, 76"
  },
  {
    "name": "Mystic Petal 54-2",
    "code": "NP N 1054 A",
    "hex": "#46332F",
    "rgb": "70, 51, 47"
  },
  {
    "name": "Silver Haven 55-2",
    "code": "NP N 1055 N",
    "hex": "#C39388",
    "rgb": "195, 147, 136"
  },
  {
    "name": "Satin Mist 56-2",
    "code": "NP N 1056 P",
    "hex": "#B6A6A2",
    "rgb": "182, 166, 162"
  },
  {
    "name": "Pacific Elegance 57-2",
    "code": "NP N 1057 T",
    "hex": "#3D3B3B",
    "rgb": "61, 59, 59"
  },
  {
    "name": "Saharan Cloud 58-2",
    "code": "NP N 1058 D",
    "hex": "#695855",
    "rgb": "105, 88, 85"
  },
  {
    "name": "Coastal Serenity 59-2",
    "code": "NP N 1059 A",
    "hex": "#D79A8D",
    "rgb": "215, 154, 141"
  },
  {
    "name": "Soft Whisper 60-2",
    "code": "NP N 1060 N",
    "hex": "#8E6F68",
    "rgb": "142, 111, 104"
  },
  {
    "name": "Cool Harmony 61-2",
    "code": "NP N 1061 P",
    "hex": "#33302F",
    "rgb": "51, 48, 47"
  },
  {
    "name": "Muted Sand 62-2",
    "code": "NP N 1062 T",
    "hex": "#938D8C",
    "rgb": "147, 141, 140"
  },
  {
    "name": "Classic Dusk 63-2",
    "code": "NP N 1063 D",
    "hex": "#D5AEA5",
    "rgb": "213, 174, 165"
  },
  {
    "name": "Mystic Echo 64-2",
    "code": "NP N 1064 A",
    "hex": "#644841",
    "rgb": "100, 72, 65"
  },
  {
    "name": "Silver Reflection 65-2",
    "code": "NP N 1065 N",
    "hex": "#3F3330",
    "rgb": "63, 51, 48"
  },
  {
    "name": "Satin Silk 66-2",
    "code": "NP N 1066 P",
    "hex": "#BAB1AF",
    "rgb": "186, 177, 175"
  },
  {
    "name": "Pacific Blossom 67-2",
    "code": "NP N 1067 T",
    "hex": "#BFB5B2",
    "rgb": "191, 181, 178"
  },
  {
    "name": "Saharan Sanctuary 68-2",
    "code": "NP N 1068 D",
    "hex": "#433532",
    "rgb": "67, 53, 50"
  },
  {
    "name": "Coastal Glow 69-2",
    "code": "NP N 1069 A",
    "hex": "#5D433D",
    "rgb": "93, 67, 61"
  },
  {
    "name": "Soft Symphony 70-2",
    "code": "NP N 1070 N",
    "hex": "#D3B0A7",
    "rgb": "211, 176, 167"
  },
  {
    "name": "Cool Horizon 71-2",
    "code": "NP N 1071 P",
    "hex": "#9A9594",
    "rgb": "154, 149, 148"
  },
  {
    "name": "Muted Tranquility 72-2",
    "code": "NP N 1072 T",
    "hex": "#34302F",
    "rgb": "52, 48, 47"
  },
  {
    "name": "Classic Breeze 73-2",
    "code": "NP N 1073 D",
    "hex": "#866860",
    "rgb": "134, 104, 96"
  },
  {
    "name": "Mystic Aura 74-2",
    "code": "NP N 1074 A",
    "hex": "#D89D8F",
    "rgb": "216, 157, 143"
  },
  {
    "name": "Silver Feather 75-2",
    "code": "NP N 1075 N",
    "hex": "#70615D",
    "rgb": "112, 97, 93"
  },
  {
    "name": "Satin Twilight 76-2",
    "code": "NP N 1076 P",
    "hex": "#393838",
    "rgb": "57, 56, 56"
  },
  {
    "name": "Pacific Tide 77-2",
    "code": "NP N 1077 T",
    "hex": "#AF9E9A",
    "rgb": "175, 158, 154"
  },
  {
    "name": "Saharan Dream 78-2",
    "code": "NP N 1078 D",
    "hex": "#C89689",
    "rgb": "200, 150, 137"
  },
  {
    "name": "Coastal Stone 79-2",
    "code": "NP N 1079 A",
    "hex": "#4B3833",
    "rgb": "75, 56, 51"
  },
  {
    "name": "Soft Dawn 80-2",
    "code": "NP N 1080 N",
    "hex": "#534A48",
    "rgb": "83, 74, 72"
  },
  {
    "name": "Cool Canvas 81-1",
    "code": "NP N 1081 P",
    "hex": "#CDC8C7",
    "rgb": "205, 200, 199"
  },
  {
    "name": "Muted Shadow 82-2",
    "code": "NP N 1082 T",
    "hex": "#A6928C",
    "rgb": "166, 146, 140"
  },
  {
    "name": "Classic Velvet 83-2",
    "code": "NP N 1083 D",
    "hex": "#362824",
    "rgb": "54, 40, 36"
  },
  {
    "name": "Mystic Petal 84-2",
    "code": "NP N 1084 A",
    "hex": "#7A5D56",
    "rgb": "122, 93, 86"
  },
  {
    "name": "Silver Haven 85-2",
    "code": "NP N 1085 N",
    "hex": "#D9C6C2",
    "rgb": "217, 198, 194"
  },
  {
    "name": "Satin Mist 86-1",
    "code": "NP N 1086 P",
    "hex": "#7C7978",
    "rgb": "124, 121, 120"
  },
  {
    "name": "Pacific Elegance 87-2",
    "code": "NP N 1087 T",
    "hex": "#352D2B",
    "rgb": "53, 45, 43"
  },
  {
    "name": "Saharan Cloud 88-2",
    "code": "NP N 1088 D",
    "hex": "#A4786C",
    "rgb": "164, 120, 108"
  },
  {
    "name": "Coastal Serenity 89-2",
    "code": "NP N 1089 A",
    "hex": "#CEA296",
    "rgb": "206, 162, 150"
  },
  {
    "name": "Soft Whisper 90-2",
    "code": "NP N 1090 N",
    "hex": "#55504E",
    "rgb": "85, 80, 78"
  },
  {
    "name": "Cool Harmony 91-2",
    "code": "NP N 1091 P",
    "hex": "#4A4746",
    "rgb": "74, 71, 70"
  },
  {
    "name": "Muted Sand 92-2",
    "code": "NP N 1092 T",
    "hex": "#C6A49A",
    "rgb": "198, 164, 154"
  },
  {
    "name": "Classic Dusk 93-2",
    "code": "NP N 1093 D",
    "hex": "#B18173",
    "rgb": "177, 129, 115"
  },
  {
    "name": "Mystic Echo 94-2",
    "code": "NP N 1094 A",
    "hex": "#3A2F2C",
    "rgb": "58, 47, 44"
  },
  {
    "name": "Silver Reflection 95-2",
    "code": "NP N 1095 N",
    "hex": "#6E6968",
    "rgb": "110, 105, 104"
  },
  {
    "name": "Satin Silk 96-2",
    "code": "NP N 1096 P",
    "hex": "#D8CCC9",
    "rgb": "216, 204, 201"
  },
  {
    "name": "Pacific Blossom 97-2",
    "code": "NP N 1097 T",
    "hex": "#896D65",
    "rgb": "137, 109, 101"
  },
  {
    "name": "Saharan Sanctuary 98-2",
    "code": "NP N 1098 D",
    "hex": "#332622",
    "rgb": "51, 38, 34"
  },
  {
    "name": "Coastal Glow 99-2",
    "code": "NP N 1099 A",
    "hex": "#988079",
    "rgb": "152, 128, 121"
  },
  {
    "name": "Soft Symphony 100-2",
    "code": "NP N 1100 N",
    "hex": "#D4CDCB",
    "rgb": "212, 205, 203"
  },
  {
    "name": "Cool Horizon 101-2",
    "code": "NP N 1101 P",
    "hex": "#5F5856",
    "rgb": "95, 88, 86"
  },
  {
    "name": "Muted Tranquility 102-2",
    "code": "NP N 1102 T",
    "hex": "#42332F",
    "rgb": "66, 51, 47"
  },
  {
    "name": "Classic Breeze 103-2",
    "code": "NP N 1103 D",
    "hex": "#BE8C7E",
    "rgb": "190, 140, 126"
  },
  {
    "name": "Mystic Aura 104-2",
    "code": "NP N 1104 A",
    "hex": "#BBA39B",
    "rgb": "187, 163, 155"
  },
  {
    "name": "Silver Feather 105-2",
    "code": "NP N 1105 N",
    "hex": "#403F3E",
    "rgb": "64, 63, 62"
  },
  {
    "name": "Satin Twilight 106-2",
    "code": "NP N 1106 P",
    "hex": "#625956",
    "rgb": "98, 89, 86"
  },
  {
    "name": "Pacific Tide 107-2",
    "code": "NP N 1107 T",
    "hex": "#D5A292",
    "rgb": "213, 162, 146"
  },
  {
    "name": "Saharan Dream 108-2",
    "code": "NP N 1108 D",
    "hex": "#957065",
    "rgb": "149, 112, 101"
  },
  {
    "name": "Coastal Stone 109-2",
    "code": "NP N 1109 A",
    "hex": "#332E2C",
    "rgb": "51, 46, 44"
  },
  {
    "name": "Soft Dawn 110-2",
    "code": "NP N 1110 N",
    "hex": "#8C8988",
    "rgb": "140, 137, 136"
  },
  {
    "name": "Cool Canvas 111-2",
    "code": "NP N 1111 P",
    "hex": "#D7BEB5",
    "rgb": "215, 190, 181"
  },
  {
    "name": "Muted Shadow 112-2",
    "code": "NP N 1112 T",
    "hex": "#6B5047",
    "rgb": "107, 80, 71"
  },
  {
    "name": "Classic Velvet 113-2",
    "code": "NP N 1113 D",
    "hex": "#3C2E2A",
    "rgb": "60, 46, 42"
  },
  {
    "name": "Mystic Petal 114-2",
    "code": "NP N 1114 A",
    "hex": "#B4A6A1",
    "rgb": "180, 166, 161"
  },
  {
    "name": "Silver Haven 115-2",
    "code": "NP N 1115 N",
    "hex": "#C4BFBD",
    "rgb": "196, 191, 189"
  },
  {
    "name": "Satin Mist 116-2",
    "code": "NP N 1116 P",
    "hex": "#483D3A",
    "rgb": "72, 61, 58"
  },
  {
    "name": "Pacific Elegance 117-2",
    "code": "NP N 1117 T",
    "hex": "#584139",
    "rgb": "88, 65, 57"
  },
  {
    "name": "Saharan Cloud 118-2",
    "code": "NP N 1118 D",
    "hex": "#D0A597",
    "rgb": "208, 165, 151"
  },
  {
    "name": "Coastal Serenity 119-2",
    "code": "NP N 1119 A",
    "hex": "#A19794",
    "rgb": "161, 151, 148"
  },
  {
    "name": "Soft Whisper 120-2",
    "code": "NP N 1120 N",
    "hex": "#353332",
    "rgb": "53, 51, 50"
  },
  {
    "name": "Cool Harmony 121-2",
    "code": "NP N 1121 P",
    "hex": "#806A63",
    "rgb": "128, 106, 99"
  },
  {
    "name": "Muted Sand 122-2",
    "code": "NP N 1122 T",
    "hex": "#D9A08D",
    "rgb": "217, 160, 141"
  },
  {
    "name": "Classic Dusk 123-2",
    "code": "NP N 1123 D",
    "hex": "#77615A",
    "rgb": "119, 97, 90"
  },
  {
    "name": "Mystic Echo 124-2",
    "code": "NP N 1124 A",
    "hex": "#373534",
    "rgb": "55, 53, 52"
  },
  {
    "name": "Silver Reflection 125-2",
    "code": "NP N 1125 N",
    "hex": "#A9A19E",
    "rgb": "169, 161, 158"
  },
  {
    "name": "Satin Silk 126-2",
    "code": "NP N 1126 P",
    "hex": "#CCA597",
    "rgb": "204, 165, 151"
  },
  {
    "name": "Pacific Blossom 127-2",
    "code": "NP N 1127 T",
    "hex": "#503C34",
    "rgb": "80, 60, 52"
  },
  {
    "name": "Saharan Sanctuary 128-2",
    "code": "NP N 1128 D",
    "hex": "#4E423E",
    "rgb": "78, 66, 62"
  },
  {
    "name": "Coastal Glow 129-2",
    "code": "NP N 1129 A",
    "hex": "#CAC4C1",
    "rgb": "202, 196, 193"
  },
  {
    "name": "Soft Symphony 130-2",
    "code": "NP N 1130 N",
    "hex": "#ACA09C",
    "rgb": "172, 160, 156"
  },
  {
    "name": "Cool Horizon 131-2",
    "code": "NP N 1131 P",
    "hex": "#382C28",
    "rgb": "56, 44, 40"
  },
  {
    "name": "Muted Tranquility 132-2",
    "code": "NP N 1132 T",
    "hex": "#73574C",
    "rgb": "115, 87, 76"
  },
  {
    "name": "Classic Breeze 133-2",
    "code": "NP N 1133 D",
    "hex": "#D8BDB3",
    "rgb": "216, 189, 179"
  },
  {
    "name": "Mystic Aura 134-2",
    "code": "NP N 1134 A",
    "hex": "#83807F",
    "rgb": "131, 128, 127"
  },
  {
    "name": "Silver Feather 135-2",
    "code": "NP N 1135 N",
    "hex": "#342F2E",
    "rgb": "52, 47, 46"
  },
  {
    "name": "Satin Twilight 136-2",
    "code": "NP N 1136 P",
    "hex": "#9E7A6D",
    "rgb": "158, 122, 109"
  },
  {
    "name": "Pacific Tide 137-2",
    "code": "NP N 1137 T",
    "hex": "#D1A08E",
    "rgb": "209, 160, 142"
  },
  {
    "name": "Saharan Dream 138-2",
    "code": "NP N 1138 D",
    "hex": "#5A514E",
    "rgb": "90, 81, 78"
  },
  {
    "name": "Coastal Stone 139-2",
    "code": "NP N 1139 A",
    "hex": "#454443",
    "rgb": "69, 68, 67"
  },
  {
    "name": "Soft Dawn 140-2",
    "code": "NP N 1140 N",
    "hex": "#C2ACA4",
    "rgb": "194, 172, 164"
  },
  {
    "name": "Cool Canvas 141-2",
    "code": "NP N 1141 P",
    "hex": "#B78B7A",
    "rgb": "183, 139, 122"
  },
  {
    "name": "Muted Shadow 142-2",
    "code": "NP N 1142 T",
    "hex": "#3D302B",
    "rgb": "61, 48, 43"
  },
  {
    "name": "Classic Velvet 143-2",
    "code": "NP N 1143 D",
    "hex": "#68605D",
    "rgb": "104, 96, 93"
  },
  {
    "name": "Mystic Petal 144-2",
    "code": "NP N 1144 A",
    "hex": "#D6D1CF",
    "rgb": "214, 209, 207"
  },
  {
    "name": "Silver Haven 145-2",
    "code": "NP N 1145 N",
    "hex": "#8F7C74",
    "rgb": "143, 124, 116"
  },
  {
    "name": "Satin Mist 146-2",
    "code": "NP N 1146 P",
    "hex": "#332621",
    "rgb": "51, 38, 33"
  },
  {
    "name": "Pacific Elegance 147-2",
    "code": "NP N 1147 T",
    "hex": "#92756A",
    "rgb": "146, 117, 106"
  },
  {
    "name": "Saharan Cloud 148-2",
    "code": "NP N 1148 D",
    "hex": "#D6C9C5",
    "rgb": "214, 201, 197"
  },
  {
    "name": "Coastal Serenity 149-2",
    "code": "NP N 1149 A",
    "hex": "#656260",
    "rgb": "101, 98, 96"
  },
  {
    "name": "Soft Whisper 150-2",
    "code": "NP N 1150 N",
    "hex": "#3E3430",
    "rgb": "62, 52, 48"
  },
  {
    "name": "Cool Harmony 151-2",
    "code": "NP N 1151 P",
    "hex": "#B98A78",
    "rgb": "185, 138, 120"
  },
  {
    "name": "Muted Sand 152-2",
    "code": "NP N 1152 T",
    "hex": "#C09F92",
    "rgb": "192, 159, 146"
  },
  {
    "name": "Classic Dusk 153-2",
    "code": "NP N 1153 D",
    "hex": "#444140",
    "rgb": "68, 65, 64"
  },
  {
    "name": "Mystic Echo 154-2",
    "code": "NP N 1154 A",
    "hex": "#5C5856",
    "rgb": "92, 88, 86"
  },
  {
    "name": "Silver Reflection 155-2",
    "code": "NP N 1155 N",
    "hex": "#D2AC9C",
    "rgb": "210, 172, 156"
  },
  {
    "name": "Satin Silk 156-2",
    "code": "NP N 1156 P",
    "hex": "#9C7565",
    "rgb": "156, 117, 101"
  },
  {
    "name": "Pacific Blossom 157-2",
    "code": "NP N 1157 T",
    "hex": "#342C29",
    "rgb": "52, 44, 41"
  },
  {
    "name": "Saharan Sanctuary 158-2",
    "code": "NP N 1158 D",
    "hex": "#858180",
    "rgb": "133, 129, 128"
  },
  {
    "name": "Coastal Glow 159-2",
    "code": "NP N 1159 A",
    "hex": "#D8CAC4",
    "rgb": "216, 202, 196"
  },
  {
    "name": "Soft Symphony 160-2",
    "code": "NP N 1160 N",
    "hex": "#715A51",
    "rgb": "113, 90, 81"
  },
  {
    "name": "Cool Horizon 161-2",
    "code": "NP N 1161 P",
    "hex": "#392B26",
    "rgb": "57, 43, 38"
  },
  {
    "name": "Muted Tranquility 162-2",
    "code": "NP N 1162 T",
    "hex": "#AE9990",
    "rgb": "174, 153, 144"
  },
  {
    "name": "Classic Breeze 163-2",
    "code": "NP N 1163 D",
    "hex": "#C8C4C2",
    "rgb": "200, 196, 194"
  },
  {
    "name": "Mystic Aura 164-2",
    "code": "NP N 1164 A",
    "hex": "#4C4643",
    "rgb": "76, 70, 67"
  },
  {
    "name": "Silver Feather 165-2",
    "code": "NP N 1165 N",
    "hex": "#524039",
    "rgb": "82, 64, 57"
  },
  {
    "name": "Satin Twilight 166-2",
    "code": "NP N 1166 P",
    "hex": "#CD9F8B",
    "rgb": "205, 159, 139"
  },
  {
    "name": "Pacific Tide 167-2",
    "code": "NP N 1167 T",
    "hex": "#A79790",
    "rgb": "167, 151, 144"
  },
  {
    "name": "Saharan Dream 168-2",
    "code": "NP N 1168 D",
    "hex": "#363535",
    "rgb": "54, 53, 53"
  },
  {
    "name": "Coastal Stone 169-2",
    "code": "NP N 1169 A",
    "hex": "#796C66",
    "rgb": "121, 108, 102"
  },
  {
    "name": "Soft Dawn 170-2",
    "code": "NP N 1170 N",
    "hex": "#D9A791",
    "rgb": "217, 167, 145"
  },
  {
    "name": "Cool Canvas 171-2",
    "code": "NP N 1171 P",
    "hex": "#7D6358",
    "rgb": "125, 99, 88"
  },
  {
    "name": "Muted Shadow 172-2",
    "code": "NP N 1172 T",
    "hex": "#353130",
    "rgb": "53, 49, 48"
  },
  {
    "name": "Classic Velvet 173-2",
    "code": "NP N 1173 D",
    "hex": "#A39F9D",
    "rgb": "163, 159, 157"
  },
  {
    "name": "Mystic Petal 174-2",
    "code": "NP N 1174 A",
    "hex": "#CFB4A7",
    "rgb": "207, 180, 167"
  },
  {
    "name": "Silver Haven 175-2",
    "code": "NP N 1175 N",
    "hex": "#564138",
    "rgb": "86, 65, 56"
  },
  {
    "name": "Satin Mist 176-2",
    "code": "NP N 1176 P",
    "hex": "#493B35",
    "rgb": "73, 59, 53"
  },
  {
    "name": "Pacific Elegance 177-2",
    "code": "NP N 1177 T",
    "hex": "#C6BBB6",
    "rgb": "198, 187, 182"
  },
  {
    "name": "Saharan Cloud 178-2",
    "code": "NP N 1178 D",
    "hex": "#B2ACA9",
    "rgb": "178, 172, 169"
  },
  {
    "name": "Coastal Serenity 179-2",
    "code": "NP N 1179 A",
    "hex": "#3B322D",
    "rgb": "59, 50, 45"
  },
  {
    "name": "Soft Whisper 180-2",
    "code": "NP N 1180 N",
    "hex": "#6D5347",
    "rgb": "109, 83, 71"
  },
  {
    "name": "Cool Harmony 181-2",
    "code": "NP N 1181 P",
    "hex": "#D7B4A4",
    "rgb": "215, 180, 164"
  },
  {
    "name": "Muted Sand 182-2",
    "code": "NP N 1182 T",
    "hex": "#8A8482",
    "rgb": "138, 132, 130"
  },
  {
    "name": "Classic Dusk 183-2",
    "code": "NP N 1183 D",
    "hex": "#333130",
    "rgb": "51, 49, 48"
  },
  {
    "name": "Mystic Echo 184-2",
    "code": "NP N 1184 A",
    "hex": "#977D70",
    "rgb": "151, 125, 112"
  },
  {
    "name": "Silver Reflection 185-2",
    "code": "NP N 1185 N",
    "hex": "#D4A28A",
    "rgb": "212, 162, 138"
  },
  {
    "name": "Satin Silk 186-2",
    "code": "NP N 1186 P",
    "hex": "#60534C",
    "rgb": "96, 83, 76"
  },
  {
    "name": "Pacific Blossom 187-2",
    "code": "NP N 1187 T",
    "hex": "#41403F",
    "rgb": "65, 64, 63"
  },
  {
    "name": "Saharan Sanctuary 188-2",
    "code": "NP N 1188 D",
    "hex": "#BDB1AB",
    "rgb": "189, 177, 171"
  },
  {
    "name": "Coastal Glow 189-2",
    "code": "NP N 1189 A",
    "hex": "#BC9886",
    "rgb": "188, 152, 134"
  },
  {
    "name": "Soft Symphony 190-2",
    "code": "NP N 1190 N",
    "hex": "#41322B",
    "rgb": "65, 50, 43"
  },
  {
    "name": "Cool Horizon 191-2",
    "code": "NP N 1191 P",
    "hex": "#615651",
    "rgb": "97, 86, 81"
  },
  {
    "name": "Muted Tranquility 192-2",
    "code": "NP N 1192 T",
    "hex": "#D4D0CE",
    "rgb": "212, 208, 206"
  },
  {
    "name": "Classic Breeze 193-2",
    "code": "NP N 1193 D",
    "hex": "#968A83",
    "rgb": "150, 138, 131"
  },
  {
    "name": "Mystic Aura 194-2",
    "code": "NP N 1194 A",
    "hex": "#332823",
    "rgb": "51, 40, 35"
  },
  {
    "name": "Silver Feather 195-2",
    "code": "NP N 1195 N",
    "hex": "#8B6D5E",
    "rgb": "139, 109, 94"
  },
  {
    "name": "Satin Twilight 196-2",
    "code": "NP N 1196 P",
    "hex": "#D7C3BA",
    "rgb": "215, 195, 186"
  },
  {
    "name": "Pacific Tide 197-2",
    "code": "NP N 1197 T",
    "hex": "#6C6A69",
    "rgb": "108, 106, 105"
  },
  {
    "name": "Saharan Dream 198-2",
    "code": "NP N 1198 D",
    "hex": "#3B3532",
    "rgb": "59, 53, 50"
  },
  {
    "name": "Coastal Stone 199-2",
    "code": "NP N 1199 A",
    "hex": "#B38C78",
    "rgb": "179, 140, 120"
  },
  {
    "name": "Soft Dawn 200-2",
    "code": "NP N 1200 N",
    "hex": "#C59E8A",
    "rgb": "197, 158, 138"
  },
  {
    "name": "Cool Canvas 201-2",
    "code": "NP N 1201 P",
    "hex": "#484341",
    "rgb": "72, 67, 65"
  },
  {
    "name": "Muted Shadow 202-2",
    "code": "NP N 1202 T",
    "hex": "#575554",
    "rgb": "87, 85, 84"
  },
  {
    "name": "Classic Velvet 203-2",
    "code": "NP N 1203 D",
    "hex": "#D0B5A8",
    "rgb": "208, 181, 168"
  },
  {
    "name": "Mystic Petal 204-2",
    "code": "NP N 1204 A",
    "hex": "#A27D6A",
    "rgb": "162, 125, 106"
  },
  {
    "name": "Silver Haven 205-2",
    "code": "NP N 1205 N",
    "hex": "#352B27",
    "rgb": "53, 43, 39"
  },
  {
    "name": "Satin Mist 206-2",
    "code": "NP N 1206 P",
    "hex": "#7F7875",
    "rgb": "127, 120, 117"
  },
  {
    "name": "Pacific Elegance 207-2",
    "code": "NP N 1207 T",
    "hex": "#D9D2CE",
    "rgb": "217, 210, 206"
  },
  {
    "name": "Saharan Cloud 208-2",
    "code": "NP N 1208 D",
    "hex": "#78665D",
    "rgb": "120, 102, 93"
  },
  {
    "name": "Coastal Serenity 209-2",
    "code": "NP N 1209 A",
    "hex": "#372A24",
    "rgb": "55, 42, 36"
  },
  {
    "name": "Soft Whisper 210-2",
    "code": "NP N 1210 N",
    "hex": "#A88E80",
    "rgb": "168, 142, 128"
  },
  {
    "name": "Cool Harmony 211-2",
    "code": "NP N 1211 P",
    "hex": "#CCC5C1",
    "rgb": "204, 197, 193"
  },
  {
    "name": "Muted Sand 212-2",
    "code": "NP N 1212 T",
    "hex": "#514E4C",
    "rgb": "81, 78, 76"
  },
  {
    "name": "Classic Dusk 213-2",
    "code": "NP N 1213 D",
    "hex": "#4D4039",
    "rgb": "77, 64, 57"
  },
  {
    "name": "Mystic Echo 214-2",
    "code": "NP N 1214 A",
    "hex": "#C99C83",
    "rgb": "201, 156, 131"
  },
  {
    "name": "Silver Reflection 215-2",
    "code": "NP N 1215 N",
    "hex": "#AD968A",
    "rgb": "173, 150, 138"
  },
  {
    "name": "Satin Silk 216-2",
    "code": "NP N 1216 P",
    "hex": "#383736",
    "rgb": "56, 55, 54"
  },
  {
    "name": "Pacific Blossom 217-2",
    "code": "NP N 1217 T",
    "hex": "#726B68",
    "rgb": "114, 107, 104"
  },
  {
    "name": "Saharan Sanctuary 218-2",
    "code": "NP N 1218 D",
    "hex": "#D8B09A",
    "rgb": "216, 176, 154"
  },
  {
    "name": "Coastal Glow 219-2",
    "code": "NP N 1219 A",
    "hex": "#846757",
    "rgb": "132, 103, 87"
  },
  {
    "name": "Soft Symphony 220-2",
    "code": "NP N 1220 N",
    "hex": "#342E2B",
    "rgb": "52, 46, 43"
  },
  {
    "name": "Cool Horizon 221-2",
    "code": "NP N 1221 P",
    "hex": "#9D9A98",
    "rgb": "157, 154, 152"
  },
  {
    "name": "Muted Tranquility 222-2",
    "code": "NP N 1222 T",
    "hex": "#D2C1B8",
    "rgb": "210, 193, 184"
  },
  {
    "name": "Classic Breeze 223-2",
    "code": "NP N 1223 D",
    "hex": "#5B493F",
    "rgb": "91, 73, 63"
  },
  {
    "name": "Mystic Aura 224-2",
    "code": "NP N 1224 A",
    "hex": "#45372F",
    "rgb": "69, 55, 47"
  },
  {
    "name": "Silver Feather 225-2",
    "code": "NP N 1225 N",
    "hex": "#C1B0A6",
    "rgb": "193, 176, 166"
  },
  {
    "name": "Satin Twilight 226-2",
    "code": "NP N 1226 P",
    "hex": "#B8B4B2",
    "rgb": "184, 180, 178"
  },
  {
    "name": "Pacific Tide 227-2",
    "code": "NP N 1227 T",
    "hex": "#3E3834",
    "rgb": "62, 56, 52"
  },
  {
    "name": "Saharan Dream 228-2",
    "code": "NP N 1228 D",
    "hex": "#675145",
    "rgb": "103, 81, 69"
  },
  {
    "name": "Coastal Stone 229-2",
    "code": "NP N 1229 A",
    "hex": "#D6AE96",
    "rgb": "214, 174, 150"
  },
  {
    "name": "Soft Dawn 230-2",
    "code": "NP N 1230 N",
    "hex": "#908781",
    "rgb": "144, 135, 129"
  },
  {
    "name": "Cool Canvas 231-2",
    "code": "NP N 1231 P",
    "hex": "#333231",
    "rgb": "51, 50, 49"
  },
  {
    "name": "Muted Shadow 232-2",
    "code": "NP N 1232 T",
    "hex": "#917F75",
    "rgb": "145, 127, 117"
  },
  {
    "name": "Classic Velvet 233-2",
    "code": "NP N 1233 D",
    "hex": "#D6A88C",
    "rgb": "214, 168, 140"
  },
  {
    "name": "Mystic Petal 234-2",
    "code": "NP N 1234 A",
    "hex": "#66554B",
    "rgb": "102, 85, 75"
  },
  {
    "name": "Silver Haven 235-2",
    "code": "NP N 1235 N",
    "hex": "#3E3B39",
    "rgb": "62, 59, 57"
  },
  {
    "name": "Satin Mist 236-2",
    "code": "NP N 1236 P",
    "hex": "#B8B2AF",
    "rgb": "184, 178, 175"
  },
  {
    "name": "Pacific Elegance 237-2",
    "code": "NP N 1237 T",
    "hex": "#C1A695",
    "rgb": "193, 166, 149"
  },
  {
    "name": "Saharan Cloud 238-2",
    "code": "NP N 1238 D",
    "hex": "#45362D",
    "rgb": "69, 54, 45"
  },
  {
    "name": "Coastal Serenity 239-2",
    "code": "NP N 1239 A",
    "hex": "#5C4E46",
    "rgb": "92, 78, 70"
  },
  {
    "name": "Soft Whisper 240-2",
    "code": "NP N 1240 N",
    "hex": "#D2CBC6",
    "rgb": "210, 203, 198"
  },
  {
    "name": "Cool Harmony 241-2",
    "code": "NP N 1241 P",
    "hex": "#9D9692",
    "rgb": "157, 150, 146"
  },
  {
    "name": "Muted Sand 242-2",
    "code": "NP N 1242 T",
    "hex": "#342C27",
    "rgb": "52, 44, 39"
  },
  {
    "name": "Classic Dusk 243-2",
    "code": "NP N 1243 D",
    "hex": "#846856",
    "rgb": "132, 104, 86"
  },
  {
    "name": "Mystic Echo 244-2",
    "code": "NP N 1244 A",
    "hex": "#D8BDAC",
    "rgb": "216, 189, 172"
  },
  {
    "name": "Silver Reflection 245-2",
    "code": "NP N 1245 N",
    "hex": "#726F6E",
    "rgb": "114, 111, 110"
  },
  {
    "name": "Satin Silk 246-2",
    "code": "NP N 1246 P",
    "hex": "#393533",
    "rgb": "57, 53, 51"
  },
  {
    "name": "Pacific Blossom 247-2",
    "code": "NP N 1247 T",
    "hex": "#AD8F7C",
    "rgb": "173, 143, 124"
  },
  {
    "name": "Saharan Sanctuary 248-2",
    "code": "NP N 1248 D",
    "hex": "#C9A085",
    "rgb": "201, 160, 133"
  },
  {
    "name": "Coastal Glow 249-2",
    "code": "NP N 1249 A",
    "hex": "#4D4540",
    "rgb": "77, 69, 64"
  },
  {
    "name": "Soft Symphony 250-2",
    "code": "NP N 1250 N",
    "hex": "#51504F",
    "rgb": "81, 80, 79"
  },
  {
    "name": "Cool Horizon 251-1",
    "code": "NP N 1251 P",
    "hex": "#CCBDB3",
    "rgb": "204, 189, 179"
  },
  {
    "name": "Muted Tranquility 252-1",
    "code": "NP N 1252 T",
    "hex": "#A88874",
    "rgb": "168, 136, 116"
  },
  {
    "name": "Classic Breeze 253-1",
    "code": "NP N 1253 D",
    "hex": "#372C25",
    "rgb": "55, 44, 37"
  },
  {
    "name": "Mystic Aura 254-1",
    "code": "NP N 1254 A",
    "hex": "#786E67",
    "rgb": "120, 110, 103"
  },
  {
    "name": "Silver Feather 255-1",
    "code": "NP N 1255 N",
    "hex": "#D9D5D2",
    "rgb": "217, 213, 210"
  },
  {
    "name": "Satin Twilight 256-1",
    "code": "NP N 1256 P",
    "hex": "#7E736B",
    "rgb": "126, 115, 107"
  },
  {
    "name": "Pacific Tide 257-1",
    "code": "NP N 1257 T",
    "hex": "#352A23",
    "rgb": "53, 42, 35"
  },
  {
    "name": "Saharan Dream 258-1",
    "code": "NP N 1258 D",
    "hex": "#A28572",
    "rgb": "162, 133, 114"
  },
  {
    "name": "Coastal Stone 259-1",
    "code": "NP N 1259 A",
    "hex": "#CFC2B9",
    "rgb": "207, 194, 185"
  },
  {
    "name": "Soft Dawn 260-1",
    "code": "NP N 1260 N",
    "hex": "#575554",
    "rgb": "87, 85, 84"
  },
  {
    "name": "Cool Canvas 261-1",
    "code": "NP N 1261 P",
    "hex": "#48403B",
    "rgb": "72, 64, 59"
  },
  {
    "name": "Muted Shadow 262-1",
    "code": "NP N 1262 T",
    "hex": "#C59D81",
    "rgb": "197, 157, 129"
  },
  {
    "name": "Classic Velvet 263-1",
    "code": "NP N 1263 D",
    "hex": "#B39682",
    "rgb": "179, 150, 130"
  },
  {
    "name": "Mystic Petal 264-1",
    "code": "NP N 1264 A",
    "hex": "#3B3836",
    "rgb": "59, 56, 54"
  },
  {
    "name": "Silver Haven 265-1",
    "code": "NP N 1265 N",
    "hex": "#6C6967",
    "rgb": "108, 105, 103"
  },
  {
    "name": "Satin Mist 266-1",
    "code": "NP N 1266 P",
    "hex": "#D7BBA7",
    "rgb": "215, 187, 167"
  },
  {
    "name": "Pacific Elegance 267-1",
    "code": "NP N 1267 T",
    "hex": "#8B6E5A",
    "rgb": "139, 110, 90"
  },
  {
    "name": "Saharan Cloud 268-1",
    "code": "NP N 1268 D",
    "hex": "#332C27",
    "rgb": "51, 44, 39"
  },
  {
    "name": "Coastal Serenity 269-1",
    "code": "NP N 1269 A",
    "hex": "#96918E",
    "rgb": "150, 145, 142"
  },
  {
    "name": "Soft Whisper 270-1",
    "code": "NP N 1270 N",
    "hex": "#D4CCC6",
    "rgb": "212, 204, 198"
  },
  {
    "name": "Cool Harmony 271-1",
    "code": "NP N 1271 P",
    "hex": "#615348",
    "rgb": "97, 83, 72"
  },
  {
    "name": "Muted Sand 272-1",
    "code": "NP N 1272 T",
    "hex": "#41342A",
    "rgb": "65, 52, 42"
  },
  {
    "name": "Classic Dusk 273-1",
    "code": "NP N 1273 D",
    "hex": "#BCA695",
    "rgb": "188, 166, 149"
  },
  {
    "name": "Mystic Echo 274-1",
    "code": "NP N 1274 A",
    "hex": "#BDB8B5",
    "rgb": "189, 184, 181"
  },
  {
    "name": "Silver Reflection 275-1",
    "code": "NP N 1275 N",
    "hex": "#413E3B",
    "rgb": "65, 62, 59"
  },
  {
    "name": "Satin Silk 276-1",
    "code": "NP N 1276 P",
    "hex": "#605045",
    "rgb": "96, 80, 69"
  },
  {
    "name": "Pacific Blossom 277-1",
    "code": "NP N 1277 T",
    "hex": "#D4AB8C",
    "rgb": "212, 171, 140"
  },
  {
    "name": "Saharan Sanctuary 278-1",
    "code": "NP N 1278 D",
    "hex": "#97887D",
    "rgb": "151, 136, 125"
  },
  {
    "name": "Coastal Glow 279-1",
    "code": "NP N 1279 A",
    "hex": "#333232",
    "rgb": "51, 50, 50"
  },
  {
    "name": "Soft Symphony 280-1",
    "code": "NP N 1280 N",
    "hex": "#8A8079",
    "rgb": "138, 128, 121"
  },
  {
    "name": "Cool Horizon 281-1",
    "code": "NP N 1281 P",
    "hex": "#D7B194",
    "rgb": "215, 177, 148"
  },
  {
    "name": "Muted Tranquility 282-1",
    "code": "NP N 1282 T",
    "hex": "#6D594A",
    "rgb": "109, 89, 74"
  },
  {
    "name": "Classic Breeze 283-1",
    "code": "NP N 1283 D",
    "hex": "#3B3633",
    "rgb": "59, 54, 51"
  },
  {
    "name": "Mystic Aura 284-1",
    "code": "NP N 1284 A",
    "hex": "#B2AFAD",
    "rgb": "178, 175, 173"
  },
  {
    "name": "Silver Feather 285-1",
    "code": "NP N 1285 N",
    "hex": "#C6B4A7",
    "rgb": "198, 180, 167"
  },
  {
    "name": "Satin Twilight 286-1",
    "code": "NP N 1286 P",
    "hex": "#493B31",
    "rgb": "73, 59, 49"
  },
  {
    "name": "Pacific Tide 287-1",
    "code": "NP N 1287 T",
    "hex": "#56473C",
    "rgb": "86, 71, 60"
  },
  {
    "name": "Saharan Dream 288-1",
    "code": "NP N 1288 D",
    "hex": "#CFC3B9",
    "rgb": "207, 195, 185"
  },
  {
    "name": "Coastal Stone 289-1",
    "code": "NP N 1289 A",
    "hex": "#A3A09D",
    "rgb": "163, 160, 157"
  },
  {
    "name": "Soft Dawn 290-1",
    "code": "NP N 1290 N",
    "hex": "#352F2B",
    "rgb": "53, 47, 43"
  },
  {
    "name": "Cool Canvas 291-1",
    "code": "NP N 1291 P",
    "hex": "#7E6552",
    "rgb": "126, 101, 82"
  },
  {
    "name": "Muted Shadow 292-1",
    "code": "NP N 1292 T",
    "hex": "#D9B89E",
    "rgb": "217, 184, 158"
  },
  {
    "name": "Classic Velvet 293-1",
    "code": "NP N 1293 D",
    "hex": "#79746F",
    "rgb": "121, 116, 111"
  },
  {
    "name": "Mystic Petal 294-1",
    "code": "NP N 1294 A",
    "hex": "#363534",
    "rgb": "54, 53, 52"
  },
  {
    "name": "Silver Haven 295-1",
    "code": "NP N 1295 N",
    "hex": "#A79282",
    "rgb": "167, 146, 130"
  },
  {
    "name": "Satin Mist 296-1",
    "code": "NP N 1296 P",
    "hex": "#CDA585",
    "rgb": "205, 165, 133"
  },
  {
    "name": "Pacific Elegance 297-1",
    "code": "NP N 1297 T",
    "hex": "#52473E",
    "rgb": "82, 71, 62"
  },
  {
    "name": "Saharan Cloud 298-1",
    "code": "NP N 1298 D",
    "hex": "#4C4A48",
    "rgb": "76, 74, 72"
  },
  {
    "name": "Coastal Serenity 299-1",
    "code": "NP N 1299 A",
    "hex": "#C8C1BB",
    "rgb": "200, 193, 187"
  },
  {
    "name": "Soft Whisper 300-1",
    "code": "NP N 1300 N",
    "hex": "#AE9581",
    "rgb": "174, 149, 129"
  },
  {
    "name": "Cool Harmony 301-1",
    "code": "NP N 1301 P",
    "hex": "#392E25",
    "rgb": "57, 46, 37"
  },
  {
    "name": "Muted Sand 302-1",
    "code": "NP N 1302 T",
    "hex": "#71645A",
    "rgb": "113, 100, 90"
  },
  {
    "name": "Classic Dusk 303-1",
    "code": "NP N 1303 D",
    "hex": "#D8D3CF",
    "rgb": "216, 211, 207"
  },
  {
    "name": "Mystic Echo 304-1",
    "code": "NP N 1304 A",
    "hex": "#857E79",
    "rgb": "133, 126, 121"
  },
  {
    "name": "Silver Reflection 305-1",
    "code": "NP N 1305 N",
    "hex": "#342C25",
    "rgb": "52, 44, 37"
  },
  {
    "name": "Satin Silk 306-1",
    "code": "NP N 1306 P",
    "hex": "#9C7F67",
    "rgb": "156, 127, 103"
  },
  {
    "name": "Pacific Blossom 307-1",
    "code": "NP N 1307 T",
    "hex": "#D2BFAE",
    "rgb": "210, 191, 174"
  },
  {
    "name": "Saharan Sanctuary 308-1",
    "code": "NP N 1308 D",
    "hex": "#5C5B59",
    "rgb": "92, 91, 89"
  },
  {
    "name": "Coastal Glow 309-1",
    "code": "NP N 1309 A",
    "hex": "#44403C",
    "rgb": "68, 64, 60"
  },
  {
    "name": "Soft Symphony 310-1",
    "code": "NP N 1310 N",
    "hex": "#C0A084",
    "rgb": "192, 160, 132"
  },
  {
    "name": "Cool Horizon 311-1",
    "code": "NP N 1311 P",
    "hex": "#B9987D",
    "rgb": "185, 152, 125"
  },
  {
    "name": "Muted Tranquility 312-1",
    "code": "NP N 1312 T",
    "hex": "#3E3A36",
    "rgb": "62, 58, 54"
  },
  {
    "name": "Classic Breeze 313-1",
    "code": "NP N 1313 D",
    "hex": "#666463",
    "rgb": "102, 100, 99"
  },
  {
    "name": "Mystic Aura 314-1",
    "code": "NP N 1314 A",
    "hex": "#D6C4B4",
    "rgb": "214, 196, 180"
  },
  {
    "name": "Silver Feather 315-1",
    "code": "NP N 1315 N",
    "hex": "#927861",
    "rgb": "146, 120, 97"
  },
  {
    "name": "Satin Twilight 316-1",
    "code": "NP N 1316 P",
    "hex": "#332B24",
    "rgb": "51, 43, 36"
  },
  {
    "name": "Pacific Tide 317-1",
    "code": "NP N 1317 T",
    "hex": "#908780",
    "rgb": "144, 135, 128"
  },
  {
    "name": "Saharan Dream 318-1",
    "code": "NP N 1318 D",
    "hex": "#D6D2CE",
    "rgb": "214, 210, 206"
  },
  {
    "name": "Coastal Stone 319-1",
    "code": "NP N 1319 A",
    "hex": "#675D54",
    "rgb": "103, 93, 84"
  },
  {
    "name": "Soft Dawn 320-1",
    "code": "NP N 1320 N",
    "hex": "#3D3228",
    "rgb": "61, 50, 40"
  },
  {
    "name": "Cool Canvas 321-1",
    "code": "NP N 1321 P",
    "hex": "#B79D85",
    "rgb": "183, 157, 133"
  },
  {
    "name": "Muted Shadow 322-1",
    "code": "NP N 1322 T",
    "hex": "#C2BAB3",
    "rgb": "194, 186, 179"
  },
  {
    "name": "Classic Velvet 323-1",
    "code": "NP N 1323 D",
    "hex": "#454442",
    "rgb": "69, 68, 66"
  },
  {
    "name": "Mystic Petal 324-1",
    "code": "NP N 1324 A",
    "hex": "#5B5046",
    "rgb": "91, 80, 70"
  },
  {
    "name": "Silver Haven 325-1",
    "code": "NP N 1325 N",
    "hex": "#D2AB88",
    "rgb": "210, 171, 136"
  },
  {
    "name": "Satin Mist 326-1",
    "code": "NP N 1326 P",
    "hex": "#9E8A78",
    "rgb": "158, 138, 120"
  },
  {
    "name": "Pacific Elegance 327-1",
    "code": "NP N 1327 T",
    "hex": "#343331",
    "rgb": "52, 51, 49"
  },
  {
    "name": "Saharan Cloud 328-1",
    "code": "NP N 1328 D",
    "hex": "#837E7A",
    "rgb": "131, 126, 122"
  },
  {
    "name": "Coastal Serenity 329-1",
    "code": "NP N 1329 A",
    "hex": "#D8BBA0",
    "rgb": "216, 187, 160"
  },
  {
    "name": "Soft Whisper 330-1",
    "code": "NP N 1330 N",
    "hex": "#735E4B",
    "rgb": "115, 94, 75"
  },
  {
    "name": "Cool Harmony 331-1",
    "code": "NP N 1331 P",
    "hex": "#38322D",
    "rgb": "56, 50, 45"
  },
  {
    "name": "Muted Sand 332-1",
    "code": "NP N 1332 T",
    "hex": "#ACA9A5",
    "rgb": "172, 169, 165"
  },
  {
    "name": "Classic Dusk 333-1",
    "code": "NP N 1333 D",
    "hex": "#CAC0B7",
    "rgb": "202, 192, 183"
  },
  {
    "name": "Mystic Echo 334-1",
    "code": "NP N 1334 A",
    "hex": "#4E4237",
    "rgb": "78, 66, 55"
  },
  {
    "name": "Silver Reflection 335-1",
    "code": "NP N 1335 N",
    "hex": "#514335",
    "rgb": "81, 67, 53"
  },
  {
    "name": "Satin Silk 336-1",
    "code": "NP N 1336 P",
    "hex": "#CCBAA9",
    "rgb": "204, 186, 169"
  },
  {
    "name": "Pacific Blossom 337-1",
    "code": "NP N 1337 T",
    "hex": "#A9A6A4",
    "rgb": "169, 166, 164"
  },
  {
    "name": "Saharan Sanctuary 338-1",
    "code": "NP N 1338 D",
    "hex": "#373330",
    "rgb": "55, 51, 48"
  },
  {
    "name": "Coastal Glow 339-1",
    "code": "NP N 1339 A",
    "hex": "#776452",
    "rgb": "119, 100, 82"
  },
  {
    "name": "Soft Symphony 340-1",
    "code": "NP N 1340 N",
    "hex": "#D9B593",
    "rgb": "217, 181, 147"
  },
  {
    "name": "Cool Horizon 341-1",
    "code": "NP N 1341 P",
    "hex": "#80776E",
    "rgb": "128, 119, 110"
  },
  {
    "name": "Muted Tranquility 342-1",
    "code": "NP N 1342 T",
    "hex": "#353433",
    "rgb": "53, 52, 51"
  },
  {
    "name": "Classic Breeze 343-1",
    "code": "NP N 1343 D",
    "hex": "#A19488",
    "rgb": "161, 148, 136"
  },
  {
    "name": "Mystic Aura 344-1",
    "code": "NP N 1344 A",
    "hex": "#D0AD8B",
    "rgb": "208, 173, 139"
  },
  {
    "name": "Silver Feather 345-1",
    "code": "NP N 1345 N",
    "hex": "#584A3D",
    "rgb": "88, 74, 61"
  },
  {
    "name": "Satin Twilight 346-1",
    "code": "NP N 1346 P",
    "hex": "#484440",
    "rgb": "72, 68, 64"
  },
  {
    "name": "Pacific Tide 347-1",
    "code": "NP N 1347 T",
    "hex": "#C4C1BD",
    "rgb": "196, 193, 189"
  },
  {
    "name": "Saharan Dream 348-1",
    "code": "NP N 1348 D",
    "hex": "#B4A391",
    "rgb": "180, 163, 145"
  },
  {
    "name": "Coastal Stone 349-1",
    "code": "NP N 1349 A",
    "hex": "#3C3127",
    "rgb": "60, 49, 39"
  },
  {
    "name": "Soft Dawn 350-1",
    "code": "NP N 1350 N",
    "hex": "#6B5C4E",
    "rgb": "107, 92, 78"
  },
  {
    "name": "Cool Canvas 351-1",
    "code": "NP N 1351 P",
    "hex": "#D7CFC6",
    "rgb": "215, 207, 198"
  },
  {
    "name": "Muted Shadow 352-1",
    "code": "NP N 1352 T",
    "hex": "#8C8985",
    "rgb": "140, 137, 133"
  },
  {
    "name": "Classic Velvet 353-1",
    "code": "NP N 1353 D",
    "hex": "#332D28",
    "rgb": "51, 45, 40"
  },
  {
    "name": "Mystic Petal 354-1",
    "code": "NP N 1354 A",
    "hex": "#957B61",
    "rgb": "149, 123, 97"
  },
  {
    "name": "Silver Haven 355-1",
    "code": "NP N 1355 N",
    "hex": "#D5BCA2",
    "rgb": "213, 188, 162"
  },
  {
    "name": "Satin Mist 356-1",
    "code": "NP N 1356 P",
    "hex": "#62605D",
    "rgb": "98, 96, 93"
  },
  {
    "name": "Pacific Elegance 357-1",
    "code": "NP N 1357 T",
    "hex": "#403E3C",
    "rgb": "64, 62, 60"
  },
  {
    "name": "Saharan Cloud 358-1",
    "code": "NP N 1358 D",
    "hex": "#BBA48B",
    "rgb": "187, 164, 139"
  },
  {
    "name": "Coastal Serenity 359-1",
    "code": "NP N 1359 A",
    "hex": "#BE9E7C",
    "rgb": "190, 158, 124"
  },
  {
    "name": "Soft Whisper 360-1",
    "code": "NP N 1360 N",
    "hex": "#423B34",
    "rgb": "66, 59, 52"
  },
  {
    "name": "Cool Harmony 361-1",
    "code": "NP N 1361 P",
    "hex": "#605E5C",
    "rgb": "96, 94, 92"
  },
  {
    "name": "Muted Sand 362-1",
    "code": "NP N 1362 T",
    "hex": "#D4CAC0",
    "rgb": "212, 202, 192"
  },
  {
    "name": "Classic Dusk 363-1",
    "code": "NP N 1363 D",
    "hex": "#98836C",
    "rgb": "152, 131, 108"
  },
  {
    "name": "Mystic Echo 364-1",
    "code": "NP N 1364 A",
    "hex": "#332B22",
    "rgb": "51, 43, 34"
  },
  {
    "name": "Silver Reflection 365-1",
    "code": "NP N 1365 N",
    "hex": "#897E71",
    "rgb": "137, 126, 113"
  },
  {
    "name": "Satin Silk 366-1",
    "code": "NP N 1366 P",
    "hex": "#D8D4D1",
    "rgb": "216, 212, 209"
  },
  {
    "name": "Pacific Blossom 367-1",
    "code": "NP N 1367 T",
    "hex": "#6E6760",
    "rgb": "110, 103, 96"
  },
  {
    "name": "Saharan Sanctuary 368-1",
    "code": "NP N 1368 D",
    "hex": "#3A3228",
    "rgb": "58, 50, 40"
  },
  {
    "name": "Coastal Glow 369-1",
    "code": "NP N 1369 A",
    "hex": "#B19678",
    "rgb": "177, 150, 120"
  },
  {
    "name": "Soft Symphony 370-1",
    "code": "NP N 1370 N",
    "hex": "#C6B9AB",
    "rgb": "198, 185, 171"
  },
  {
    "name": "Cool Horizon 371-1",
    "code": "NP N 1371 P",
    "hex": "#4A4948",
    "rgb": "74, 73, 72"
  },
  {
    "name": "Muted Tranquility 372-1",
    "code": "NP N 1372 T",
    "hex": "#554F48",
    "rgb": "85, 79, 72"
  },
  {
    "name": "Classic Breeze 373-1",
    "code": "NP N 1373 D",
    "hex": "#CFAE8A",
    "rgb": "207, 174, 138"
  },
  {
    "name": "Mystic Aura 374-1",
    "code": "NP N 1374 A",
    "hex": "#A48D73",
    "rgb": "164, 141, 115"
  },
  {
    "name": "Silver Feather 375-1",
    "code": "NP N 1375 N",
    "hex": "#353330",
    "rgb": "53, 51, 48"
  },
  {
    "name": "Satin Twilight 376-1",
    "code": "NP N 1376 P",
    "hex": "#7C7A78",
    "rgb": "124, 122, 120"
  },
  {
    "name": "Pacific Tide 377-1",
    "code": "NP N 1377 T",
    "hex": "#D9C5AF",
    "rgb": "217, 197, 175"
  },
  {
    "name": "Saharan Dream 378-1",
    "code": "NP N 1378 D",
    "hex": "#7A6650",
    "rgb": "122, 102, 80"
  },
  {
    "name": "Coastal Stone 379-1",
    "code": "NP N 1379 A",
    "hex": "#362F27",
    "rgb": "54, 47, 39"
  },
  {
    "name": "Soft Dawn 380-1",
    "code": "NP N 1380 N",
    "hex": "#A6A099",
    "rgb": "166, 160, 153"
  },
  {
    "name": "Cool Canvas 381-1",
    "code": "NP N 1381 P",
    "hex": "#CDC9C3",
    "rgb": "205, 201, 195"
  },
  {
    "name": "Muted Shadow 382-1",
    "code": "NP N 1382 T",
    "hex": "#534A40",
    "rgb": "83, 74, 64"
  },
  {
    "name": "Classic Velvet 383-1",
    "code": "NP N 1383 D",
    "hex": "#4C3F31",
    "rgb": "76, 63, 49"
  },
  {
    "name": "Mystic Petal 384-1",
    "code": "NP N 1384 A",
    "hex": "#C8B298",
    "rgb": "200, 178, 152"
  },
  {
    "name": "Silver Haven 385-1",
    "code": "NP N 1385 N",
    "hex": "#AFABA5",
    "rgb": "175, 171, 165"
  },
  {
    "name": "Satin Mist 386-1",
    "code": "NP N 1386 P",
    "hex": "#393735",
    "rgb": "57, 55, 53"
  },
  {
    "name": "Pacific Elegance 387-1",
    "code": "NP N 1387 T",
    "hex": "#706353",
    "rgb": "112, 99, 83"
  },
  {
    "name": "Saharan Cloud 388-1",
    "code": "NP N 1388 D",
    "hex": "#D8B68D",
    "rgb": "216, 182, 141"
  },
  {
    "name": "Coastal Serenity 389-1",
    "code": "NP N 1389 A",
    "hex": "#867A6B",
    "rgb": "134, 122, 107"
  },
  {
    "name": "Soft Whisper 390-1",
    "code": "NP N 1390 N",
    "hex": "#343332",
    "rgb": "52, 51, 50"
  },
  {
    "name": "Cool Harmony 391-1",
    "code": "NP N 1391 P",
    "hex": "#9B948C",
    "rgb": "155, 148, 140"
  },
  {
    "name": "Muted Sand 392-1",
    "code": "NP N 1392 T",
    "hex": "#D3B796",
    "rgb": "211, 183, 150"
  },
  {
    "name": "Classic Dusk 393-1",
    "code": "NP N 1393 D",
    "hex": "#5D4F3E",
    "rgb": "93, 79, 62"
  },
  {
    "name": "Mystic Echo 394-1",
    "code": "NP N 1394 A",
    "hex": "#433E38",
    "rgb": "67, 62, 56"
  },
  {
    "name": "Silver Reflection 395-1",
    "code": "NP N 1395 N",
    "hex": "#C0BDB9",
    "rgb": "192, 189, 185"
  },
  {
    "name": "Satin Silk 396-1",
    "code": "NP N 1396 P",
    "hex": "#B9AFA2",
    "rgb": "185, 175, 162"
  },
  {
    "name": "Pacific Blossom 397-1",
    "code": "NP N 1397 T",
    "hex": "#3F362B",
    "rgb": "63, 54, 43"
  },
  {
    "name": "Saharan Sanctuary 398-1",
    "code": "NP N 1398 D",
    "hex": "#655644",
    "rgb": "101, 86, 68"
  },
  {
    "name": "Coastal Glow 399-1",
    "code": "NP N 1399 A",
    "hex": "#D5C8B8",
    "rgb": "213, 200, 184"
  },
  {
    "name": "Soft Symphony 400-1",
    "code": "NP N 1400 N",
    "hex": "#93918E",
    "rgb": "147, 145, 142"
  },
  {
    "name": "Cool Horizon 401",
    "code": "NP N 1401 P",
    "hex": "#332F2B",
    "rgb": "51, 47, 43"
  },
  {
    "name": "Muted Tranquility 402",
    "code": "NP N 1402 T",
    "hex": "#8E7A5F",
    "rgb": "142, 122, 95"
  },
  {
    "name": "Classic Breeze 403",
    "code": "NP N 1403 D",
    "hex": "#D7BA96",
    "rgb": "215, 186, 150"
  },
  {
    "name": "Mystic Aura 404",
    "code": "NP N 1404 A",
    "hex": "#69645D",
    "rgb": "105, 100, 93"
  },
  {
    "name": "Silver Feather 405",
    "code": "NP N 1405 N",
    "hex": "#3D3C3B",
    "rgb": "61, 60, 59"
  },
  {
    "name": "Satin Twilight 406",
    "code": "NP N 1406 P",
    "hex": "#B6A793",
    "rgb": "182, 167, 147"
  },
  {
    "name": "Pacific Tide 407",
    "code": "NP N 1407 T",
    "hex": "#C3A57F",
    "rgb": "195, 165, 127"
  },
  {
    "name": "Saharan Dream 408",
    "code": "NP N 1408 D",
    "hex": "#463E33",
    "rgb": "70, 62, 51"
  },
  {
    "name": "Coastal Stone 409",
    "code": "NP N 1409 A",
    "hex": "#5A5753",
    "rgb": "90, 87, 83"
  },
  {
    "name": "Soft Dawn 410",
    "code": "NP N 1410 N",
    "hex": "#D1CDC7",
    "rgb": "209, 205, 199"
  },
  {
    "name": "Cool Canvas 411",
    "code": "NP N 1411 P",
    "hex": "#9F8F7B",
    "rgb": "159, 143, 123"
  },
  {
    "name": "Muted Shadow 412",
    "code": "NP N 1412 T",
    "hex": "#342C22",
    "rgb": "52, 44, 34"
  },
  {
    "name": "Classic Velvet 413",
    "code": "NP N 1413 D",
    "hex": "#827563",
    "rgb": "130, 117, 99"
  },
  {
    "name": "Mystic Petal 414",
    "code": "NP N 1414 A",
    "hex": "#D8D3CC",
    "rgb": "216, 211, 204"
  },
  {
    "name": "Silver Haven 415",
    "code": "NP N 1415 N",
    "hex": "#74716C",
    "rgb": "116, 113, 108"
  },
  {
    "name": "Satin Mist 416",
    "code": "NP N 1416 P",
    "hex": "#383229",
    "rgb": "56, 50, 41"
  },
  {
    "name": "Pacific Elegance 417",
    "code": "NP N 1417 T",
    "hex": "#AB9270",
    "rgb": "171, 146, 112"
  },
  {
    "name": "Saharan Cloud 418",
    "code": "NP N 1418 D",
    "hex": "#CAB9A1",
    "rgb": "202, 185, 161"
  },
  {
    "name": "Coastal Serenity 419",
    "code": "NP N 1419 A",
    "hex": "#4F4D4B",
    "rgb": "79, 77, 75"
  },
  {
    "name": "Soft Whisper 420",
    "code": "NP N 1420 N",
    "hex": "#504D48",
    "rgb": "80, 77, 72"
  },
  {
    "name": "Cool Harmony 421",
    "code": "NP N 1421 P",
    "hex": "#CBB290",
    "rgb": "203, 178, 144"
  },
  {
    "name": "Muted Sand 422",
    "code": "NP N 1422 T",
    "hex": "#AA9271",
    "rgb": "170, 146, 113"
  },
  {
    "name": "Classic Dusk 423",
    "code": "NP N 1423 D",
    "hex": "#37332E",
    "rgb": "55, 51, 46"
  },
  {
    "name": "Mystic Echo 424",
    "code": "NP N 1424 A",
    "hex": "#767472",
    "rgb": "118, 116, 114"
  },
  {
    "name": "Silver Reflection 425",
    "code": "NP N 1425 N",
    "hex": "#D9CDBE",
    "rgb": "217, 205, 190"
  },
  {
    "name": "Satin Silk 426",
    "code": "NP N 1426 P",
    "hex": "#817058",
    "rgb": "129, 112, 88"
  },
  {
    "name": "Pacific Blossom 427",
    "code": "NP N 1427 T",
    "hex": "#352E24",
    "rgb": "53, 46, 36"
  },
  {
    "name": "Saharan Sanctuary 428",
    "code": "NP N 1428 D",
    "hex": "#A0978A",
    "rgb": "160, 151, 138"
  },
  {
    "name": "Coastal Glow 429",
    "code": "NP N 1429 A",
    "hex": "#D0CECA",
    "rgb": "208, 206, 202"
  },
  {
    "name": "Soft Symphony 430",
    "code": "NP N 1430 N",
    "hex": "#58534B",
    "rgb": "88, 83, 75"
  },
  {
    "name": "Cool Horizon 431",
    "code": "NP N 1431 P",
    "hex": "#473D2F",
    "rgb": "71, 61, 47"
  },
  {
    "name": "Muted Tranquility 432",
    "code": "NP N 1432 T",
    "hex": "#C3AC89",
    "rgb": "195, 172, 137"
  },
  {
    "name": "Classic Breeze 433",
    "code": "NP N 1433 D",
    "hex": "#B5ADA2",
    "rgb": "181, 173, 162"
  },
  {
    "name": "Mystic Aura 434",
    "code": "NP N 1434 A",
    "hex": "#3C3B3A",
    "rgb": "60, 59, 58"
  },
  {
    "name": "Silver Feather 435",
    "code": "NP N 1435 N",
    "hex": "#6A6256",
    "rgb": "106, 98, 86"
  },
  {
    "name": "Satin Twilight 436",
    "code": "NP N 1436 P",
    "hex": "#D7B98D",
    "rgb": "215, 185, 141"
  },
  {
    "name": "Pacific Tide 437",
    "code": "NP N 1437 T",
    "hex": "#8D7E67",
    "rgb": "141, 126, 103"
  },
  {
    "name": "Saharan Dream 438",
    "code": "NP N 1438 D",
    "hex": "#33312F",
    "rgb": "51, 49, 47"
  },
  {
    "name": "Coastal Stone 439",
    "code": "NP N 1439 A",
    "hex": "#94918D",
    "rgb": "148, 145, 141"
  },
  {
    "name": "Soft Dawn 440",
    "code": "NP N 1440 N",
    "hex": "#D5C2A5",
    "rgb": "213, 194, 165"
  },
  {
    "name": "Cool Canvas 441",
    "code": "NP N 1441 P",
    "hex": "#635541",
    "rgb": "99, 85, 65"
  },
  {
    "name": "Muted Shadow 442",
    "code": "NP N 1442 T",
    "hex": "#403A30",
    "rgb": "64, 58, 48"
  },
  {
    "name": "Classic Velvet 443",
    "code": "NP N 1443 D",
    "hex": "#BBB6B0",
    "rgb": "187, 182, 176"
  },
  {
    "name": "Mystic Petal 444",
    "code": "NP N 1444 A",
    "hex": "#BFB9B1",
    "rgb": "191, 185, 177"
  },
  {
    "name": "Silver Haven 445",
    "code": "NP N 1445 N",
    "hex": "#433C31",
    "rgb": "67, 60, 49"
  },
  {
    "name": "Satin Mist 446",
    "code": "NP N 1446 P",
    "hex": "#5F523E",
    "rgb": "95, 82, 62"
  },
  {
    "name": "Pacific Elegance 447",
    "code": "NP N 1447 T",
    "hex": "#D3C2A8",
    "rgb": "211, 194, 168"
  },
  {
    "name": "Saharan Cloud 448",
    "code": "NP N 1448 D",
    "hex": "#999793",
    "rgb": "153, 151, 147"
  },
  {
    "name": "Coastal Serenity 449",
    "code": "NP N 1449 A",
    "hex": "#33322F",
    "rgb": "51, 50, 47"
  },
  {
    "name": "Soft Whisper 450",
    "code": "NP N 1450 N",
    "hex": "#887861",
    "rgb": "136, 120, 97"
  },
  {
    "name": "Cool Harmony 451",
    "code": "NP N 1451 P",
    "hex": "#D8BC8F",
    "rgb": "216, 188, 143"
  },
  {
    "name": "Muted Sand 452",
    "code": "NP N 1452 T",
    "hex": "#6F685C",
    "rgb": "111, 104, 92"
  },
  {
    "name": "Classic Dusk 453",
    "code": "NP N 1453 D",
    "hex": "#3A3938",
    "rgb": "58, 57, 56"
  },
  {
    "name": "Mystic Echo 454",
    "code": "NP N 1454 A",
    "hex": "#B0A89A",
    "rgb": "176, 168, 154"
  },
  {
    "name": "Silver Reflection 455",
    "code": "NP N 1455 N",
    "hex": "#C7AF89",
    "rgb": "199, 175, 137"
  },
  {
    "name": "Satin Silk 456",
    "code": "NP N 1456 P",
    "hex": "#4B4133",
    "rgb": "75, 65, 51"
  },
  {
    "name": "Pacific Blossom 457",
    "code": "NP N 1457 T",
    "hex": "#545049",
    "rgb": "84, 80, 73"
  },
  {
    "name": "Saharan Sanctuary 458",
    "code": "NP N 1458 D",
    "hex": "#CECCC8",
    "rgb": "206, 204, 200"
  },
  {
    "name": "Coastal Glow 459",
    "code": "NP N 1459 A",
    "hex": "#A59B8B",
    "rgb": "165, 155, 139"
  },
  {
    "name": "Soft Symphony 460",
    "code": "NP N 1460 N",
    "hex": "#362F24",
    "rgb": "54, 47, 36"
  },
  {
    "name": "Cool Horizon 461",
    "code": "NP N 1461 P",
    "hex": "#7B6D57",
    "rgb": "123, 109, 87"
  },
  {
    "name": "Muted Tranquility 462",
    "code": "NP N 1462 T",
    "hex": "#D9D0C2",
    "rgb": "217, 208, 194"
  },
  {
    "name": "Classic Breeze 463",
    "code": "NP N 1463 D",
    "hex": "#7B7977",
    "rgb": "123, 121, 119"
  },
  {
    "name": "Mystic Aura 464",
    "code": "NP N 1464 A",
    "hex": "#36322B",
    "rgb": "54, 50, 43"
  },
  {
    "name": "Silver Feather 465",
    "code": "NP N 1465 N",
    "hex": "#A5906C",
    "rgb": "165, 144, 108"
  },
  {
    "name": "Satin Twilight 466",
    "code": "NP N 1466 P",
    "hex": "#CEB996",
    "rgb": "206, 185, 150"
  },
  {
    "name": "Pacific Tide 467",
    "code": "NP N 1467 T",
    "hex": "#54514D",
    "rgb": "84, 81, 77"
  },
  {
    "name": "Saharan Dream 468",
    "code": "NP N 1468 D",
    "hex": "#4B4947",
    "rgb": "75, 73, 71"
  },
  {
    "name": "Coastal Stone 469",
    "code": "NP N 1469 A",
    "hex": "#C7B69A",
    "rgb": "199, 182, 154"
  },
  {
    "name": "Soft Dawn 470",
    "code": "NP N 1470 N",
    "hex": "#B09A73",
    "rgb": "176, 154, 115"
  },
  {
    "name": "Cool Canvas 471",
    "code": "NP N 1471 P",
    "hex": "#3A352C",
    "rgb": "58, 53, 44"
  },
  {
    "name": "Muted Shadow 472",
    "code": "NP N 1472 T",
    "hex": "#6F6D69",
    "rgb": "111, 109, 105"
  },
  {
    "name": "Classic Velvet 473",
    "code": "NP N 1473 D",
    "hex": "#D8D2C9",
    "rgb": "216, 210, 201"
  },
  {
    "name": "Mystic Petal 474",
    "code": "NP N 1474 A",
    "hex": "#877B64",
    "rgb": "135, 123, 100"
  },
  {
    "name": "Silver Haven 475",
    "code": "NP N 1475 N",
    "hex": "#342D22",
    "rgb": "52, 45, 34"
  },
  {
    "name": "Satin Mist 476",
    "code": "NP N 1476 P",
    "hex": "#9A8E7A",
    "rgb": "154, 142, 122"
  },
  {
    "name": "Pacific Elegance 477",
    "code": "NP N 1477 T",
    "hex": "#D3D0CB",
    "rgb": "211, 208, 203"
  },
  {
    "name": "Saharan Cloud 478",
    "code": "NP N 1478 D",
    "hex": "#5E5B55",
    "rgb": "94, 91, 85"
  },
  {
    "name": "Coastal Serenity 479",
    "code": "NP N 1479 A",
    "hex": "#433C30",
    "rgb": "67, 60, 48"
  },
  {
    "name": "Soft Whisper 480",
    "code": "NP N 1480 N",
    "hex": "#BFA87E",
    "rgb": "191, 168, 126"
  },
  {
    "name": "Cool Harmony 481",
    "code": "NP N 1481 P",
    "hex": "#BAAF9B",
    "rgb": "186, 175, 155"
  },
  {
    "name": "Muted Sand 482",
    "code": "NP N 1482 T",
    "hex": "#3F3F3D",
    "rgb": "63, 63, 61"
  },
  {
    "name": "Classic Dusk 483",
    "code": "NP N 1483 D",
    "hex": "#645F57",
    "rgb": "100, 95, 87"
  },
  {
    "name": "Mystic Echo 484",
    "code": "NP N 1484 A",
    "hex": "#D5BE92",
    "rgb": "213, 190, 146"
  },
  {
    "name": "Silver Reflection 485",
    "code": "NP N 1485 N",
    "hex": "#948364",
    "rgb": "148, 131, 100"
  },
  {
    "name": "Satin Silk 486",
    "code": "NP N 1486 P",
    "hex": "#33312C",
    "rgb": "51, 49, 44"
  },
  {
    "name": "Pacific Blossom 487",
    "code": "NP N 1487 T",
    "hex": "#8D8C89",
    "rgb": "141, 140, 137"
  },
  {
    "name": "Saharan Sanctuary 488",
    "code": "NP N 1488 D",
    "hex": "#D7CBB5",
    "rgb": "215, 203, 181"
  },
  {
    "name": "Coastal Glow 489",
    "code": "NP N 1489 A",
    "hex": "#6A5D46",
    "rgb": "106, 93, 70"
  },
  {
    "name": "Soft Symphony 490",
    "code": "NP N 1490 N",
    "hex": "#3C362A",
    "rgb": "60, 54, 42"
  },
  {
    "name": "Cool Horizon 491",
    "code": "NP N 1491 P",
    "hex": "#B5AFA2",
    "rgb": "181, 175, 162"
  },
  {
    "name": "Muted Tranquility 492",
    "code": "NP N 1492 T",
    "hex": "#C3C1BC",
    "rgb": "195, 193, 188"
  },
  {
    "name": "Classic Breeze 493",
    "code": "NP N 1493 D",
    "hex": "#474239",
    "rgb": "71, 66, 57"
  },
  {
    "name": "Mystic Aura 494",
    "code": "NP N 1494 A",
    "hex": "#594E3A",
    "rgb": "89, 78, 58"
  },
  {
    "name": "Silver Feather 495",
    "code": "NP N 1495 N",
    "hex": "#D1BD98",
    "rgb": "209, 189, 152"
  },
  {
    "name": "Satin Twilight 496",
    "code": "NP N 1496 P",
    "hex": "#A09C93",
    "rgb": "160, 156, 147"
  },
  {
    "name": "Pacific Tide 497",
    "code": "NP N 1497 T",
    "hex": "#343432",
    "rgb": "52, 52, 50"
  },
  {
    "name": "Saharan Dream 498",
    "code": "NP N 1498 D",
    "hex": "#817764",
    "rgb": "129, 119, 100"
  },
  {
    "name": "Coastal Stone 499",
    "code": "NP N 1499 A",
    "hex": "#D9BF8D",
    "rgb": "217, 191, 141"
  },
  {
    "name": "Soft Dawn 500",
    "code": "NP N 1500 N",
    "hex": "#756C59",
    "rgb": "117, 108, 89"
  },
  {
    "name": "Cool Canvas 501",
    "code": "NP N 1501 P",
    "hex": "#373634",
    "rgb": "55, 54, 52"
  },
  {
    "name": "Muted Shadow 502",
    "code": "NP N 1502 T",
    "hex": "#AAA79F",
    "rgb": "170, 167, 159"
  },
  {
    "name": "Classic Velvet 503",
    "code": "NP N 1503 D",
    "hex": "#CBB996",
    "rgb": "203, 185, 150"
  },
  {
    "name": "Mystic Petal 504",
    "code": "NP N 1504 A",
    "hex": "#4F4634",
    "rgb": "79, 70, 52"
  },
  {
    "name": "Silver Haven 505",
    "code": "NP N 1505 N",
    "hex": "#4F4A3F",
    "rgb": "79, 74, 63"
  },
  {
    "name": "Satin Mist 506",
    "code": "NP N 1506 P",
    "hex": "#CAC8C2",
    "rgb": "202, 200, 194"
  },
  {
    "name": "Pacific Elegance 507",
    "code": "NP N 1507 T",
    "hex": "#ABA69B",
    "rgb": "171, 166, 155"
  },
  {
    "name": "Saharan Cloud 508",
    "code": "NP N 1508 D",
    "hex": "#383228",
    "rgb": "56, 50, 40"
  },
  {
    "name": "Coastal Serenity 509",
    "code": "NP N 1509 A",
    "hex": "#75684D",
    "rgb": "117, 104, 77"
  },
  {
    "name": "Soft Whisper 510",
    "code": "NP N 1510 N",
    "hex": "#D8CDB4",
    "rgb": "216, 205, 180"
  },
  {
    "name": "Cool Harmony 511",
    "code": "NP N 1511 P",
    "hex": "#82807E",
    "rgb": "130, 128, 126"
  },
  {
    "name": "Muted Sand 512",
    "code": "NP N 1512 T",
    "hex": "#34322E",
    "rgb": "52, 50, 46"
  },
  {
    "name": "Classic Dusk 513",
    "code": "NP N 1513 D",
    "hex": "#9F8F6D",
    "rgb": "159, 143, 109"
  },
  {
    "name": "Mystic Echo 514",
    "code": "NP N 1514 A",
    "hex": "#D1BC8E",
    "rgb": "209, 188, 142"
  },
  {
    "name": "Silver Reflection 515",
    "code": "NP N 1515 N",
    "hex": "#59564D",
    "rgb": "89, 86, 77"
  },
  {
    "name": "Satin Silk 516",
    "code": "NP N 1516 P",
    "hex": "#464644",
    "rgb": "70, 70, 68"
  },
  {
    "name": "Pacific Blossom 517",
    "code": "NP N 1517 T",
    "hex": "#C3B9A4",
    "rgb": "195, 185, 164"
  },
  {
    "name": "Saharan Sanctuary 518",
    "code": "NP N 1518 D",
    "hex": "#B6A379",
    "rgb": "182, 163, 121"
  },
  {
    "name": "Coastal Glow 519",
    "code": "NP N 1519 A",
    "hex": "#3D372B",
    "rgb": "61, 55, 43"
  },
  {
    "name": "Soft Symphony 520",
    "code": "NP N 1520 N",
    "hex": "#69655E",
    "rgb": "105, 101, 94"
  },
  {
    "name": "Cool Horizon 521",
    "code": "NP N 1521 P",
    "hex": "#D7D4CF",
    "rgb": "215, 212, 207"
  },
  {
    "name": "Muted Tranquility 522",
    "code": "NP N 1522 T",
    "hex": "#8E8673",
    "rgb": "142, 134, 115"
  },
  {
    "name": "Classic Breeze 523",
    "code": "NP N 1523 D",
    "hex": "#332E21",
    "rgb": "51, 46, 33"
  },
  {
    "name": "Mystic Aura 524",
    "code": "NP N 1524 A",
    "hex": "#93876B",
    "rgb": "147, 135, 107"
  },
  {
    "name": "Silver Feather 525",
    "code": "NP N 1525 N",
    "hex": "#D5D0C5",
    "rgb": "213, 208, 197"
  },
  {
    "name": "Satin Twilight 526",
    "code": "NP N 1526 P",
    "hex": "#64635F",
    "rgb": "100, 99, 95"
  },
  {
    "name": "Pacific Tide 527",
    "code": "NP N 1527 T",
    "hex": "#3F3B31",
    "rgb": "63, 59, 49"
  },
  {
    "name": "Saharan Dream 528",
    "code": "NP N 1528 D",
    "hex": "#BAA679",
    "rgb": "186, 166, 121"
  },
  {
    "name": "Coastal Stone 529",
    "code": "NP N 1529 A",
    "hex": "#BFB292",
    "rgb": "191, 178, 146"
  },
  {
    "name": "Soft Dawn 530",
    "code": "NP N 1530 N",
    "hex": "#43423F",
    "rgb": "67, 66, 63"
  },
  {
    "name": "Cool Canvas 531",
    "code": "NP N 1531 P",
    "hex": "#5E5C57",
    "rgb": "94, 92, 87"
  },
  {
    "name": "Muted Shadow 532",
    "code": "NP N 1532 T",
    "hex": "#D3C29C",
    "rgb": "211, 194, 156"
  },
  {
    "name": "Classic Velvet 533",
    "code": "NP N 1533 D",
    "hex": "#9A8A65",
    "rgb": "154, 138, 101"
  },
  {
    "name": "Mystic Petal 534",
    "code": "NP N 1534 A",
    "hex": "#343029",
    "rgb": "52, 48, 41"
  },
  {
    "name": "Silver Haven 535",
    "code": "NP N 1535 N",
    "hex": "#878581",
    "rgb": "135, 133, 129"
  },
  {
    "name": "Satin Mist 536",
    "code": "NP N 1536 P",
    "hex": "#D8D2C3",
    "rgb": "216, 210, 195"
  },
  {
    "name": "Pacific Elegance 537",
    "code": "NP N 1537 T",
    "hex": "#706650",
    "rgb": "112, 102, 80"
  },
  {
    "name": "Saharan Cloud 538",
    "code": "NP N 1538 D",
    "hex": "#393426",
    "rgb": "57, 52, 38"
  },
  {
    "name": "Coastal Serenity 539",
    "code": "NP N 1539 A",
    "hex": "#AFA792",
    "rgb": "175, 167, 146"
  },
  {
    "name": "Soft Whisper 540",
    "code": "NP N 1540 N",
    "hex": "#C8C6C1",
    "rgb": "200, 198, 193"
  },
  {
    "name": "Cool Harmony 541",
    "code": "NP N 1541 P",
    "hex": "#4B4942",
    "rgb": "75, 73, 66"
  },
  {
    "name": "Muted Sand 542",
    "code": "NP N 1542 T",
    "hex": "#534C39",
    "rgb": "83, 76, 57"
  },
  {
    "name": "Classic Dusk 543",
    "code": "NP N 1543 D",
    "hex": "#CDBA8C",
    "rgb": "205, 186, 140"
  },
  {
    "name": "Mystic Echo 544",
    "code": "NP N 1544 A",
    "hex": "#A6A08F",
    "rgb": "166, 160, 143"
  },
  {
    "name": "Silver Reflection 545",
    "code": "NP N 1545 N",
    "hex": "#363634",
    "rgb": "54, 54, 52"
  },
  {
    "name": "Satin Silk 546",
    "code": "NP N 1546 P",
    "hex": "#7A7567",
    "rgb": "122, 117, 103"
  },
  {
    "name": "Pacific Blossom 547",
    "code": "NP N 1547 T",
    "hex": "#D9C491",
    "rgb": "217, 196, 145"
  },
  {
    "name": "Saharan Sanctuary 548",
    "code": "NP N 1548 D",
    "hex": "#7C7257",
    "rgb": "124, 114, 87"
  },
  {
    "name": "Coastal Glow 549",
    "code": "NP N 1549 A",
    "hex": "#363430",
    "rgb": "54, 52, 48"
  },
  {
    "name": "Soft Symphony 550",
    "code": "NP N 1550 N",
    "hex": "#A4A39E",
    "rgb": "164, 163, 158"
  },
  {
    "name": "Cool Harmony 1-3",
    "code": "NP BGG 1001 P",
    "hex": "#24A022",
    "rgb": "36, 160, 34"
  },
  {
    "name": "Muted Sand 2-3",
    "code": "NP BGG 1002 T",
    "hex": "#266825",
    "rgb": "38, 104, 37"
  },
  {
    "name": "Classic Dusk 3-3",
    "code": "NP BGG 1003 D",
    "hex": "#91C191",
    "rgb": "145, 193, 145"
  },
  {
    "name": "Mystic Echo 4-3",
    "code": "NP BGG 1004 A",
    "hex": "#B8E2B7",
    "rgb": "184, 226, 183"
  },
  {
    "name": "Silver Reflection 5-3",
    "code": "NP BGG 1005 N",
    "hex": "#3B803A",
    "rgb": "59, 128, 58"
  },
  {
    "name": "Satin Silk 6-2",
    "code": "NP BGG 1006 P",
    "hex": "#197918",
    "rgb": "25, 121, 24"
  },
  {
    "name": "Pacific Blossom 7-3",
    "code": "NP BGG 1007 T",
    "hex": "#5DDC5D",
    "rgb": "93, 220, 93"
  },
  {
    "name": "Saharan Sanctuary 8-3",
    "code": "NP BGG 1008 D",
    "hex": "#A1CAA1",
    "rgb": "161, 202, 161"
  },
  {
    "name": "Coastal Glow 9-3",
    "code": "NP BGG 1009 A",
    "hex": "#536B53",
    "rgb": "83, 107, 83"
  },
  {
    "name": "Soft Symphony 10-3",
    "code": "NP BGG 1010 N",
    "hex": "#3A963B",
    "rgb": "58, 150, 59"
  },
  {
    "name": "Cool Horizon 11-3",
    "code": "NP BGG 1011 P",
    "hex": "#30EA32",
    "rgb": "48, 234, 50"
  },
  {
    "name": "Muted Tranquility 12-3",
    "code": "NP BGG 1012 T",
    "hex": "#53AA54",
    "rgb": "83, 170, 84"
  },
  {
    "name": "Classic Breeze 13-3",
    "code": "NP BGG 1013 D",
    "hex": "#556655",
    "rgb": "85, 102, 85"
  },
  {
    "name": "Mystic Aura 14-3",
    "code": "NP BGG 1014 A",
    "hex": "#85B886",
    "rgb": "133, 184, 134"
  },
  {
    "name": "Silver Feather 15-3",
    "code": "NP BGG 1015 N",
    "hex": "#4CE64F",
    "rgb": "76, 230, 79"
  },
  {
    "name": "Satin Twilight 16-3",
    "code": "NP BGG 1016 P",
    "hex": "#1F8921",
    "rgb": "31, 137, 33"
  },
  {
    "name": "Pacific Tide 17-3",
    "code": "NP BGG 1017 T",
    "hex": "#407342",
    "rgb": "64, 115, 66"
  },
  {
    "name": "Saharan Dream 18-3",
    "code": "NP BGG 1018 D",
    "hex": "#B5D6B6",
    "rgb": "181, 214, 182"
  },
  {
    "name": "Coastal Stone 19-3",
    "code": "NP BGG 1019 A",
    "hex": "#8BD28D",
    "rgb": "139, 210, 141"
  },
  {
    "name": "Soft Dawn 20-3",
    "code": "NP BGG 1020 N",
    "hex": "#1F7022",
    "rgb": "31, 112, 34"
  },
  {
    "name": "Cool Canvas 21-3",
    "code": "NP BGG 1021 P",
    "hex": "#248D28",
    "rgb": "36, 141, 40"
  },
  {
    "name": "Muted Shadow 22-3",
    "code": "NP BGG 1022 T",
    "hex": "#92E895",
    "rgb": "146, 232, 149"
  },
  {
    "name": "Classic Velvet 23-3",
    "code": "NP BGG 1023 D",
    "hex": "#98B49A",
    "rgb": "152, 180, 154"
  },
  {
    "name": "Mystic Petal 24-3",
    "code": "NP BGG 1024 A",
    "hex": "#3D663F",
    "rgb": "61, 102, 63"
  },
  {
    "name": "Silver Haven 25-3",
    "code": "NP BGG 1025 N",
    "hex": "#29AE30",
    "rgb": "41, 174, 48"
  },
  {
    "name": "Satin Mist 26-3",
    "code": "NP BGG 1026 P",
    "hex": "#46E94F",
    "rgb": "70, 233, 79"
  },
  {
    "name": "Pacific Elegance 27-3",
    "code": "NP BGG 1027 T",
    "hex": "#659268",
    "rgb": "101, 146, 104"
  },
  {
    "name": "Saharan Cloud 28-3",
    "code": "NP BGG 1028 D",
    "hex": "#5C6D5D",
    "rgb": "92, 109, 93"
  },
  {
    "name": "Coastal Serenity 29-3",
    "code": "NP BGG 1029 A",
    "hex": "#6CCE72",
    "rgb": "108, 206, 114"
  },
  {
    "name": "Soft Whisper 30-3",
    "code": "NP BGG 1030 N",
    "hex": "#2EDA39",
    "rgb": "46, 218, 57"
  },
  {
    "name": "Cool Harmony 31-3",
    "code": "NP BGG 1031 P",
    "hex": "#2A762F",
    "rgb": "42, 118, 47"
  },
  {
    "name": "Muted Sand 32-3",
    "code": "NP BGG 1032 T",
    "hex": "#638465",
    "rgb": "99, 132, 101"
  },
  {
    "name": "Classic Dusk 33-3",
    "code": "NP BGG 1033 D",
    "hex": "#B9E4BC",
    "rgb": "185, 228, 188"
  },
  {
    "name": "Mystic Echo 34-3",
    "code": "NP BGG 1034 A",
    "hex": "#56BD5E",
    "rgb": "86, 189, 94"
  },
  {
    "name": "Silver Reflection 35-3",
    "code": "NP BGG 1035 N",
    "hex": "#15671B",
    "rgb": "21, 103, 27"
  },
  {
    "name": "Satin Silk 36-3",
    "code": "NP BGG 1036 P",
    "hex": "#45A44D",
    "rgb": "69, 164, 77"
  },
  {
    "name": "Pacific Blossom 37-3",
    "code": "NP BGG 1037 T",
    "hex": "#BAEABE",
    "rgb": "186, 234, 190"
  },
  {
    "name": "Saharan Sanctuary 38-3",
    "code": "NP BGG 1038 D",
    "hex": "#789B7B",
    "rgb": "120, 155, 123"
  },
  {
    "name": "Coastal Glow 39-3",
    "code": "NP BGG 1039 A",
    "hex": "#296A2F",
    "rgb": "41, 106, 47"
  },
  {
    "name": "Soft Symphony 40-3",
    "code": "NP BGG 1040 N",
    "hex": "#28C537",
    "rgb": "40, 197, 55"
  },
  {
    "name": "Cool Horizon 41-3",
    "code": "NP BGG 1041 P",
    "hex": "#6EE079",
    "rgb": "110, 224, 121"
  },
  {
    "name": "Muted Tranquility 42-3",
    "code": "NP BGG 1042 T",
    "hex": "#677D69",
    "rgb": "103, 125, 105"
  },
  {
    "name": "Classic Breeze 43-3",
    "code": "NP BGG 1043 D",
    "hex": "#5A7C5D",
    "rgb": "90, 124, 93"
  },
  {
    "name": "Mystic Aura 44-3",
    "code": "NP BGG 1044 A",
    "hex": "#49DF59",
    "rgb": "73, 223, 89"
  },
  {
    "name": "Silver Feather 45-3",
    "code": "NP BGG 1045 N",
    "hex": "#2CC63D",
    "rgb": "44, 198, 61"
  },
  {
    "name": "Satin Twilight 46-3",
    "code": "NP BGG 1046 P",
    "hex": "#3B6A41",
    "rgb": "59, 106, 65"
  },
  {
    "name": "Pacific Tide 47-3",
    "code": "NP BGG 1047 T",
    "hex": "#839A85",
    "rgb": "131, 154, 133"
  },
  {
    "name": "Saharan Dream 48-3",
    "code": "NP BGG 1048 D",
    "hex": "#9BEAA4",
    "rgb": "155, 234, 164"
  },
  {
    "name": "Coastal Stone 49-3",
    "code": "NP BGG 1049 A",
    "hex": "#2EA53C",
    "rgb": "46, 165, 60"
  },
  {
    "name": "Soft Dawn 50-3",
    "code": "NP BGG 1050 N",
    "hex": "#1A6724",
    "rgb": "26, 103, 36"
  },
  {
    "name": "Cool Canvas 51-3",
    "code": "NP BGG 1051 P",
    "hex": "#76BC7F",
    "rgb": "118, 188, 127"
  },
  {
    "name": "Muted Shadow 52-3",
    "code": "NP BGG 1052 T",
    "hex": "#C2E4C7",
    "rgb": "194, 228, 199"
  },
  {
    "name": "Classic Velvet 53-3",
    "code": "NP BGG 1053 D",
    "hex": "#4F8556",
    "rgb": "79, 133, 86"
  },
  {
    "name": "Mystic Petal 54-3",
    "code": "NP BGG 1054 A",
    "hex": "#1C7528",
    "rgb": "28, 117, 40"
  },
  {
    "name": "Silver Haven 55-3",
    "code": "NP BGG 1055 N",
    "hex": "#41D956",
    "rgb": "65, 217, 86"
  },
  {
    "name": "Satin Mist 56-3",
    "code": "NP BGG 1056 P",
    "hex": "#8FCF98",
    "rgb": "143, 207, 152"
  },
  {
    "name": "Pacific Elegance 57-3",
    "code": "NP BGG 1057 T",
    "hex": "#5C6E5F",
    "rgb": "92, 110, 95"
  },
  {
    "name": "Saharan Cloud 58-3",
    "code": "NP BGG 1058 D",
    "hex": "#4C9156",
    "rgb": "76, 145, 86"
  },
  {
    "name": "Coastal Serenity 59-3",
    "code": "NP BGG 1059 A",
    "hex": "#31E94D",
    "rgb": "49, 233, 77"
  },
  {
    "name": "Soft Whisper 60-3",
    "code": "NP BGG 1060 N",
    "hex": "#3FAF50",
    "rgb": "63, 175, 80"
  },
  {
    "name": "Cool Harmony 61-3",
    "code": "NP BGG 1061 P",
    "hex": "#4C6650",
    "rgb": "76, 102, 80"
  },
  {
    "name": "Muted Sand 62-3",
    "code": "NP BGG 1062 T",
    "hex": "#91B396",
    "rgb": "145, 179, 150"
  },
  {
    "name": "Classic Dusk 63-3",
    "code": "NP BGG 1063 D",
    "hex": "#69E87E",
    "rgb": "105, 232, 126"
  },
  {
    "name": "Mystic Echo 64-3",
    "code": "NP BGG 1064 A",
    "hex": "#1C8E2F",
    "rgb": "28, 142, 47"
  },
  {
    "name": "Silver Reflection 65-3",
    "code": "NP BGG 1065 N",
    "hex": "#2F703A",
    "rgb": "47, 112, 58"
  },
  {
    "name": "Satin Silk 66-3",
    "code": "NP BGG 1066 P",
    "hex": "#A7D2AE",
    "rgb": "167, 210, 174"
  },
  {
    "name": "Pacific Blossom 67-3",
    "code": "NP BGG 1067 T",
    "hex": "#A6D6AE",
    "rgb": "166, 214, 174"
  },
  {
    "name": "Saharan Sanctuary 68-3",
    "code": "NP BGG 1068 D",
    "hex": "#2D7339",
    "rgb": "45, 115, 57"
  },
  {
    "name": "Coastal Glow 69-3",
    "code": "NP BGG 1069 A",
    "hex": "#1C882F",
    "rgb": "28, 136, 47"
  },
  {
    "name": "Soft Symphony 70-3",
    "code": "NP BGG 1070 N",
    "hex": "#71E686",
    "rgb": "113, 230, 134"
  },
  {
    "name": "Cool Horizon 71-3",
    "code": "NP BGG 1071 P",
    "hex": "#99B99F",
    "rgb": "153, 185, 159"
  },
  {
    "name": "Muted Tranquility 72-3",
    "code": "NP BGG 1072 T",
    "hex": "#4A664F",
    "rgb": "74, 102, 79"
  },
  {
    "name": "Classic Breeze 73-3",
    "code": "NP BGG 1073 D",
    "hex": "#37A94D",
    "rgb": "55, 169, 77"
  },
  {
    "name": "Mystic Aura 74-3",
    "code": "NP BGG 1074 A",
    "hex": "#34EA58",
    "rgb": "52, 234, 88"
  },
  {
    "name": "Silver Feather 75-3",
    "code": "NP BGG 1075 N",
    "hex": "#559762",
    "rgb": "85, 151, 98"
  },
  {
    "name": "Satin Twilight 76-3",
    "code": "NP BGG 1076 P",
    "hex": "#5B6B5E",
    "rgb": "91, 107, 94"
  },
  {
    "name": "Pacific Tide 77-3",
    "code": "NP BGG 1077 T",
    "hex": "#85C993",
    "rgb": "133, 201, 147"
  },
  {
    "name": "Saharan Dream 78-3",
    "code": "NP BGG 1078 D",
    "hex": "#3DDD5E",
    "rgb": "61, 221, 94"
  },
  {
    "name": "Coastal Stone 79-3",
    "code": "NP BGG 1079 A",
    "hex": "#1F7A32",
    "rgb": "31, 122, 50"
  },
  {
    "name": "Soft Dawn 80-3",
    "code": "NP BGG 1080 N",
    "hex": "#50805A",
    "rgb": "80, 128, 90"
  },
  {
    "name": "Cool Canvas 81-2",
    "code": "NP BGG 1081 P",
    "hex": "#C0E2C7",
    "rgb": "192, 226, 199"
  },
  {
    "name": "Muted Shadow 82-3",
    "code": "NP BGG 1082 T",
    "hex": "#73C285",
    "rgb": "115, 194, 133"
  },
  {
    "name": "Classic Velvet 83-3",
    "code": "NP BGG 1083 D",
    "hex": "#19682A",
    "rgb": "25, 104, 42"
  },
  {
    "name": "Mystic Petal 84-3",
    "code": "NP BGG 1084 A",
    "hex": "#309F49",
    "rgb": "48, 159, 73"
  },
  {
    "name": "Silver Haven 85-3",
    "code": "NP BGG 1085 N",
    "hex": "#A3EBB3",
    "rgb": "163, 235, 179"
  },
  {
    "name": "Satin Mist 86-2",
    "code": "NP BGG 1086 P",
    "hex": "#87A18D",
    "rgb": "135, 161, 141"
  },
  {
    "name": "Pacific Elegance 87-3",
    "code": "NP BGG 1087 T",
    "hex": "#376842",
    "rgb": "55, 104, 66"
  },
  {
    "name": "Saharan Cloud 88-3",
    "code": "NP BGG 1088 D",
    "hex": "#29C14D",
    "rgb": "41, 193, 77"
  },
  {
    "name": "Coastal Serenity 89-3",
    "code": "NP BGG 1089 A",
    "hex": "#51E274",
    "rgb": "81, 226, 116"
  },
  {
    "name": "Soft Whisper 90-3",
    "code": "NP BGG 1090 N",
    "hex": "#618169",
    "rgb": "97, 129, 105"
  },
  {
    "name": "Cool Harmony 91-3",
    "code": "NP BGG 1091 P",
    "hex": "#627867",
    "rgb": "98, 120, 103"
  },
  {
    "name": "Muted Sand 92-3",
    "code": "NP BGG 1092 T",
    "hex": "#64DC82",
    "rgb": "100, 220, 130"
  },
  {
    "name": "Classic Dusk 93-3",
    "code": "NP BGG 1093 D",
    "hex": "#29CB51",
    "rgb": "41, 203, 81"
  },
  {
    "name": "Mystic Echo 94-3",
    "code": "NP BGG 1094 A",
    "hex": "#2E6C3D",
    "rgb": "46, 108, 61"
  },
  {
    "name": "Silver Reflection 95-3",
    "code": "NP BGG 1095 N",
    "hex": "#77957E",
    "rgb": "119, 149, 126"
  },
  {
    "name": "Satin Silk 96-3",
    "code": "NP BGG 1096 P",
    "hex": "#B4EAC2",
    "rgb": "180, 234, 194"
  },
  {
    "name": "Pacific Blossom 97-3",
    "code": "NP BGG 1097 T",
    "hex": "#42AB5D",
    "rgb": "66, 171, 93"
  },
  {
    "name": "Saharan Sanctuary 98-3",
    "code": "NP BGG 1098 D",
    "hex": "#15662A",
    "rgb": "21, 102, 42"
  },
  {
    "name": "Coastal Glow 99-3",
    "code": "NP BGG 1099 A",
    "hex": "#5AB773",
    "rgb": "90, 183, 115"
  },
  {
    "name": "Soft Symphony 100-3",
    "code": "NP BGG 1100 N",
    "hex": "#BFE6C9",
    "rgb": "191, 230, 201"
  },
  {
    "name": "Cool Horizon 101-3",
    "code": "NP BGG 1101 P",
    "hex": "#63896E",
    "rgb": "99, 137, 110"
  },
  {
    "name": "Muted Tranquility 102-3",
    "code": "NP BGG 1102 T",
    "hex": "#25723B",
    "rgb": "37, 114, 59"
  },
  {
    "name": "Classic Breeze 103-3",
    "code": "NP BGG 1103 D",
    "hex": "#30D55E",
    "rgb": "48, 213, 94"
  },
  {
    "name": "Mystic Aura 104-3",
    "code": "NP BGG 1104 A",
    "hex": "#76D391",
    "rgb": "118, 211, 145"
  },
  {
    "name": "Silver Feather 105-3",
    "code": "NP BGG 1105 N",
    "hex": "#5F7164",
    "rgb": "95, 113, 100"
  },
  {
    "name": "Satin Twilight 106-3",
    "code": "NP BGG 1106 P",
    "hex": "#5C8C6A",
    "rgb": "92, 140, 106"
  },
  {
    "name": "Pacific Tide 107-3",
    "code": "NP BGG 1107 T",
    "hex": "#40E771",
    "rgb": "64, 231, 113"
  },
  {
    "name": "Saharan Dream 108-3",
    "code": "NP BGG 1108 D",
    "hex": "#2EB456",
    "rgb": "46, 180, 86"
  },
  {
    "name": "Coastal Stone 109-3",
    "code": "NP BGG 1109 A",
    "hex": "#40664C",
    "rgb": "64, 102, 76"
  },
  {
    "name": "Soft Dawn 110-3",
    "code": "NP BGG 1110 N",
    "hex": "#93AD9B",
    "rgb": "147, 173, 155"
  },
  {
    "name": "Cool Canvas 111-3",
    "code": "NP BGG 1111 P",
    "hex": "#8AE9A7",
    "rgb": "138, 233, 167"
  },
  {
    "name": "Muted Shadow 112-3",
    "code": "NP BGG 1112 T",
    "hex": "#239345",
    "rgb": "35, 147, 69"
  },
  {
    "name": "Classic Velvet 113-3",
    "code": "NP BGG 1113 D",
    "hex": "#216D38",
    "rgb": "33, 109, 56"
  },
  {
    "name": "Mystic Petal 114-3",
    "code": "NP BGG 1114 A",
    "hex": "#8ECDA2",
    "rgb": "142, 205, 162"
  },
  {
    "name": "Silver Haven 115-3",
    "code": "NP BGG 1115 N",
    "hex": "#B7DAC2",
    "rgb": "183, 218, 194"
  },
  {
    "name": "Satin Mist 116-3",
    "code": "NP BGG 1116 P",
    "hex": "#3E7650",
    "rgb": "62, 118, 80"
  },
  {
    "name": "Pacific Elegance 117-3",
    "code": "NP BGG 1117 T",
    "hex": "#1C833D",
    "rgb": "28, 131, 61"
  },
  {
    "name": "Saharan Cloud 118-3",
    "code": "NP BGG 1118 D",
    "hex": "#52E481",
    "rgb": "82, 228, 129"
  },
  {
    "name": "Coastal Serenity 119-3",
    "code": "NP BGG 1119 A",
    "hex": "#8EBE9E",
    "rgb": "142, 190, 158"
  },
  {
    "name": "Soft Whisper 120-3",
    "code": "NP BGG 1120 N",
    "hex": "#54675A",
    "rgb": "84, 103, 90"
  },
  {
    "name": "Cool Harmony 121-3",
    "code": "NP BGG 1121 P",
    "hex": "#4AA368",
    "rgb": "74, 163, 104"
  },
  {
    "name": "Muted Sand 122-3",
    "code": "NP BGG 1122 T",
    "hex": "#2FEB6E",
    "rgb": "47, 235, 110"
  },
  {
    "name": "Classic Dusk 123-3",
    "code": "NP BGG 1123 D",
    "hex": "#429C61",
    "rgb": "66, 156, 97"
  },
  {
    "name": "Mystic Echo 124-3",
    "code": "NP BGG 1124 A",
    "hex": "#54695B",
    "rgb": "84, 105, 91"
  },
  {
    "name": "Silver Reflection 125-3",
    "code": "NP BGG 1125 N",
    "hex": "#98C5A7",
    "rgb": "152, 197, 167"
  },
  {
    "name": "Satin Silk 126-3",
    "code": "NP BGG 1126 P",
    "hex": "#57E086",
    "rgb": "87, 224, 134"
  },
  {
    "name": "Pacific Blossom 127-3",
    "code": "NP BGG 1127 T",
    "hex": "#1A7E3D",
    "rgb": "26, 126, 61"
  },
  {
    "name": "Saharan Sanctuary 128-3",
    "code": "NP BGG 1128 D",
    "hex": "#3D7C53",
    "rgb": "61, 124, 83"
  },
  {
    "name": "Coastal Glow 129-3",
    "code": "NP BGG 1129 A",
    "hex": "#B8DFC6",
    "rgb": "184, 223, 198"
  },
  {
    "name": "Soft Symphony 130-3",
    "code": "NP BGG 1130 N",
    "hex": "#8FC7A3",
    "rgb": "143, 199, 163"
  },
  {
    "name": "Cool Horizon 131-3",
    "code": "NP BGG 1131 P",
    "hex": "#236A3D",
    "rgb": "35, 106, 61"
  },
  {
    "name": "Muted Tranquility 132-3",
    "code": "NP BGG 1132 T",
    "hex": "#229A4E",
    "rgb": "34, 154, 78"
  },
  {
    "name": "Classic Breeze 133-3",
    "code": "NP BGG 1133 D",
    "hex": "#84EAA9",
    "rgb": "132, 234, 169"
  },
  {
    "name": "Mystic Aura 134-3",
    "code": "NP BGG 1134 A",
    "hex": "#8CA696",
    "rgb": "140, 166, 150"
  },
  {
    "name": "Silver Feather 135-3",
    "code": "NP BGG 1135 N",
    "hex": "#446751",
    "rgb": "68, 103, 81"
  },
  {
    "name": "Satin Twilight 136-3",
    "code": "NP BGG 1136 P",
    "hex": "#34BB67",
    "rgb": "52, 187, 103"
  },
  {
    "name": "Pacific Tide 137-3",
    "code": "NP BGG 1137 T",
    "hex": "#3BE57B",
    "rgb": "59, 229, 123"
  },
  {
    "name": "Saharan Dream 138-3",
    "code": "NP BGG 1138 D",
    "hex": "#548667",
    "rgb": "84, 134, 103"
  },
  {
    "name": "Coastal Stone 139-3",
    "code": "NP BGG 1139 A",
    "hex": "#63756A",
    "rgb": "99, 117, 106"
  },
  {
    "name": "Soft Dawn 140-3",
    "code": "NP BGG 1140 N",
    "hex": "#80D8A3",
    "rgb": "128, 216, 163"
  },
  {
    "name": "Cool Canvas 141-3",
    "code": "NP BGG 1141 P",
    "hex": "#31CF6F",
    "rgb": "49, 207, 111"
  },
  {
    "name": "Muted Shadow 142-3",
    "code": "NP BGG 1142 T",
    "hex": "#216E40",
    "rgb": "33, 110, 64"
  },
  {
    "name": "Classic Velvet 143-3",
    "code": "NP BGG 1143 D",
    "hex": "#649076",
    "rgb": "100, 144, 118"
  },
  {
    "name": "Mystic Petal 144-3",
    "code": "NP BGG 1144 A",
    "hex": "#C3E9D2",
    "rgb": "195, 233, 210"
  },
  {
    "name": "Silver Haven 145-3",
    "code": "NP BGG 1145 N",
    "hex": "#5CB07E",
    "rgb": "92, 176, 126"
  },
  {
    "name": "Satin Mist 146-3",
    "code": "NP BGG 1146 P",
    "hex": "#166636",
    "rgb": "22, 102, 54"
  },
  {
    "name": "Pacific Elegance 147-3",
    "code": "NP BGG 1147 T",
    "hex": "#40B26E",
    "rgb": "64, 178, 110"
  },
  {
    "name": "Saharan Cloud 148-3",
    "code": "NP BGG 1148 D",
    "hex": "#AEE8C6",
    "rgb": "174, 232, 198"
  },
  {
    "name": "Coastal Serenity 149-3",
    "code": "NP BGG 1149 A",
    "hex": "#748E7F",
    "rgb": "116, 142, 127"
  },
  {
    "name": "Soft Whisper 150-3",
    "code": "NP BGG 1150 N",
    "hex": "#326F4C",
    "rgb": "50, 111, 76"
  },
  {
    "name": "Cool Harmony 151-3",
    "code": "NP BGG 1151 P",
    "hex": "#2AD170",
    "rgb": "42, 209, 112"
  },
  {
    "name": "Muted Sand 152-3",
    "code": "NP BGG 1152 T",
    "hex": "#5BD78F",
    "rgb": "91, 215, 143"
  },
  {
    "name": "Classic Dusk 153-3",
    "code": "NP BGG 1153 D",
    "hex": "#5C7466",
    "rgb": "92, 116, 102"
  },
  {
    "name": "Mystic Echo 154-3",
    "code": "NP BGG 1154 A",
    "hex": "#688776",
    "rgb": "104, 135, 118"
  },
  {
    "name": "Silver Reflection 155-3",
    "code": "NP BGG 1155 N",
    "hex": "#59E696",
    "rgb": "89, 230, 150"
  },
  {
    "name": "Satin Silk 156-3",
    "code": "NP BGG 1156 P",
    "hex": "#26BA66",
    "rgb": "38, 186, 102"
  },
  {
    "name": "Pacific Blossom 157-3",
    "code": "NP BGG 1157 T",
    "hex": "#326749",
    "rgb": "50, 103, 73"
  },
  {
    "name": "Saharan Sanctuary 158-3",
    "code": "NP BGG 1158 D",
    "hex": "#8BA898",
    "rgb": "139, 168, 152"
  },
  {
    "name": "Coastal Glow 159-3",
    "code": "NP BGG 1159 A",
    "hex": "#A9EAC6",
    "rgb": "169, 234, 198"
  },
  {
    "name": "Soft Symphony 160-3",
    "code": "NP BGG 1160 N",
    "hex": "#32985F",
    "rgb": "50, 152, 95"
  },
  {
    "name": "Cool Horizon 161-3",
    "code": "NP BGG 1161 P",
    "hex": "#186B3D",
    "rgb": "24, 107, 61"
  },
  {
    "name": "Muted Tranquility 162-3",
    "code": "NP BGG 1162 T",
    "hex": "#71C999",
    "rgb": "113, 201, 153"
  },
  {
    "name": "Classic Breeze 163-3",
    "code": "NP BGG 1163 D",
    "hex": "#BBDDCB",
    "rgb": "187, 221, 203"
  },
  {
    "name": "Mystic Aura 164-3",
    "code": "NP BGG 1164 A",
    "hex": "#517A64",
    "rgb": "81, 122, 100"
  },
  {
    "name": "Silver Feather 165-3",
    "code": "NP BGG 1165 N",
    "hex": "#237F4E",
    "rgb": "35, 127, 78"
  },
  {
    "name": "Satin Twilight 166-3",
    "code": "NP BGG 1166 P",
    "hex": "#3AE188",
    "rgb": "58, 225, 136"
  },
  {
    "name": "Pacific Tide 167-3",
    "code": "NP BGG 1167 T",
    "hex": "#7BC39D",
    "rgb": "123, 195, 157"
  },
  {
    "name": "Saharan Dream 168-3",
    "code": "NP BGG 1168 D",
    "hex": "#596960",
    "rgb": "89, 105, 96"
  },
  {
    "name": "Coastal Stone 169-3",
    "code": "NP BGG 1169 A",
    "hex": "#5E9E7C",
    "rgb": "94, 158, 124"
  },
  {
    "name": "Soft Dawn 170-3",
    "code": "NP BGG 1170 N",
    "hex": "#38EB8D",
    "rgb": "56, 235, 141"
  },
  {
    "name": "Cool Canvas 171-3",
    "code": "NP BGG 1171 P",
    "hex": "#31A267",
    "rgb": "49, 162, 103"
  },
  {
    "name": "Muted Shadow 172-3",
    "code": "NP BGG 1172 T",
    "hex": "#486857",
    "rgb": "72, 104, 87"
  },
  {
    "name": "Classic Velvet 173-3",
    "code": "NP BGG 1173 D",
    "hex": "#A1C0B0",
    "rgb": "161, 192, 176"
  },
  {
    "name": "Mystic Petal 174-3",
    "code": "NP BGG 1174 A",
    "hex": "#77E3AB",
    "rgb": "119, 227, 171"
  },
  {
    "name": "Silver Haven 175-3",
    "code": "NP BGG 1175 N",
    "hex": "#1B824E",
    "rgb": "27, 130, 78"
  },
  {
    "name": "Satin Mist 176-3",
    "code": "NP BGG 1176 P",
    "hex": "#2B7851",
    "rgb": "43, 120, 81"
  },
  {
    "name": "Pacific Elegance 177-3",
    "code": "NP BGG 1177 T",
    "hex": "#A4DBC0",
    "rgb": "164, 219, 192"
  },
  {
    "name": "Saharan Cloud 178-3",
    "code": "NP BGG 1178 D",
    "hex": "#A5CCB9",
    "rgb": "165, 204, 185"
  },
  {
    "name": "Coastal Serenity 179-3",
    "code": "NP BGG 1179 A",
    "hex": "#316C4F",
    "rgb": "49, 108, 79"
  },
  {
    "name": "Soft Whisper 180-3",
    "code": "NP BGG 1180 N",
    "hex": "#1E945A",
    "rgb": "30, 148, 90"
  },
  {
    "name": "Cool Harmony 181-3",
    "code": "NP BGG 1181 P",
    "hex": "#63EAA7",
    "rgb": "99, 234, 167"
  },
  {
    "name": "Muted Sand 182-3",
    "code": "NP BGG 1182 T",
    "hex": "#88AB9A",
    "rgb": "136, 171, 154"
  },
  {
    "name": "Classic Dusk 183-3",
    "code": "NP BGG 1183 D",
    "hex": "#4F665B",
    "rgb": "79, 102, 91"
  },
  {
    "name": "Mystic Echo 184-3",
    "code": "NP BGG 1184 A",
    "hex": "#46B680",
    "rgb": "70, 182, 128"
  },
  {
    "name": "Silver Reflection 185-3",
    "code": "NP BGG 1185 N",
    "hex": "#2FE78F",
    "rgb": "47, 231, 143"
  },
  {
    "name": "Satin Silk 186-3",
    "code": "NP BGG 1186 P",
    "hex": "#448A69",
    "rgb": "68, 138, 105"
  },
  {
    "name": "Pacific Blossom 187-3",
    "code": "NP BGG 1187 T",
    "hex": "#5E7268",
    "rgb": "94, 114, 104"
  },
  {
    "name": "Saharan Sanctuary 188-3",
    "code": "NP BGG 1188 D",
    "hex": "#99D4B8",
    "rgb": "153, 212, 184"
  },
  {
    "name": "Coastal Glow 189-3",
    "code": "NP BGG 1189 A",
    "hex": "#45D491",
    "rgb": "69, 212, 145"
  },
  {
    "name": "Soft Symphony 190-3",
    "code": "NP BGG 1190 N",
    "hex": "#197148",
    "rgb": "25, 113, 72"
  },
  {
    "name": "Cool Horizon 191-3",
    "code": "NP BGG 1191 P",
    "hex": "#4E8B6F",
    "rgb": "78, 139, 111"
  },
  {
    "name": "Muted Tranquility 192-3",
    "code": "NP BGG 1192 T",
    "hex": "#C4E7D7",
    "rgb": "196, 231, 215"
  },
  {
    "name": "Classic Breeze 193-3",
    "code": "NP BGG 1193 D",
    "hex": "#78B599",
    "rgb": "120, 181, 153"
  },
  {
    "name": "Mystic Aura 194-3",
    "code": "NP BGG 1194 A",
    "hex": "#1C6645",
    "rgb": "28, 102, 69"
  },
  {
    "name": "Silver Feather 195-3",
    "code": "NP BGG 1195 N",
    "hex": "#2CAC73",
    "rgb": "44, 172, 115"
  },
  {
    "name": "Satin Twilight 196-3",
    "code": "NP BGG 1196 P",
    "hex": "#93E9C3",
    "rgb": "147, 233, 195"
  },
  {
    "name": "Pacific Tide 197-3",
    "code": "NP BGG 1197 T",
    "hex": "#7D938A",
    "rgb": "125, 147, 138"
  },
  {
    "name": "Saharan Dream 198-3",
    "code": "NP BGG 1198 D",
    "hex": "#406D59",
    "rgb": "64, 109, 89"
  },
  {
    "name": "Coastal Stone 199-3",
    "code": "NP BGG 1199 A",
    "hex": "#30CD88",
    "rgb": "48, 205, 136"
  },
  {
    "name": "Soft Dawn 200-3",
    "code": "NP BGG 1200 N",
    "hex": "#42DB98",
    "rgb": "66, 219, 152"
  },
  {
    "name": "Cool Canvas 201-3",
    "code": "NP BGG 1201 P",
    "hex": "#537767",
    "rgb": "83, 119, 103"
  },
  {
    "name": "Muted Shadow 202-3",
    "code": "NP BGG 1202 T",
    "hex": "#6D837A",
    "rgb": "109, 131, 122"
  },
  {
    "name": "Classic Velvet 203-3",
    "code": "NP BGG 1203 D",
    "hex": "#77E3B5",
    "rgb": "119, 227, 181"
  },
  {
    "name": "Mystic Petal 204-3",
    "code": "NP BGG 1204 A",
    "hex": "#28BF7F",
    "rgb": "40, 191, 127"
  },
  {
    "name": "Silver Haven 205-3",
    "code": "NP BGG 1205 N",
    "hex": "#25684C",
    "rgb": "37, 104, 76"
  },
  {
    "name": "Satin Mist 206-3",
    "code": "NP BGG 1206 P",
    "hex": "#7AA392",
    "rgb": "122, 163, 146"
  },
  {
    "name": "Pacific Elegance 207-3",
    "code": "NP BGG 1207 T",
    "hex": "#BEEBD8",
    "rgb": "190, 235, 216"
  },
  {
    "name": "Saharan Cloud 208-3",
    "code": "NP BGG 1208 D",
    "hex": "#479D7A",
    "rgb": "71, 157, 122"
  },
  {
    "name": "Coastal Serenity 209-3",
    "code": "NP BGG 1209 A",
    "hex": "#156947",
    "rgb": "21, 105, 71"
  },
  {
    "name": "Soft Whisper 210-3",
    "code": "NP BGG 1210 N",
    "hex": "#53C496",
    "rgb": "83, 196, 150"
  },
  {
    "name": "Cool Harmony 211-3",
    "code": "NP BGG 1211 P",
    "hex": "#B3E1CE",
    "rgb": "179, 225, 206"
  },
  {
    "name": "Muted Sand 212-3",
    "code": "NP BGG 1212 T",
    "hex": "#617E73",
    "rgb": "97, 126, 115"
  },
  {
    "name": "Classic Dusk 213-3",
    "code": "NP BGG 1213 D",
    "hex": "#307B5D",
    "rgb": "48, 123, 93"
  },
  {
    "name": "Mystic Echo 214-3",
    "code": "NP BGG 1214 A",
    "hex": "#2DDE99",
    "rgb": "45, 222, 153"
  },
  {
    "name": "Silver Reflection 215-3",
    "code": "NP BGG 1215 N",
    "hex": "#62C8A0",
    "rgb": "98, 200, 160"
  },
  {
    "name": "Satin Silk 216-3",
    "code": "NP BGG 1216 P",
    "hex": "#586A63",
    "rgb": "88, 106, 99"
  },
  {
    "name": "Pacific Blossom 217-3",
    "code": "NP BGG 1217 T",
    "hex": "#6E9988",
    "rgb": "110, 153, 136"
  },
  {
    "name": "Saharan Sanctuary 218-3",
    "code": "NP BGG 1218 D",
    "hex": "#4CEAAE",
    "rgb": "76, 234, 174"
  },
  {
    "name": "Coastal Glow 219-3",
    "code": "NP BGG 1219 A",
    "hex": "#25A776",
    "rgb": "37, 167, 118"
  },
  {
    "name": "Soft Symphony 220-3",
    "code": "NP BGG 1220 N",
    "hex": "#3A6756",
    "rgb": "58, 103, 86"
  },
  {
    "name": "Cool Horizon 221-3",
    "code": "NP BGG 1221 P",
    "hex": "#9EBBB0",
    "rgb": "158, 187, 176"
  },
  {
    "name": "Muted Tranquility 222-3",
    "code": "NP BGG 1222 T",
    "hex": "#97E5C8",
    "rgb": "151, 229, 200"
  },
  {
    "name": "Classic Breeze 223-3",
    "code": "NP BGG 1223 D",
    "hex": "#258663",
    "rgb": "37, 134, 99"
  },
  {
    "name": "Mystic Aura 224-3",
    "code": "NP BGG 1224 A",
    "hex": "#1E7455",
    "rgb": "30, 116, 85"
  },
  {
    "name": "Silver Feather 225-3",
    "code": "NP BGG 1225 N",
    "hex": "#88D8BB",
    "rgb": "136, 216, 187"
  },
  {
    "name": "Satin Twilight 226-3",
    "code": "NP BGG 1226 P",
    "hex": "#B1D0C5",
    "rgb": "177, 208, 197"
  },
  {
    "name": "Pacific Tide 227-3",
    "code": "NP BGG 1227 T",
    "hex": "#426F5F",
    "rgb": "66, 111, 95"
  },
  {
    "name": "Saharan Dream 228-3",
    "code": "NP BGG 1228 D",
    "hex": "#228F69",
    "rgb": "34, 143, 105"
  },
  {
    "name": "Coastal Stone 229-3",
    "code": "NP BGG 1229 A",
    "hex": "#46E8B0",
    "rgb": "70, 232, 176"
  },
  {
    "name": "Soft Dawn 230-3",
    "code": "NP BGG 1230 N",
    "hex": "#7BB19E",
    "rgb": "123, 177, 158"
  },
  {
    "name": "Cool Canvas 231-3",
    "code": "NP BGG 1231 P",
    "hex": "#556660",
    "rgb": "85, 102, 96"
  },
  {
    "name": "Muted Shadow 232-3",
    "code": "NP BGG 1232 T",
    "hex": "#5CB194",
    "rgb": "92, 177, 148"
  },
  {
    "name": "Classic Velvet 233-3",
    "code": "NP BGG 1233 D",
    "hex": "#31E8AA",
    "rgb": "49, 232, 170"
  },
  {
    "name": "Mystic Petal 234-3",
    "code": "NP BGG 1234 A",
    "hex": "#338F70",
    "rgb": "51, 143, 112"
  },
  {
    "name": "Silver Haven 235-3",
    "code": "NP BGG 1235 N",
    "hex": "#536F66",
    "rgb": "83, 111, 102"
  },
  {
    "name": "Satin Mist 236-3",
    "code": "NP BGG 1236 P",
    "hex": "#A9D0C3",
    "rgb": "169, 208, 195"
  },
  {
    "name": "Pacific Elegance 237-3",
    "code": "NP BGG 1237 T",
    "hex": "#62D8B1",
    "rgb": "98, 216, 177"
  },
  {
    "name": "Saharan Cloud 238-3",
    "code": "NP BGG 1238 D",
    "hex": "#177456",
    "rgb": "23, 116, 86"
  },
  {
    "name": "Coastal Serenity 239-3",
    "code": "NP BGG 1239 A",
    "hex": "#39866E",
    "rgb": "57, 134, 110"
  },
  {
    "name": "Soft Whisper 240-3",
    "code": "NP BGG 1240 N",
    "hex": "#B6E5D6",
    "rgb": "182, 229, 214"
  },
  {
    "name": "Cool Harmony 241-3",
    "code": "NP BGG 1241 P",
    "hex": "#90BAAD",
    "rgb": "144, 186, 173"
  },
  {
    "name": "Muted Sand 242-3",
    "code": "NP BGG 1242 T",
    "hex": "#286753",
    "rgb": "40, 103, 83"
  },
  {
    "name": "Classic Dusk 243-3",
    "code": "NP BGG 1243 D",
    "hex": "#22A77E",
    "rgb": "34, 167, 126"
  },
  {
    "name": "Mystic Echo 244-3",
    "code": "NP BGG 1244 A",
    "hex": "#73EAC6",
    "rgb": "115, 234, 198"
  },
  {
    "name": "Silver Reflection 245-3",
    "code": "NP BGG 1245 N",
    "hex": "#7E9991",
    "rgb": "126, 153, 145"
  },
  {
    "name": "Satin Silk 246-3",
    "code": "NP BGG 1246 P",
    "hex": "#4D6A62",
    "rgb": "77, 106, 98"
  },
  {
    "name": "Pacific Blossom 247-3",
    "code": "NP BGG 1247 T",
    "hex": "#41C8A0",
    "rgb": "65, 200, 160"
  },
  {
    "name": "Saharan Sanctuary 248-3",
    "code": "NP BGG 1248 D",
    "hex": "#32DEAB",
    "rgb": "50, 222, 171"
  },
  {
    "name": "Coastal Glow 249-3",
    "code": "NP BGG 1249 A",
    "hex": "#457B6B",
    "rgb": "69, 123, 107"
  },
  {
    "name": "Soft Symphony 250-3",
    "code": "NP BGG 1250 N",
    "hex": "#6B7E79",
    "rgb": "107, 126, 121"
  },
  {
    "name": "Cool Horizon 251-2",
    "code": "NP BGG 1251 P",
    "hex": "#94E1CB",
    "rgb": "148, 225, 203"
  },
  {
    "name": "Muted Tranquility 252-2",
    "code": "NP BGG 1252 T",
    "hex": "#36C49C",
    "rgb": "54, 196, 156"
  },
  {
    "name": "Classic Breeze 253-2",
    "code": "NP BGG 1253 D",
    "hex": "#1B6953",
    "rgb": "27, 105, 83"
  },
  {
    "name": "Mystic Aura 254-2",
    "code": "NP BGG 1254 A",
    "hex": "#639D8D",
    "rgb": "99, 157, 141"
  },
  {
    "name": "Silver Feather 255-2",
    "code": "NP BGG 1255 N",
    "hex": "#C7EBE1",
    "rgb": "199, 235, 225"
  },
  {
    "name": "Satin Twilight 256-2",
    "code": "NP BGG 1256 P",
    "hex": "#60A290",
    "rgb": "96, 162, 144"
  },
  {
    "name": "Pacific Tide 257-2",
    "code": "NP BGG 1257 T",
    "hex": "#196852",
    "rgb": "25, 104, 82"
  },
  {
    "name": "Saharan Dream 258-2",
    "code": "NP BGG 1258 D",
    "hex": "#3ABF9C",
    "rgb": "58, 191, 156"
  },
  {
    "name": "Coastal Stone 259-2",
    "code": "NP BGG 1259 A",
    "hex": "#9EE3D1",
    "rgb": "158, 227, 209"
  },
  {
    "name": "Soft Dawn 260-2",
    "code": "NP BGG 1260 N",
    "hex": "#6D837D",
    "rgb": "109, 131, 125"
  },
  {
    "name": "Cool Canvas 261-2",
    "code": "NP BGG 1261 P",
    "hex": "#3E7769",
    "rgb": "62, 119, 105"
  },
  {
    "name": "Muted Shadow 262-2",
    "code": "NP BGG 1262 T",
    "hex": "#2EDBAF",
    "rgb": "46, 219, 175"
  },
  {
    "name": "Classic Velvet 263-2",
    "code": "NP BGG 1263 D",
    "hex": "#4ACCAC",
    "rgb": "74, 204, 172"
  },
  {
    "name": "Mystic Petal 264-2",
    "code": "NP BGG 1264 A",
    "hex": "#516D66",
    "rgb": "81, 109, 102"
  },
  {
    "name": "Silver Haven 265-2",
    "code": "NP BGG 1265 N",
    "hex": "#78948D",
    "rgb": "120, 148, 141"
  },
  {
    "name": "Satin Mist 266-2",
    "code": "NP BGG 1266 P",
    "hex": "#6AE9CB",
    "rgb": "106, 233, 203"
  },
  {
    "name": "Pacific Elegance 267-2",
    "code": "NP BGG 1267 T",
    "hex": "#23AC8B",
    "rgb": "35, 172, 139"
  },
  {
    "name": "Saharan Cloud 268-2",
    "code": "NP BGG 1268 D",
    "hex": "#2B6658",
    "rgb": "43, 102, 88"
  },
  {
    "name": "Coastal Serenity 269-2",
    "code": "NP BGG 1269 A",
    "hex": "#90B5AD",
    "rgb": "144, 181, 173"
  },
  {
    "name": "Soft Whisper 270-2",
    "code": "NP BGG 1270 N",
    "hex": "#B2E7DB",
    "rgb": "178, 231, 219"
  },
  {
    "name": "Cool Harmony 271-2",
    "code": "NP BGG 1271 P",
    "hex": "#368B78",
    "rgb": "54, 139, 120"
  },
  {
    "name": "Muted Sand 272-2",
    "code": "NP BGG 1272 T",
    "hex": "#17715D",
    "rgb": "23, 113, 93"
  },
  {
    "name": "Classic Dusk 273-2",
    "code": "NP BGG 1273 D",
    "hex": "#68D4BC",
    "rgb": "104, 212, 188"
  },
  {
    "name": "Mystic Echo 274-2",
    "code": "NP BGG 1274 A",
    "hex": "#B0D4CC",
    "rgb": "176, 212, 204"
  },
  {
    "name": "Silver Reflection 275-2",
    "code": "NP BGG 1275 N",
    "hex": "#52716B",
    "rgb": "82, 113, 107"
  },
  {
    "name": "Satin Silk 276-2",
    "code": "NP BGG 1276 P",
    "hex": "#2D8A77",
    "rgb": "45, 138, 119"
  },
  {
    "name": "Pacific Blossom 277-2",
    "code": "NP BGG 1277 T",
    "hex": "#34E7C1",
    "rgb": "52, 231, 193"
  },
  {
    "name": "Saharan Sanctuary 278-2",
    "code": "NP BGG 1278 D",
    "hex": "#67B6A6",
    "rgb": "103, 182, 166"
  },
  {
    "name": "Coastal Glow 279-2",
    "code": "NP BGG 1279 A",
    "hex": "#566663",
    "rgb": "86, 102, 99"
  },
  {
    "name": "Soft Symphony 280-2",
    "code": "NP BGG 1280 N",
    "hex": "#71ACA0",
    "rgb": "113, 172, 160"
  },
  {
    "name": "Cool Horizon 281-2",
    "code": "NP BGG 1281 P",
    "hex": "#40EAC8",
    "rgb": "64, 234, 200"
  },
  {
    "name": "Muted Tranquility 282-2",
    "code": "NP BGG 1282 T",
    "hex": "#26947F",
    "rgb": "38, 148, 127"
  },
  {
    "name": "Classic Breeze 283-2",
    "code": "NP BGG 1283 D",
    "hex": "#446C65",
    "rgb": "68, 108, 101"
  },
  {
    "name": "Mystic Aura 284-2",
    "code": "NP BGG 1284 A",
    "hex": "#ADCCC6",
    "rgb": "173, 204, 198"
  },
  {
    "name": "Silver Feather 285-2",
    "code": "NP BGG 1285 N",
    "hex": "#82DBCB",
    "rgb": "130, 219, 203"
  },
  {
    "name": "Satin Twilight 286-2",
    "code": "NP BGG 1286 P",
    "hex": "#1C7867",
    "rgb": "28, 120, 103"
  },
  {
    "name": "Pacific Tide 287-2",
    "code": "NP BGG 1287 T",
    "hex": "#278272",
    "rgb": "39, 130, 114"
  },
  {
    "name": "Saharan Dream 288-2",
    "code": "NP BGG 1288 D",
    "hex": "#9EE3D7",
    "rgb": "158, 227, 215"
  },
  {
    "name": "Coastal Stone 289-2",
    "code": "NP BGG 1289 A",
    "hex": "#A0C0BA",
    "rgb": "160, 192, 186"
  },
  {
    "name": "Soft Dawn 290-2",
    "code": "NP BGG 1290 N",
    "hex": "#36685F",
    "rgb": "54, 104, 95"
  },
  {
    "name": "Cool Canvas 291-2",
    "code": "NP BGG 1291 P",
    "hex": "#22A28C",
    "rgb": "34, 162, 140"
  },
  {
    "name": "Muted Shadow 292-2",
    "code": "NP BGG 1292 T",
    "hex": "#54EBD2",
    "rgb": "84, 235, 210"
  },
  {
    "name": "Classic Velvet 293-2",
    "code": "NP BGG 1293 D",
    "hex": "#779E98",
    "rgb": "119, 158, 152"
  },
  {
    "name": "Mystic Petal 294-2",
    "code": "NP BGG 1294 A",
    "hex": "#556966",
    "rgb": "85, 105, 102"
  },
  {
    "name": "Silver Haven 295-2",
    "code": "NP BGG 1295 N",
    "hex": "#58C3B2",
    "rgb": "88, 195, 178"
  },
  {
    "name": "Satin Mist 296-2",
    "code": "NP BGG 1296 P",
    "hex": "#2DE1C6",
    "rgb": "45, 225, 198"
  },
  {
    "name": "Pacific Elegance 297-2",
    "code": "NP BGG 1297 T",
    "hex": "#367F74",
    "rgb": "54, 127, 116"
  },
  {
    "name": "Saharan Cloud 298-2",
    "code": "NP BGG 1298 D",
    "hex": "#617A77",
    "rgb": "97, 122, 119"
  },
  {
    "name": "Coastal Serenity 299-2",
    "code": "NP BGG 1299 A",
    "hex": "#ABDED6",
    "rgb": "171, 222, 214"
  },
  {
    "name": "Soft Whisper 300-2",
    "code": "NP BGG 1300 N",
    "hex": "#4DC9B7",
    "rgb": "77, 201, 183"
  },
  {
    "name": "Cool Harmony 301-2",
    "code": "NP BGG 1301 P",
    "hex": "#166B5F",
    "rgb": "22, 107, 95"
  },
  {
    "name": "Muted Sand 302-2",
    "code": "NP BGG 1302 T",
    "hex": "#4B988D",
    "rgb": "75, 152, 141"
  },
  {
    "name": "Classic Dusk 303-2",
    "code": "NP BGG 1303 D",
    "hex": "#C2EAE5",
    "rgb": "194, 234, 229"
  },
  {
    "name": "Mystic Echo 304-2",
    "code": "NP BGG 1304 A",
    "hex": "#79A8A2",
    "rgb": "121, 168, 162"
  },
  {
    "name": "Silver Reflection 305-2",
    "code": "NP BGG 1305 N",
    "hex": "#21675E",
    "rgb": "33, 103, 94"
  },
  {
    "name": "Satin Silk 306-2",
    "code": "NP BGG 1306 P",
    "hex": "#2ABAA8",
    "rgb": "42, 186, 168"
  },
  {
    "name": "Pacific Blossom 307-2",
    "code": "NP BGG 1307 T",
    "hex": "#81E5D9",
    "rgb": "129, 229, 217"
  },
  {
    "name": "Saharan Sanctuary 308-2",
    "code": "NP BGG 1308 D",
    "hex": "#728785",
    "rgb": "114, 135, 133"
  },
  {
    "name": "Coastal Glow 309-2",
    "code": "NP BGG 1309 A",
    "hex": "#4C746F",
    "rgb": "76, 116, 111"
  },
  {
    "name": "Soft Symphony 310-2",
    "code": "NP BGG 1310 N",
    "hex": "#3BD7C6",
    "rgb": "59, 215, 198"
  },
  {
    "name": "Cool Horizon 311-2",
    "code": "NP BGG 1311 P",
    "hex": "#36D1C0",
    "rgb": "54, 209, 192"
  },
  {
    "name": "Muted Tranquility 312-2",
    "code": "NP BGG 1312 T",
    "hex": "#466F6B",
    "rgb": "70, 111, 107"
  },
  {
    "name": "Classic Breeze 313-2",
    "code": "NP BGG 1313 D",
    "hex": "#798E8C",
    "rgb": "121, 142, 140"
  },
  {
    "name": "Mystic Aura 314-2",
    "code": "NP BGG 1314 A",
    "hex": "#89E8DF",
    "rgb": "137, 232, 223"
  },
  {
    "name": "Silver Feather 315-2",
    "code": "NP BGG 1315 N",
    "hex": "#2AB2A5",
    "rgb": "42, 178, 165"
  },
  {
    "name": "Satin Twilight 316-2",
    "code": "NP BGG 1316 P",
    "hex": "#1F665F",
    "rgb": "31, 102, 95"
  },
  {
    "name": "Pacific Tide 317-2",
    "code": "NP BGG 1317 T",
    "hex": "#7AB0AB",
    "rgb": "122, 176, 171"
  },
  {
    "name": "Saharan Dream 318-2",
    "code": "NP BGG 1318 D",
    "hex": "#C3E9E5",
    "rgb": "195, 233, 229"
  },
  {
    "name": "Coastal Stone 319-2",
    "code": "NP BGG 1319 A",
    "hex": "#4B908A",
    "rgb": "75, 144, 138"
  },
  {
    "name": "Soft Dawn 320-2",
    "code": "NP BGG 1320 N",
    "hex": "#176E67",
    "rgb": "23, 110, 103"
  },
  {
    "name": "Cool Canvas 321-2",
    "code": "NP BGG 1321 P",
    "hex": "#4BD0C5",
    "rgb": "75, 208, 197"
  },
  {
    "name": "Muted Shadow 322-2",
    "code": "NP BGG 1322 T",
    "hex": "#A2D8D4",
    "rgb": "162, 216, 212"
  },
  {
    "name": "Classic Velvet 323-2",
    "code": "NP BGG 1323 D",
    "hex": "#5F7573",
    "rgb": "95, 117, 115"
  },
  {
    "name": "Mystic Petal 324-2",
    "code": "NP BGG 1324 A",
    "hex": "#3C8681",
    "rgb": "60, 134, 129"
  },
  {
    "name": "Silver Haven 325-2",
    "code": "NP BGG 1325 N",
    "hex": "#2EE5D8",
    "rgb": "46, 229, 216"
  },
  {
    "name": "Satin Mist 326-2",
    "code": "NP BGG 1326 P",
    "hex": "#4FBBB4",
    "rgb": "79, 187, 180"
  },
  {
    "name": "Pacific Elegance 327-2",
    "code": "NP BGG 1327 T",
    "hex": "#526766",
    "rgb": "82, 103, 102"
  },
  {
    "name": "Saharan Cloud 328-2",
    "code": "NP BGG 1328 D",
    "hex": "#80A6A4",
    "rgb": "128, 166, 164"
  },
  {
    "name": "Coastal Serenity 329-2",
    "code": "NP BGG 1329 A",
    "hex": "#5AEAE2",
    "rgb": "90, 234, 226"
  },
  {
    "name": "Soft Whisper 330-2",
    "code": "NP BGG 1330 N",
    "hex": "#1F9993",
    "rgb": "31, 153, 147"
  },
  {
    "name": "Cool Harmony 331-2",
    "code": "NP BGG 1331 P",
    "hex": "#346A67",
    "rgb": "52, 106, 103"
  },
  {
    "name": "Muted Sand 332-2",
    "code": "NP BGG 1332 T",
    "hex": "#A5C7C6",
    "rgb": "165, 199, 198"
  },
  {
    "name": "Classic Dusk 333-2",
    "code": "NP BGG 1333 D",
    "hex": "#A0DFDC",
    "rgb": "160, 223, 220"
  },
  {
    "name": "Mystic Echo 334-2",
    "code": "NP BGG 1334 A",
    "hex": "#287B78",
    "rgb": "40, 123, 120"
  },
  {
    "name": "Silver Reflection 335-2",
    "code": "NP BGG 1335 N",
    "hex": "#1C7E7A",
    "rgb": "28, 126, 122"
  },
  {
    "name": "Satin Silk 336-2",
    "code": "NP BGG 1336 P",
    "hex": "#7EE0DD",
    "rgb": "126, 224, 221"
  },
  {
    "name": "Pacific Blossom 337-2",
    "code": "NP BGG 1337 T",
    "hex": "#A6C5C4",
    "rgb": "166, 197, 196"
  },
  {
    "name": "Saharan Sanctuary 338-2",
    "code": "NP BGG 1338 D",
    "hex": "#456968",
    "rgb": "69, 105, 104"
  },
  {
    "name": "Coastal Glow 339-2",
    "code": "NP BGG 1339 A",
    "hex": "#2B9C99",
    "rgb": "43, 156, 153"
  },
  {
    "name": "Soft Symphony 340-2",
    "code": "NP BGG 1340 N",
    "hex": "#3CEBE6",
    "rgb": "60, 235, 230"
  },
  {
    "name": "Cool Horizon 341-2",
    "code": "NP BGG 1341 P",
    "hex": "#67A3A2",
    "rgb": "103, 163, 162"
  },
  {
    "name": "Muted Tranquility 342-2",
    "code": "NP BGG 1342 T",
    "hex": "#586767",
    "rgb": "88, 103, 103"
  },
  {
    "name": "Classic Breeze 343-2",
    "code": "NP BGG 1343 D",
    "hex": "#70BEBD",
    "rgb": "112, 190, 189"
  },
  {
    "name": "Mystic Aura 344-2",
    "code": "NP BGG 1344 A",
    "hex": "#36E4E2",
    "rgb": "54, 228, 226"
  },
  {
    "name": "Silver Feather 345-2",
    "code": "NP BGG 1345 N",
    "hex": "#288382",
    "rgb": "40, 131, 130"
  },
  {
    "name": "Satin Twilight 346-2",
    "code": "NP BGG 1346 P",
    "hex": "#527776",
    "rgb": "82, 119, 118"
  },
  {
    "name": "Pacific Tide 347-2",
    "code": "NP BGG 1347 T",
    "hex": "#B7DADA",
    "rgb": "183, 218, 218"
  },
  {
    "name": "Saharan Dream 348-2",
    "code": "NP BGG 1348 D",
    "hex": "#6BCDCD",
    "rgb": "107, 205, 205"
  },
  {
    "name": "Coastal Stone 349-2",
    "code": "NP BGG 1349 A",
    "hex": "#176D6D",
    "rgb": "23, 109, 109"
  },
  {
    "name": "Soft Dawn 350-2",
    "code": "NP BGG 1350 N",
    "hex": "#359293",
    "rgb": "53, 146, 147"
  },
  {
    "name": "Cool Canvas 351-2",
    "code": "NP BGG 1351 P",
    "hex": "#AFE9E9",
    "rgb": "175, 233, 233"
  },
  {
    "name": "Muted Shadow 352-2",
    "code": "NP BGG 1352 T",
    "hex": "#8CADAD",
    "rgb": "140, 173, 173"
  },
  {
    "name": "Classic Velvet 353-2",
    "code": "NP BGG 1353 D",
    "hex": "#2E6566",
    "rgb": "46, 101, 102"
  },
  {
    "name": "Mystic Petal 354-2",
    "code": "NP BGG 1354 A",
    "hex": "#24B2B4",
    "rgb": "36, 178, 180"
  },
  {
    "name": "Silver Haven 355-2",
    "code": "NP BGG 1355 N",
    "hex": "#62E5E7",
    "rgb": "98, 229, 231"
  },
  {
    "name": "Satin Mist 356-2",
    "code": "NP BGG 1356 P",
    "hex": "#6F8B8C",
    "rgb": "111, 139, 140"
  },
  {
    "name": "Pacific Elegance 357-2",
    "code": "NP BGG 1357 T",
    "hex": "#577071",
    "rgb": "87, 112, 113"
  },
  {
    "name": "Saharan Cloud 358-2",
    "code": "NP BGG 1358 D",
    "hex": "#51CFD3",
    "rgb": "81, 207, 211"
  },
  {
    "name": "Coastal Serenity 359-2",
    "code": "NP BGG 1359 A",
    "hex": "#2CCFD5",
    "rgb": "44, 207, 213"
  },
  {
    "name": "Soft Whisper 360-2",
    "code": "NP BGG 1360 N",
    "hex": "#387072",
    "rgb": "56, 112, 114"
  },
  {
    "name": "Cool Harmony 361-2",
    "code": "NP BGG 1361 P",
    "hex": "#72898A",
    "rgb": "114, 137, 138"
  },
  {
    "name": "Muted Sand 362-2",
    "code": "NP BGG 1362 T",
    "hex": "#A6E4E7",
    "rgb": "166, 228, 231"
  },
  {
    "name": "Classic Dusk 363-2",
    "code": "NP BGG 1363 D",
    "hex": "#3CB2B7",
    "rgb": "60, 178, 183"
  },
  {
    "name": "Mystic Echo 364-2",
    "code": "NP BGG 1364 A",
    "hex": "#176366",
    "rgb": "23, 99, 102"
  },
  {
    "name": "Silver Reflection 365-2",
    "code": "NP BGG 1365 N",
    "hex": "#60A7AB",
    "rgb": "96, 167, 171"
  },
  {
    "name": "Satin Silk 366-2",
    "code": "NP BGG 1366 P",
    "hex": "#C6E8EA",
    "rgb": "198, 232, 234"
  },
  {
    "name": "Pacific Blossom 367-2",
    "code": "NP BGG 1367 T",
    "hex": "#629295",
    "rgb": "98, 146, 149"
  },
  {
    "name": "Saharan Sanctuary 368-2",
    "code": "NP BGG 1368 D",
    "hex": "#1E676C",
    "rgb": "30, 103, 108"
  },
  {
    "name": "Coastal Glow 369-2",
    "code": "NP BGG 1369 A",
    "hex": "#34C2CB",
    "rgb": "52, 194, 203"
  },
  {
    "name": "Soft Symphony 370-2",
    "code": "NP BGG 1370 N",
    "hex": "#8BD7DC",
    "rgb": "139, 215, 220"
  },
  {
    "name": "Cool Horizon 371-2",
    "code": "NP BGG 1371 P",
    "hex": "#667778",
    "rgb": "102, 119, 120"
  },
  {
    "name": "Muted Tranquility 372-2",
    "code": "NP BGG 1372 T",
    "hex": "#4C7D81",
    "rgb": "76, 125, 129"
  },
  {
    "name": "Classic Breeze 373-2",
    "code": "NP BGG 1373 D",
    "hex": "#35D6E2",
    "rgb": "53, 214, 226"
  },
  {
    "name": "Mystic Aura 374-2",
    "code": "NP BGG 1374 A",
    "hex": "#3BB6C0",
    "rgb": "59, 182, 192"
  },
  {
    "name": "Silver Feather 375-2",
    "code": "NP BGG 1375 N",
    "hex": "#486568",
    "rgb": "72, 101, 104"
  },
  {
    "name": "Satin Twilight 376-2",
    "code": "NP BGG 1376 P",
    "hex": "#879FA1",
    "rgb": "135, 159, 161"
  },
  {
    "name": "Pacific Tide 377-2",
    "code": "NP BGG 1377 T",
    "hex": "#7AE1EB",
    "rgb": "122, 225, 235"
  },
  {
    "name": "Saharan Dream 378-2",
    "code": "NP BGG 1378 D",
    "hex": "#21949F",
    "rgb": "33, 148, 159"
  },
  {
    "name": "Coastal Stone 379-2",
    "code": "NP BGG 1379 A",
    "hex": "#266268",
    "rgb": "38, 98, 104"
  },
  {
    "name": "Soft Dawn 380-2",
    "code": "NP BGG 1380 N",
    "hex": "#92BEC2",
    "rgb": "146, 190, 194"
  },
  {
    "name": "Cool Canvas 381-2",
    "code": "NP BGG 1381 P",
    "hex": "#B7DDE1",
    "rgb": "183, 221, 225"
  },
  {
    "name": "Muted Shadow 382-2",
    "code": "NP BGG 1382 T",
    "hex": "#3A7980",
    "rgb": "58, 121, 128"
  },
  {
    "name": "Classic Velvet 383-2",
    "code": "NP BGG 1383 D",
    "hex": "#18707A",
    "rgb": "24, 112, 122"
  },
  {
    "name": "Mystic Petal 384-2",
    "code": "NP BGG 1384 A",
    "hex": "#5ED0DD",
    "rgb": "94, 208, 221"
  },
  {
    "name": "Silver Haven 385-2",
    "code": "NP BGG 1385 N",
    "hex": "#A0C5C9",
    "rgb": "160, 197, 201"
  },
  {
    "name": "Satin Mist 386-2",
    "code": "NP BGG 1386 P",
    "hex": "#52686B",
    "rgb": "82, 104, 107"
  },
  {
    "name": "Pacific Elegance 387-2",
    "code": "NP BGG 1387 T",
    "hex": "#3A8C97",
    "rgb": "58, 140, 151"
  },
  {
    "name": "Saharan Cloud 388-2",
    "code": "NP BGG 1388 D",
    "hex": "#30D4EA",
    "rgb": "48, 212, 234"
  },
  {
    "name": "Coastal Serenity 389-2",
    "code": "NP BGG 1389 A",
    "hex": "#539EA9",
    "rgb": "83, 158, 169"
  },
  {
    "name": "Soft Whisper 390-2",
    "code": "NP BGG 1390 N",
    "hex": "#556467",
    "rgb": "85, 100, 103"
  },
  {
    "name": "Cool Harmony 391-2",
    "code": "NP BGG 1391 P",
    "hex": "#85B2B9",
    "rgb": "133, 178, 185"
  },
  {
    "name": "Muted Sand 392-2",
    "code": "NP BGG 1392 T",
    "hex": "#4BD2E6",
    "rgb": "75, 210, 230"
  },
  {
    "name": "Classic Dusk 393-2",
    "code": "NP BGG 1393 D",
    "hex": "#1F7A88",
    "rgb": "31, 122, 136"
  },
  {
    "name": "Mystic Echo 394-2",
    "code": "NP BGG 1394 A",
    "hex": "#416C73",
    "rgb": "65, 108, 115"
  },
  {
    "name": "Silver Reflection 395-2",
    "code": "NP BGG 1395 N",
    "hex": "#B5D2D6",
    "rgb": "181, 210, 214"
  },
  {
    "name": "Satin Silk 396-2",
    "code": "NP BGG 1396 P",
    "hex": "#8AC7D2",
    "rgb": "138, 199, 210"
  },
  {
    "name": "Pacific Blossom 397-2",
    "code": "NP BGG 1397 T",
    "hex": "#1F6470",
    "rgb": "31, 100, 112"
  },
  {
    "name": "Saharan Sanctuary 398-2",
    "code": "NP BGG 1398 D",
    "hex": "#257E8E",
    "rgb": "37, 126, 142"
  },
  {
    "name": "Coastal Glow 399-2",
    "code": "NP BGG 1399 A",
    "hex": "#93DBE8",
    "rgb": "147, 219, 232"
  },
  {
    "name": "Soft Symphony 400-2",
    "code": "NP BGG 1400 N",
    "hex": "#98AEB3",
    "rgb": "152, 174, 179"
  },
  {
    "name": "Cool Horizon 401-1",
    "code": "NP BGG 1401 P",
    "hex": "#3C6066",
    "rgb": "60, 96, 102"
  },
  {
    "name": "Muted Tranquility 402-1",
    "code": "NP BGG 1402 T",
    "hex": "#299AAF",
    "rgb": "41, 154, 175"
  },
  {
    "name": "Classic Breeze 403-1",
    "code": "NP BGG 1403 D",
    "hex": "#47CFE9",
    "rgb": "71, 207, 233"
  },
  {
    "name": "Mystic Aura 404-1",
    "code": "NP BGG 1404 A",
    "hex": "#658A91",
    "rgb": "101, 138, 145"
  },
  {
    "name": "Silver Feather 405-1",
    "code": "NP BGG 1405 N",
    "hex": "#5C6B6E",
    "rgb": "92, 107, 110"
  },
  {
    "name": "Satin Twilight 406-1",
    "code": "NP BGG 1406 P",
    "hex": "#6CBECF",
    "rgb": "108, 190, 207"
  },
  {
    "name": "Pacific Tide 407-1",
    "code": "NP BGG 1407 T",
    "hex": "#2EBBD9",
    "rgb": "46, 187, 217"
  },
  {
    "name": "Saharan Dream 408-1",
    "code": "NP BGG 1408 D",
    "hex": "#2A6875",
    "rgb": "42, 104, 117"
  },
  {
    "name": "Coastal Stone 409-1",
    "code": "NP BGG 1409 A",
    "hex": "#647F85",
    "rgb": "100, 127, 133"
  },
  {
    "name": "Soft Dawn 410-1",
    "code": "NP BGG 1410 N",
    "hex": "#B9DDE4",
    "rgb": "185, 221, 228"
  },
  {
    "name": "Cool Canvas 411-1",
    "code": "NP BGG 1411 P",
    "hex": "#55A9BC",
    "rgb": "85, 169, 188"
  },
  {
    "name": "Muted Shadow 412-1",
    "code": "NP BGG 1412 T",
    "hex": "#155867",
    "rgb": "21, 88, 103"
  },
  {
    "name": "Classic Velvet 413-1",
    "code": "NP BGG 1413 D",
    "hex": "#4693A5",
    "rgb": "70, 147, 165"
  },
  {
    "name": "Mystic Petal 414-1",
    "code": "NP BGG 1414 A",
    "hex": "#BBE1EA",
    "rgb": "187, 225, 234"
  },
  {
    "name": "Silver Haven 415-1",
    "code": "NP BGG 1415 N",
    "hex": "#77939A",
    "rgb": "119, 147, 154"
  },
  {
    "name": "Satin Mist 416-1",
    "code": "NP BGG 1416 P",
    "hex": "#295D6A",
    "rgb": "41, 93, 106"
  },
  {
    "name": "Pacific Elegance 417-1",
    "code": "NP BGG 1417 T",
    "hex": "#29A6C6",
    "rgb": "41, 166, 198"
  },
  {
    "name": "Saharan Cloud 418-1",
    "code": "NP BGG 1418 D",
    "hex": "#6EC8DF",
    "rgb": "110, 200, 223"
  },
  {
    "name": "Coastal Serenity 419-1",
    "code": "NP BGG 1419 A",
    "hex": "#67787C",
    "rgb": "103, 120, 124"
  },
  {
    "name": "Soft Whisper 420-1",
    "code": "NP BGG 1420 N",
    "hex": "#5A767D",
    "rgb": "90, 118, 125"
  },
  {
    "name": "Cool Harmony 421-1",
    "code": "NP BGG 1421 P",
    "hex": "#49BFE0",
    "rgb": "73, 191, 224"
  },
  {
    "name": "Muted Sand 422-1",
    "code": "NP BGG 1422 T",
    "hex": "#2CA4C5",
    "rgb": "44, 164, 197"
  },
  {
    "name": "Classic Dusk 423-1",
    "code": "NP BGG 1423 D",
    "hex": "#3C5F69",
    "rgb": "60, 95, 105"
  },
  {
    "name": "Mystic Echo 424-1",
    "code": "NP BGG 1424 A",
    "hex": "#84969B",
    "rgb": "132, 150, 155"
  },
  {
    "name": "Silver Reflection 425-1",
    "code": "NP BGG 1425 N",
    "hex": "#9AD8EA",
    "rgb": "154, 216, 234"
  },
  {
    "name": "Satin Silk 426-1",
    "code": "NP BGG 1426 P",
    "hex": "#2D89A4",
    "rgb": "45, 137, 164"
  },
  {
    "name": "Pacific Blossom 427-1",
    "code": "NP BGG 1427 T",
    "hex": "#1B5567",
    "rgb": "27, 85, 103"
  },
  {
    "name": "Saharan Sanctuary 428-1",
    "code": "NP BGG 1428 D",
    "hex": "#78ADBD",
    "rgb": "120, 173, 189"
  },
  {
    "name": "Coastal Glow 429-1",
    "code": "NP BGG 1429 A",
    "hex": "#C2DCE4",
    "rgb": "194, 220, 228"
  },
  {
    "name": "Soft Symphony 430-1",
    "code": "NP BGG 1430 N",
    "hex": "#4E7784",
    "rgb": "78, 119, 132"
  },
  {
    "name": "Cool Horizon 431-1",
    "code": "NP BGG 1431 P",
    "hex": "#1C6076",
    "rgb": "28, 96, 118"
  },
  {
    "name": "Muted Tranquility 432-1",
    "code": "NP BGG 1432 T",
    "hex": "#42B4DA",
    "rgb": "66, 180, 218"
  },
  {
    "name": "Classic Breeze 433-1",
    "code": "NP BGG 1433 D",
    "hex": "#8FBECE",
    "rgb": "143, 190, 206"
  },
  {
    "name": "Mystic Aura 434-1",
    "code": "NP BGG 1434 A",
    "hex": "#5B696D",
    "rgb": "91, 105, 109"
  },
  {
    "name": "Silver Feather 435-1",
    "code": "NP BGG 1435 N",
    "hex": "#4C8092",
    "rgb": "76, 128, 146"
  },
  {
    "name": "Satin Twilight 436-1",
    "code": "NP BGG 1436 P",
    "hex": "#31B9E9",
    "rgb": "49, 185, 233"
  },
  {
    "name": "Pacific Tide 437-1",
    "code": "NP BGG 1437 T",
    "hex": "#3F91AE",
    "rgb": "63, 145, 174"
  },
  {
    "name": "Saharan Dream 438-1",
    "code": "NP BGG 1438 D",
    "hex": "#4D5F66",
    "rgb": "77, 95, 102"
  },
  {
    "name": "Coastal Stone 439-1",
    "code": "NP BGG 1439 A",
    "hex": "#92AAB4",
    "rgb": "146, 170, 180"
  },
  {
    "name": "Soft Dawn 440-1",
    "code": "NP BGG 1440 N",
    "hex": "#68C5E8",
    "rgb": "104, 197, 232"
  },
  {
    "name": "Cool Canvas 441-1",
    "code": "NP BGG 1441 P",
    "hex": "#1C6E8D",
    "rgb": "28, 110, 141"
  },
  {
    "name": "Muted Shadow 442-1",
    "code": "NP BGG 1442 T",
    "hex": "#305E70",
    "rgb": "48, 94, 112"
  },
  {
    "name": "Classic Velvet 443-1",
    "code": "NP BGG 1443 D",
    "hex": "#A8C6D2",
    "rgb": "168, 198, 210"
  },
  {
    "name": "Mystic Petal 444-1",
    "code": "NP BGG 1444 A",
    "hex": "#A4C8D6",
    "rgb": "164, 200, 214"
  },
  {
    "name": "Silver Haven 445-1",
    "code": "NP BGG 1445 N",
    "hex": "#2C5E72",
    "rgb": "44, 94, 114"
  },
  {
    "name": "Satin Mist 446-1",
    "code": "NP BGG 1446 P",
    "hex": "#1C6989",
    "rgb": "28, 105, 137"
  },
  {
    "name": "Pacific Elegance 447-1",
    "code": "NP BGG 1447 T",
    "hex": "#72C4E6",
    "rgb": "114, 196, 230"
  },
  {
    "name": "Saharan Cloud 448-1",
    "code": "NP BGG 1448 D",
    "hex": "#98AFB8",
    "rgb": "152, 175, 184"
  },
  {
    "name": "Coastal Serenity 449-1",
    "code": "NP BGG 1449 A",
    "hex": "#4A5E66",
    "rgb": "74, 94, 102"
  },
  {
    "name": "Soft Whisper 450-1",
    "code": "NP BGG 1450 N",
    "hex": "#3787AA",
    "rgb": "55, 135, 170"
  },
  {
    "name": "Cool Harmony 1-4",
    "code": "NP PB 1001 P",
    "hex": "#196B99",
    "rgb": "25, 107, 153"
  },
  {
    "name": "Muted Sand 2-4",
    "code": "NP PB 1002 T",
    "hex": "#1D455C",
    "rgb": "29, 69, 92"
  },
  {
    "name": "Classic Dusk 3-4",
    "code": "NP PB 1003 D",
    "hex": "#8CABBD",
    "rgb": "140, 171, 189"
  },
  {
    "name": "Mystic Echo 4-4",
    "code": "NP PB 1004 A",
    "hex": "#B6D1E1",
    "rgb": "182, 209, 225"
  },
  {
    "name": "Silver Reflection 5-4",
    "code": "NP PB 1005 N",
    "hex": "#325D76",
    "rgb": "50, 93, 118"
  },
  {
    "name": "Satin Silk 6-3",
    "code": "NP PB 1006 P",
    "hex": "#114B6E",
    "rgb": "17, 75, 110"
  },
  {
    "name": "Pacific Blossom 7-4",
    "code": "NP PB 1007 T",
    "hex": "#55A8DB",
    "rgb": "85, 168, 219"
  },
  {
    "name": "Saharan Sanctuary 8-4",
    "code": "NP PB 1008 D",
    "hex": "#9DB7C7",
    "rgb": "157, 183, 199"
  },
  {
    "name": "Coastal Glow 9-4",
    "code": "NP PB 1009 A",
    "hex": "#49575F",
    "rgb": "73, 87, 95"
  },
  {
    "name": "Soft Symphony 10-4",
    "code": "NP PB 1010 N",
    "hex": "#326A8E",
    "rgb": "50, 106, 142"
  },
  {
    "name": "Cool Horizon 11-4",
    "code": "NP PB 1011 P",
    "hex": "#249DEA",
    "rgb": "36, 157, 234"
  },
  {
    "name": "Muted Tranquility 12-4",
    "code": "NP PB 1012 T",
    "hex": "#4C81A3",
    "rgb": "76, 129, 163"
  },
  {
    "name": "Classic Breeze 13-4",
    "code": "NP PB 1013 D",
    "hex": "#4A535A",
    "rgb": "74, 83, 90"
  },
  {
    "name": "Mystic Aura 14-4",
    "code": "NP PB 1014 A",
    "hex": "#7F9EB3",
    "rgb": "127, 158, 179"
  },
  {
    "name": "Silver Feather 15-4",
    "code": "NP PB 1015 N",
    "hex": "#42A4E6",
    "rgb": "66, 164, 230"
  },
  {
    "name": "Satin Twilight 16-4",
    "code": "NP PB 1016 P",
    "hex": "#16557F",
    "rgb": "22, 85, 127"
  },
  {
    "name": "Pacific Tide 17-4",
    "code": "NP PB 1017 T",
    "hex": "#375467",
    "rgb": "55, 84, 103"
  },
  {
    "name": "Saharan Dream 18-4",
    "code": "NP PB 1018 D",
    "hex": "#B3C6D4",
    "rgb": "179, 198, 212"
  },
  {
    "name": "Coastal Stone 19-4",
    "code": "NP PB 1019 A",
    "hex": "#87B2D0",
    "rgb": "135, 178, 208"
  },
  {
    "name": "Soft Dawn 20-4",
    "code": "NP PB 1020 N",
    "hex": "#174464",
    "rgb": "23, 68, 100"
  },
  {
    "name": "Cool Canvas 21-4",
    "code": "NP PB 1021 P",
    "hex": "#1C5884",
    "rgb": "28, 88, 132"
  },
  {
    "name": "Muted Shadow 22-4",
    "code": "NP PB 1022 T",
    "hex": "#8EC1E7",
    "rgb": "142, 193, 231"
  },
  {
    "name": "Classic Velvet 23-4",
    "code": "NP PB 1023 D",
    "hex": "#94A3AE",
    "rgb": "148, 163, 174"
  },
  {
    "name": "Mystic Petal 24-4",
    "code": "NP PB 1024 A",
    "hex": "#334959",
    "rgb": "51, 73, 89"
  },
  {
    "name": "Silver Haven 25-4",
    "code": "NP PB 1025 N",
    "hex": "#206DA8",
    "rgb": "32, 109, 168"
  },
  {
    "name": "Satin Mist 26-4",
    "code": "NP PB 1026 P",
    "hex": "#3C9EE9",
    "rgb": "60, 158, 233"
  },
  {
    "name": "Pacific Elegance 27-4",
    "code": "NP PB 1027 T",
    "hex": "#5D7689",
    "rgb": "93, 118, 137"
  },
  {
    "name": "Saharan Cloud 28-4",
    "code": "NP PB 1028 D",
    "hex": "#515A61",
    "rgb": "81, 90, 97"
  },
  {
    "name": "Coastal Serenity 29-4",
    "code": "NP PB 1029 A",
    "hex": "#669ECB",
    "rgb": "102, 158, 203"
  },
  {
    "name": "Soft Whisper 30-4",
    "code": "NP PB 1030 N",
    "hex": "#2387D8",
    "rgb": "35, 135, 216"
  },
  {
    "name": "Cool Harmony 31-4",
    "code": "NP PB 1031 P",
    "hex": "#224A6B",
    "rgb": "34, 74, 107"
  },
  {
    "name": "Muted Sand 32-4",
    "code": "NP PB 1032 T",
    "hex": "#5B6C7A",
    "rgb": "91, 108, 122"
  },
  {
    "name": "Classic Dusk 33-4",
    "code": "NP PB 1033 D",
    "hex": "#B8D0E3",
    "rgb": "184, 208, 227"
  },
  {
    "name": "Mystic Echo 34-4",
    "code": "NP PB 1034 A",
    "hex": "#4E88B9",
    "rgb": "78, 136, 185"
  },
  {
    "name": "Silver Reflection 35-4",
    "code": "NP PB 1035 N",
    "hex": "#0E375B",
    "rgb": "14, 55, 91"
  },
  {
    "name": "Satin Silk 36-4",
    "code": "NP PB 1036 P",
    "hex": "#3D719D",
    "rgb": "61, 113, 157"
  },
  {
    "name": "Pacific Blossom 37-4",
    "code": "NP PB 1037 T",
    "hex": "#B9D3EA",
    "rgb": "185, 211, 234"
  },
  {
    "name": "Saharan Sanctuary 38-4",
    "code": "NP PB 1038 D",
    "hex": "#718394",
    "rgb": "113, 131, 148"
  },
  {
    "name": "Coastal Glow 39-4",
    "code": "NP PB 1039 A",
    "hex": "#21415D",
    "rgb": "33, 65, 93"
  },
  {
    "name": "Soft Symphony 40-4",
    "code": "NP PB 1040 N",
    "hex": "#1E74C2",
    "rgb": "30, 116, 194"
  },
  {
    "name": "Cool Horizon 41-4",
    "code": "NP PB 1041 P",
    "hex": "#67A5DF",
    "rgb": "103, 165, 223"
  },
  {
    "name": "Muted Tranquility 42-4",
    "code": "NP PB 1042 T",
    "hex": "#5E6972",
    "rgb": "94, 105, 114"
  },
  {
    "name": "Classic Breeze 43-4",
    "code": "NP PB 1043 D",
    "hex": "#516272",
    "rgb": "81, 98, 114"
  },
  {
    "name": "Mystic Aura 44-4",
    "code": "NP PB 1044 A",
    "hex": "#4091DE",
    "rgb": "64, 145, 222"
  },
  {
    "name": "Silver Feather 45-4",
    "code": "NP PB 1045 N",
    "hex": "#2274C3",
    "rgb": "34, 116, 195"
  },
  {
    "name": "Satin Twilight 46-4",
    "code": "NP PB 1046 P",
    "hex": "#32485D",
    "rgb": "50, 72, 93"
  },
  {
    "name": "Pacific Tide 47-4",
    "code": "NP PB 1047 T",
    "hex": "#7C8793",
    "rgb": "124, 135, 147"
  },
  {
    "name": "Saharan Dream 48-4",
    "code": "NP PB 1048 D",
    "hex": "#98C1EA",
    "rgb": "152, 193, 234"
  },
  {
    "name": "Coastal Stone 49-4",
    "code": "NP PB 1049 A",
    "hex": "#25619E",
    "rgb": "37, 97, 158"
  },
  {
    "name": "Soft Dawn 50-4",
    "code": "NP PB 1050 N",
    "hex": "#13365A",
    "rgb": "19, 54, 90"
  },
  {
    "name": "Cool Canvas 51-4",
    "code": "NP PB 1051 P",
    "hex": "#7193B8",
    "rgb": "113, 147, 184"
  },
  {
    "name": "Muted Shadow 52-4",
    "code": "NP PB 1052 T",
    "hex": "#C2D2E4",
    "rgb": "194, 210, 228"
  },
  {
    "name": "Classic Velvet 53-4",
    "code": "NP PB 1053 D",
    "hex": "#47607B",
    "rgb": "71, 96, 123"
  },
  {
    "name": "Mystic Petal 54-4",
    "code": "NP PB 1054 A",
    "hex": "#143D6A",
    "rgb": "20, 61, 106"
  },
  {
    "name": "Silver Haven 55-4",
    "code": "NP PB 1055 N",
    "hex": "#3884D7",
    "rgb": "56, 132, 215"
  },
  {
    "name": "Satin Mist 56-4",
    "code": "NP PB 1056 P",
    "hex": "#8BAACC",
    "rgb": "139, 170, 204"
  },
  {
    "name": "Pacific Elegance 57-4",
    "code": "NP PB 1057 T",
    "hex": "#525962",
    "rgb": "82, 89, 98"
  },
  {
    "name": "Saharan Cloud 58-4",
    "code": "NP PB 1058 D",
    "hex": "#446488",
    "rgb": "68, 100, 136"
  },
  {
    "name": "Coastal Serenity 59-4",
    "code": "NP PB 1059 A",
    "hex": "#2681E9",
    "rgb": "38, 129, 233"
  },
  {
    "name": "Soft Whisper 60-4",
    "code": "NP PB 1060 N",
    "hex": "#366BA9",
    "rgb": "54, 107, 169"
  },
  {
    "name": "Cool Harmony 61-4",
    "code": "NP PB 1061 P",
    "hex": "#424D59",
    "rgb": "66, 77, 89"
  },
  {
    "name": "Muted Sand 62-4",
    "code": "NP PB 1062 T",
    "hex": "#8C9BAD",
    "rgb": "140, 155, 173"
  },
  {
    "name": "Classic Dusk 63-4",
    "code": "NP PB 1063 D",
    "hex": "#629FE8",
    "rgb": "98, 159, 232"
  },
  {
    "name": "Mystic Echo 64-4",
    "code": "NP PB 1064 A",
    "hex": "#144785",
    "rgb": "20, 71, 133"
  },
  {
    "name": "Silver Reflection 65-4",
    "code": "NP PB 1065 N",
    "hex": "#274264",
    "rgb": "39, 66, 100"
  },
  {
    "name": "Satin Silk 66-4",
    "code": "NP PB 1066 P",
    "hex": "#A4B7CF",
    "rgb": "164, 183, 207"
  },
  {
    "name": "Pacific Blossom 67-4",
    "code": "NP PB 1067 T",
    "hex": "#A3B9D4",
    "rgb": "163, 185, 212"
  },
  {
    "name": "Saharan Sanctuary 68-4",
    "code": "NP PB 1068 D",
    "hex": "#254268",
    "rgb": "37, 66, 104"
  },
  {
    "name": "Coastal Glow 69-4",
    "code": "NP PB 1069 A",
    "hex": "#14427E",
    "rgb": "20, 66, 126"
  },
  {
    "name": "Soft Symphony 70-4",
    "code": "NP PB 1070 N",
    "hex": "#6A9FE5",
    "rgb": "106, 159, 229"
  },
  {
    "name": "Cool Horizon 71-4",
    "code": "NP PB 1071 P",
    "hex": "#95A2B4",
    "rgb": "149, 162, 180"
  },
  {
    "name": "Muted Tranquility 72-4",
    "code": "NP PB 1072 T",
    "hex": "#404B5A",
    "rgb": "64, 75, 90"
  },
  {
    "name": "Classic Breeze 73-4",
    "code": "NP PB 1073 D",
    "hex": "#2F60A2",
    "rgb": "47, 96, 162"
  },
  {
    "name": "Mystic Aura 74-4",
    "code": "NP PB 1074 A",
    "hex": "#297AEA",
    "rgb": "41, 122, 234"
  },
  {
    "name": "Silver Feather 75-4",
    "code": "NP PB 1075 N",
    "hex": "#4D688F",
    "rgb": "77, 104, 143"
  },
  {
    "name": "Satin Twilight 76-4",
    "code": "NP PB 1076 P",
    "hex": "#50565F",
    "rgb": "80, 86, 95"
  },
  {
    "name": "Pacific Tide 77-4",
    "code": "NP PB 1077 T",
    "hex": "#809DC6",
    "rgb": "128, 157, 198"
  },
  {
    "name": "Saharan Dream 78-4",
    "code": "NP PB 1078 D",
    "hex": "#3378DC",
    "rgb": "51, 120, 220"
  },
  {
    "name": "Coastal Stone 79-4",
    "code": "NP PB 1079 A",
    "hex": "#173B6F",
    "rgb": "23, 59, 111"
  },
  {
    "name": "Soft Dawn 80-4",
    "code": "NP PB 1080 N",
    "hex": "#485A75",
    "rgb": "72, 90, 117"
  },
  {
    "name": "Cool Canvas 81-3",
    "code": "NP PB 1081 P",
    "hex": "#BFCCE1",
    "rgb": "191, 204, 225"
  },
  {
    "name": "Muted Shadow 82-4",
    "code": "NP PB 1082 T",
    "hex": "#6D8DBE",
    "rgb": "109, 141, 190"
  },
  {
    "name": "Classic Velvet 83-4",
    "code": "NP PB 1083 D",
    "hex": "#112F5C",
    "rgb": "17, 47, 92"
  },
  {
    "name": "Mystic Petal 84-4",
    "code": "NP PB 1084 A",
    "hex": "#275398",
    "rgb": "39, 83, 152"
  },
  {
    "name": "Silver Haven 85-4",
    "code": "NP PB 1085 N",
    "hex": "#A0BDEB",
    "rgb": "160, 189, 235"
  },
  {
    "name": "Satin Mist 86-3",
    "code": "NP PB 1086 P",
    "hex": "#808A9A",
    "rgb": "128, 138, 154"
  },
  {
    "name": "Pacific Elegance 87-4",
    "code": "NP PB 1087 T",
    "hex": "#2E3F5B",
    "rgb": "46, 63, 91"
  },
  {
    "name": "Saharan Cloud 88-4",
    "code": "NP PB 1088 D",
    "hex": "#1F5ABC",
    "rgb": "31, 90, 188"
  },
  {
    "name": "Coastal Serenity 89-4",
    "code": "NP PB 1089 A",
    "hex": "#4882E2",
    "rgb": "72, 130, 226"
  },
  {
    "name": "Soft Whisper 90-4",
    "code": "NP PB 1090 N",
    "hex": "#586477",
    "rgb": "88, 100, 119"
  },
  {
    "name": "Cool Harmony 91-4",
    "code": "NP PB 1091 P",
    "hex": "#58606D",
    "rgb": "88, 96, 109"
  },
  {
    "name": "Muted Sand 92-4",
    "code": "NP PB 1092 T",
    "hex": "#5D8BDA",
    "rgb": "93, 139, 218"
  },
  {
    "name": "Classic Dusk 93-4",
    "code": "NP PB 1093 D",
    "hex": "#1E5CC8",
    "rgb": "30, 92, 200"
  },
  {
    "name": "Mystic Echo 94-4",
    "code": "NP PB 1094 A",
    "hex": "#253A60",
    "rgb": "37, 58, 96"
  },
  {
    "name": "Silver Reflection 95-4",
    "code": "NP PB 1095 N",
    "hex": "#6F7A8D",
    "rgb": "111, 122, 141"
  },
  {
    "name": "Satin Silk 96-4",
    "code": "NP PB 1096 P",
    "hex": "#B3C6EA",
    "rgb": "179, 198, 234"
  },
  {
    "name": "Pacific Blossom 97-4",
    "code": "NP PB 1097 T",
    "hex": "#3A5FA4",
    "rgb": "58, 95, 164"
  },
  {
    "name": "Saharan Sanctuary 98-4",
    "code": "NP PB 1098 D",
    "hex": "#0E285A",
    "rgb": "14, 40, 90"
  },
  {
    "name": "Coastal Glow 99-4",
    "code": "NP PB 1099 A",
    "hex": "#5374B2",
    "rgb": "83, 116, 178"
  },
  {
    "name": "Soft Symphony 100-4",
    "code": "NP PB 1100 N",
    "hex": "#BECCE6",
    "rgb": "190, 204, 230"
  },
  {
    "name": "Cool Horizon 101-4",
    "code": "NP PB 1101 P",
    "hex": "#5B6880",
    "rgb": "91, 104, 128"
  },
  {
    "name": "Muted Tranquility 102-4",
    "code": "NP PB 1102 T",
    "hex": "#1D3666",
    "rgb": "29, 54, 102"
  },
  {
    "name": "Classic Breeze 103-4",
    "code": "NP PB 1103 D",
    "hex": "#255FD3",
    "rgb": "37, 95, 211"
  },
  {
    "name": "Mystic Aura 104-4",
    "code": "NP PB 1104 A",
    "hex": "#7190D1",
    "rgb": "113, 144, 209"
  },
  {
    "name": "Silver Feather 105-4",
    "code": "NP PB 1105 N",
    "hex": "#555A65",
    "rgb": "85, 90, 101"
  },
  {
    "name": "Satin Twilight 106-4",
    "code": "NP PB 1106 P",
    "hex": "#556483",
    "rgb": "85, 100, 131"
  },
  {
    "name": "Pacific Tide 107-4",
    "code": "NP PB 1107 T",
    "hex": "#366FE7",
    "rgb": "54, 111, 231"
  },
  {
    "name": "Saharan Dream 108-4",
    "code": "NP PB 1108 D",
    "hex": "#2551AF",
    "rgb": "37, 81, 175"
  },
  {
    "name": "Coastal Stone 109-4",
    "code": "NP PB 1109 A",
    "hex": "#374259",
    "rgb": "55, 66, 89"
  },
  {
    "name": "Soft Dawn 110-4",
    "code": "NP PB 1110 N",
    "hex": "#8E96A7",
    "rgb": "142, 150, 167"
  },
  {
    "name": "Cool Canvas 111-4",
    "code": "NP PB 1111 P",
    "hex": "#86A4E9",
    "rgb": "134, 164, 233"
  },
  {
    "name": "Muted Shadow 112-4",
    "code": "NP PB 1112 T",
    "hex": "#1A3D8A",
    "rgb": "26, 61, 138"
  },
  {
    "name": "Classic Velvet 113-4",
    "code": "NP PB 1113 D",
    "hex": "#192F61",
    "rgb": "25, 47, 97"
  },
  {
    "name": "Mystic Petal 114-4",
    "code": "NP PB 1114 A",
    "hex": "#8A9DCA",
    "rgb": "138, 157, 202"
  },
  {
    "name": "Silver Haven 115-4",
    "code": "NP PB 1115 N",
    "hex": "#B5C0D9",
    "rgb": "181, 192, 217"
  },
  {
    "name": "Satin Mist 116-4",
    "code": "NP PB 1116 P",
    "hex": "#36456B",
    "rgb": "54, 69, 107"
  },
  {
    "name": "Pacific Elegance 117-4",
    "code": "NP PB 1117 T",
    "hex": "#143179",
    "rgb": "20, 49, 121"
  },
  {
    "name": "Saharan Cloud 118-4",
    "code": "NP PB 1118 D",
    "hex": "#4975E3",
    "rgb": "73, 117, 227"
  },
  {
    "name": "Coastal Serenity 119-4",
    "code": "NP PB 1119 A",
    "hex": "#8A97BA",
    "rgb": "138, 151, 186"
  },
  {
    "name": "Soft Whisper 120-4",
    "code": "NP PB 1120 N",
    "hex": "#494E5B",
    "rgb": "73, 78, 91"
  },
  {
    "name": "Cool Harmony 121-4",
    "code": "NP PB 1121 P",
    "hex": "#425B9D",
    "rgb": "66, 91, 157"
  },
  {
    "name": "Muted Sand 122-4",
    "code": "NP PB 1122 T",
    "hex": "#235AEA",
    "rgb": "35, 90, 234"
  },
  {
    "name": "Classic Dusk 123-4",
    "code": "NP PB 1123 D",
    "hex": "#3A5395",
    "rgb": "58, 83, 149"
  },
  {
    "name": "Mystic Echo 124-4",
    "code": "NP PB 1124 A",
    "hex": "#494F5D",
    "rgb": "73, 79, 93"
  },
  {
    "name": "Silver Reflection 125-4",
    "code": "NP PB 1125 N",
    "hex": "#94A0C1",
    "rgb": "148, 160, 193"
  },
  {
    "name": "Satin Silk 126-4",
    "code": "NP PB 1126 P",
    "hex": "#4E75DF",
    "rgb": "78, 117, 223"
  },
  {
    "name": "Pacific Blossom 127-4",
    "code": "NP PB 1127 T",
    "hex": "#122B73",
    "rgb": "18, 43, 115"
  },
  {
    "name": "Saharan Sanctuary 128-4",
    "code": "NP PB 1128 D",
    "hex": "#344471",
    "rgb": "52, 68, 113"
  },
  {
    "name": "Coastal Glow 129-4",
    "code": "NP PB 1129 A",
    "hex": "#B7C1DD",
    "rgb": "183, 193, 221"
  },
  {
    "name": "Soft Symphony 130-4",
    "code": "NP PB 1130 N",
    "hex": "#8B99C4",
    "rgb": "139, 153, 196"
  },
  {
    "name": "Cool Horizon 131-4",
    "code": "NP PB 1131 P",
    "hex": "#1B2C5E",
    "rgb": "27, 44, 94"
  },
  {
    "name": "Muted Tranquility 132-4",
    "code": "NP PB 1132 T",
    "hex": "#1A3792",
    "rgb": "26, 55, 146"
  },
  {
    "name": "Classic Breeze 133-4",
    "code": "NP PB 1133 D",
    "hex": "#7E99EA",
    "rgb": "126, 153, 234"
  },
  {
    "name": "Mystic Aura 134-4",
    "code": "NP PB 1134 A",
    "hex": "#878D9F",
    "rgb": "135, 141, 159"
  },
  {
    "name": "Silver Feather 135-4",
    "code": "NP PB 1135 N",
    "hex": "#3A425A",
    "rgb": "58, 66, 90"
  },
  {
    "name": "Satin Twilight 136-4",
    "code": "NP PB 1136 P",
    "hex": "#2A4BB7",
    "rgb": "42, 75, 183"
  },
  {
    "name": "Pacific Tide 137-4",
    "code": "NP PB 1137 T",
    "hex": "#305AE4",
    "rgb": "48, 90, 228"
  },
  {
    "name": "Saharan Dream 138-4",
    "code": "NP PB 1138 D",
    "hex": "#4C577C",
    "rgb": "76, 87, 124"
  },
  {
    "name": "Coastal Stone 139-4",
    "code": "NP PB 1139 A",
    "hex": "#5A5D69",
    "rgb": "90, 93, 105"
  },
  {
    "name": "Soft Dawn 140-4",
    "code": "NP PB 1140 N",
    "hex": "#7B8FD7",
    "rgb": "123, 143, 215"
  },
  {
    "name": "Cool Canvas 141-4",
    "code": "NP PB 1141 P",
    "hex": "#274BCD",
    "rgb": "39, 75, 205"
  },
  {
    "name": "Muted Shadow 142-4",
    "code": "NP PB 1142 T",
    "hex": "#1A2962",
    "rgb": "26, 41, 98"
  },
  {
    "name": "Classic Velvet 143-4",
    "code": "NP PB 1143 D",
    "hex": "#5C6587",
    "rgb": "92, 101, 135"
  },
  {
    "name": "Mystic Petal 144-4",
    "code": "NP PB 1144 A",
    "hex": "#C3CAE8",
    "rgb": "195, 202, 232"
  },
  {
    "name": "Silver Haven 145-4",
    "code": "NP PB 1145 N",
    "hex": "#5567AA",
    "rgb": "85, 103, 170"
  },
  {
    "name": "Satin Mist 146-4",
    "code": "NP PB 1146 P",
    "hex": "#0E1E59",
    "rgb": "14, 30, 89"
  },
  {
    "name": "Pacific Elegance 147-4",
    "code": "NP PB 1147 T",
    "hex": "#374FAC",
    "rgb": "55, 79, 172"
  },
  {
    "name": "Saharan Cloud 148-4",
    "code": "NP PB 1148 D",
    "hex": "#ACB8E8",
    "rgb": "172, 184, 232"
  },
  {
    "name": "Coastal Serenity 149-4",
    "code": "NP PB 1149 A",
    "hex": "#6C7186",
    "rgb": "108, 113, 134"
  },
  {
    "name": "Soft Whisper 150-4",
    "code": "NP PB 1150 N",
    "hex": "#2A3563",
    "rgb": "42, 53, 99"
  },
  {
    "name": "Cool Harmony 151-4",
    "code": "NP PB 1151 P",
    "hex": "#1F40CE",
    "rgb": "31, 64, 206"
  },
  {
    "name": "Muted Sand 152-4",
    "code": "NP PB 1152 T",
    "hex": "#536BD5",
    "rgb": "83, 107, 213"
  },
  {
    "name": "Classic Dusk 153-4",
    "code": "NP PB 1153 D",
    "hex": "#525668",
    "rgb": "82, 86, 104"
  },
  {
    "name": "Mystic Echo 154-4",
    "code": "NP PB 1154 A",
    "hex": "#60657E",
    "rgb": "96, 101, 126"
  },
  {
    "name": "Silver Reflection 155-4",
    "code": "NP PB 1155 N",
    "hex": "#516BE5",
    "rgb": "81, 107, 229"
  },
  {
    "name": "Satin Silk 156-4",
    "code": "NP PB 1156 P",
    "hex": "#1C37B5",
    "rgb": "28, 55, 181"
  },
  {
    "name": "Pacific Blossom 157-4",
    "code": "NP PB 1157 T",
    "hex": "#2A325A",
    "rgb": "42, 50, 90"
  },
  {
    "name": "Saharan Sanctuary 158-4",
    "code": "NP PB 1158 D",
    "hex": "#858AA1",
    "rgb": "133, 138, 161"
  },
  {
    "name": "Coastal Glow 159-4",
    "code": "NP PB 1159 A",
    "hex": "#A6B1EA",
    "rgb": "166, 177, 234"
  },
  {
    "name": "Soft Symphony 160-4",
    "code": "NP PB 1160 N",
    "hex": "#293A90",
    "rgb": "41, 58, 144"
  },
  {
    "name": "Cool Horizon 161-4",
    "code": "NP PB 1161 P",
    "hex": "#111D5E",
    "rgb": "17, 29, 94"
  },
  {
    "name": "Muted Tranquility 162-4",
    "code": "NP PB 1162 T",
    "hex": "#6B79C5",
    "rgb": "107, 121, 197"
  },
  {
    "name": "Classic Breeze 163-4",
    "code": "NP PB 1163 D",
    "hex": "#BABFDC",
    "rgb": "186, 191, 220"
  },
  {
    "name": "Mystic Aura 164-4",
    "code": "NP PB 1164 A",
    "hex": "#484E6F",
    "rgb": "72, 78, 111"
  },
  {
    "name": "Silver Feather 165-4",
    "code": "NP PB 1165 N",
    "hex": "#1B2875",
    "rgb": "27, 40, 117"
  },
  {
    "name": "Satin Twilight 166-4",
    "code": "NP PB 1166 P",
    "hex": "#2F49E0",
    "rgb": "47, 73, 224"
  },
  {
    "name": "Pacific Tide 167-4",
    "code": "NP PB 1167 T",
    "hex": "#7580BF",
    "rgb": "117, 128, 191"
  },
  {
    "name": "Saharan Dream 168-4",
    "code": "NP PB 1168 D",
    "hex": "#4E505C",
    "rgb": "78, 80, 92"
  },
  {
    "name": "Coastal Stone 169-4",
    "code": "NP PB 1169 A",
    "hex": "#565F97",
    "rgb": "86, 95, 151"
  },
  {
    "name": "Soft Dawn 170-4",
    "code": "NP PB 1170 N",
    "hex": "#2D46EB",
    "rgb": "45, 70, 235"
  },
  {
    "name": "Cool Canvas 171-4",
    "code": "NP PB 1171 P",
    "hex": "#28379A",
    "rgb": "40, 55, 154"
  },
  {
    "name": "Muted Shadow 172-4",
    "code": "NP PB 1172 T",
    "hex": "#3E425B",
    "rgb": "62, 66, 91"
  },
  {
    "name": "Classic Velvet 173-4",
    "code": "NP PB 1173 D",
    "hex": "#9DA1BC",
    "rgb": "157, 161, 188"
  },
  {
    "name": "Mystic Petal 174-4",
    "code": "NP PB 1174 A",
    "hex": "#717EE2",
    "rgb": "113, 126, 226"
  },
  {
    "name": "Silver Haven 175-4",
    "code": "NP PB 1175 N",
    "hex": "#131F78",
    "rgb": "19, 31, 120"
  },
  {
    "name": "Satin Mist 176-4",
    "code": "NP PB 1176 P",
    "hex": "#232B6D",
    "rgb": "35, 43, 109"
  },
  {
    "name": "Pacific Elegance 177-4",
    "code": "NP PB 1177 T",
    "hex": "#A2A8DA",
    "rgb": "162, 168, 218"
  },
  {
    "name": "Saharan Cloud 178-4",
    "code": "NP PB 1178 D",
    "hex": "#A2A6C9",
    "rgb": "162, 166, 201"
  },
  {
    "name": "Coastal Serenity 179-4",
    "code": "NP PB 1179 A",
    "hex": "#292E60",
    "rgb": "41, 46, 96"
  },
  {
    "name": "Soft Whisper 180-4",
    "code": "NP PB 1180 N",
    "hex": "#15218C",
    "rgb": "21, 33, 140"
  },
  {
    "name": "Cool Harmony 181-4",
    "code": "NP PB 1181 P",
    "hex": "#5B69E9",
    "rgb": "91, 105, 233"
  },
  {
    "name": "Muted Sand 182-4",
    "code": "NP PB 1182 T",
    "hex": "#8386A5",
    "rgb": "131, 134, 165"
  },
  {
    "name": "Classic Dusk 183-4",
    "code": "NP PB 1183 D",
    "hex": "#454659",
    "rgb": "69, 70, 89"
  },
  {
    "name": "Mystic Echo 184-4",
    "code": "NP PB 1184 A",
    "hex": "#3E49B1",
    "rgb": "62, 73, 177"
  },
  {
    "name": "Silver Reflection 185-4",
    "code": "NP PB 1185 N",
    "hex": "#2435E6",
    "rgb": "36, 53, 230"
  },
  {
    "name": "Satin Silk 186-4",
    "code": "NP PB 1186 P",
    "hex": "#3C4281",
    "rgb": "60, 66, 129"
  },
  {
    "name": "Pacific Blossom 187-4",
    "code": "NP PB 1187 T",
    "hex": "#545666",
    "rgb": "84, 86, 102"
  },
  {
    "name": "Saharan Sanctuary 188-4",
    "code": "NP PB 1188 D",
    "hex": "#959AD2",
    "rgb": "149, 154, 210"
  },
  {
    "name": "Coastal Glow 189-4",
    "code": "NP PB 1189 A",
    "hex": "#3C47D1",
    "rgb": "60, 71, 209"
  },
  {
    "name": "Soft Symphony 190-4",
    "code": "NP PB 1190 N",
    "hex": "#121865",
    "rgb": "18, 24, 101"
  },
  {
    "name": "Cool Horizon 191-4",
    "code": "NP PB 1191 P",
    "hex": "#464A82",
    "rgb": "70, 74, 130"
  },
  {
    "name": "Muted Tranquility 192-4",
    "code": "NP PB 1192 T",
    "hex": "#C3C6E7",
    "rgb": "195, 198, 231"
  },
  {
    "name": "Classic Breeze 193-4",
    "code": "NP PB 1193 D",
    "hex": "#7276B0",
    "rgb": "114, 118, 176"
  },
  {
    "name": "Mystic Aura 194-4",
    "code": "NP PB 1194 A",
    "hex": "#151959",
    "rgb": "21, 25, 89"
  },
  {
    "name": "Silver Feather 195-4",
    "code": "NP PB 1195 N",
    "hex": "#232BA6",
    "rgb": "35, 43, 166"
  },
  {
    "name": "Satin Twilight 196-4",
    "code": "NP PB 1196 P",
    "hex": "#8F94E9",
    "rgb": "143, 148, 233"
  },
  {
    "name": "Pacific Tide 197-4",
    "code": "NP PB 1197 T",
    "hex": "#76778B",
    "rgb": "118, 119, 139"
  },
  {
    "name": "Saharan Dream 198-4",
    "code": "NP PB 1198 D",
    "hex": "#373960",
    "rgb": "55, 57, 96"
  },
  {
    "name": "Coastal Stone 199-4",
    "code": "NP PB 1199 A",
    "hex": "#262ECA",
    "rgb": "38, 46, 202"
  },
  {
    "name": "Soft Dawn 200-4",
    "code": "NP PB 1200 N",
    "hex": "#393FD9",
    "rgb": "57, 63, 217"
  },
  {
    "name": "Cool Canvas 201-4",
    "code": "NP PB 1201 P",
    "hex": "#4A4B6C",
    "rgb": "74, 75, 108"
  },
  {
    "name": "Muted Shadow 202-4",
    "code": "NP PB 1202 T",
    "hex": "#656679",
    "rgb": "101, 102, 121"
  },
  {
    "name": "Classic Velvet 203-4",
    "code": "NP PB 1203 D",
    "hex": "#7174E3",
    "rgb": "113, 116, 227"
  },
  {
    "name": "Mystic Petal 204-4",
    "code": "NP PB 1204 A",
    "hex": "#1E23BB",
    "rgb": "30, 35, 187"
  },
  {
    "name": "Silver Haven 205-4",
    "code": "NP PB 1205 N",
    "hex": "#1D1F5B",
    "rgb": "29, 31, 91"
  },
  {
    "name": "Satin Mist 206-4",
    "code": "NP PB 1206 P",
    "hex": "#73749C",
    "rgb": "115, 116, 156"
  },
  {
    "name": "Pacific Elegance 207-4",
    "code": "NP PB 1207 T",
    "hex": "#BEBEEB",
    "rgb": "190, 190, 235"
  },
  {
    "name": "Saharan Cloud 208-4",
    "code": "NP PB 1208 D",
    "hex": "#3F4196",
    "rgb": "63, 65, 150"
  },
  {
    "name": "Coastal Serenity 209-4",
    "code": "NP PB 1209 A",
    "hex": "#0E0F5C",
    "rgb": "14, 15, 92"
  },
  {
    "name": "Soft Whisper 210-4",
    "code": "NP PB 1210 N",
    "hex": "#4B4CC0",
    "rgb": "75, 76, 192"
  },
  {
    "name": "Cool Harmony 211-4",
    "code": "NP PB 1211 P",
    "hex": "#B1B1E0",
    "rgb": "177, 177, 224"
  },
  {
    "name": "Muted Sand 212-4",
    "code": "NP PB 1212 T",
    "hex": "#595974",
    "rgb": "89, 89, 116"
  },
  {
    "name": "Classic Dusk 213-4",
    "code": "NP PB 1213 D",
    "hex": "#272870",
    "rgb": "39, 40, 112"
  },
  {
    "name": "Mystic Echo 214-4",
    "code": "NP PB 1214 A",
    "hex": "#2222DD",
    "rgb": "34, 34, 221"
  },
  {
    "name": "Silver Reflection 215-4",
    "code": "NP PB 1215 N",
    "hex": "#5C5BC4",
    "rgb": "92, 91, 196"
  },
  {
    "name": "Satin Silk 216-4",
    "code": "NP PB 1216 P",
    "hex": "#4E4E5E",
    "rgb": "78, 78, 94"
  },
  {
    "name": "Pacific Blossom 217-4",
    "code": "NP PB 1217 T",
    "hex": "#676791",
    "rgb": "103, 103, 145"
  },
  {
    "name": "Saharan Sanctuary 218-4",
    "code": "NP PB 1218 D",
    "hex": "#4543EA",
    "rgb": "69, 67, 234"
  },
  {
    "name": "Coastal Glow 219-4",
    "code": "NP PB 1219 A",
    "hex": "#1E1CA0",
    "rgb": "30, 28, 160"
  },
  {
    "name": "Soft Symphony 220-4",
    "code": "NP PB 1220 N",
    "hex": "#31315A",
    "rgb": "49, 49, 90"
  },
  {
    "name": "Cool Horizon 221-4",
    "code": "NP PB 1221 P",
    "hex": "#9B9AB6",
    "rgb": "155, 154, 182"
  },
  {
    "name": "Muted Tranquility 222-4",
    "code": "NP PB 1222 T",
    "hex": "#9593E5",
    "rgb": "149, 147, 229"
  },
  {
    "name": "Classic Breeze 223-4",
    "code": "NP PB 1223 D",
    "hex": "#201D7D",
    "rgb": "32, 29, 125"
  },
  {
    "name": "Mystic Aura 224-4",
    "code": "NP PB 1224 A",
    "hex": "#191669",
    "rgb": "25, 22, 105"
  },
  {
    "name": "Silver Feather 225-4",
    "code": "NP PB 1225 N",
    "hex": "#8683D6",
    "rgb": "134, 131, 214"
  },
  {
    "name": "Satin Twilight 226-4",
    "code": "NP PB 1226 P",
    "hex": "#B0AFCE",
    "rgb": "176, 175, 206"
  },
  {
    "name": "Pacific Tide 227-4",
    "code": "NP PB 1227 T",
    "hex": "#3A3963",
    "rgb": "58, 57, 99"
  },
  {
    "name": "Saharan Dream 228-4",
    "code": "NP PB 1228 D",
    "hex": "#1E1A87",
    "rgb": "30, 26, 135"
  },
  {
    "name": "Coastal Stone 229-4",
    "code": "NP PB 1229 A",
    "hex": "#443DE8",
    "rgb": "68, 61, 232"
  },
  {
    "name": "Soft Dawn 230-4",
    "code": "NP PB 1230 N",
    "hex": "#7875AB",
    "rgb": "120, 117, 171"
  },
  {
    "name": "Cool Canvas 231-4",
    "code": "NP PB 1231 P",
    "hex": "#4B4B59",
    "rgb": "75, 75, 89"
  },
  {
    "name": "Muted Shadow 232-4",
    "code": "NP PB 1232 T",
    "hex": "#5A55AB",
    "rgb": "90, 85, 171"
  },
  {
    "name": "Classic Velvet 233-4",
    "code": "NP PB 1233 D",
    "hex": "#3126E8",
    "rgb": "49, 38, 232"
  },
  {
    "name": "Mystic Petal 234-4",
    "code": "NP PB 1234 A",
    "hex": "#312B86",
    "rgb": "49, 43, 134"
  },
  {
    "name": "Silver Haven 235-4",
    "code": "NP PB 1235 N",
    "hex": "#4B4963",
    "rgb": "75, 73, 99"
  },
  {
    "name": "Satin Mist 236-4",
    "code": "NP PB 1236 P",
    "hex": "#A9A6CE",
    "rgb": "169, 166, 206"
  },
  {
    "name": "Pacific Elegance 237-4",
    "code": "NP PB 1237 T",
    "hex": "#635AD6",
    "rgb": "99, 90, 214"
  },
  {
    "name": "Saharan Cloud 238-4",
    "code": "NP PB 1238 D",
    "hex": "#161069",
    "rgb": "22, 16, 105"
  },
  {
    "name": "Coastal Serenity 239-4",
    "code": "NP PB 1239 A",
    "hex": "#37317D",
    "rgb": "55, 49, 125"
  },
  {
    "name": "Soft Whisper 240-4",
    "code": "NP PB 1240 N",
    "hex": "#B9B5E5",
    "rgb": "185, 181, 229"
  },
  {
    "name": "Cool Harmony 241-4",
    "code": "NP PB 1241 P",
    "hex": "#8F8BB6",
    "rgb": "143, 139, 182"
  },
  {
    "name": "Muted Sand 242-4",
    "code": "NP PB 1242 T",
    "hex": "#25205A",
    "rgb": "37, 32, 90"
  },
  {
    "name": "Classic Dusk 243-4",
    "code": "NP PB 1243 D",
    "hex": "#2519A1",
    "rgb": "37, 25, 161"
  },
  {
    "name": "Mystic Echo 244-4",
    "code": "NP PB 1244 A",
    "hex": "#786DEA",
    "rgb": "120, 109, 234"
  },
  {
    "name": "Silver Reflection 245-4",
    "code": "NP PB 1245 N",
    "hex": "#7A7891",
    "rgb": "122, 120, 145"
  },
  {
    "name": "Satin Silk 246-4",
    "code": "NP PB 1246 P",
    "hex": "#45435E",
    "rgb": "69, 67, 94"
  },
  {
    "name": "Pacific Blossom 247-4",
    "code": "NP PB 1247 T",
    "hex": "#4638C5",
    "rgb": "70, 56, 197"
  },
  {
    "name": "Saharan Sanctuary 248-4",
    "code": "NP PB 1248 D",
    "hex": "#3A27DD",
    "rgb": "58, 39, 221"
  },
  {
    "name": "Coastal Glow 249-4",
    "code": "NP PB 1249 A",
    "hex": "#423D70",
    "rgb": "66, 61, 112"
  },
  {
    "name": "Soft Symphony 250-4",
    "code": "NP PB 1250 N",
    "hex": "#646274",
    "rgb": "100, 98, 116"
  },
  {
    "name": "Cool Horizon 251-3",
    "code": "NP PB 1251 P",
    "hex": "#9990E0",
    "rgb": "153, 144, 224"
  },
  {
    "name": "Muted Tranquility 252-3",
    "code": "NP PB 1252 T",
    "hex": "#3D2CC0",
    "rgb": "61, 44, 192"
  },
  {
    "name": "Classic Breeze 253-3",
    "code": "NP PB 1253 D",
    "hex": "#1C145C",
    "rgb": "28, 20, 92"
  },
  {
    "name": "Mystic Aura 254-3",
    "code": "NP PB 1254 A",
    "hex": "#635C96",
    "rgb": "99, 92, 150"
  },
  {
    "name": "Silver Feather 255-3",
    "code": "NP PB 1255 N",
    "hex": "#CCC7EB",
    "rgb": "204, 199, 235"
  },
  {
    "name": "Satin Twilight 256-3",
    "code": "NP PB 1256 P",
    "hex": "#61599B",
    "rgb": "97, 89, 155"
  },
  {
    "name": "Pacific Tide 257-3",
    "code": "NP PB 1257 T",
    "hex": "#1B115B",
    "rgb": "27, 17, 91"
  },
  {
    "name": "Saharan Dream 258-3",
    "code": "NP PB 1258 D",
    "hex": "#4331BB",
    "rgb": "67, 49, 187"
  },
  {
    "name": "Coastal Stone 259-3",
    "code": "NP PB 1259 A",
    "hex": "#A49BE2",
    "rgb": "164, 155, 226"
  },
  {
    "name": "Soft Dawn 260-3",
    "code": "NP PB 1260 N",
    "hex": "#686579",
    "rgb": "104, 101, 121"
  },
  {
    "name": "Cool Canvas 261-3",
    "code": "NP PB 1261 P",
    "hex": "#3D366C",
    "rgb": "61, 54, 108"
  },
  {
    "name": "Muted Shadow 262-3",
    "code": "NP PB 1262 T",
    "hex": "#3E23D9",
    "rgb": "62, 35, 217"
  },
  {
    "name": "Classic Velvet 263-3",
    "code": "NP PB 1263 D",
    "hex": "#5541CA",
    "rgb": "85, 65, 202"
  },
  {
    "name": "Mystic Petal 264-3",
    "code": "NP PB 1264 A",
    "hex": "#4B4860",
    "rgb": "75, 72, 96"
  },
  {
    "name": "Silver Haven 265-3",
    "code": "NP PB 1265 N",
    "hex": "#75708B",
    "rgb": "117, 112, 139"
  },
  {
    "name": "Satin Mist 266-3",
    "code": "NP PB 1266 P",
    "hex": "#7862E9",
    "rgb": "120, 98, 233"
  },
  {
    "name": "Pacific Elegance 267-3",
    "code": "NP PB 1267 T",
    "hex": "#3019A6",
    "rgb": "48, 25, 166"
  },
  {
    "name": "Saharan Cloud 268-3",
    "code": "NP PB 1268 D",
    "hex": "#2C2359",
    "rgb": "44, 35, 89"
  },
  {
    "name": "Coastal Serenity 269-3",
    "code": "NP PB 1269 A",
    "hex": "#928BB0",
    "rgb": "146, 139, 176"
  },
  {
    "name": "Soft Whisper 270-3",
    "code": "NP PB 1270 N",
    "hex": "#BAB0E7",
    "rgb": "186, 176, 231"
  },
  {
    "name": "Cool Harmony 271-3",
    "code": "NP PB 1271 P",
    "hex": "#3C2E82",
    "rgb": "60, 46, 130"
  },
  {
    "name": "Muted Sand 272-3",
    "code": "NP PB 1272 T",
    "hex": "#1F1065",
    "rgb": "31, 16, 101"
  },
  {
    "name": "Classic Dusk 273-3",
    "code": "NP PB 1273 D",
    "hex": "#7561D2",
    "rgb": "117, 97, 210"
  },
  {
    "name": "Mystic Echo 274-3",
    "code": "NP PB 1274 A",
    "hex": "#B4AED2",
    "rgb": "180, 174, 210"
  },
  {
    "name": "Silver Reflection 275-3",
    "code": "NP PB 1275 N",
    "hex": "#4E4866",
    "rgb": "78, 72, 102"
  },
  {
    "name": "Satin Silk 276-3",
    "code": "NP PB 1276 P",
    "hex": "#362581",
    "rgb": "54, 37, 129"
  },
  {
    "name": "Pacific Blossom 277-3",
    "code": "NP PB 1277 T",
    "hex": "#4D29E6",
    "rgb": "77, 41, 230"
  },
  {
    "name": "Saharan Sanctuary 278-3",
    "code": "NP PB 1278 D",
    "hex": "#6F60B1",
    "rgb": "111, 96, 177"
  },
  {
    "name": "Coastal Glow 279-3",
    "code": "NP PB 1279 A",
    "hex": "#4E4C59",
    "rgb": "78, 76, 89"
  },
  {
    "name": "Soft Symphony 280-3",
    "code": "NP PB 1280 N",
    "hex": "#766BA5",
    "rgb": "118, 107, 165"
  },
  {
    "name": "Cool Horizon 281-3",
    "code": "NP PB 1281 P",
    "hex": "#5A36E9",
    "rgb": "90, 54, 233"
  },
  {
    "name": "Muted Tranquility 282-3",
    "code": "NP PB 1282 T",
    "hex": "#341E8C",
    "rgb": "52, 30, 140"
  },
  {
    "name": "Classic Breeze 283-3",
    "code": "NP PB 1283 D",
    "hex": "#433B60",
    "rgb": "67, 59, 96"
  },
  {
    "name": "Mystic Aura 284-3",
    "code": "NP PB 1284 A",
    "hex": "#B1ABC9",
    "rgb": "177, 171, 201"
  },
  {
    "name": "Silver Feather 285-3",
    "code": "NP PB 1285 N",
    "hex": "#917DDA",
    "rgb": "145, 125, 218"
  },
  {
    "name": "Satin Twilight 286-3",
    "code": "NP PB 1286 P",
    "hex": "#28156D",
    "rgb": "40, 21, 109"
  },
  {
    "name": "Pacific Tide 287-3",
    "code": "NP PB 1287 T",
    "hex": "#331F78",
    "rgb": "51, 31, 120"
  },
  {
    "name": "Saharan Dream 288-3",
    "code": "NP PB 1288 D",
    "hex": "#AA9AE2",
    "rgb": "170, 154, 226"
  },
  {
    "name": "Coastal Stone 289-3",
    "code": "NP PB 1289 A",
    "hex": "#A49DBB",
    "rgb": "164, 157, 187"
  },
  {
    "name": "Soft Dawn 290-3",
    "code": "NP PB 1290 N",
    "hex": "#382D5B",
    "rgb": "56, 45, 91"
  },
  {
    "name": "Cool Canvas 291-3",
    "code": "NP PB 1291 P",
    "hex": "#37199B",
    "rgb": "55, 25, 155"
  },
  {
    "name": "Muted Shadow 292-3",
    "code": "NP PB 1292 T",
    "hex": "#714CEB",
    "rgb": "113, 76, 235"
  },
  {
    "name": "Classic Velvet 293-3",
    "code": "NP PB 1293 D",
    "hex": "#797097",
    "rgb": "121, 112, 151"
  },
  {
    "name": "Mystic Petal 294-3",
    "code": "NP PB 1294 A",
    "hex": "#4F4A5C",
    "rgb": "79, 74, 92"
  },
  {
    "name": "Silver Haven 295-3",
    "code": "NP PB 1295 N",
    "hex": "#6C51BF",
    "rgb": "108, 81, 191"
  },
  {
    "name": "Satin Mist 296-3",
    "code": "NP PB 1296 P",
    "hex": "#5122E0",
    "rgb": "81, 34, 224"
  },
  {
    "name": "Pacific Elegance 297-3",
    "code": "NP PB 1297 T",
    "hex": "#3F2E75",
    "rgb": "63, 46, 117"
  },
  {
    "name": "Saharan Cloud 298-3",
    "code": "NP PB 1298 D",
    "hex": "#5E586F",
    "rgb": "94, 88, 111"
  },
  {
    "name": "Coastal Serenity 299-3",
    "code": "NP PB 1299 A",
    "hex": "#B6A8DC",
    "rgb": "182, 168, 220"
  },
  {
    "name": "Soft Whisper 300-3",
    "code": "NP PB 1300 N",
    "hex": "#6645C5",
    "rgb": "102, 69, 197"
  },
  {
    "name": "Cool Harmony 301-3",
    "code": "NP PB 1301 P",
    "hex": "#240F5E",
    "rgb": "36, 15, 94"
  },
  {
    "name": "Muted Sand 302-3",
    "code": "NP PB 1302 T",
    "hex": "#574390",
    "rgb": "87, 67, 144"
  },
  {
    "name": "Classic Dusk 303-3",
    "code": "NP PB 1303 D",
    "hex": "#CCC1EA",
    "rgb": "204, 193, 234"
  },
  {
    "name": "Mystic Echo 304-3",
    "code": "NP PB 1304 A",
    "hex": "#7F72A1",
    "rgb": "127, 114, 161"
  },
  {
    "name": "Silver Reflection 305-3",
    "code": "NP PB 1305 N",
    "hex": "#2B1A5A",
    "rgb": "43, 26, 90"
  },
  {
    "name": "Satin Silk 306-3",
    "code": "NP PB 1306 P",
    "hex": "#4920B5",
    "rgb": "73, 32, 181"
  },
  {
    "name": "Pacific Blossom 307-3",
    "code": "NP PB 1307 T",
    "hex": "#997CE5",
    "rgb": "153, 124, 229"
  },
  {
    "name": "Saharan Sanctuary 308-3",
    "code": "NP PB 1308 D",
    "hex": "#706A7E",
    "rgb": "112, 106, 126"
  },
  {
    "name": "Coastal Glow 309-3",
    "code": "NP PB 1309 A",
    "hex": "#4E4368",
    "rgb": "78, 67, 104"
  },
  {
    "name": "Soft Symphony 310-3",
    "code": "NP PB 1310 N",
    "hex": "#6131D5",
    "rgb": "97, 49, 213"
  },
  {
    "name": "Cool Horizon 311-3",
    "code": "NP PB 1311 P",
    "hex": "#5B2CCE",
    "rgb": "91, 44, 206"
  },
  {
    "name": "Muted Tranquility 312-3",
    "code": "NP PB 1312 T",
    "hex": "#483D63",
    "rgb": "72, 61, 99"
  },
  {
    "name": "Classic Breeze 313-3",
    "code": "NP PB 1313 D",
    "hex": "#777186",
    "rgb": "119, 113, 134"
  },
  {
    "name": "Mystic Aura 314-3",
    "code": "NP PB 1314 A",
    "hex": "#A385E8",
    "rgb": "163, 133, 232"
  },
  {
    "name": "Silver Feather 315-3",
    "code": "NP PB 1315 N",
    "hex": "#4B21AC",
    "rgb": "75, 33, 172"
  },
  {
    "name": "Satin Twilight 316-3",
    "code": "NP PB 1316 P",
    "hex": "#2C1759",
    "rgb": "44, 23, 89"
  },
  {
    "name": "Pacific Tide 317-3",
    "code": "NP PB 1317 T",
    "hex": "#8574AA",
    "rgb": "133, 116, 170"
  },
  {
    "name": "Saharan Dream 318-3",
    "code": "NP PB 1318 D",
    "hex": "#CEC2E8",
    "rgb": "206, 194, 232"
  },
  {
    "name": "Coastal Stone 319-3",
    "code": "NP PB 1319 A",
    "hex": "#594387",
    "rgb": "89, 67, 135"
  },
  {
    "name": "Soft Dawn 320-3",
    "code": "NP PB 1320 N",
    "hex": "#2A1062",
    "rgb": "42, 16, 98"
  },
  {
    "name": "Cool Canvas 321-3",
    "code": "NP PB 1321 P",
    "hex": "#6F42CD",
    "rgb": "111, 66, 205"
  },
  {
    "name": "Muted Shadow 322-3",
    "code": "NP PB 1322 T",
    "hex": "#B19FD6",
    "rgb": "177, 159, 214"
  },
  {
    "name": "Classic Velvet 323-3",
    "code": "NP PB 1323 D",
    "hex": "#5C5569",
    "rgb": "92, 85, 105"
  },
  {
    "name": "Mystic Petal 324-3",
    "code": "NP PB 1324 A",
    "hex": "#4C347C",
    "rgb": "76, 52, 124"
  },
  {
    "name": "Silver Haven 325-3",
    "code": "NP PB 1325 N",
    "hex": "#6322E4",
    "rgb": "99, 34, 228"
  },
  {
    "name": "Satin Mist 326-3",
    "code": "NP PB 1326 P",
    "hex": "#6D48B7",
    "rgb": "109, 72, 183"
  },
  {
    "name": "Pacific Elegance 327-3",
    "code": "NP PB 1327 T",
    "hex": "#4E475A",
    "rgb": "78, 71, 90"
  },
  {
    "name": "Saharan Cloud 328-3",
    "code": "NP PB 1328 D",
    "hex": "#877AA0",
    "rgb": "135, 122, 160"
  },
  {
    "name": "Coastal Serenity 329-3",
    "code": "NP PB 1329 A",
    "hex": "#8752EA",
    "rgb": "135, 82, 234"
  },
  {
    "name": "Soft Whisper 330-3",
    "code": "NP PB 1330 N",
    "hex": "#421792",
    "rgb": "66, 23, 146"
  },
  {
    "name": "Cool Harmony 331-3",
    "code": "NP PB 1331 P",
    "hex": "#3D2C5E",
    "rgb": "61, 44, 94"
  },
  {
    "name": "Muted Sand 332-3",
    "code": "NP PB 1332 T",
    "hex": "#AEA2C4",
    "rgb": "174, 162, 196"
  },
  {
    "name": "Classic Dusk 333-3",
    "code": "NP PB 1333 D",
    "hex": "#B49DDD",
    "rgb": "180, 157, 221"
  },
  {
    "name": "Mystic Echo 334-3",
    "code": "NP PB 1334 A",
    "hex": "#3D2071",
    "rgb": "61, 32, 113"
  },
  {
    "name": "Silver Reflection 335-3",
    "code": "NP PB 1335 N",
    "hex": "#371473",
    "rgb": "55, 20, 115"
  },
  {
    "name": "Satin Silk 336-3",
    "code": "NP PB 1336 P",
    "hex": "#9E79DF",
    "rgb": "158, 121, 223"
  },
  {
    "name": "Pacific Blossom 337-3",
    "code": "NP PB 1337 T",
    "hex": "#AEA3C1",
    "rgb": "174, 163, 193"
  },
  {
    "name": "Saharan Sanctuary 338-3",
    "code": "NP PB 1338 D",
    "hex": "#483C5D",
    "rgb": "72, 60, 93"
  },
  {
    "name": "Coastal Glow 339-3",
    "code": "NP PB 1339 A",
    "hex": "#4D2295",
    "rgb": "77, 34, 149"
  },
  {
    "name": "Soft Symphony 340-3",
    "code": "NP PB 1340 N",
    "hex": "#7832EA",
    "rgb": "120, 50, 234"
  },
  {
    "name": "Cool Horizon 341-3",
    "code": "NP PB 1341 P",
    "hex": "#77609C",
    "rgb": "119, 96, 156"
  },
  {
    "name": "Muted Tranquility 342-3",
    "code": "NP PB 1342 T",
    "hex": "#524D5B",
    "rgb": "82, 77, 91"
  },
  {
    "name": "Classic Breeze 343-3",
    "code": "NP PB 1343 D",
    "hex": "#896ABA",
    "rgb": "137, 106, 186"
  },
  {
    "name": "Mystic Aura 344-3",
    "code": "NP PB 1344 A",
    "hex": "#732BE3",
    "rgb": "115, 43, 227"
  },
  {
    "name": "Silver Feather 345-3",
    "code": "NP PB 1345 N",
    "hex": "#432079",
    "rgb": "67, 32, 121"
  },
  {
    "name": "Satin Twilight 346-3",
    "code": "NP PB 1346 P",
    "hex": "#57496B",
    "rgb": "87, 73, 107"
  },
  {
    "name": "Pacific Tide 347-3",
    "code": "NP PB 1347 T",
    "hex": "#C3B5D9",
    "rgb": "195, 181, 217"
  },
  {
    "name": "Saharan Dream 348-3",
    "code": "NP PB 1348 D",
    "hex": "#8E64CA",
    "rgb": "142, 100, 202"
  },
  {
    "name": "Coastal Stone 349-3",
    "code": "NP PB 1349 A",
    "hex": "#311061",
    "rgb": "49, 16, 97"
  },
  {
    "name": "Soft Dawn 350-3",
    "code": "NP PB 1350 N",
    "hex": "#532D8A",
    "rgb": "83, 45, 138"
  },
  {
    "name": "Cool Canvas 351-3",
    "code": "NP PB 1351 P",
    "hex": "#C6ADE9",
    "rgb": "198, 173, 233"
  },
  {
    "name": "Muted Shadow 352-3",
    "code": "NP PB 1352 T",
    "hex": "#9487A7",
    "rgb": "148, 135, 167"
  },
  {
    "name": "Classic Velvet 353-3",
    "code": "NP PB 1353 D",
    "hex": "#3B2659",
    "rgb": "59, 38, 89"
  },
  {
    "name": "Mystic Petal 354-3",
    "code": "NP PB 1354 A",
    "hex": "#591AAF",
    "rgb": "89, 26, 175"
  },
  {
    "name": "Silver Haven 355-3",
    "code": "NP PB 1355 N",
    "hex": "#965BE7",
    "rgb": "150, 91, 231"
  },
  {
    "name": "Satin Mist 356-3",
    "code": "NP PB 1356 P",
    "hex": "#736883",
    "rgb": "115, 104, 131"
  },
  {
    "name": "Pacific Elegance 357-3",
    "code": "NP PB 1357 T",
    "hex": "#574D65",
    "rgb": "87, 77, 101"
  },
  {
    "name": "Saharan Cloud 358-3",
    "code": "NP PB 1358 D",
    "hex": "#8449D1",
    "rgb": "132, 73, 209"
  },
  {
    "name": "Coastal Serenity 359-3",
    "code": "NP PB 1359 A",
    "hex": "#6F21D3",
    "rgb": "111, 33, 211"
  },
  {
    "name": "Soft Whisper 360-3",
    "code": "NP PB 1360 N",
    "hex": "#483066",
    "rgb": "72, 48, 102"
  },
  {
    "name": "Cool Harmony 361-3",
    "code": "NP PB 1361 P",
    "hex": "#746A80",
    "rgb": "116, 106, 128"
  },
  {
    "name": "Muted Sand 362-3",
    "code": "NP PB 1362 T",
    "hex": "#C1A3E6",
    "rgb": "193, 163, 230"
  },
  {
    "name": "Classic Dusk 363-3",
    "code": "NP PB 1363 D",
    "hex": "#6C33B2",
    "rgb": "108, 51, 178"
  },
  {
    "name": "Mystic Echo 364-3",
    "code": "NP PB 1364 A",
    "hex": "#31105A",
    "rgb": "49, 16, 90"
  },
  {
    "name": "Silver Reflection 365-3",
    "code": "NP PB 1365 N",
    "hex": "#7B59A5",
    "rgb": "123, 89, 165"
  },
  {
    "name": "Satin Silk 366-3",
    "code": "NP PB 1366 P",
    "hex": "#D6C6EA",
    "rgb": "214, 198, 234"
  },
  {
    "name": "Pacific Blossom 367-3",
    "code": "NP PB 1367 T",
    "hex": "#725B8D",
    "rgb": "114, 91, 141"
  },
  {
    "name": "Saharan Sanctuary 368-3",
    "code": "NP PB 1368 D",
    "hex": "#381660",
    "rgb": "56, 22, 96"
  },
  {
    "name": "Coastal Glow 369-3",
    "code": "NP PB 1369 A",
    "hex": "#742BC8",
    "rgb": "116, 43, 200"
  },
  {
    "name": "Soft Symphony 370-3",
    "code": "NP PB 1370 N",
    "hex": "#AE86DA",
    "rgb": "174, 134, 218"
  },
  {
    "name": "Cool Horizon 371-3",
    "code": "NP PB 1371 P",
    "hex": "#655D6D",
    "rgb": "101, 93, 109"
  },
  {
    "name": "Muted Tranquility 372-3",
    "code": "NP PB 1372 T",
    "hex": "#5C4477",
    "rgb": "92, 68, 119"
  },
  {
    "name": "Classic Breeze 373-3",
    "code": "NP PB 1373 D",
    "hex": "#822BE2",
    "rgb": "130, 43, 226"
  },
  {
    "name": "Mystic Aura 374-3",
    "code": "NP PB 1374 A",
    "hex": "#7431BC",
    "rgb": "116, 49, 188"
  },
  {
    "name": "Silver Feather 375-3",
    "code": "NP PB 1375 N",
    "hex": "#4D3E5B",
    "rgb": "77, 62, 91"
  },
  {
    "name": "Satin Twilight 376-3",
    "code": "NP PB 1376 P",
    "hex": "#8D809A",
    "rgb": "141, 128, 154"
  },
  {
    "name": "Pacific Tide 377-3",
    "code": "NP PB 1377 T",
    "hex": "#AE74EB",
    "rgb": "174, 116, 235"
  },
  {
    "name": "Saharan Dream 378-3",
    "code": "NP PB 1378 D",
    "hex": "#571897",
    "rgb": "87, 24, 151"
  },
  {
    "name": "Coastal Stone 379-3",
    "code": "NP PB 1379 A",
    "hex": "#3D1E5C",
    "rgb": "61, 30, 92"
  },
  {
    "name": "Soft Dawn 380-3",
    "code": "NP PB 1380 N",
    "hex": "#A68EBE",
    "rgb": "166, 142, 190"
  },
  {
    "name": "Cool Harmony 1-5",
    "code": "NP R 1001 P",
    "hex": "#A31258",
    "rgb": "163, 18, 88"
  },
  {
    "name": "Muted Sand 2-5",
    "code": "NP R 1002 T",
    "hex": "#681C41",
    "rgb": "104, 28, 65"
  },
  {
    "name": "Classic Dusk 3-5",
    "code": "NP R 1003 D",
    "hex": "#C789A6",
    "rgb": "199, 137, 166"
  },
  {
    "name": "Mystic Echo 4-5",
    "code": "NP R 1004 A",
    "hex": "#E9B1CC",
    "rgb": "233, 177, 204"
  },
  {
    "name": "Silver Reflection 5-5",
    "code": "NP R 1005 N",
    "hex": "#823157",
    "rgb": "130, 49, 87"
  },
  {
    "name": "Satin Silk 6-4",
    "code": "NP R 1006 P",
    "hex": "#7A0C40",
    "rgb": "122, 12, 64"
  },
  {
    "name": "Pacific Blossom 7-5",
    "code": "NP R 1007 T",
    "hex": "#E34D93",
    "rgb": "227, 77, 147"
  },
  {
    "name": "Saharan Sanctuary 8-5",
    "code": "NP R 1008 D",
    "hex": "#D09AB3",
    "rgb": "208, 154, 179"
  },
  {
    "name": "Coastal Glow 9-5",
    "code": "NP R 1009 A",
    "hex": "#6C4D5B",
    "rgb": "108, 77, 91"
  },
  {
    "name": "Soft Symphony 10-5",
    "code": "NP R 1010 N",
    "hex": "#992E5F",
    "rgb": "153, 46, 95"
  },
  {
    "name": "Cool Horizon 11-5",
    "code": "NP R 1011 P",
    "hex": "#F1197C",
    "rgb": "241, 25, 124"
  },
  {
    "name": "Muted Tranquility 12-5",
    "code": "NP R 1012 T",
    "hex": "#AE4876",
    "rgb": "174, 72, 118"
  },
  {
    "name": "Classic Breeze 13-5",
    "code": "NP R 1013 D",
    "hex": "#664F5A",
    "rgb": "102, 79, 90"
  },
  {
    "name": "Mystic Aura 14-5",
    "code": "NP R 1014 A",
    "hex": "#BD7D9A",
    "rgb": "189, 125, 154"
  },
  {
    "name": "Silver Feather 15-5",
    "code": "NP R 1015 N",
    "hex": "#EE398A",
    "rgb": "238, 57, 138"
  },
  {
    "name": "Satin Twilight 16-5",
    "code": "NP R 1016 P",
    "hex": "#8B1148",
    "rgb": "139, 17, 72"
  },
  {
    "name": "Pacific Tide 17-5",
    "code": "NP R 1017 T",
    "hex": "#733853",
    "rgb": "115, 56, 83"
  },
  {
    "name": "Saharan Dream 18-5",
    "code": "NP R 1018 D",
    "hex": "#DCAFC3",
    "rgb": "220, 175, 195"
  },
  {
    "name": "Coastal Stone 19-5",
    "code": "NP R 1019 A",
    "hex": "#D981A8",
    "rgb": "217, 129, 168"
  },
  {
    "name": "Soft Dawn 20-5",
    "code": "NP R 1020 N",
    "hex": "#71153D",
    "rgb": "113, 21, 61"
  },
  {
    "name": "Cool Canvas 21-5",
    "code": "NP R 1021 P",
    "hex": "#8F174B",
    "rgb": "143, 23, 75"
  },
  {
    "name": "Muted Shadow 22-5",
    "code": "NP R 1022 T",
    "hex": "#EF86B4",
    "rgb": "239, 134, 180"
  },
  {
    "name": "Classic Velvet 23-5",
    "code": "NP R 1023 D",
    "hex": "#B893A3",
    "rgb": "184, 147, 163"
  },
  {
    "name": "Mystic Petal 24-5",
    "code": "NP R 1024 A",
    "hex": "#66364A",
    "rgb": "102, 54, 74"
  },
  {
    "name": "Silver Haven 25-5",
    "code": "NP R 1025 N",
    "hex": "#B2195B",
    "rgb": "178, 25, 91"
  },
  {
    "name": "Satin Mist 26-5",
    "code": "NP R 1026 P",
    "hex": "#F13284",
    "rgb": "241, 50, 132"
  },
  {
    "name": "Pacific Elegance 27-5",
    "code": "NP R 1027 T",
    "hex": "#945E75",
    "rgb": "148, 94, 117"
  },
  {
    "name": "Saharan Cloud 28-5",
    "code": "NP R 1028 D",
    "hex": "#6E5660",
    "rgb": "110, 86, 96"
  },
  {
    "name": "Coastal Serenity 29-5",
    "code": "NP R 1029 A",
    "hex": "#D45F90",
    "rgb": "212, 95, 144"
  },
  {
    "name": "Soft Whisper 30-5",
    "code": "NP R 1030 N",
    "hex": "#E0196C",
    "rgb": "224, 25, 108"
  },
  {
    "name": "Cool Harmony 31-5",
    "code": "NP R 1031 P",
    "hex": "#772044",
    "rgb": "119, 32, 68"
  },
  {
    "name": "Muted Sand 32-5",
    "code": "NP R 1032 T",
    "hex": "#865C6E",
    "rgb": "134, 92, 110"
  },
  {
    "name": "Classic Dusk 33-5",
    "code": "NP R 1033 D",
    "hex": "#EBB3CA",
    "rgb": "235, 179, 202"
  },
  {
    "name": "Mystic Echo 34-5",
    "code": "NP R 1034 A",
    "hex": "#C2497A",
    "rgb": "194, 73, 122"
  },
  {
    "name": "Silver Reflection 35-5",
    "code": "NP R 1035 N",
    "hex": "#670A30",
    "rgb": "103, 10, 48"
  },
  {
    "name": "Satin Silk 36-5",
    "code": "NP R 1036 P",
    "hex": "#A83966",
    "rgb": "168, 57, 102"
  },
  {
    "name": "Pacific Blossom 37-5",
    "code": "NP R 1037 T",
    "hex": "#F2B3CD",
    "rgb": "242, 179, 205"
  },
  {
    "name": "Saharan Sanctuary 38-5",
    "code": "NP R 1038 D",
    "hex": "#9E7183",
    "rgb": "158, 113, 131"
  },
  {
    "name": "Coastal Glow 39-5",
    "code": "NP R 1039 A",
    "hex": "#6A203D",
    "rgb": "106, 32, 61"
  },
  {
    "name": "Soft Symphony 40-5",
    "code": "NP R 1040 N",
    "hex": "#CB155D",
    "rgb": "203, 21, 93"
  },
  {
    "name": "Cool Horizon 41-5",
    "code": "NP R 1041 P",
    "hex": "#E75F95",
    "rgb": "231, 95, 149"
  },
  {
    "name": "Muted Tranquility 42-5",
    "code": "NP R 1042 T",
    "hex": "#7E626D",
    "rgb": "126, 98, 109"
  },
  {
    "name": "Classic Breeze 43-5",
    "code": "NP R 1043 D",
    "hex": "#7D5364",
    "rgb": "125, 83, 100"
  },
  {
    "name": "Mystic Aura 44-5",
    "code": "NP R 1044 A",
    "hex": "#E6377B",
    "rgb": "230, 55, 123"
  },
  {
    "name": "Silver Feather 45-5",
    "code": "NP R 1045 N",
    "hex": "#CC195E",
    "rgb": "204, 25, 94"
  },
  {
    "name": "Satin Twilight 46-5",
    "code": "NP R 1046 P",
    "hex": "#6A3449",
    "rgb": "106, 52, 73"
  },
  {
    "name": "Pacific Tide 47-5",
    "code": "NP R 1047 T",
    "hex": "#9D7D8A",
    "rgb": "157, 125, 138"
  },
  {
    "name": "Saharan Dream 48-5",
    "code": "NP R 1048 D",
    "hex": "#F290B5",
    "rgb": "242, 144, 181"
  },
  {
    "name": "Coastal Stone 49-5",
    "code": "NP R 1049 A",
    "hex": "#A91F53",
    "rgb": "169, 31, 83"
  },
  {
    "name": "Soft Dawn 50-5",
    "code": "NP R 1050 N",
    "hex": "#671131",
    "rgb": "103, 17, 49"
  },
  {
    "name": "Cool Canvas 51-5",
    "code": "NP R 1051 P",
    "hex": "#C16D8C",
    "rgb": "193, 109, 140"
  },
  {
    "name": "Muted Shadow 52-5",
    "code": "NP R 1052 T",
    "hex": "#ECBCCE",
    "rgb": "236, 188, 206"
  },
  {
    "name": "Classic Velvet 53-5",
    "code": "NP R 1053 D",
    "hex": "#87475E",
    "rgb": "135, 71, 94"
  },
  {
    "name": "Mystic Petal 54-5",
    "code": "NP R 1054 A",
    "hex": "#761136",
    "rgb": "118, 17, 54"
  },
  {
    "name": "Silver Haven 55-5",
    "code": "NP R 1055 N",
    "hex": "#E02F6F",
    "rgb": "224, 47, 111"
  },
  {
    "name": "Satin Mist 56-5",
    "code": "NP R 1056 P",
    "hex": "#D586A3",
    "rgb": "213, 134, 163"
  },
  {
    "name": "Pacific Elegance 57-5",
    "code": "NP R 1057 T",
    "hex": "#6E575F",
    "rgb": "110, 87, 95"
  },
  {
    "name": "Saharan Cloud 58-5",
    "code": "NP R 1058 D",
    "hex": "#93425F",
    "rgb": "147, 66, 95"
  },
  {
    "name": "Coastal Serenity 59-5",
    "code": "NP R 1059 A",
    "hex": "#F01B67",
    "rgb": "240, 27, 103"
  },
  {
    "name": "Soft Whisper 60-5",
    "code": "NP R 1060 N",
    "hex": "#B3305F",
    "rgb": "179, 48, 95"
  },
  {
    "name": "Cool Harmony 61-5",
    "code": "NP R 1061 P",
    "hex": "#664752",
    "rgb": "102, 71, 82"
  },
  {
    "name": "Muted Sand 62-5",
    "code": "NP R 1062 T",
    "hex": "#B78B9A",
    "rgb": "183, 139, 154"
  },
  {
    "name": "Classic Dusk 63-5",
    "code": "NP R 1063 D",
    "hex": "#EF5A8E",
    "rgb": "239, 90, 142"
  },
  {
    "name": "Mystic Echo 64-5",
    "code": "NP R 1064 A",
    "hex": "#900E3B",
    "rgb": "144, 14, 59"
  },
  {
    "name": "Silver Reflection 65-5",
    "code": "NP R 1065 N",
    "hex": "#702640",
    "rgb": "112, 38, 64"
  },
  {
    "name": "Satin Silk 66-5",
    "code": "NP R 1066 P",
    "hex": "#D8A0B3",
    "rgb": "216, 160, 179"
  },
  {
    "name": "Pacific Blossom 67-5",
    "code": "NP R 1067 T",
    "hex": "#DD9EB3",
    "rgb": "221, 158, 179"
  },
  {
    "name": "Saharan Sanctuary 68-5",
    "code": "NP R 1068 D",
    "hex": "#74233E",
    "rgb": "116, 35, 62"
  },
  {
    "name": "Coastal Glow 69-5",
    "code": "NP R 1069 A",
    "hex": "#8A0E38",
    "rgb": "138, 14, 56"
  },
  {
    "name": "Soft Symphony 70-5",
    "code": "NP R 1070 N",
    "hex": "#ED6290",
    "rgb": "237, 98, 144"
  },
  {
    "name": "Cool Horizon 71-5",
    "code": "NP R 1071 P",
    "hex": "#BE93A1",
    "rgb": "190, 147, 161"
  },
  {
    "name": "Muted Tranquility 72-5",
    "code": "NP R 1072 T",
    "hex": "#67444F",
    "rgb": "103, 68, 79"
  },
  {
    "name": "Classic Breeze 73-5",
    "code": "NP R 1073 D",
    "hex": "#AD2954",
    "rgb": "173, 41, 84"
  },
  {
    "name": "Mystic Aura 74-5",
    "code": "NP R 1074 A",
    "hex": "#F21E63",
    "rgb": "242, 30, 99"
  },
  {
    "name": "Silver Feather 75-5",
    "code": "NP R 1075 N",
    "hex": "#9A4B64",
    "rgb": "154, 75, 100"
  },
  {
    "name": "Satin Twilight 76-5",
    "code": "NP R 1076 P",
    "hex": "#6B555C",
    "rgb": "107, 85, 92"
  },
  {
    "name": "Pacific Tide 77-5",
    "code": "NP R 1077 T",
    "hex": "#CF7C96",
    "rgb": "207, 124, 150"
  },
  {
    "name": "Saharan Dream 78-5",
    "code": "NP R 1078 D",
    "hex": "#E42A65",
    "rgb": "228, 42, 101"
  },
  {
    "name": "Coastal Stone 79-5",
    "code": "NP R 1079 A",
    "hex": "#7B1434",
    "rgb": "123, 20, 52"
  },
  {
    "name": "Soft Dawn 80-5",
    "code": "NP R 1080 N",
    "hex": "#81495A",
    "rgb": "129, 73, 90"
  },
  {
    "name": "Cool Canvas 81-4",
    "code": "NP R 1081 P",
    "hex": "#E9BAC8",
    "rgb": "233, 186, 200"
  },
  {
    "name": "Muted Shadow 82-5",
    "code": "NP R 1082 T",
    "hex": "#C76986",
    "rgb": "199, 105, 134"
  },
  {
    "name": "Classic Velvet 83-5",
    "code": "NP R 1083 D",
    "hex": "#690F2A",
    "rgb": "105, 15, 42"
  },
  {
    "name": "Mystic Petal 84-5",
    "code": "NP R 1084 A",
    "hex": "#A22249",
    "rgb": "162, 34, 73"
  },
  {
    "name": "Silver Haven 85-5",
    "code": "NP R 1085 N",
    "hex": "#F299B4",
    "rgb": "242, 153, 180"
  },
  {
    "name": "Satin Mist 86-4",
    "code": "NP R 1086 P",
    "hex": "#A4818C",
    "rgb": "164, 129, 140"
  },
  {
    "name": "Pacific Elegance 87-5",
    "code": "NP R 1087 T",
    "hex": "#682F40",
    "rgb": "104, 47, 64"
  },
  {
    "name": "Saharan Cloud 88-5",
    "code": "NP R 1088 D",
    "hex": "#C6164A",
    "rgb": "198, 22, 74"
  },
  {
    "name": "Coastal Serenity 89-5",
    "code": "NP R 1089 A",
    "hex": "#EA3F71",
    "rgb": "234, 63, 113"
  },
  {
    "name": "Soft Whisper 90-5",
    "code": "NP R 1090 N",
    "hex": "#835A66",
    "rgb": "131, 90, 102"
  },
  {
    "name": "Cool Harmony 91-5",
    "code": "NP R 1091 P",
    "hex": "#795C65",
    "rgb": "121, 92, 101"
  },
  {
    "name": "Muted Sand 92-5",
    "code": "NP R 1092 T",
    "hex": "#E3557D",
    "rgb": "227, 85, 125"
  },
  {
    "name": "Classic Dusk 93-5",
    "code": "NP R 1093 D",
    "hex": "#D1154A",
    "rgb": "209, 21, 74"
  },
  {
    "name": "Mystic Echo 94-5",
    "code": "NP R 1094 A",
    "hex": "#6C2539",
    "rgb": "108, 37, 57"
  },
  {
    "name": "Silver Reflection 95-5",
    "code": "NP R 1095 N",
    "hex": "#98707C",
    "rgb": "152, 112, 124"
  },
  {
    "name": "Satin Silk 96-5",
    "code": "NP R 1096 P",
    "hex": "#F1ADC0",
    "rgb": "241, 173, 192"
  },
  {
    "name": "Pacific Blossom 97-5",
    "code": "NP R 1097 T",
    "hex": "#AE3556",
    "rgb": "174, 53, 86"
  },
  {
    "name": "Saharan Sanctuary 98-5",
    "code": "NP R 1098 D",
    "hex": "#660B24",
    "rgb": "102, 11, 36"
  },
  {
    "name": "Coastal Glow 99-5",
    "code": "NP R 1099 A",
    "hex": "#BC4E6C",
    "rgb": "188, 78, 108"
  },
  {
    "name": "Soft Symphony 100-5",
    "code": "NP R 1100 N",
    "hex": "#EEB9C7",
    "rgb": "238, 185, 199"
  },
  {
    "name": "Cool Horizon 101-5",
    "code": "NP R 1101 P",
    "hex": "#8C5C69",
    "rgb": "140, 92, 105"
  },
  {
    "name": "Muted Tranquility 102-5",
    "code": "NP R 1102 T",
    "hex": "#731B32",
    "rgb": "115, 27, 50"
  },
  {
    "name": "Classic Breeze 103-5",
    "code": "NP R 1103 D",
    "hex": "#DB1B4E",
    "rgb": "219, 27, 78"
  },
  {
    "name": "Mystic Aura 104-5",
    "code": "NP R 1104 A",
    "hex": "#D96A87",
    "rgb": "217, 106, 135"
  },
  {
    "name": "Silver Feather 105-5",
    "code": "NP R 1105 N",
    "hex": "#715A60",
    "rgb": "113, 90, 96"
  },
  {
    "name": "Satin Twilight 106-5",
    "code": "NP R 1106 P",
    "hex": "#8E5563",
    "rgb": "142, 85, 99"
  },
  {
    "name": "Pacific Tide 107-5",
    "code": "NP R 1107 T",
    "hex": "#EF2C5D",
    "rgb": "239, 44, 93"
  },
  {
    "name": "Saharan Dream 108-5",
    "code": "NP R 1108 D",
    "hex": "#B91E45",
    "rgb": "185, 30, 69"
  },
  {
    "name": "Coastal Stone 109-5",
    "code": "NP R 1109 A",
    "hex": "#663945",
    "rgb": "102, 57, 69"
  },
  {
    "name": "Soft Dawn 110-5",
    "code": "NP R 1110 N",
    "hex": "#B18E97",
    "rgb": "177, 142, 151"
  },
  {
    "name": "Cool Canvas 111-5",
    "code": "NP R 1111 P",
    "hex": "#F17E9A",
    "rgb": "241, 126, 154"
  },
  {
    "name": "Muted Shadow 112-5",
    "code": "NP R 1112 T",
    "hex": "#951534",
    "rgb": "149, 21, 52"
  },
  {
    "name": "Classic Velvet 113-5",
    "code": "NP R 1113 D",
    "hex": "#6D172C",
    "rgb": "109, 23, 44"
  },
  {
    "name": "Mystic Petal 114-5",
    "code": "NP R 1114 A",
    "hex": "#D38598",
    "rgb": "211, 133, 152"
  },
  {
    "name": "Silver Haven 115-5",
    "code": "NP R 1115 N",
    "hex": "#E1B1BC",
    "rgb": "225, 177, 188"
  },
  {
    "name": "Satin Mist 116-5",
    "code": "NP R 1116 P",
    "hex": "#773645",
    "rgb": "119, 54, 69"
  },
  {
    "name": "Pacific Elegance 117-5",
    "code": "NP R 1117 T",
    "hex": "#850F2B",
    "rgb": "133, 15, 43"
  },
  {
    "name": "Saharan Cloud 118-5",
    "code": "NP R 1118 D",
    "hex": "#EB4067",
    "rgb": "235, 64, 103"
  },
  {
    "name": "Coastal Serenity 119-5",
    "code": "NP R 1119 A",
    "hex": "#C38795",
    "rgb": "195, 135, 149"
  },
  {
    "name": "Soft Whisper 120-5",
    "code": "NP R 1120 N",
    "hex": "#674E54",
    "rgb": "103, 78, 84"
  },
  {
    "name": "Cool Harmony 121-5",
    "code": "NP R 1121 P",
    "hex": "#A73E56",
    "rgb": "167, 62, 86"
  },
  {
    "name": "Muted Sand 122-5",
    "code": "NP R 1122 T",
    "hex": "#F21849",
    "rgb": "242, 24, 73"
  },
  {
    "name": "Classic Dusk 123-5",
    "code": "NP R 1123 D",
    "hex": "#9F364D",
    "rgb": "159, 54, 77"
  },
  {
    "name": "Mystic Echo 124-5",
    "code": "NP R 1124 A",
    "hex": "#694E54",
    "rgb": "105, 78, 84"
  },
  {
    "name": "Silver Reflection 125-5",
    "code": "NP R 1125 N",
    "hex": "#CA919D",
    "rgb": "202, 145, 157"
  },
  {
    "name": "Satin Silk 126-5",
    "code": "NP R 1126 P",
    "hex": "#E74668",
    "rgb": "231, 70, 104"
  },
  {
    "name": "Pacific Blossom 127-5",
    "code": "NP R 1127 T",
    "hex": "#7F0D25",
    "rgb": "127, 13, 37"
  },
  {
    "name": "Saharan Sanctuary 128-5",
    "code": "NP R 1128 D",
    "hex": "#7D3443",
    "rgb": "125, 52, 67"
  },
  {
    "name": "Coastal Glow 129-5",
    "code": "NP R 1129 A",
    "hex": "#E6B2BD",
    "rgb": "230, 178, 189"
  },
  {
    "name": "Soft Symphony 130-5",
    "code": "NP R 1130 N",
    "hex": "#CD8796",
    "rgb": "205, 135, 150"
  },
  {
    "name": "Cool Horizon 131-5",
    "code": "NP R 1131 P",
    "hex": "#6A192A",
    "rgb": "106, 25, 42"
  },
  {
    "name": "Muted Tranquility 132-5",
    "code": "NP R 1132 T",
    "hex": "#9D142F",
    "rgb": "157, 20, 47"
  },
  {
    "name": "Classic Breeze 133-5",
    "code": "NP R 1133 D",
    "hex": "#F2768F",
    "rgb": "242, 118, 143"
  },
  {
    "name": "Mystic Aura 134-5",
    "code": "NP R 1134 A",
    "hex": "#AA878E",
    "rgb": "170, 135, 142"
  },
  {
    "name": "Silver Feather 135-5",
    "code": "NP R 1135 N",
    "hex": "#673D45",
    "rgb": "103, 61, 69"
  },
  {
    "name": "Satin Twilight 136-5",
    "code": "NP R 1136 P",
    "hex": "#C02341",
    "rgb": "192, 35, 65"
  },
  {
    "name": "Pacific Tide 137-5",
    "code": "NP R 1137 T",
    "hex": "#EC264C",
    "rgb": "236, 38, 76"
  },
  {
    "name": "Saharan Dream 138-5",
    "code": "NP R 1138 D",
    "hex": "#874C57",
    "rgb": "135, 76, 87"
  },
  {
    "name": "Coastal Stone 139-5",
    "code": "NP R 1139 A",
    "hex": "#765E62",
    "rgb": "118, 94, 98"
  },
  {
    "name": "Soft Dawn 140-5",
    "code": "NP R 1140 N",
    "hex": "#DF7588",
    "rgb": "223, 117, 136"
  },
  {
    "name": "Cool Canvas 141-5",
    "code": "NP R 1141 P",
    "hex": "#D61E3F",
    "rgb": "214, 30, 63"
  },
  {
    "name": "Muted Shadow 142-5",
    "code": "NP R 1142 T",
    "hex": "#6F1727",
    "rgb": "111, 23, 39"
  },
  {
    "name": "Classic Velvet 143-5",
    "code": "NP R 1143 D",
    "hex": "#935D66",
    "rgb": "147, 93, 102"
  },
  {
    "name": "Mystic Petal 144-5",
    "code": "NP R 1144 A",
    "hex": "#F0BDC6",
    "rgb": "240, 189, 198"
  },
  {
    "name": "Silver Haven 145-5",
    "code": "NP R 1145 N",
    "hex": "#B45162",
    "rgb": "180, 81, 98"
  },
  {
    "name": "Satin Mist 146-5",
    "code": "NP R 1146 P",
    "hex": "#660B1B",
    "rgb": "102, 11, 27"
  },
  {
    "name": "Pacific Elegance 147-5",
    "code": "NP R 1147 T",
    "hex": "#B63148",
    "rgb": "182, 49, 72"
  },
  {
    "name": "Saharan Cloud 148-5",
    "code": "NP R 1148 D",
    "hex": "#F0A6B2",
    "rgb": "240, 166, 178"
  },
  {
    "name": "Coastal Serenity 149-5",
    "code": "NP R 1149 A",
    "hex": "#916E74",
    "rgb": "145, 110, 116"
  },
  {
    "name": "Soft Whisper 150-5",
    "code": "NP R 1150 N",
    "hex": "#702A35",
    "rgb": "112, 42, 53"
  },
  {
    "name": "Cool Harmony 151-5",
    "code": "NP R 1151 P",
    "hex": "#D71635",
    "rgb": "215, 22, 53"
  },
  {
    "name": "Muted Sand 152-5",
    "code": "NP R 1152 T",
    "hex": "#DE4B63",
    "rgb": "222, 75, 99"
  },
  {
    "name": "Classic Dusk 153-5",
    "code": "NP R 1153 D",
    "hex": "#74565B",
    "rgb": "116, 86, 91"
  },
  {
    "name": "Mystic Echo 154-5",
    "code": "NP R 1154 A",
    "hex": "#896268",
    "rgb": "137, 98, 104"
  },
  {
    "name": "Silver Reflection 155-5",
    "code": "NP R 1155 N",
    "hex": "#ED4761",
    "rgb": "237, 71, 97"
  },
  {
    "name": "Satin Silk 156-5",
    "code": "NP R 1156 P",
    "hex": "#BE142E",
    "rgb": "190, 20, 46"
  },
  {
    "name": "Pacific Blossom 157-5",
    "code": "NP R 1157 T",
    "hex": "#672A33",
    "rgb": "103, 42, 51"
  },
  {
    "name": "Saharan Sanctuary 158-5",
    "code": "NP R 1158 D",
    "hex": "#AC858B",
    "rgb": "172, 133, 139"
  },
  {
    "name": "Coastal Glow 159-5",
    "code": "NP R 1159 A",
    "hex": "#F2A0AB",
    "rgb": "242, 160, 171"
  },
  {
    "name": "Soft Symphony 160-5",
    "code": "NP R 1160 N",
    "hex": "#9B2535",
    "rgb": "155, 37, 53"
  },
  {
    "name": "Cool Horizon 161-5",
    "code": "NP R 1161 P",
    "hex": "#6B0D1B",
    "rgb": "107, 13, 27"
  },
  {
    "name": "Muted Tranquility 162-5",
    "code": "NP R 1162 T",
    "hex": "#CE6574",
    "rgb": "206, 101, 116"
  },
  {
    "name": "Classic Breeze 163-5",
    "code": "NP R 1163 D",
    "hex": "#E4B6BC",
    "rgb": "228, 182, 188"
  },
  {
    "name": "Mystic Aura 164-5",
    "code": "NP R 1164 A",
    "hex": "#7B4950",
    "rgb": "123, 73, 80"
  },
  {
    "name": "Silver Feather 165-5",
    "code": "NP R 1165 N",
    "hex": "#801725",
    "rgb": "128, 23, 37"
  },
  {
    "name": "Satin Twilight 166-5",
    "code": "NP R 1166 P",
    "hex": "#E8253F",
    "rgb": "232, 37, 63"
  },
  {
    "name": "Pacific Tide 167-5",
    "code": "NP R 1167 T",
    "hex": "#C8717C",
    "rgb": "200, 113, 124"
  },
  {
    "name": "Saharan Dream 168-5",
    "code": "NP R 1168 D",
    "hex": "#695456",
    "rgb": "105, 84, 86"
  },
  {
    "name": "Coastal Stone 169-5",
    "code": "NP R 1169 A",
    "hex": "#A1545E",
    "rgb": "161, 84, 94"
  },
  {
    "name": "Soft Dawn 170-5",
    "code": "NP R 1170 N",
    "hex": "#F2223B",
    "rgb": "242, 34, 59"
  },
  {
    "name": "Cool Canvas 171-5",
    "code": "NP R 1171 P",
    "hex": "#A52332",
    "rgb": "165, 35, 50"
  },
  {
    "name": "Muted Shadow 172-5",
    "code": "NP R 1172 T",
    "hex": "#684246",
    "rgb": "104, 66, 70"
  },
  {
    "name": "Classic Velvet 173-5",
    "code": "NP R 1173 D",
    "hex": "#C59BA0",
    "rgb": "197, 155, 160"
  },
  {
    "name": "Mystic Petal 174-5",
    "code": "NP R 1174 A",
    "hex": "#EA6977",
    "rgb": "234, 105, 119"
  },
  {
    "name": "Silver Haven 175-5",
    "code": "NP R 1175 N",
    "hex": "#830F1C",
    "rgb": "131, 15, 28"
  },
  {
    "name": "Satin Mist 176-5",
    "code": "NP R 1176 P",
    "hex": "#79212A",
    "rgb": "121, 33, 42"
  },
  {
    "name": "Pacific Elegance 177-5",
    "code": "NP R 1177 T",
    "hex": "#E29CA4",
    "rgb": "226, 156, 164"
  },
  {
    "name": "Saharan Cloud 178-5",
    "code": "NP R 1178 D",
    "hex": "#D29FA4",
    "rgb": "210, 159, 164"
  },
  {
    "name": "Coastal Serenity 179-5",
    "code": "NP R 1179 A",
    "hex": "#6D282F",
    "rgb": "109, 40, 47"
  },
  {
    "name": "Soft Whisper 180-5",
    "code": "NP R 1180 N",
    "hex": "#970F1D",
    "rgb": "151, 15, 29"
  },
  {
    "name": "Cool Harmony 181-5",
    "code": "NP R 1181 P",
    "hex": "#F15262",
    "rgb": "241, 82, 98"
  },
  {
    "name": "Muted Sand 182-5",
    "code": "NP R 1182 T",
    "hex": "#AF8286",
    "rgb": "175, 130, 134"
  },
  {
    "name": "Classic Dusk 183-5",
    "code": "NP R 1183 D",
    "hex": "#66494C",
    "rgb": "102, 73, 76"
  },
  {
    "name": "Mystic Echo 184-5",
    "code": "NP R 1184 A",
    "hex": "#BB3844",
    "rgb": "187, 56, 68"
  },
  {
    "name": "Silver Reflection 185-5",
    "code": "NP R 1185 N",
    "hex": "#EE192C",
    "rgb": "238, 25, 44"
  },
  {
    "name": "Satin Silk 186-5",
    "code": "NP R 1186 P",
    "hex": "#8C3A41",
    "rgb": "140, 58, 65"
  },
  {
    "name": "Pacific Blossom 187-5",
    "code": "NP R 1187 T",
    "hex": "#72595B",
    "rgb": "114, 89, 91"
  },
  {
    "name": "Saharan Sanctuary 188-5",
    "code": "NP R 1188 D",
    "hex": "#DB9097",
    "rgb": "219, 144, 151"
  },
  {
    "name": "Coastal Glow 189-5",
    "code": "NP R 1189 A",
    "hex": "#DA3441",
    "rgb": "218, 52, 65"
  },
  {
    "name": "Soft Symphony 190-5",
    "code": "NP R 1190 N",
    "hex": "#720E16",
    "rgb": "114, 14, 22"
  },
  {
    "name": "Cool Horizon 191-5",
    "code": "NP R 1191 P",
    "hex": "#8D454B",
    "rgb": "141, 69, 75"
  },
  {
    "name": "Muted Tranquility 192-5",
    "code": "NP R 1192 T",
    "hex": "#EFBEC1",
    "rgb": "239, 190, 193"
  },
  {
    "name": "Classic Breeze 193-5",
    "code": "NP R 1193 D",
    "hex": "#BA6F74",
    "rgb": "186, 111, 116"
  },
  {
    "name": "Mystic Aura 194-5",
    "code": "NP R 1194 A",
    "hex": "#661318",
    "rgb": "102, 19, 24"
  },
  {
    "name": "Silver Feather 195-5",
    "code": "NP R 1195 N",
    "hex": "#B01C27",
    "rgb": "176, 28, 39"
  },
  {
    "name": "Satin Twilight 196-5",
    "code": "NP R 1196 P",
    "hex": "#F1888F",
    "rgb": "241, 136, 143"
  },
  {
    "name": "Pacific Tide 197-5",
    "code": "NP R 1197 T",
    "hex": "#96787A",
    "rgb": "150, 120, 122"
  },
  {
    "name": "Saharan Dream 198-5",
    "code": "NP R 1198 D",
    "hex": "#6D393C",
    "rgb": "109, 57, 60"
  },
  {
    "name": "Coastal Stone 199-5",
    "code": "NP R 1199 A",
    "hex": "#D21D28",
    "rgb": "210, 29, 40"
  },
  {
    "name": "Soft Dawn 200-5",
    "code": "NP R 1200 N",
    "hex": "#E1303A",
    "rgb": "225, 48, 58"
  },
  {
    "name": "Cool Canvas 201-5",
    "code": "NP R 1201 P",
    "hex": "#784C4E",
    "rgb": "120, 76, 78"
  },
  {
    "name": "Muted Shadow 202-5",
    "code": "NP R 1202 T",
    "hex": "#84686A",
    "rgb": "132, 104, 106"
  },
  {
    "name": "Classic Velvet 203-5",
    "code": "NP R 1203 D",
    "hex": "#EA6970",
    "rgb": "234, 105, 112"
  },
  {
    "name": "Mystic Petal 204-5",
    "code": "NP R 1204 A",
    "hex": "#C4161E",
    "rgb": "196, 22, 30"
  },
  {
    "name": "Silver Haven 205-5",
    "code": "NP R 1205 N",
    "hex": "#681C20",
    "rgb": "104, 28, 32"
  },
  {
    "name": "Satin Mist 206-5",
    "code": "NP R 1206 P",
    "hex": "#A67375",
    "rgb": "166, 115, 117"
  },
  {
    "name": "Pacific Elegance 207-5",
    "code": "NP R 1207 T",
    "hex": "#F2B8BA",
    "rgb": "242, 184, 186"
  },
  {
    "name": "Saharan Cloud 208-5",
    "code": "NP R 1208 D",
    "hex": "#A03C40",
    "rgb": "160, 60, 64"
  },
  {
    "name": "Coastal Serenity 209-5",
    "code": "NP R 1209 A",
    "hex": "#690B0E",
    "rgb": "105, 11, 14"
  },
  {
    "name": "Soft Whisper 210-5",
    "code": "NP R 1210 N",
    "hex": "#C94549",
    "rgb": "201, 69, 73"
  },
  {
    "name": "Cool Harmony 211-5",
    "code": "NP R 1211 P",
    "hex": "#E8ACAE",
    "rgb": "232, 172, 174"
  },
  {
    "name": "Muted Sand 212-5",
    "code": "NP R 1212 T",
    "hex": "#805B5C",
    "rgb": "128, 91, 92"
  },
  {
    "name": "Classic Dusk 213-5",
    "code": "NP R 1213 D",
    "hex": "#7C2528",
    "rgb": "124, 37, 40"
  },
  {
    "name": "Mystic Echo 214-5",
    "code": "NP R 1214 A",
    "hex": "#E5181E",
    "rgb": "229, 24, 30"
  },
  {
    "name": "Silver Reflection 215-5",
    "code": "NP R 1215 N",
    "hex": "#CD5558",
    "rgb": "205, 85, 88"
  },
  {
    "name": "Satin Silk 216-5",
    "code": "NP R 1216 P",
    "hex": "#6B5353",
    "rgb": "107, 83, 83"
  },
  {
    "name": "Pacific Blossom 217-5",
    "code": "NP R 1217 T",
    "hex": "#9C6768",
    "rgb": "156, 103, 104"
  },
  {
    "name": "Saharan Sanctuary 218-5",
    "code": "NP R 1218 D",
    "hex": "#F2393D",
    "rgb": "242, 57, 61"
  },
  {
    "name": "Coastal Glow 219-5",
    "code": "NP R 1219 A",
    "hex": "#AB1518",
    "rgb": "171, 21, 24"
  },
  {
    "name": "Soft Symphony 220-5",
    "code": "NP R 1220 N",
    "hex": "#673233",
    "rgb": "103, 50, 51"
  },
  {
    "name": "Cool Horizon 221-5",
    "code": "NP R 1221 P",
    "hex": "#BF9899",
    "rgb": "191, 152, 153"
  },
  {
    "name": "Muted Tranquility 222-5",
    "code": "NP R 1222 T",
    "hex": "#EC8D8E",
    "rgb": "236, 141, 142"
  },
  {
    "name": "Classic Breeze 223-5",
    "code": "NP R 1223 D",
    "hex": "#88191A",
    "rgb": "136, 25, 26"
  },
  {
    "name": "Mystic Aura 224-5",
    "code": "NP R 1224 A",
    "hex": "#751314",
    "rgb": "117, 19, 20"
  },
  {
    "name": "Silver Feather 225-5",
    "code": "NP R 1225 N",
    "hex": "#DE7D7E",
    "rgb": "222, 125, 126"
  },
  {
    "name": "Satin Twilight 226-5",
    "code": "NP R 1226 P",
    "hex": "#D6ABAB",
    "rgb": "214, 171, 171"
  },
  {
    "name": "Pacific Tide 227-5",
    "code": "NP R 1227 T",
    "hex": "#6F3A3A",
    "rgb": "111, 58, 58"
  },
  {
    "name": "Saharan Dream 228-5",
    "code": "NP R 1228 D",
    "hex": "#921514",
    "rgb": "146, 21, 20"
  },
  {
    "name": "Coastal Stone 229-5",
    "code": "NP R 1229 A",
    "hex": "#F03433",
    "rgb": "240, 52, 51"
  },
  {
    "name": "Soft Dawn 230-5",
    "code": "NP R 1230 N",
    "hex": "#B57373",
    "rgb": "181, 115, 115"
  },
  {
    "name": "Cool Canvas 231-5",
    "code": "NP R 1231 P",
    "hex": "#665050",
    "rgb": "102, 80, 80"
  },
  {
    "name": "Muted Shadow 232-5",
    "code": "NP R 1232 T",
    "hex": "#B55251",
    "rgb": "181, 82, 81"
  },
  {
    "name": "Classic Velvet 233-5",
    "code": "NP R 1233 D",
    "hex": "#F01E1B",
    "rgb": "240, 30, 27"
  },
  {
    "name": "Mystic Petal 234-5",
    "code": "NP R 1234 A",
    "hex": "#922928",
    "rgb": "146, 41, 40"
  },
  {
    "name": "Silver Haven 235-5",
    "code": "NP R 1235 N",
    "hex": "#6F4E4D",
    "rgb": "111, 78, 77"
  },
  {
    "name": "Satin Mist 236-5",
    "code": "NP R 1236 P",
    "hex": "#D6A4A3",
    "rgb": "214, 164, 163"
  },
  {
    "name": "Pacific Elegance 237-5",
    "code": "NP R 1237 T",
    "hex": "#DE5653",
    "rgb": "222, 86, 83"
  },
  {
    "name": "Saharan Cloud 238-5",
    "code": "NP R 1238 D",
    "hex": "#750E0C",
    "rgb": "117, 14, 12"
  },
  {
    "name": "Coastal Serenity 239-5",
    "code": "NP R 1239 A",
    "hex": "#88312E",
    "rgb": "136, 49, 46"
  },
  {
    "name": "Soft Whisper 240-5",
    "code": "NP R 1240 N",
    "hex": "#EDB1AF",
    "rgb": "237, 177, 175"
  },
  {
    "name": "Cool Harmony 241-5",
    "code": "NP R 1241 P",
    "hex": "#BF8A89",
    "rgb": "191, 138, 137"
  },
  {
    "name": "Muted Sand 242-5",
    "code": "NP R 1242 T",
    "hex": "#67211F",
    "rgb": "103, 33, 31"
  },
  {
    "name": "Classic Dusk 243-5",
    "code": "NP R 1243 D",
    "hex": "#AB1712",
    "rgb": "171, 23, 18"
  },
  {
    "name": "Mystic Echo 244-5",
    "code": "NP R 1244 A",
    "hex": "#F26964",
    "rgb": "242, 105, 100"
  },
  {
    "name": "Silver Reflection 245-5",
    "code": "NP R 1245 N",
    "hex": "#9C7A79",
    "rgb": "156, 122, 121"
  },
  {
    "name": "Satin Silk 246-5",
    "code": "NP R 1246 P",
    "hex": "#6B4846",
    "rgb": "107, 72, 70"
  },
  {
    "name": "Pacific Blossom 247-5",
    "code": "NP R 1247 T",
    "hex": "#CE3731",
    "rgb": "206, 55, 49"
  },
  {
    "name": "Saharan Sanctuary 248-5",
    "code": "NP R 1248 D",
    "hex": "#E5261D",
    "rgb": "229, 38, 29"
  },
  {
    "name": "Coastal Glow 249-5",
    "code": "NP R 1249 A",
    "hex": "#7C403D",
    "rgb": "124, 64, 61"
  },
  {
    "name": "Soft Symphony 250-5",
    "code": "NP R 1250 N",
    "hex": "#806766",
    "rgb": "128, 103, 102"
  },
  {
    "name": "Cool Horizon 251-4",
    "code": "NP R 1251 P",
    "hex": "#E88F8A",
    "rgb": "232, 143, 138"
  },
  {
    "name": "Muted Tranquility 252-4",
    "code": "NP R 1252 T",
    "hex": "#C92D25",
    "rgb": "201, 45, 37"
  },
  {
    "name": "Classic Breeze 253-4",
    "code": "NP R 1253 D",
    "hex": "#691611",
    "rgb": "105, 22, 17"
  },
  {
    "name": "Mystic Aura 254-4",
    "code": "NP R 1254 A",
    "hex": "#A05F5A",
    "rgb": "160, 95, 90"
  },
  {
    "name": "Silver Feather 255-4",
    "code": "NP R 1255 N",
    "hex": "#F2C5C2",
    "rgb": "242, 197, 194"
  },
  {
    "name": "Satin Twilight 256-4",
    "code": "NP R 1256 P",
    "hex": "#A65C57",
    "rgb": "166, 92, 87"
  },
  {
    "name": "Pacific Tide 257-4",
    "code": "NP R 1257 T",
    "hex": "#68140E",
    "rgb": "104, 20, 14"
  },
  {
    "name": "Saharan Dream 258-4",
    "code": "NP R 1258 D",
    "hex": "#C43429",
    "rgb": "196, 52, 41"
  },
  {
    "name": "Coastal Stone 259-4",
    "code": "NP R 1259 A",
    "hex": "#EA9A94",
    "rgb": "234, 154, 148"
  },
  {
    "name": "Soft Dawn 260-4",
    "code": "NP R 1260 N",
    "hex": "#846A68",
    "rgb": "132, 106, 104"
  },
  {
    "name": "Cool Canvas 261-4",
    "code": "NP R 1261 P",
    "hex": "#783B36",
    "rgb": "120, 59, 54"
  },
  {
    "name": "Classic Velvet 263-4",
    "code": "NP R 1263 D",
    "hex": "#D24539",
    "rgb": "210, 69, 57"
  },
  {
    "name": "Mystic Petal 264-4",
    "code": "NP R 1264 A",
    "hex": "#6D4E4B",
    "rgb": "109, 78, 75"
  },
  {
    "name": "Silver Haven 265-4",
    "code": "NP R 1265 N",
    "hex": "#967572",
    "rgb": "150, 117, 114"
  },
  {
    "name": "Satin Mist 266-4",
    "code": "NP R 1266 P",
    "hex": "#F1665A",
    "rgb": "241, 102, 90"
  },
  {
    "name": "Pacific Elegance 267-4",
    "code": "NP R 1267 T",
    "hex": "#B01F12",
    "rgb": "176, 31, 18"
  },
  {
    "name": "Saharan Cloud 268-4",
    "code": "NP R 1268 D",
    "hex": "#662923",
    "rgb": "102, 41, 35"
  },
  {
    "name": "Coastal Serenity 269-4",
    "code": "NP R 1269 A",
    "hex": "#BA8E8A",
    "rgb": "186, 142, 138"
  },
  {
    "name": "Soft Whisper 270-4",
    "code": "NP R 1270 N",
    "hex": "#EFB1AB",
    "rgb": "239, 177, 171"
  },
  {
    "name": "Cool Harmony 271-4",
    "code": "NP R 1271 P",
    "hex": "#8D342A",
    "rgb": "141, 52, 42"
  },
  {
    "name": "Muted Sand 272-4",
    "code": "NP R 1272 T",
    "hex": "#72160C",
    "rgb": "114, 22, 12"
  },
  {
    "name": "Classic Dusk 273-4",
    "code": "NP R 1273 D",
    "hex": "#DA675B",
    "rgb": "218, 103, 91"
  },
  {
    "name": "Mystic Echo 274-4",
    "code": "NP R 1274 A",
    "hex": "#DBAFAA",
    "rgb": "219, 175, 170"
  },
  {
    "name": "Silver Reflection 275-4",
    "code": "NP R 1275 N",
    "hex": "#724F4B",
    "rgb": "114, 79, 75"
  },
  {
    "name": "Satin Silk 276-4",
    "code": "NP R 1276 P",
    "hex": "#8C2C21",
    "rgb": "140, 44, 33"
  },
  {
    "name": "Pacific Blossom 277-4",
    "code": "NP R 1277 T",
    "hex": "#EE341E",
    "rgb": "238, 52, 30"
  },
  {
    "name": "Saharan Sanctuary 278-4",
    "code": "NP R 1278 D",
    "hex": "#BB665C",
    "rgb": "187, 102, 92"
  },
  {
    "name": "Coastal Glow 279-4",
    "code": "NP R 1279 A",
    "hex": "#665451",
    "rgb": "102, 84, 81"
  },
  {
    "name": "Soft Symphony 280-4",
    "code": "NP R 1280 N",
    "hex": "#B07068",
    "rgb": "176, 112, 104"
  },
  {
    "name": "Cool Horizon 281-4",
    "code": "NP R 1281 P",
    "hex": "#F1422C",
    "rgb": "241, 66, 44"
  },
  {
    "name": "Muted Tranquility 282-4",
    "code": "NP R 1282 T",
    "hex": "#972718",
    "rgb": "151, 39, 24"
  },
  {
    "name": "Classic Breeze 283-4",
    "code": "NP R 1283 D",
    "hex": "#6D433D",
    "rgb": "109, 67, 61"
  },
  {
    "name": "Mystic Aura 284-4",
    "code": "NP R 1284 A",
    "hex": "#D2ADA8",
    "rgb": "210, 173, 168"
  },
  {
    "name": "Silver Feather 285-4",
    "code": "NP R 1285 N",
    "hex": "#E28376",
    "rgb": "226, 131, 118"
  },
  {
    "name": "Satin Twilight 286-4",
    "code": "NP R 1286 P",
    "hex": "#791E11",
    "rgb": "121, 30, 17"
  },
  {
    "name": "Pacific Tide 287-4",
    "code": "NP R 1287 T",
    "hex": "#84291C",
    "rgb": "132, 41, 28"
  },
  {
    "name": "Saharan Dream 288-4",
    "code": "NP R 1288 D",
    "hex": "#EA9F94",
    "rgb": "234, 159, 148"
  },
  {
    "name": "Coastal Stone 289-4",
    "code": "NP R 1289 A",
    "hex": "#C5A09B",
    "rgb": "197, 160, 155"
  },
  {
    "name": "Soft Dawn 290-4",
    "code": "NP R 1290 N",
    "hex": "#68362E",
    "rgb": "104, 54, 46"
  },
  {
    "name": "Cool Canvas 291-4",
    "code": "NP R 1291 P",
    "hex": "#A52612",
    "rgb": "165, 38, 18"
  },
  {
    "name": "Muted Shadow 292-4",
    "code": "NP R 1292 T",
    "hex": "#F25A42",
    "rgb": "242, 90, 66"
  },
  {
    "name": "Classic Velvet 293-4",
    "code": "NP R 1293 D",
    "hex": "#A17770",
    "rgb": "161, 119, 112"
  },
  {
    "name": "Mystic Petal 294-4",
    "code": "NP R 1294 A",
    "hex": "#69534F",
    "rgb": "105, 83, 79"
  },
  {
    "name": "Silver Haven 295-4",
    "code": "NP R 1295 N",
    "hex": "#C85D4B",
    "rgb": "200, 93, 75"
  },
  {
    "name": "Satin Mist 296-4",
    "code": "NP R 1296 P",
    "hex": "#E83617",
    "rgb": "232, 54, 23"
  },
  {
    "name": "Pacific Elegance 297-4",
    "code": "NP R 1297 T",
    "hex": "#80382C",
    "rgb": "128, 56, 44"
  },
  {
    "name": "Saharan Cloud 298-4",
    "code": "NP R 1298 D",
    "hex": "#7B605C",
    "rgb": "123, 96, 92"
  },
  {
    "name": "Coastal Serenity 299-4",
    "code": "NP R 1299 A",
    "hex": "#E4ADA3",
    "rgb": "228, 173, 163"
  },
  {
    "name": "Soft Whisper 300-4",
    "code": "NP R 1300 N",
    "hex": "#CE543E",
    "rgb": "206, 84, 62"
  },
  {
    "name": "Cool Harmony 301-4",
    "code": "NP R 1301 P",
    "hex": "#6B1A0B",
    "rgb": "107, 26, 11"
  },
  {
    "name": "Muted Sand 302-4",
    "code": "NP R 1302 T",
    "hex": "#9B4F40",
    "rgb": "155, 79, 64"
  },
  {
    "name": "Classic Dusk 303-4",
    "code": "NP R 1303 D",
    "hex": "#F2C4BC",
    "rgb": "242, 196, 188"
  },
  {
    "name": "Mystic Echo 304-4",
    "code": "NP R 1304 A",
    "hex": "#AC7B71",
    "rgb": "172, 123, 113"
  },
  {
    "name": "Silver Reflection 305-4",
    "code": "NP R 1305 N",
    "hex": "#672518",
    "rgb": "103, 37, 24"
  },
  {
    "name": "Satin Silk 306-4",
    "code": "NP R 1306 P",
    "hex": "#BF3418",
    "rgb": "191, 52, 24"
  },
  {
    "name": "Pacific Blossom 307-4",
    "code": "NP R 1307 T",
    "hex": "#ED8974",
    "rgb": "237, 137, 116"
  },
  {
    "name": "Saharan Sanctuary 308-4",
    "code": "NP R 1308 D",
    "hex": "#89726D",
    "rgb": "137, 114, 109"
  },
  {
    "name": "Coastal Glow 309-4",
    "code": "NP R 1309 A",
    "hex": "#744D45",
    "rgb": "116, 77, 69"
  },
  {
    "name": "Soft Symphony 310-4",
    "code": "NP R 1310 N",
    "hex": "#DE4828",
    "rgb": "222, 72, 40"
  },
  {
    "name": "Cool Horizon 311-4",
    "code": "NP R 1311 P",
    "hex": "#D74323",
    "rgb": "215, 67, 35"
  },
  {
    "name": "Muted Tranquility 312-4",
    "code": "NP R 1312 T",
    "hex": "#70483F",
    "rgb": "112, 72, 63"
  },
  {
    "name": "Classic Breeze 313-4",
    "code": "NP R 1313 D",
    "hex": "#917974",
    "rgb": "145, 121, 116"
  },
  {
    "name": "Mystic Aura 314-4",
    "code": "NP R 1314 A",
    "hex": "#F0927D",
    "rgb": "240, 146, 125"
  },
  {
    "name": "Silver Feather 315-4",
    "code": "NP R 1315 N",
    "hex": "#B63719",
    "rgb": "182, 55, 25"
  },
  {
    "name": "Satin Twilight 316-4",
    "code": "NP R 1316 P",
    "hex": "#662516",
    "rgb": "102, 37, 22"
  },
  {
    "name": "Pacific Tide 317-4",
    "code": "NP R 1317 T",
    "hex": "#B47F72",
    "rgb": "180, 127, 114"
  },
  {
    "name": "Saharan Dream 318-4",
    "code": "NP R 1318 D",
    "hex": "#F0C7BD",
    "rgb": "240, 199, 189"
  },
  {
    "name": "Coastal Stone 319-4",
    "code": "NP R 1319 A",
    "hex": "#925141",
    "rgb": "146, 81, 65"
  },
  {
    "name": "Soft Dawn 320-4",
    "code": "NP R 1320 N",
    "hex": "#6F200C",
    "rgb": "111, 32, 12"
  },
  {
    "name": "Cool Canvas 321-4",
    "code": "NP R 1321 P",
    "hex": "#D6593A",
    "rgb": "214, 89, 58"
  },
  {
    "name": "Muted Shadow 322-4",
    "code": "NP R 1322 T",
    "hex": "#DFA89A",
    "rgb": "223, 168, 154"
  },
  {
    "name": "Classic Velvet 323-4",
    "code": "NP R 1323 D",
    "hex": "#765F59",
    "rgb": "118, 95, 89"
  },
  {
    "name": "Mystic Petal 324-4",
    "code": "NP R 1324 A",
    "hex": "#884432",
    "rgb": "136, 68, 50"
  },
  {
    "name": "Silver Haven 325-4",
    "code": "NP R 1325 N",
    "hex": "#EC4418",
    "rgb": "236, 68, 24"
  },
  {
    "name": "Satin Mist 326-4",
    "code": "NP R 1326 P",
    "hex": "#C05C42",
    "rgb": "192, 92, 66"
  },
  {
    "name": "Pacific Elegance 327-4",
    "code": "NP R 1327 T",
    "hex": "#67524C",
    "rgb": "103, 82, 76"
  },
  {
    "name": "Saharan Cloud 328-4",
    "code": "NP R 1328 D",
    "hex": "#AA8479",
    "rgb": "170, 132, 121"
  },
  {
    "name": "Coastal Serenity 329-4",
    "code": "NP R 1329 A",
    "hex": "#F26D49",
    "rgb": "242, 109, 73"
  },
  {
    "name": "Soft Whisper 330-4",
    "code": "NP R 1330 N",
    "hex": "#9C2F10",
    "rgb": "156, 47, 16"
  },
  {
    "name": "Cool Harmony 331-4",
    "code": "NP R 1331 P",
    "hex": "#6A3A2C",
    "rgb": "106, 58, 44"
  },
  {
    "name": "Muted Sand 332-4",
    "code": "NP R 1332 T",
    "hex": "#CDA99F",
    "rgb": "205, 169, 159"
  },
  {
    "name": "Classic Dusk 333-4",
    "code": "NP R 1333 D",
    "hex": "#E5A997",
    "rgb": "229, 169, 151"
  },
  {
    "name": "Mystic Echo 334-4",
    "code": "NP R 1334 A",
    "hex": "#7D331D",
    "rgb": "125, 51, 29"
  },
  {
    "name": "Silver Reflection 335-4",
    "code": "NP R 1335 N",
    "hex": "#7F2A10",
    "rgb": "127, 42, 16"
  },
  {
    "name": "Satin Silk 336-4",
    "code": "NP R 1336 P",
    "hex": "#E78D72",
    "rgb": "231, 141, 114"
  },
  {
    "name": "Pacific Blossom 337-4",
    "code": "NP R 1337 T",
    "hex": "#CAAAA1",
    "rgb": "202, 170, 161"
  },
  {
    "name": "Saharan Sanctuary 338-4",
    "code": "NP R 1338 D",
    "hex": "#69493F",
    "rgb": "105, 73, 63"
  },
  {
    "name": "Coastal Glow 339-4",
    "code": "NP R 1339 A",
    "hex": "#9F3C1D",
    "rgb": "159, 60, 29"
  },
  {
    "name": "Soft Symphony 340-4",
    "code": "NP R 1340 N",
    "hex": "#F25827",
    "rgb": "242, 88, 39"
  },
  {
    "name": "Cool Horizon 341-4",
    "code": "NP R 1341 P",
    "hex": "#A7705E",
    "rgb": "167, 112, 94"
  },
  {
    "name": "Muted Tranquility 342-4",
    "code": "NP R 1342 T",
    "hex": "#675853",
    "rgb": "103, 88, 83"
  },
  {
    "name": "Classic Breeze 343-4",
    "code": "NP R 1343 D",
    "hex": "#C37D66",
    "rgb": "195, 125, 102"
  },
  {
    "name": "Mystic Aura 344-4",
    "code": "NP R 1344 A",
    "hex": "#EB5321",
    "rgb": "235, 83, 33"
  },
  {
    "name": "Silver Feather 345-4",
    "code": "NP R 1345 N",
    "hex": "#85361C",
    "rgb": "133, 54, 28"
  },
  {
    "name": "Satin Twilight 346-4",
    "code": "NP R 1346 P",
    "hex": "#78574C",
    "rgb": "120, 87, 76"
  },
  {
    "name": "Pacific Tide 347-4",
    "code": "NP R 1347 T",
    "hex": "#E1BDB1",
    "rgb": "225, 189, 177"
  },
  {
    "name": "Saharan Dream 348-4",
    "code": "NP R 1348 D",
    "hex": "#D37C5E",
    "rgb": "211, 124, 94"
  },
  {
    "name": "Coastal Stone 349-4",
    "code": "NP R 1349 A",
    "hex": "#6D250C",
    "rgb": "109, 37, 12"
  },
  {
    "name": "Soft Dawn 350-4",
    "code": "NP R 1350 N",
    "hex": "#954529",
    "rgb": "149, 69, 41"
  },
  {
    "name": "Cool Canvas 351-4",
    "code": "NP R 1351 P",
    "hex": "#F1BAA7",
    "rgb": "241, 186, 167"
  },
  {
    "name": "Muted Shadow 352-4",
    "code": "NP R 1352 T",
    "hex": "#B19286",
    "rgb": "177, 146, 134"
  },
  {
    "name": "Classic Velvet 353-4",
    "code": "NP R 1353 D",
    "hex": "#663726",
    "rgb": "102, 55, 38"
  },
  {
    "name": "Mystic Petal 354-4",
    "code": "NP R 1354 A",
    "hex": "#B94013",
    "rgb": "185, 64, 19"
  },
  {
    "name": "Silver Haven 355-4",
    "code": "NP R 1355 N",
    "hex": "#EF7C52",
    "rgb": "239, 124, 82"
  },
  {
    "name": "Satin Mist 356-4",
    "code": "NP R 1356 P",
    "hex": "#8E7369",
    "rgb": "142, 115, 105"
  },
  {
    "name": "Pacific Elegance 357-4",
    "code": "NP R 1357 T",
    "hex": "#715A51",
    "rgb": "113, 90, 81"
  },
  {
    "name": "Saharan Cloud 358-4",
    "code": "NP R 1358 D",
    "hex": "#D96C41",
    "rgb": "217, 108, 65"
  },
  {
    "name": "Coastal Serenity 359-4",
    "code": "NP R 1359 A",
    "hex": "#DB4E17",
    "rgb": "219, 78, 23"
  },
  {
    "name": "Soft Whisper 360-4",
    "code": "NP R 1360 N",
    "hex": "#734330",
    "rgb": "115, 67, 48"
  },
  {
    "name": "Cool Harmony 361-4",
    "code": "NP R 1361 P",
    "hex": "#8C756C",
    "rgb": "140, 117, 108"
  },
  {
    "name": "Muted Sand 362-4",
    "code": "NP R 1362 T",
    "hex": "#EEB49D",
    "rgb": "238, 180, 157"
  },
  {
    "name": "Classic Dusk 363-4",
    "code": "NP R 1363 D",
    "hex": "#BC562C",
    "rgb": "188, 86, 44"
  },
  {
    "name": "Mystic Echo 364-4",
    "code": "NP R 1364 A",
    "hex": "#66270D",
    "rgb": "102, 39, 13"
  },
  {
    "name": "Silver Reflection 365-4",
    "code": "NP R 1365 N",
    "hex": "#AF7056",
    "rgb": "175, 112, 86"
  },
  {
    "name": "Satin Silk 366-4",
    "code": "NP R 1366 P",
    "hex": "#F1CFC0",
    "rgb": "241, 207, 192"
  },
  {
    "name": "Pacific Blossom 367-4",
    "code": "NP R 1367 T",
    "hex": "#986C5A",
    "rgb": "152, 108, 90"
  },
  {
    "name": "Saharan Sanctuary 368-4",
    "code": "NP R 1368 D",
    "hex": "#6C2E14",
    "rgb": "108, 46, 20"
  }
];

export const BUILTIN_EXCEL_PALETTES: ColorPalette[] = [
  {
    id: 'excel-builtin-1',
    name: 'Abacadabra & Aegean Sea',
    region: 'Colour Creation II',
    description: 'Abacadabra (NP N 2034 P) wall, Aegean Sea (NP BGG 1597 D) trim, Accented Brown (NP N 3386 A) highlight.',
    wall: createColorParam('Abacadabra', '#CEC9C3', 'NP N 2034 P'),
    border: createColorParam('Aegean Sea', '#00A0A0', 'NP BGG 1597 D'),
    highlight: createColorParam('Accented Brown', '#554841', 'NP N 3386 A'),
  },
  {
    id: 'excel-builtin-2',
    name: 'Air Cushion & Absolute Yellow',
    region: 'Colour Creation II',
    description: 'Air Cushion (NP OW 1081 P) wall, Absolute Yellow (NP YO 1113 A) trim, Acid Lime (NP BGG 1687 A) highlight.',
    wall: createColorParam('Air Cushion', '#EAE6DF', 'NP OW 1081 P'),
    border: createColorParam('Absolute Yellow', '#FACF19', 'NP YO 1113 A'),
    highlight: createColorParam('Acid Lime', '#CBCF2F', 'NP BGG 1687 A'),
  },
  {
    id: 'excel-builtin-3',
    name: 'Antique White & Peacock Blue',
    region: 'Colour Creation II',
    description: 'Antique White (NP OW 1002 P) wall, Peacock Blue (NP BGG 1580 D) trim, Terracotta Red (NP R 1282 A) highlight.',
    wall: createColorParam('Antique White', '#FAF5EA', 'NP OW 1002 P'),
    border: createColorParam('Peacock Blue', '#1A6B7C', 'NP BGG 1580 D'),
    highlight: createColorParam('Terracotta Red', '#A84E32', 'NP R 1282 A'),
  },
  {
    id: 'excel-builtin-4',
    name: 'Alps Blue & Slate Graphite',
    region: 'Colour Creation II',
    description: 'Alps Blue (NP BGG 1572 P) wall, Slate Graphite (NP N 2040 T) trim, Absolutely Pink (NP AC 2077 A) highlight.',
    wall: createColorParam('Alps Blue', '#B8D5E5', 'NP BGG 1572 P'),
    border: createColorParam('Slate Graphite', '#3A404A', 'NP N 2040 T'),
    highlight: createColorParam('Absolutely Pink', '#BF486C', 'NP AC 2077 A'),
  },
  {
    id: 'excel-builtin-5',
    name: 'Warm Sand & Olive Grove',
    region: 'Colour Creation II',
    description: 'Warm Sand (NP YO 1201 T) wall, Olive Grove (NP BGG 1675 A) trim, Mocha Fudge (NP N 1870 A) highlight.',
    wall: createColorParam('Warm Sand', '#E8C59C', 'NP YO 1201 T'),
    border: createColorParam('Olive Grove', '#6B7D3B', 'NP BGG 1675 A'),
    highlight: createColorParam('Mocha Fudge', '#5C4A38', 'NP N 1870 A'),
  },
];
